/* ── Счётчик работы движка ──────────────────────────────────────────────
   Каждый вызов, который реально крутит ffmpeg (process / processMulti /
   processMultiStreaming), прибавляет свою длительность к window.__execWork.
   telemetry-tier0 отдаёт сумму как `exec_sec` в tool_complete и обнуляет.
   Это единственный честный источник для страничных блоков «сколько идёт
   обработка»: `proc_sec` стартует от загрузки файла и считает раздумья
   человека, `encode_sec` ставит вручную один тул из 776 (/enhance-video).
   Объект принадлежит раннему шиму в layouts/app.blade.php (грузится на каждой
   странице и раньше движков); здесь — только запись полей, без присваивания
   глобала: страницы с no_media_js не должны тянуться за глобалом из
   отброшенной группы. Сторож — ExecWorkIsMeteredTest. */
function _execWorkAdd(t0){
    try{var w=window.__execWork;if(w){w.ms+=Date.now()-t0;w.n++;}}catch(_){}
}
/* Главный поток меряется НА ЭКЗЕМПЛЯРЕ, а не в методах: у процессора шесть
   главнопоточных дверей (process, processMulti, processSegments,
   concatSegments, reencodeAndConcat, analyzeLoudness), все зовут e.exec(...),
   и правка в методах пропустила бы следующую дверь молча. Обёртка ставится в
   момент создания (e=_instrumentExec(new t)) — reinit() пересоздаёт экземпляр
   тем же путём и получает её снова. Идемпотентна. */
/* The paid quality axis, enforced where NOTHING can step around it.
 *
 * getCodecArgs() is the front door and now clamps, but 58 blades build their own
 * args and write `-b:a` by hand — measured 2026-09-18: /vocal-remover and
 * /music-mastering hand an anonymous user 320k, /voice-changer 160–192k, while
 * their own limit block says 128. Patching 58 tools is a list that goes stale
 * the day someone adds the 59th, so the rule goes on the ONE boundary every
 * exec passes through — the same boundary the libopus translation already uses,
 * for the same reason.
 *
 * Scope is deliberate: an AUDIO output only. A video export is sold by height
 * (video_max_height), and its audio track is a passenger — clamping that would
 * apply an axis the tier table does not describe. webm/mka are excluded for
 * exactly that reason: they are video containers far more often than not. */
var _AUDIO_OUT_RX=/\.(mp3|aac|m4a|ogg|oga|opus|wma|mp2|ac3|eac3|m4r|amr|awb|spx|dts|caf|ra|au|snd|voc|wav|flac|aiff|aif|alac|tta|wv)$/i;
function _clampAudioKbpsArgs(args){
    if(!args||!args.length)return args;
    /* Выдача, КУПЛЕННАЯ ТОКЕНАМИ, потолком тарифа не зажимается (разбор — у
       __qualityTier.clamp; ставит метку audio-pipeline.js, PAID_ARG).
       Метка — ЗНАЧЕНИЕ в аргументах, а не свойство массива: свойство теряется на
       первой же перестройке (замер 18.09.2026 — FFmpegResampleQuality.apply
       делает concat, и платная выдача возвращалась к 128). Значение едет вместе
       с тем единственным вызовом, который его поставил, и на соседний экспорт
       протечь не может: у него свой массив. Глобального режима «сейчас платно»
       здесь нет намеренно — exec последователен, и такой режим пометил бы
       следующий чужой вызов. Метку ОБЯЗАТЕЛЬНО вырезать: ffmpeg такой опции не
       знает и упал бы. */
    for(var _p=0;_p<args.length;_p++){if(String(args[_p])==="-tmb_paid"){args.splice(_p,2);return args;}}
    /* `-tmb_std_rate <why>` — a rate fixed by a DELIVERY STANDARD, not sold by
       the plan: AC-3 5.1 at 448 kbps is what a pressed DVD carries, and the
       tier's 128 kbps is a stereo-lossy number — on six channels it is a broken
       disc, not a cheaper one. /surround-disc declared its AC-3 rate outside the
       tier (comment at #sdBitrate); this door, added later (18.09), clamped it
       back to 128 regardless — measured 09.10.2026: a guest's album came out at
       128 kbps and its MKV chapters, computed from the requested 448, ended at
       4.5 s of a 15.8 s album. Same treatment as the paid marker: stripped
       before ffmpeg sees it, travels only with the call that set it. */
    for(var _q=0;_q<args.length;_q++){if(String(args[_q])==="-tmb_std_rate"){args.splice(_q,2);return args;}}
    if(!window.__qualityTier||typeof window.__qualityTier.clamp!=="function")return args;
    var out=String(args[args.length-1]||"");
    if(!_AUDIO_OUT_RX.test(out))return args;
    var lowered=false;
    for(var i=0;i<args.length-1;i++){
        if(!/^-b:a(:\d+)?$/.test(String(args[i])))continue;
        var m=String(args[i+1]).match(/^(\d+(?:\.\d+)?)k$/i);
        if(!m)continue;
        var req=parseFloat(m[1]);
        var cap=window.__qualityTier.clamp("kbps",req);
        if(cap<req){args[i+1]=cap+"k";lowered=true;}
    }
    /* Vorbis and MP3 VBR are asked for as a QUALITY RANK, not kbps — eight audio
       blades write `-q:a N` by hand, and a rank is an axis this clamp would miss
       entirely. The ceiling's own rank is not hardcoded here: the door is asked
       what it would emit for the ceiling, so there is one mapping in the codebase
       and not two (config/formats.php qualityMap). Lower rank = higher quality,
       hence the >= comparison. */
    try{
        var ceilKbps=window.__qualityTier.clamp("kbps",1000000);
        if(ceilKbps<1000000&&window.FFmpegProcessor&&window.FFmpegProcessor.getCodecArgs){
            var ext=(out.match(/\.([a-z0-9]+)$/i)||[])[1];
            var ref=ext?window.FFmpegProcessor.getCodecArgs(ext,ceilKbps):[];
            var maxRank=null;
            for(var r=0;r<ref.length-1;r++)if(String(ref[r])==="-q:a")maxRank=parseFloat(ref[r+1]);
            if(maxRank!==null&&isFinite(maxRank)){
                for(var j=0;j<args.length-1;j++){
                    if(!/^-q:a(:\d+)?$/.test(String(args[j])))continue;
                    var have=parseFloat(args[j+1]);
                    if(isFinite(have)&&have<maxRank){args[j+1]=String(maxRank);lowered=true;}
                }
            }
        }
    }catch(_){}
    if(lowered){try{window.__qualityTier.noteCeilingApplied&&window.__qualityTier.noteCeilingApplied("kbps");}catch(_){}}
    return args;
}
/* An MP3 bitrate between two steps of the CBR grid lands on a step that is not
 * under it (2026-10-07).
 *
 * CBR MP3 has fourteen bitrates, and «Исходное» hands over whatever the source
 * averaged — a VBR file reads 85, 143, 287. libmp3lame takes the NEAREST step.
 * Measured on this very build (the core run in Node,
 * tests/js/ffmpeg-mp3-grid-door.test.mjs): 85k → 80, 103k → 96, 119k → 112,
 * 143k → 128, 175k → 160, 287k → 256 — a file asked to keep its quality comes
 * back up to 11 % under the bitrate it arrived with. The browser encoder's door
 * (snapBitrate in mp3-encoder.js) stopped doing that the same day, and the same
 * export then came out at 96 or at 80 depending on which engine the device was
 * routed to (FFmpegMp3Lane below sends some devices to lamejs).
 *
 * One rule for both engines: the step below only when the request is within 4 %
 * of it (a CBR file measured by size ÷ duration reads a little over its step —
 * tags, the Xing frame), otherwise the step up. The two copies of the rule are
 * held together by the test above; the story is docs/why/primitives/lamejs-build.md.
 *
 * Left alone on purpose: a request of 32 and under (MPEG-2/2.5 rates — 8, 16,
 * 24 kbps at 8–24 kHz — have a table of their own, and the lowest step here
 * would double a voice memo), a request over 320 (the encoder caps it itself),
 * and average-bitrate mode, where any number is a valid target.
 *
 * It stands on the exec boundary for the reason the ceiling above does: 58 blades
 * write `-b:a` by hand. After the ceiling — a ceiling is a step of the grid, and
 * the step chosen here is never above the next one, so it cannot pass it. */
var _MP3_GRID=[32,40,48,56,64,80,96,112,128,160,192,224,256,320];
function _mp3GridKbps(b){
    if(!(b>32)||b>320)return b;
    for(var i=1;i<_MP3_GRID.length;i++){
        if(_MP3_GRID[i]>=b)return b<=_MP3_GRID[i-1]*1.04?_MP3_GRID[i-1]:_MP3_GRID[i];
    }
    return b;
}
function _mp3GridArgs(args){
    if(!args||!args.length)return args;
    if(!/\.mp3$/i.test(String(args[args.length-1]||"")))return args;
    for(var a=0;a<args.length-1;a++){if(String(args[a])==="-abr"&&String(args[a+1])==="1")return args;}
    for(var i=0;i<args.length-1;i++){
        if(!/^-b:a(:\d+)?$/.test(String(args[i])))continue;
        var m=String(args[i+1]).match(/^(\d+(?:\.\d+)?)k$/i);
        if(!m)continue;
        var req=parseInt(m[1],10),on=_mp3GridKbps(req);   // whole kbps, as the other door reads it
        if(on!==req)args[i+1]=on+"k";
    }
    return args;
}
/* Лог принадлежит ОДНОМУ запуску (27.09.2026).
 *
 * Экземпляр ffmpeg.wasm живёт всю страницу, каждый exec — новый main() над теми
 * же глобалами библиотеки, и `-v`/`-loglevel` и `-hide_banner` пишут ГЛОБАЛЫ,
 * которые между запусками никто не сбрасывает. Замер на нашей сборке (FFmpeg
 * 5.1.4): после одного `-v error -stats` проба того же файла отдаёт 90 знаков
 * вместо 3155 — ни «Duration:», ни «Stream … Video:», только строка `frame=`,
 * которую print_report при уровне ниже INFO пишет мимо av_log. Так /repair-video
 * отвергал собственный исправный результат: диагноз гоняет video-vitals с
 * `-v error`, и каждая следующая проверка выхода получала «no_duration_parse»
 * (RU, 30 дней: 64 сессии, 41 из них кончились «не удалось восстановить»).
 * Слепнет всё, что печатается на INFO: пробы, замер громкости, строки потоков.
 * `-hide_banner` так же убивает баннер «ffmpeg version» у всех следующих
 * запусков, а по нему ownRunLog находит начало своего прогона.
 *
 * Поэтому каждый запуск начинается с состояния свежего экземпляра: уровень,
 * не названный вызывающим, — `-loglevel info` (ровно умолчание: уровень без
 * префикса флаги не трогает), а `-hide_banner` снимается — отменить его после
 * запуска нечем (`-nohide_banner` ffmpeg в parse_loglevel читает как сам флаг).
 * Баннер стоит в начале лога, кольцо _ffLogs хранит КОНЕЦ, и ни один разбор его
 * не читает. Массив вызывающего не трогаем: стратегии переиспользуют свои.
 * Внешняя обёртка загрузчика (телеметрия exec, -threads) видит аргументы
 * вызывающего — эта стоит ВНУТРИ неё. Сторожа — tests/js/ffmpeg-run-starts-fresh.test.mjs
 * (в суите; прежний процессор даёт 3 из 3 красных) и
 * tests/playwright/ffmpeg-log-level-does-not-leak.mjs (настоящее ядро). */
/* Те же ГЛОБАЛЫ, что меняют время, а не лог (02.10.2026). `-copyts` пишет
 * переменную fftools, и после запуска с ним (окна encodeWindowsStreaming,
 * точная обрезка) ВСЕ следующие запуски экземпляра шли с исходными метками:
 * замер на настоящем ядре — то же окно звука mkv после чужого `-copyts` легло
 * на 15 сэмплов иначе, окно с выходным `-t` вышло ПУСТЫМ, а «секунда тишины»
 * самих окон (`-t 1` после `-copyts`) у файла с началом позже 1 с (TS) — пуста.
 * `-nocopyts` возвращает умолчание. Дверь помнит, что поменял прошлый запуск
 * ЭТОГО экземпляра, и возвращает умолчание следующему, который глобал не
 * задаёт сам; обычный запуск не меняется ни на байт. ⛔ `-vsync` — глобал без
 * сброса в 5.1 (`-vsync -1` не возвращает «auto», если значение уже другое):
 * только `-fps_mode` у выхода. Сторож нового глобала —
 * FfmpegGlobalsDoNotOutliveTheRunTest.
 * `-max_error_rate` (30.10.2026, /repair-video перекодирует повреждённый файл с
 * `1`, чтобы его ошибки декодера не кончали запуск кодом 69 при записанном
 * выходе): глобал fftools, умолчание 2/3. Замер на настоящем ядре, файл с 252
 * битыми AAC-кадрами из 258: без флага — 69, с `1` — 0, и следующий запуск без
 * флага — тоже 0 (наследовал); со сбросом — снова 69. */
var _RUN_GLOBAL_RESETS={"-copyts":["-nocopyts"],"-stats_period":["-stats_period","0.5"],"-max_error_rate":["-max_error_rate","0.6666667"]};
function _freshRunArgs(a,inst){
    if(!a||typeof a.length!=="number")return a;
    var level=false,hide=false,sets={},pre=[];
    for(var i=0;i<a.length;i++){var s=a[i];if(s==="-v"||s==="-loglevel")level=true;else if(s==="-hide_banner")hide=true;else if(_RUN_GLOBAL_RESETS.hasOwnProperty(s))sets[s]=1;}
    if(inst){
        var dirty=inst.__runGlobals||(inst.__runGlobals={});
        for(var k in dirty)if(dirty[k]&&!sets[k]){pre=pre.concat(_RUN_GLOBAL_RESETS[k]);dirty[k]=0;}
        for(var g in sets)dirty[g]=1;
    }
    if(level&&!hide&&!pre.length)return a;
    var out=(level?[]:["-loglevel","info"]).concat(pre);
    for(var j=0;j<a.length;j++)if(a[j]!=="-hide_banner")out.push(a[j]);
    return out;
}
/* Файлы ОДНОГО вызова process() в памяти FFmpeg — свои у каждого вызова (30.09.2026).
 *
 * process() пишет вход в MEMFS, запускает exec, читает выход и стирает оба.
 * Экземпляр один на страницу, и шаги двух вызовов чередуются: вход второго
 * пишется, пока первый ещё не запущен, выход второго лежит там, откуда первый
 * его читает. Уникальным делалось только имя входа ПО УМОЛЧАНИЮ (07-15); явное
 * имя («input.wav» — его передают ради расширения у Blob без имени) и имя
 * выхода у всех вызовов были общими.
 *
 * Замер 30.09.2026 на /karaoke (общий AudioPipeline.stretch, три смены
 * тональности одной песни подряд, tests/playwright/ffmpeg-process-files-are-per-call.mjs):
 * в 3 прогонах из 4 смена молча приходила с ЧУЖОЙ тональностью (просили −5
 * полутонов — звучало +4), остальные падали «input.wav: No such file or
 * directory». Прод RU, 30 дней: /karaoke — 145 таких ошибок в 100 сессиях;
 * /enhance-video, /mute-video, /time-stretch, /equalizer, /virtual-orchestra —
 * тот же класс с другими явными именами.
 *
 * Имя вызывающего нужно ему ради расширения (по нему FFmpeg выбирает формат)
 * и ради `name` в ответе — расширение остаётся, `name` в ответе прежний. В
 * аргументах этими именами никто не пользуется (grep по всем вызовам,
 * 30.09.2026). Сторож — tests/js/ffmpeg-process-files-are-per-call.test.mjs. */
function _ffCallFsName(name,seq){
    name=String(name==null?"":name);
    var d=name.lastIndexOf(".");
    return (d>0&&name.indexOf("/",d)<0)?name.slice(0,d)+"_c"+seq+name.slice(d):name+"_c"+seq;
}
/* Звук, которого контейнер не несёт, едет в AAC, а не валит выдачу (29.09.2026).
 *
 * `-c copy` / `-c:a copy` в mp4 падает на заголовке, если кодек звука в mp4 не
 * кладётся: «Could not find tag for codec pcm_alaw in stream #1, codec not
 * currently supported in container». Таких источников много, и это не экзотика:
 * G.711 (pcm_alaw / pcm_mulaw) пишут IP-камеры и регистраторы, LPCM — зеркалки и
 * камкордеры (pcm_s16le/s16be/s24le в MOV), AMR — старые телефоны (3GP), ADPCM и
 * WMA — AVI/WMV. Прод, 30 дней, оба шарда: 190 сессий с этим отказом, из них по
 * звуку — pcm_alaw (/repair-video 12, /video-trim 7, /enhance-video 4), pcm_s16le
 * (13 + 14 + 3 + 2), amr_nb (13 + 4), adpcm_ima_wav (5 + 6 + 2 + 1), wmav2,
 * pcm_mulaw, pcm_s16be … Часть тулов выкручивалась своим повтором (/repair-video
 * «audio_transcode_retry», /video-converter — лестница), часть — нет
 * (/enhance-video processMulti, склейка /video-trim), и каждый писал это заново.
 *
 * Правило живёт на двери exec — единственной, через которую идёт КАЖДЫЙ запуск
 * главного экземпляра (те же доводы, что у libopus и тегов RIFF): запуск,
 * который копирует звук в контейнер семейства mp4 и упал ровно этим отказом на
 * ЗВУКОВОМ кодеке, повторяется один раз с тем же набором и `-c:a aac -b:a 128k`
 * (картинка остаётся копией). Отказ на заголовке дешёвый: ffmpeg умирает до
 * первого пакета. Видео-кодек, дорожка данных (`none`), субтитры — не звук, их
 * отказ уходит вызывающему как раньше: перекодирование картинки — решение тула.
 *
 * Лог прогона — свой: слушатель вешается только на такой запуск и только на
 * его время; прогон отрезается по своему баннеру, если он есть (см. _freshRunArgs).
 * Сторож — tests/js/ffmpeg-audio-copy-rescue.test.mjs (в суите; в нём и
 * настоящее ядро 5.1.4 на файле с pcm_alaw). */
var _MP4_FAMILY_OUT_RX=/\.(mp4|m4v|mov|3gp|3g2|m4a|m4b|m4r)$/i;
var _MP4_FAMILY_FMT_RX=/^(mp4|mov|ipod|3gp|3g2|psp|ismv)$/i;
var _AUDIO_CODEC_RX=/^(pcm_|adpcm_|[a-z]*_dpcm|amr|wmav|wmapro|wmalossless|wmavoice|gsm|g72|g723|g729|opus$|vorbis$|speex$|qcelp$|nellymoser$|ilbc$|truehd$|mlp$|mp1$|mp2|mp3|alac$|flac$|ac3$|eac3$|dts$|dca$|aac|ra_|cook$|atrac|sipr$|evrc$|qdm|imc$|dsd_|tta$|wavpack$|ape$|shorten$|mace|interplay_|comfortnoise$|dss_sp$|twinvq$|metasound$|smackaudio$|musepack|truespeech$|sonic$)/;
/* Запуск, копирующий звук в выход семейства mp4 → {from} (начало опций выхода), иначе null. */
function _audioCopyPlan(a){
    if(!a||typeof a.length!=="number"||a.length<3)return null;
    var from=0;
    for(var i=0;i<a.length-1;i++){if(a[i]==="-n")return null;if(a[i]==="-i")from=i+2;}
    var out=String(a[a.length-1]||""),fmt="",copies=false;
    for(var k=from;k<a.length-1;k++){
        var o=String(a[k]);
        if(o==="-f")fmt=String(a[k+1]||"");
        if(String(a[k+1])!=="copy")continue;
        if(o==="-c"||o==="-codec"||o==="-acodec"||/^-(c|codec):a(:\d+)?$/.test(o))copies=true;
    }
    if(!copies)return null;
    if(!(_MP4_FAMILY_OUT_RX.test(out)||_MP4_FAMILY_FMT_RX.test(fmt)))return null;
    return {from:from};
}
/* Упавший прогон + его лог → {args, codec} для повтора со звуком в AAC, иначе null. Чистая. */
function _audioCopyRescueArgs(a,log){
    var plan=_audioCopyPlan(a);
    if(!plan||!log||!log.length)return null;
    var codec=null,i;
    for(i=log.length-1;i>=0&&!codec;i--){var m=/Could not find tag for codec\s+([a-z0-9_]+)\s+in stream\s+#\d+/i.exec(String(log[i]));if(m)codec=m[1].toLowerCase();}
    if(!codec)return null;
    var isAudio=_AUDIO_CODEC_RX.test(codec);
    if(!isAudio){var rx=new RegExp("Audio:\\s*"+codec.replace(/[^a-z0-9_]/g,"")+"\\b");for(i=0;i<log.length&&!isAudio;i++)isAudio=rx.test(String(log[i]));}
    if(!isAudio)return null;
    var out=Array.prototype.slice.call(a),changed=false,generic=-1,hasRate=false;
    for(var k=plan.from;k<out.length-1;k++){
        var o=String(out[k]);
        if(o==="-b:a"||o==="-ab"||/^-b:a:\d+$/.test(o))hasRate=true;
        if(String(out[k+1])!=="copy")continue;
        if(o==="-acodec"||/^-(c|codec):a(:\d+)?$/.test(o)){out[k+1]="aac";changed=true;}
        else if((o==="-c"||o==="-codec")&&generic<0)generic=k;
    }
    /* `-c copy` для всех потоков: потоковый спецификатор сильнее общего, поэтому
       `-c:a aac` сразу за ним переопределяет только звук. */
    if(!changed&&generic>=0){out.splice(generic+2,0,"-c:a","aac");changed=true;}
    if(!changed)return null;
    if(!hasRate)out.splice(out.length-1,0,"-b:a","128k");
    /* Упавший прогон уже создал выходной файл (ffmpeg открывает его до заголовка). */
    if(out.indexOf("-y")===-1)out.unshift("-y");
    return {args:out,codec:codec};
}
/* Слушатель лога на время одного такого запуска. null — запуск не копирует звук в mp4. */
function _audioCopyWatch(inst,a){
    if(!_audioCopyPlan(a)||!inst||typeof inst.on!=="function"||typeof inst.off!=="function")return null;
    var lines=[],live=true;
    var cb=function(ev){try{lines.push(String(ev&&ev.message!=null?ev.message:ev));if(lines.length>600)lines.splice(0,lines.length-400);}catch(_){}};
    inst.on("log",cb);
    function stop(){if(!live)return;live=false;try{inst.off("log",cb);}catch(_){}}
    return {
        stop:stop,
        rescue:function(code){
            stop();
            if(code===0)return null;
            var from=0;for(var i=lines.length-1;i>=0;i--){if(/^ffmpeg version /.test(lines[i])){from=i;break;}}
            return _audioCopyRescueArgs(a,lines.slice(from));
        },
        report:function(re,code){
            try{
                var out=String(a[a.length-1]||""),ext=(out.match(/\.([a-z0-9]{1,5})$/i)||[])[1]||"";
                window.__ae&&window.__ae("feature_use",{f:"audio_copy_rescued",codec:re.codec,out:ext.toLowerCase(),ok:code===0?1:0,slug:window.__TOOL_SLUG||""});
            }catch(_){}
        }
    };
}
/* One run through the MP3 lane (or the engine itself), and — only for a run
   that copies audio into an mp4-family output and was refused for it — one
   re-run with the audio in AAC. See _audioCopyRescueArgs above. */
async function _execWithAudioRescue(inst,orig,args,paid){
    var L=window.FFmpegMp3Lane,watch=null;
    try{watch=_audioCopyWatch(inst,args[0]);}catch(_){watch=null;}
    try{
        var rc=await(L?L.exec(inst,orig,args,paid):orig.apply(inst,args));
        var re=watch?watch.rescue(rc):null;
        if(re){
            var again=Array.prototype.slice.call(args);again[0]=re.args;
            if(!paid){try{_clampAudioKbpsArgs(again[0]);}catch(_){}}
            rc=await(L?L.exec(inst,orig,again,paid):orig.apply(inst,again));
            watch.report(re,rc);
        }
        return rc;
    }finally{if(watch)watch.stop();}
}
function _instrumentExec(inst){
    try{
        var orig=inst.exec;
        if(typeof orig!=="function"||orig.__execWorkWrapped)return inst;
        var wrapped=async function(){inst.__execN=(inst.__execN||0)+1;var t0=Date.now(),a=arguments[0],paid=false;try{paid=!!(a&&a.indexOf("-tmb_paid")!==-1);_clampAudioKbpsArgs(a);try{_mp3GridArgs(a);}catch(_){}arguments[0]=_freshRunArgs(a,inst);}catch(_){}try{return await _execWithAudioRescue(inst,orig,arguments,paid);}finally{_execWorkAdd(t0);}};
        wrapped.__execWorkWrapped=true;
        inst.exec=wrapped;
        /* Кто кодирует MP3 на этом устройстве и запись «exec в полёте» —
           FFmpegMp3Lane ниже; метка платной выдачи снимается ДО того, как
           _clampAudioKbpsArgs её вырежет, иначе lamejs зажал бы оплаченное. */
        try{window.FFmpegMp3Lane&&window.FFmpegMp3Lane.adopt(inst);}catch(_){}
    }catch(_){}
    return inst;
}
/* Monotonic engine-activity counter. ⚠️ _ffLogs is a RING (cap 20/40/200), so
   its .length pins at the cap and STOPS CHANGING while ffmpeg is working —
   any watchdog polling _ffLogs.length goes blind after ~20 lines. Measured
   2026-08-08 on a healthy 51.6 s render: log CONTENT never paused >1.0 s,
   yet .length sat unchanged for 19.5 s. Bump a counter that only ever grows
   so liveness is observable regardless of the ring cap. */
window._ffLogSeq = window._ffLogSeq || 0;
window._ffTick = function () { window._ffLogSeq++; };

/* ═══════════ RIFF/IFF: текстовый тег в этих контейнерах — НЕ Unicode ═══════════
 *
 * У ID3v2, Vorbis-комментария и iTunes-атома кодировка ОБЪЯВЛЕНА внутри тега
 * (у ID3v2.4 это байт 0x03 = UTF-8), поэтому плеер читает их однозначно. У
 * RIFF `LIST/INFO` (WAV) и IFF `NAME`/`AUTH` (AIFF) объявления кодировки НЕТ
 * ВООБЩЕ: спецификация старше Unicode, и всякий проигрыватель на Windows
 * разбирает эти байты системной ANSI-кодовой страницей. FFmpeg кладёт туда
 * UTF-8 — то есть на русской машине пользователь ГАРАНТИРОВАННО видит кашу.
 *
 * ЗАМЕР 2026-09-01 на нашей же WASM-сборке, вход — mp3 с тегом «Пустота»:
 *
 *   выход   тег              байты                    что видит плеер
 *   mp3     TIT2, enc=0x03   UTF-8, объявлен          Пустота          ✓
 *   flac    VORBIS_COMMENT   UTF-8 по спецификации    Пустота          ✓
 *   m4a     ilst             UTF-8 по спецификации    Пустота          ✓
 *   wav     LIST/INFO/INAM   UTF-8, НЕ объявлен       РџСѓСЃС‚РѕС‚Р°   ✗
 *   aiff    NAME             UTF-8, НЕ объявлен       РџСѓСЃС‚РѕС‚Р°   ✗
 *
 * Именно это и есть жалоба #3792 (01.09.2026): «вместо нормальных названий
 * пошли имена символами юникода на всех языках сразу — У с галочкой, кресты,
 * градусы». Все три названных знака — ровно cp1251-прочтение UTF-8 кириллицы:
 * `С`→d0a1→«РЎ», `ц`→d186→«С†», `а`→d0b0→«Р°». Второй его симптом —
 * «переименовываю файл, а в плеере название не меняется» — следствие первого:
 * пока тег есть, плеер показывает ЕГО, а не имя файла.
 *
 * Лечение — не чинить кодировку (в RIFF её негде объявить), а НЕ НАСЛЕДОВАТЬ
 * тег в такой контейнер: имя файла пользователь контролирует сам, оно лежит в
 * файловой системе в Unicode и переименовывается. Пустой тег честнее сломанного.
 *
 * Живёт на границе exec — единственной, через которую проходят ВСЕ вызовы
 * ffmpeg (та же точка, что и подмена libopus ниже). Правило в 97 блейдах,
 * умеющих отдавать WAV, разошлось бы молча.
 *
 * ⚠️ Не трогаем вызывающего, который метаданными управляет САМ (`-map_metadata`
 * или `-metadata` в аргументах): у /audio-metadata запись тега — смысл тула, и
 * решение «что делать с кириллицей в WAV» принадлежит ему, а не этой границе.
 */
window.FFmpegContainerTagRule = (function () {
    'use strict';
    /* Контейнеры, чьи текстовые чанки не несут объявления кодировки. */
    var RX_ANSI_TAG_CONTAINER = /\.(wav|aiff|aif|aifc)$/i;

    /** argv → argv. Идемпотентна, ничего не бросает, возвращает ТОТ ЖЕ массив,
     *  если правило не применимо. */
    function apply(argv) {
        if (!argv || !argv.length) return argv;
        var out = argv[argv.length - 1];
        if (typeof out !== 'string' || !RX_ANSI_TAG_CONTAINER.test(out)) return argv;
        /* Хвост — ВХОД, а не выход, если перед ним стоит `-i`: так выглядит
           проба `-hide_banner -i файл.wav` (выхода нет, ffmpeg печатает заголовок
           и выходит). С 01.09 по 25.09.2026 правило вставляло `-map_metadata -1`
           МЕЖДУ `-i` и путём, и проба любого WAV/AIFF падала с «Unrecognized
           option '1'» — длительность, частота и каналы не читались вовсе
           (/speech-restorer, замер 25.09). */
        if (argv.length >= 2 && argv[argv.length - 2] === '-i') return argv;
        for (var i = 0; i < argv.length; i++) {
            /* `-metadata` ловит и `-metadata:s:a:0` — вызывающий, который пишет
               хоть один тег, владеет всеми. */
            if (argv[i] === '-map_metadata' || String(argv[i]).indexOf('-metadata') === 0) return argv;
        }
        var next = argv.slice(0, argv.length - 1);
        next.push('-map_metadata', '-1', out);
        return next;
    }

    return { apply: apply, _rx: RX_ANSI_TAG_CONTAINER };
})();

/* ═══════ Opus: libopus — только моно; всё остальное — встроенный `opus` ═══════
 *
 * libopus в этом ядре падает «memory access out of bounds» (в Firefox «index out
 * of bounds», в WebKit «Out of bounds memory access») на звуке больше чем в
 * один канал при 48 кГц — а 48 кГц он выбирает сам для любого стерео-исхода.
 * Замер 08.10.2026, оба ядра, свежий экземпляр на каждый случай:
 *
 *   1 канал  48000 / 44100 / 44100→16000 / 16000     кодирует
 *   2 канала 48000 / 44100                            ПАДАЕТ
 *   2 канала 48000 → 24000                            кодирует
 *   6 каналов 48000                                   ПАДАЕТ
 *
 * и то же самое в Chromium, Firefox и WebKit через этот загрузчик: шесть форм
 * аргументов, какими его просят тулы (ogg-звук, экспорт webm, замена звука у
 * webm-копии, 5.1, 44100), — пять падений; живёт только моно (демо-минута).
 * Встроенный `opus` кодирует всё, но он экспериментальный и на речи слабее:
 * демо-минута /audio-to-text на сервере — 8,3 % ошибок в словах против 6,9 % у
 * libopus и 6,6 % у WAV (9 минут трёх записанных заседаний, 793 слова эталона).
 *
 * Отсюда правило, на этой границе с 09.07.2026 (до 08.10 — без исключения для
 * моно и без двух дыр ниже):
 *   · `libopus` при явном `-ac 1` остаётся libopus — моно ему не страшно;
 *   · иначе → встроенный `opus` + `-strict -2`;
 *   · вызывающий, который САМ просит встроенный `opus`, получает `-strict -2`.
 * Дыры, через которые libopus доходил до стерео: написание `-codec:a` (так
 * просит /audio-compressor — 4 падения за 30 дней) и выход без названного
 * кодека, где его выбирает сам ffmpeg (.opus, .webm). Частоту, которую выбранный
 * кодировщик не берёт, после этого правила исправляет FFmpegSampleRateRule.
 * Сторож — tests/js/ffmpeg-sample-rate-rule.test.mjs (на настоящем ядре).
 */
window.FFmpegOpusRule = (function () {
    'use strict';
    var RX_CODEC = /^-(c|codec|acodec)(:a)?(:0)?$/;
    var RX_AC = /^-ac(:a)?(:\d+)?$/;
    var DEFAULTS_TO_LIBOPUS = /\.(opus|webm)$/i;

    function apply(argv) {
        if (!argv || !argv.length) return argv;
        var last = argv.length - 1;
        if (argv.length >= 2 && argv[last - 1] === '-i') return argv;        // проба
        var from = 0;
        for (var i = 0; i < last; i++) if (argv[i] === '-i') from = i + 2;
        var at = -1, enc = null, fmt = null, mono = false, noAudio = false, strict = false;
        for (var k = from; k < last; k++) {
            var a = String(argv[k]);
            if (RX_CODEC.test(a) && (a.indexOf(':a') > 0 || a === '-acodec')) { at = k + 1; enc = String(argv[k + 1] || ''); }
            else if ((a === '-c' || a === '-codec') && argv[k + 1] === 'copy') enc = 'copy';
            else if (RX_AC.test(a)) mono = String(argv[k + 1]) === '1';
            else if (a === '-an') noAudio = true;
            else if (a === '-f') fmt = String(argv[k + 1] || '');
            else if (a === '-strict') strict = true;
        }
        if (enc === 'copy' || noAudio) return argv;
        var out;
        if (enc === 'libopus') {
            if (mono) return argv;
            out = argv.slice();
            out[at] = 'opus';
        } else if (enc === 'opus') {
            if (strict) return argv;
            out = argv.slice();
        } else if (enc === null && !mono && (fmt === 'webm' || fmt === 'opus' || (!fmt && DEFAULTS_TO_LIBOPUS.test(String(argv[last]))))) {
            out = argv.slice(0, last).concat(['-c:a', 'opus'], [argv[last]]);
            at = last + 1;
        } else {
            return argv;
        }
        if (!strict) out.splice(at + 1, 0, '-strict', '-2');
        return out;
    }

    return { apply: apply };
})();

/* ═══════ Частота выхода — та, которую кодировщик ПРИНИМАЕТ ═══════
 *
 * Явный `-ar`, которого выбранный кодировщик не умеет, ffmpeg не округляет, а
 * отвергает: «Specified sample rate 16000 is not supported», выход не создан.
 * Без `-ar` ffmpeg сам выбирает ближайшую допустимую частоту — значит, ломает
 * прогон только просьба вызывающего, и она шире одного тула (прод, 30 дней до
 * 08.10.2026): /audio-to-text — демо-минута сервера просила opus 16 кГц и КАЖДЫЙ
 * раз падала в запасной WAV (1,9 МБ вместо ~120 КБ, 3–8 сессий в день с 08.09);
 * /acx-mastering — mp3 96 кГц, 46 попыток в одной сессии; /convert и
 * /audio-compressor — aac 192 кГц, libopus 22050; /voice-enhancer — aac 51200.
 *
 * Списки — замер на ОБОИХ ядрах этого сайта (основное и no-SIMD дали одно и то
 * же), 08.10.2026, проба `-c:a <кодировщик> -ar <частота>` по сетке 7350…192000:
 *
 *   aac          7350 8000 11025 12000 16000 22050 24000 32000 44100 48000 64000 88200 96000
 *   libmp3lame   8000 11025 12000 16000 22050 24000 32000 44100 48000
 *   opus         48000                      (встроенный; сюда ведёт FFmpegOpusRule выше)
 *   libopus      8000 12000 16000 24000 48000
 *   ac3, eac3    32000 44100 48000
 *   mp2          16000 22050 24000 32000 44100 48000
 *   wmav2        любая до 48000
 *   libvorbis, flac, alac, pcm_*   любая
 *
 * Правило округления — то же, что у window.__audioCodecLimits.rateFor (одно на
 * сайт): наибольшая допустимая частота НЕ ВЫШЕ запрошенной, а если таких нет —
 * наименьшая. Потолки тарифа (48 / 96 кГц) оно не переступает: вверх оно идёт
 * только там, где ниже ничего нет (opus — только 48000; ac3 — от 32000). Opus
 * своей частоты не имеет вовсе — он всегда декодируется в 48 кГц, полосу решает
 * битрейт; поэтому 16000 → 48000 файл не утяжеляет.
 *
 * Кодировщик — из `-c:a` (и синонимов) после последнего `-i`; не назван —
 * из `-f` или расширения выхода (что ffmpeg выбирает сам, тоже замерено:
 * .mp3 → libmp3lame, .m4a/.aac → aac, .opus/.webm → libopus, .ogg/.mka →
 * libvorbis, .ac3 → ac3, .mp2 → mp2, .wma → wmav2). `-ar` ДО `-i` — частота
 * сырого входа, её не трогаем; копию (`-c:a copy`) — тоже.
 *
 * Живёт на границе exec рядом с FFmpegContainerTagRule и по тем же причинам,
 * и идёт ПОСЛЕ FFmpegOpusRule — судит тот кодировщик, что реально запустится:
 * через неё проходят все вызовы основного экземпляра. Каждая замена — в
 * телеметрию (`ffmpeg_ar_snapped`, раз на страницу для пары частот), чтобы тул,
 * предлагающий человеку невозможную пару «формат × частота», был виден.
 * Сторож — tests/js/ffmpeg-sample-rate-rule.test.mjs (в том числе на настоящем
 * ядре); разбор — docs/why/ffmpeg-wasm.md.
 */
window.FFmpegSampleRateRule = (function () {
    'use strict';
    var RATES = {
        aac:        [7350, 8000, 11025, 12000, 16000, 22050, 24000, 32000, 44100, 48000, 64000, 88200, 96000],
        libmp3lame: [8000, 11025, 12000, 16000, 22050, 24000, 32000, 44100, 48000],
        opus:       [48000],
        libopus:    [8000, 12000, 16000, 24000, 48000],
        ac3:        [32000, 44100, 48000],
        eac3:       [32000, 44100, 48000],
        mp2:        [16000, 22050, 24000, 32000, 44100, 48000]
    };
    /* Кодировщики, берущие любую частоту не выше потолка. */
    var MAX = { wmav2: 48000, wmav1: 48000 };
    /* Что ffmpeg выбирает сам, когда `-c:a` не назван. */
    var BY_EXT = { mp3: 'libmp3lame', m4a: 'aac', aac: 'aac', m4r: 'aac', m4b: 'aac', mp4: 'aac', mov: 'aac',
        '3gp': 'aac', opus: 'libopus', webm: 'libopus', ac3: 'ac3', eac3: 'eac3', mp2: 'mp2', wma: 'wmav2' };
    var BY_FMT = { mp3: 'libmp3lame', adts: 'aac', ipod: 'aac', mp4: 'aac', mov: 'aac', '3gp': 'aac',
        opus: 'libopus', webm: 'libopus', ac3: 'ac3', eac3: 'eac3', mp2: 'mp2', asf: 'wmav2' };
    var RX_CODEC = /^-(c|codec|acodec)(:a)?(:0)?$/;
    var RX_AR = /^-ar(:a)?(:\d+)?$/;
    var told = {};

    /* Как __audioCodecLimits.rateFor: наибольшая не выше, иначе наименьшая. */
    function nearest(list, want) {
        var below = 0, lowest = list[0];
        for (var i = 0; i < list.length; i++) {
            if (list[i] <= want && list[i] > below) below = list[i];
            if (list[i] < lowest) lowest = list[i];
        }
        return below || lowest;
    }

    /** Частота, которую примет кодировщик `enc`, вместо `want`; та же, если примет. */
    function fit(enc, want) {
        if (!(want > 0)) return want;
        var list = RATES[enc];
        if (list) return list.indexOf(want) >= 0 ? want : nearest(list, want);
        if (MAX[enc] && want > MAX[enc]) return MAX[enc];
        return want;
    }

    /** argv → argv. Идемпотентна, ничего не бросает; тот же массив, если менять нечего. */
    function apply(argv) {
        if (!argv || !argv.length) return argv;
        var last = argv.length - 1;
        if (argv.length >= 2 && argv[last - 1] === '-i') return argv;        // проба: хвост — вход
        var from = 0;
        for (var i = 0; i < last; i++) if (argv[i] === '-i') from = i + 2;  // опции выхода — после последнего входа
        var enc = null, fmt = null, ars = [];
        for (var k = from; k < last; k++) {
            var a = String(argv[k]);
            if (RX_CODEC.test(a) && (a.indexOf(':a') > 0 || a === '-acodec')) enc = String(argv[k + 1] || '');
            else if (a === '-c' && argv[k + 1] === 'copy') enc = 'copy';                // `-c copy` копирует и звук
            else if (a === '-f') fmt = String(argv[k + 1] || '');
            else if (RX_AR.test(a)) ars.push(k + 1);
        }
        if (!ars.length || enc === 'copy') return argv;
        if (!enc) {
            if (fmt) enc = BY_FMT[fmt] || null;
            else {
                var m = /\.([a-z0-9]+)$/i.exec(String(argv[last]));
                enc = m ? (BY_EXT[m[1].toLowerCase()] || null) : null;
            }
        }
        if (!enc) return argv;
        var out = argv;
        for (var j = 0; j < ars.length; j++) {
            var want = parseInt(argv[ars[j]], 10), got = fit(enc, want);
            if (got === want) continue;
            if (out === argv) out = argv.slice();
            out[ars[j]] = String(got);
            var key = enc + ':' + want + ':' + got;
            if (!told[key]) {
                told[key] = 1;
                try { if (window.__aeDiagnostic) window.__aeDiagnostic({ issue: 'ffmpeg_ar_snapped', enc: enc, from: want, to: got }); } catch (_) {}
            }
        }
        return out;
    }

    return { apply: apply, fit: fit, _rates: RATES };
})();

/* ═══════ Перекодированный кадр стоит там же, где стоял в исходнике ═══════
 *
 * Без `-fps_mode` ffmpeg для mp4/mov выбирает режим CFR (у muxer'а mov нет
 * флага AVFMT_VARIABLE_FPS) и перекладывает каждый кадр на сетку 1/частоту:
 * неровные кадры исходника дублирует и выбрасывает. Даже с `-fps_mode vfr`
 * время кадра округляется до часов КОДИРОВЩИКА — они по умолчанию тоже
 * 1/частоту. Камеры видеонаблюдения, регистраторы, телефоны в темноте,
 * записи экрана пишут неровные метки времени, и в выходе такой файл
 * «дёргается»: картинка стоит, потом прыгает на два кадра.
 *
 * Отзыв 04.11.2026 на /enhance-video («скачанное видео дёргается в
 * конвульсиях»): 768×576, 15 к/с, H.264 c SEI в каждом кадре; все пять его
 * файлов сделал этот путь (быстрый упал на кодировщике). Замер на ЭТОМ ядре
 * (n5.1.4 wasm), фикстура с движущейся полосой, позиция которой = 160 px/с ×
 * время съёмки кадра; ошибка = время, которое кадр показывает, минус время,
 * когда плеер его покажет (p95):
 *
 *   исходник                     без правила            с правилом (= исходник)
 *   ровные 15 к/с                4,2 мс                 4,2 мс
 *   джиттер ±10 мс               38,7 мс                5,9 мс
 *   джиттер ±28 мс               52,0 мс                5,8 мс
 *   пропуски (каждый 3-й ×2)     70,8 мс, +68 дублей    8,3 мс, 0 дублей
 *
 * Только `-fps_mode vfr` (без часов кодировщика) на джиттере даёт те же
 * 38,7 / 52,0 мс: время кадра всё равно квантуется к 1/15 с. Часы 1/90000 —
 * явные, а не «как у входа» (`-1`): у входа бывают грубые часы (AVI — 1/fps),
 * а фильтр времени (`setpts=PTS/2`) даёт метки между ними. Замер нативного
 * ffmpeg 7: ускорение ×2 и замедление ×2 из входа 1/15 — кадров ровно столько,
 * сколько в исходнике (615 / 1230); без правила замедление выходило 25 к/с с
 * 2870 вставленными дублями (частота после `setpts` неизвестна, ffmpeg берёт 25).
 *
 * Где правило НЕ действует — и почему:
 *  · вызывающий сам назвал часы: `-r`, `-fps_mode`, `-vsync`, `-enc_time_base`
 *    после последнего `-i` (частоту выхода решил тул);
 *  · `-copyts` — окна encodeWindowsStreaming и точная обрезка ведут свои часы;
 *  · копия видео (`-c copy`, `-c:v copy`), `-vn`, проба (`… -i x` в хвосте);
 *  · контейнер без меток времени или с правилом своей частоты: AVI, GIF,
 *    картинки, сырой поток, `-f null`;
 *  · кодировщики с ограничением часов: mpeg2video берёт только стандартные
 *    частоты MPEG, mpeg4 — знаменатель ≤ 65535. Правило знает libx264 и
 *    libvpx(-vp9) — 131 из 135 вызовов видеокодировщика на сайте (перепись
 *    04.11.2026); остальные — как были.
 * Часы — только видео (`:v`): у звукового кодировщика свои (1/частоту).
 * Вспомогательные экземпляры в воркерах (spawnHelper / spawnSecondary) эту
 * дверь, как и соседние правила, не проходят.
 * Сторож — tests/js/ffmpeg-frame-timing-rule.test.mjs (в том числе на
 * настоящем ядре); разбор — docs/why/primitives/ffmpeg-frame-timing.md.
 */
window.FFmpegFrameTimingRule = (function () {
    'use strict';
    var CONTAINERS = { mp4: 1, mov: 1, m4v: 1, '3gp': 1, mkv: 1, webm: 1 };
    var FORMATS = { mp4: 1, mov: 1, ipod: 1, '3gp': 1, matroska: 1, webm: 1 };
    var ENCODERS = { libx264: 1, libx264rgb: 1, libvpx: 1, 'libvpx-vp9': 1 };
    /* Что ffmpeg этого ядра кодирует сам, когда `-c:v` не назван. */
    var DEFAULT_BY_CONTAINER = { mp4: 'libx264', mov: 'libx264', m4v: 'libx264', '3gp': 'libx264', mkv: 'libx264', webm: 'libvpx-vp9' };
    var RX_RATE = /^-(r|fps_mode|vsync|enc_time_base)(:v)?(:\d+)?$/;
    var RX_VCODEC = /^-(c|codec)(:v)(:\d+)?$|^-vcodec$/;

    /** argv → argv. Идемпотентна, ничего не бросает; тот же массив, если менять нечего. */
    function apply(argv) {
        if (!argv || !argv.length) return argv;
        var last = argv.length - 1;
        if (argv.length >= 2 && argv[last - 1] === '-i') return argv;        // проба: хвост — вход
        var from = -1;
        for (var i = 0; i < last; i++) {
            var s = String(argv[i]);
            if (s === '-i') from = i + 2;
            else if (s === '-copyts') return argv;
        }
        if (from < 0) return argv;                                           // без входа — не кодирование
        var enc = null, fmt = null;
        for (var k = from; k < last; k++) {
            var a = String(argv[k]);
            if (RX_RATE.test(a) || a === '-vn') return argv;
            if (RX_VCODEC.test(a)) enc = String(argv[k + 1] || '');
            else if (a === '-c' || a === '-codec') { if (argv[k + 1] === 'copy') enc = 'copy'; }
            else if (a === '-f') fmt = String(argv[k + 1] || '');
        }
        var ext = (/\.([a-z0-9]+)$/i.exec(String(argv[last])) || [])[1];
        ext = ext ? ext.toLowerCase() : '';
        if (fmt ? !FORMATS[fmt] : !CONTAINERS[ext]) return argv;
        if (!enc) enc = DEFAULT_BY_CONTAINER[ext] || (fmt === 'webm' ? 'libvpx-vp9' : 'libx264');
        if (!ENCODERS[enc]) return argv;
        var out = argv.slice(0, last);
        out.push('-fps_mode:v', 'vfr', '-enc_time_base:v', '1:90000', argv[last]);
        return out;
    }

    return { apply: apply };
})();

/* ═══════ Теги источника переживают обработку, которая идёт через буфер ═══════
 *
 * Политика целиком — в `audio-source-tags.js` (что считается описательным,
 * откуда берётся источник, в какие контейнеры писать можно). Здесь только
 * ПРИМЕНЕНИЕ к аргументам: тег пишется в том же проходе ffmpeg, который и так
 * идёт, — ни чтения выхода, ни лишней копии.
 *
 * ⚠️ Кодировщиков у сайта ТРИ, и они не знают друг о друге: этот, общий
 * mp3-энкодер в воркере (`mp3-encoder.js`) и lamejs, поднятый прямо в
 * нескольких блейдах (/equalizer, /voice-changer, /voice-gender). Правило,
 * написанное только здесь, на главном пути /speed молчало бы — mp3 там
 * кодирует lamejs. Поэтому политика одна, а дверей несколько; кто из них
 * дверь, держит `AudioSourceTagsAreCarriedTest`.
 *
 * Модуль грузит ЗОНА ЗАГРУЗКИ (tool-uploader.js), как только на страницу
 * пришёл звук: у /voice-gender нет ни FFmpeg, ни общего mp3-энкодера, и
 * загрузчик, живший здесь, туда не доезжал. Не загружен — применение no-op.
 */

/* ════════════════ компенсация задержки фильтров с lookahead ════════════════
 *
 * Два FFmpeg-фильтра, которые мы применяем, ЗАДЕРЖИВАЮТ звук — и при этом НЕ
 * удлиняют выход. Значит задержка целиком оплачена ХВОСТОМ: последние
 * миллисекунды записи молча пропадают. Замер 2026-08-21, чирп 200 Гц→8 кГц
 * (на чистом тоне лаг неоднозначен: любой сдвиг, кратный периоду, даёт
 * идеальное совпадение — первая версия пробы «намеряла» 1200 и 2864 сэмпла
 * для одного и того же фильтра, и обе цифры «подтверждались»):
 *
 *   фильтр                 задержка   на 22050 / 44100 / 48000 / 96000 Гц
 *   alimiter                 5.0 мс   109 / 219 / 239 / 479 сэмплов
 *   afftdn                  25.0 мс   550 / 1102 / 1200 / 2400 сэмплов
 *   afftdn + alimiter       30.0 мс   задержки СКЛАДЫВАЮТСЯ (1439 на 48 кГц)
 *
 *   не задерживают вовсе: volume, acompressor, agate, dynaudnorm, adeclick,
 *   adeclip, equalizer, highpass, lowpass, afade
 *
 * 25 мс — это четверть слога: у речи пропадает последний согласный. Дефект
 * тихий, поэтому и жил незамеченным — его видно только при сравнении двух
 * маршрутов между собой, а не каждого с ожиданием.
 *
 * Лечится `apad` (дать фильтру доработать до конца) + `atrim` (снять внесённую
 * им задержку с начала). Компенсация задаётся ВРЕМЕНЕМ, а не сэмплами: здесь,
 * в общей точке, частота дискретизации неизвестна, а обе задержки временны́е.
 * Проверено на 44100 и 48000: остаточный сдвиг ≤2 сэмплов (0.04 мс).
 *
 * Живёт ЗДЕСЬ, в единственном месте, через которое проходят все браузерные
 * вызовы ffmpeg (96 файлов), а не в 57 местах сборки цепочек. Тул, который
 * завтра добавит `alimiter`, получит компенсацию бесплатно.
 */
/* ── Ресемплер: качество по умолчанию, а не «как получится» ──────────────
 *
 * swresample берёт `filter_size=32` — ядро настолько короткое, что фильтр не
 * успевает ни выпрямить полосу, ни подавить зеркала. Замерено 2026-09-18 в
 * ЭТОМ ядре (wasm 0.12.10 и нативный 7.0 дают одно и то же), тон 23 кГц при
 * понижении 48 → 44.1 кГц, где он обязан исчезнуть, а не свернуться в 21.1:
 *
 *      filter_size   зеркало    20 кГц     21 кГц     время*
 *      32 (дефолт)   −29.1 дБ   −0.48 дБ   −1.78 дБ   ×1.00
 *      64            −62.1      0          −0.44      —
 *      96            −103.2     0          −0.04      ×1.36
 *      128           −103.8     0          0          ×1.81
 *      256           −111.5     0          0          ×2.98
 *      * 5 минут звука в wasm, чередующиеся прогоны, минимум из трёх —
 *        машина общая, и среднее по ней врёт.
 *
 * 96 — колено: подавление уходит с 20 дБ на 94, то есть на пол 16 бит. Выше
 * покупаются децибелы, которых в 16/24-битной выдаче не существует.
 *
 * ⚠️ Почему правило ГЛОБАЛЬНОЕ, а не список тулов: там, где частота не
 * меняется, стадия ресемплера не запускается вовсе, и опция бесплатна.
 * Замерено абсурдным ядром 4096: 48→48 не сдвинулось (168 → 172 мс), а
 * 48→44.1 выросло в 38 раз. Плату берёт сам ffmpeg и только с тех прогонов,
 * которые действительно пересчитывают, — списку тулов тут делать нечего, он
 * бы только протух.
 *
 * ⚠️ Задержку своего ядра swresample компенсирует сам: щелчок, поставленный на
 * 1.000 с, остаётся на 1.000249 с (сетка 44.1 кГц) и при 32, и при 96, и при
 * 4096, длительность не меняется. С FFmpegDelayCompensation не пересекается.
 *
 * libsoxr дал бы ещё ~40 дБ, но требует своей сборки ядра И парной пересборки
 * no-SIMD-ядра (NoSimdCoreIsTheMainCoreWithoutSimdTest требует того же
 * FFmpeg) — ради разницы под полом формата. Наш `soxr` в строках .wasm — это
 * имя опции, движок в сборку не включён (`--enable-libsoxr` в configure нет).
 */
window.FFmpegResampleQuality = (function () {
    'use strict';

    var FILTER_SIZE = 96;

    /** Прогон, где ffmpeg вообще не декодирует звук: ресемплера там нет. */
    function isPureCopy(args) {
        for (var i = 0; i < args.length - 1; i++) {
            if (args[i] === '-af' || args[i] === '-filter_complex' || args[i] === '-ar') return false;
        }
        for (var j = 0; j < args.length - 1; j++) {
            if ((args[j] === '-c' || args[j] === '-c:a' || args[j] === '-codec:a') && args[j + 1] === 'copy') return true;
        }
        return false;
    }

    /** Идемпотентна; выбор вызывающего сильнее умолчания; fail-open. */
    function apply(args) {
        try {
            if (!args || !args.length) return args;
            if (args.indexOf('-filter_size') !== -1) return args;
            if (isPureCopy(args)) return args;
            return args.concat(['-filter_size', String(FILTER_SIZE)]);
        } catch (_) { return args; }
    }

    return { apply: apply, FILTER_SIZE: FILTER_SIZE };
})();

window.FFmpegDelayCompensation = (function () {
    'use strict';

    /* ── Задержки ЗАМЕРЕНЫ, а не взяты из документации ──────────────────
     *
     * Прибор: импульс в известной точке, сдвиг пика = задержка. Одной
     * командой — `node scripts/filter-latency-probe.mjs <фильтр>`; он же
     * проверяет ЧЕТЫРЕ позиции импульса, потому что по одной отличить
     * задержку от модуляции нельзя: `vibrato` даёт 2.52 / 4.98 / 4.63 / 4.98
     * мс в зависимости от того, куда попал щелчок (это модуляция двигает
     * транзиент), а `afftdn` — ровно 25.00 во всех четырёх. Компенсировать
     * первое значило бы вносить рассинхрон, а не убирать.
     *
     * Замер 2026-09-18, ffmpeg 7.0 и wasm 0.12.10 сошлись. ⚠️ Три последних
     * фильтра у нас сегодня НЕ используются — они здесь ровно поэтому: чтобы
     * первый же тул, который их возьмёт, получил компенсацию сразу, а не
     * через три месяца и обращение. */
    var DELAY_MS = {
        afftdn: 25,            // шумодав по спектру: окно анализа
        anlmdn: 8,             // нелокальные средние: окно
        firequalizer: 10,      // линейно-фазовый КИХ: половина ядра
        superequalizer: 85.31, // самый тяжёлый из встреченных
    };

    /* Замерено НУЛЁМ в том же прогоне (моно и стерео). Список существует ради
     * единственной цели: отличить «фильтр без задержки» от «фильтра, о котором
     * мы ничего не знаем». Без этого различия незнакомый фильтр компенсируется
     * как ноль — молча и неотличимо от правды, и таблица тихо протухает вместе
     * с первым же новым тулом. */
    var KNOWN_ZERO = ('acompressor agate crystalizer highpass lowpass treble bass equalizer loudnorm '
        + 'volume aformat aresample pan amix amerge asplit afade apad aecho adelay asetpts anull '
        + 'dynaudnorm speechnorm deesser aexciter acrusher asoftclip extrastereo stereotools '
        + 'stereowiden channelmap asubboost tremolo chorus flanger aphaser vibrato '
        + 'atrim atempo silenceremove areverse aselect aloop asetrate acrossfade channelsplit join '
        // asetnsamples=n=480:p=0 — the frame size of LoudnessStage's rider
        // (loudness-stage.js); 0.00 ms at all four positions, probed 2026-09-27
        + 'asetnsamples'
        ).split(' ');

    /* Незнакомое имя больше не молчит. Один раз на имя за сессию — этого
     * хватает, чтобы день, когда кто-то возьмёт `firequalizer`, был виден в
     * телеметрии, и не хватает, чтобы её засорить. */
    var reportedUnknown = {};
    function noteUnknown(name) {
        if (!name || reportedUnknown[name]) return;
        reportedUnknown[name] = 1;
        try {
            if (typeof window !== 'undefined' && window.__ae) {
                window.__ae('feature_use', { f: 'filter_latency_unknown', name: String(name).slice(0, 32) });
            }
        } catch (_) {}
    }

    /** Задержка фильтра в СЕКУНДАХ по его записи в цепочке. */
    function delayOf(filter) {
        var name = filter.split('=')[0].trim();
        if (name === 'alimiter') {
            // attack задаётся в мс и ЕСТЬ задержка: attack=1 даёт 47 сэмплов
            // на 48 кГц (≈1 мс) против 239 при умолчании 5 мс.
            // Разделителем может быть и `:` (attack не первый), и `=`
            // (`alimiter=attack=20:limit=0.9` — attack первым). Первая версия
            // ловила только `:` и на первой позиции молча возвращала
            // умолчание 5 мс, то есть компенсировала бы не ту величину.
            var m = filter.match(/[=:]attack=([0-9.]+)/);
            return (m ? parseFloat(m[1]) : 5) / 1000;
        }
        if (Object.prototype.hasOwnProperty.call(DELAY_MS, name)) return DELAY_MS[name] / 1000;
        if (name && KNOWN_ZERO.indexOf(name) === -1) noteUnknown(name);
        return 0;
    }

    /* Фильтры, меняющие длину или ХОД ВРЕМЕНИ. Если такой стоит ПОСЛЕ
       задерживающего, наружная обрезка снимет не задержку, а живой звук:
       `alimiter,atrim=end=10` отдаёт 0…10−d, и обрезка съест первые d
       СОДЕРЖИМОГО. До задерживающего они безопасны.

       Список сужен ЗАМЕРОМ 2026-08-21, а не осторожностью: `aresample`,
       `loudnorm`, `aecho` и `apad` в нём БЫЛИ и оказались безвредны —
       ни один не вносит задержки и не мешает обрезке по ВРЕМЕНИ. Это не
       мелочь: наши цепочки штатно кончаются на `aresample=48000` (июньская
       починка вывода loudnorm в 192 кГц), и с прежним списком компенсация
       не применялась бы ровно к /audio-enhancer и /voice-enhancer — тем, у
       кого цепочка длиннее всех и теряется 30 мс. */
    var TIME_CHANGING = /^(atrim|atempo|silenceremove|areverse|aselect|adelay|aloop|asetrate)\b/;

    /** Пометка «здесь уже компенсировано» — защита от повторного применения
     *  на ретрае (process() зовётся второй раз с ТЕМИ ЖЕ args). */
    var MARK = 'asetpts=PTS-STARTPTS';

    /**
     * @param {string} chain значение -af
     * @returns {{chain:string, applied:boolean, reason:string, delay:number}}
     */
    function compensate(chain) {
        if (!chain || typeof chain !== 'string') return { chain: chain, applied: false, reason: 'empty', delay: 0 };

        // Разбор по запятым верхнего уровня: внутри выражений (aeval, volume
        // с enable=) запятые экранированы обратным слэшем, и наивный split
        // разорвал бы фильтр пополам.
        var parts = [], cur = '', esc = false, inQ = false;
        for (var i = 0; i < chain.length; i++) {
            var c = chain[i];
            if (esc) { cur += c; esc = false; continue; }
            if (c === '\\') { cur += c; esc = true; continue; }
            if (c === "'") { inQ = !inQ; cur += c; continue; }
            if (c === ',' && !inQ) { parts.push(cur); cur = ''; continue; }
            cur += c;
        }
        parts.push(cur);

        var total = 0, lastDelayIdx = -1, firstDelayIdx = -1;
        for (i = 0; i < parts.length; i++) {
            var d = delayOf(parts[i]);
            if (d > 0) { total += d; lastDelayIdx = i; if (firstDelayIdx < 0) firstDelayIdx = i; }
        }
        if (total <= 0) return { chain: chain, applied: false, reason: 'no_delay', delay: 0 };
        if (chain.indexOf(MARK) !== -1) return { chain: chain, applied: false, reason: 'already', delay: total };

        for (i = lastDelayIdx + 1; i < parts.length; i++) {
            if (TIME_CHANGING.test(parts[i].trim())) {
                return { chain: chain, applied: false, reason: 'time_changing_after_delay:' + parts[i].split('=')[0], delay: total };
            }
        }

        // Запас 2 мс: сборка ffmpeg-WASM другой версии, чем та, на которой
        // задержки замерены. Лишняя тишина в конце безвредна, срезанный
        // звук — нет. Асимметрия намеренная.
        var pad = (total + 0.002).toFixed(6);
        // `apad` встаёт ВПЛОТНУЮ перед первым задерживающим фильтром, а не в
        // голову цепочки. Голова была неверна дважды, и оба раза молча:
        //
        //  1. В ГРАФЕ первым фильтром звена может быть многовходовый
        //     (`[0:a][1:a]acrossfade,alimiter`). `apad` в голове забирал ОБЕ
        //     метки — «Too many inputs specified for the apad filter» →
        //     «Error initializing complex filters. Invalid argument» → выход 1.
        //     Так с 21.08 падал КАЖДЫЙ кроссфейд на дереве слияния /join.
        //  2. Любой `atrim` МЕЖДУ головой и лимитером срезал сам паддинг:
        //     дорасти лимитеру было негде, хвост терялся по-прежнему, а
        //     наружная `atrim=start` съедала 5 мс ЖИВОГО звука с начала.
        //     Сторож TIME_CHANGING смотрел только ПОСЛЕ задержки и этого
        //     класса не видел.
        //
        // Вплотную перед задерживающим оба случая исчезают по построению:
        // между `apad` и фильтром нет никого, кто мог бы срезать паддинг, а
        // многовходовый фильтр остаётся при своих метках. Когда задержка и так
        // первая (обычный `-af`), строка выходит БАЙТ В БАЙТ прежней.
        var k = firstDelayIdx;
        var padded = parts.slice(0, k).concat(['apad=pad_dur=' + pad]).concat(parts.slice(k)).join(',');
        return {
            chain: padded + ',atrim=start=' + total.toFixed(6) + ',' + MARK,
            applied: true,
            reason: 'ok',
            delay: total
        };
    }

    /** Переписать массив аргументов ffmpeg, если в нём есть -af/-filter:a. */
    /**
     * Компенсация внутри `-filter_complex`.
     *
     * Граф — это `;`-разделённые звенья вида `[in][in2]фильтры[out]`. Правим
     * только середину каждого звена, метки не трогаем.
     *
     * ⚠️ Середина звена — НЕ то же самое, что цепочка `-af`, и разница стоила
     * трёх дней сломанного /join. У звена бывает НЕСКОЛЬКО входных меток
     * (первый фильтр многовходовый) и НЕСКОЛЬКО выходных (`asplit`), а обёртка
     * `apad … atrim` — строго однопоточная. Поэтому:
     *   • вход  — за размещение `apad` отвечает `compensate()`: он ставит его
     *     вплотную перед задерживающим фильтром, то есть заведомо ПОСЛЕ
     *     многовходового;
     *   • выход — звено с более чем одной выходной меткой не компенсируем
     *     вовсе: приписать в конец однопоточный `atrim` там нельзя, а
     *     «примерно приписать» — это ровно тот молчаливый сломанный граф,
     *     который здесь уже был.
     *
     * Звенья без задерживающих фильтров (видео-ветки, `amix`, `volume`)
     * возвращаются байт-в-байт: решение принимает та же `compensate()`.
     */
    function compensateGraph(graph) {
        if (!graph || typeof graph !== 'string') return { graph: graph, applied: false, delay: 0, reason: 'empty' };
        var segs = graph.split(';');
        var changed = false, total = 0, reason = 'no_delay';
        for (var i = 0; i < segs.length; i++) {
            var seg = segs[i];
            var head = seg.match(/^(\s*(?:\[[^\]]+\]\s*)*)/)[1];
            var tail = seg.slice(head.length).match(/((?:\s*\[[^\]]+\])*\s*)$/)[1];
            var body = seg.slice(head.length, seg.length - tail.length);
            if (!body) continue;
            var res = compensate(body);
            if (res.delay > 0) { total += res.delay; reason = res.reason; }
            if (!res.applied) continue;
            // Несколько выходных меток — обёртка неприменима (см. шапку).
            if ((tail.match(/\[/g) || []).length > 1) { reason = 'multi_output'; continue; }
            segs[i] = head + res.chain + tail;
            changed = true;
        }
        return { graph: changed ? segs.join(';') : graph, applied: changed, delay: total, reason: changed ? 'ok' : reason };
    }

    /**
     * Переписать массив аргументов ffmpeg. Покрывает и `-af`, и
     * `-filter_complex`: в проекте есть тулы, чья аудио-ветка живёт только в
     * графе (`gif-to-video`, `add-music-to-video`), и до них правка иначе не
     * доходит.
     */
    /**
     * `-shortest` теряет ровно ОДИН аудиопакет — но не всегда.
     *
     * Замерено 2026-08-21 (ffmpeg 7.0), четыре конфигурации:
     *
     *   аудио КОРОЧЕ видео        режется видео       потеря 0 — точно
     *   аудио = видео, -c:a copy  не режется ничего   потеря 0
     *   аудио = видео, перекодир. режется аудио       ~21 мс (кадр AAC = 1024)
     *   аудио ДЛИННЕЕ видео       режется аудио       21–75 мс (один пакет)
     *
     * То есть больно только когда `-shortest` режет ИМЕННО аудио и оно
     * перекодируется. `-shortest_buf_duration` проверен и ОТВЕРГНУТ: выход
     * становится длиннее видео на 0.1–3 с, непредсказуемо. Фильтр `apad`
     * тоже не помогает — проверено, стало хуже. Надёжно чинит только явный
     * `-t <длительность>`, а она известна не везде.
     *
     * Здесь мы НИЧЕГО не меняем — только считаем, сколько прогонов реально
     * попадает в потерянный класс. Без этого числа свип по 26 оставшимся
     * местам был бы правкой вслепую: ради 21 мс в чужих тулах. Мест с
     * `-shortest` в проекте 27; худший класс (музыка длиннее ролика) был
     * один — /gif-to-video, и он уже переведён на `-t`.
     */
    var REENCODE_AUDIO = /^(aac|libmp3lame|libopus|libvorbis|libfdk_aac|flac|pcm_[a-z0-9]+|libtwolame|ac3)$/;
    function observeShortest(args, slug) {
        var hasShortest = false, aCodec = null, hasT = false;
        for (var i = 0; i < args.length; i++) {
            if (args[i] === '-shortest') hasShortest = true;
            else if (args[i] === '-t') hasT = true;
            else if ((args[i] === '-c:a' || args[i] === '-acodec') && i + 1 < args.length) aCodec = String(args[i + 1]);
        }
        if (!hasShortest) return;
        var lossy = !hasT && !!aCodec && REENCODE_AUDIO.test(aCodec);
        try {
            window.__ae && window.__ae('feature_use', {
                slug: slug || (document.querySelector('meta[name="tool-slug"]') || {}).content || 'unknown',
                f: 'shortest_exposure',
                // 1 = прогон в классе, где теряется аудиопакет
                lossy: lossy ? 1 : 0,
                acodec: aCodec || 'none',
                has_t: hasT ? 1 : 0
            });
        } catch (_) {}
    }

    function apply(args, slug) {
        if (!args || !args.length) return args;
        try { observeShortest(args, slug); } catch (_) {}
        var out = args, copied = false, delay = 0, reason = null, applied = false;
        for (var i = 0; i < out.length - 1; i++) {
            var flag = out[i];
            var isAf = (flag === '-af' || flag === '-filter:a');
            var isGraph = (flag === '-filter_complex' || flag === '-lavfi');
            if (!isAf && !isGraph) continue;
            var res = isAf ? compensate(out[i + 1]) : compensateGraph(out[i + 1]);
            var val = isAf ? res.chain : res.graph;
            if (res.applied) {
                if (!copied) { out = out.slice(); copied = true; }
                out[i + 1] = val;
                applied = true;
            }
            if (res.delay > 0) { delay = res.delay; reason = res.reason; }
        }
        if (delay > 0) {
            try {
                window.__ae && window.__ae('feature_use', {
                    slug: slug || (document.querySelector('meta[name="tool-slug"]') || {}).content || 'unknown',
                    f: 'ff_delay_compensation',
                    applied: applied ? 1 : 0,
                    reason: reason,
                    ms: Math.round(delay * 1000)
                });
            } catch (_) {}
        }
        return out;
    }

    return { compensate: compensate, compensateGraph: compensateGraph, apply: apply, delayOf: delayOf, observeShortest: observeShortest };
})();

/* ══════ MP3: чей кодировщик работает на ЭТОМ устройстве — одна дверь на все тулы ══════
 *
 * ЗАМЕР 2026-09-24 (комментарий #1740 под /denoise: «Удалите это гауно с
 * сайта!»). Яндекс.Браузер 24.10 — последняя сборка для Windows 7/8.1 (в UA
 * всё равно «Windows NT 10.0»: у Chromium ≥ 110 строка заморожена), 4 ГБ.
 * Три падения вкладки за пять минут, и каждое — через 1–2 с после старта
 * FFmpeg: экспорт в MP3 на /repair-audio, превью /denoise (оно кодировалось в
 * MP3), снова превью. Отчёты Reporting API — `reason: unknown`, то есть НЕ
 * нехватка памяти. По RU за 7 дней, экспорт → падение вкладки ≤ 15 с:
 *
 *   браузер (Windows)              в MP3 (libmp3lame)    в AAC/M4A/MP4/WAV
 *   Яндекс 24 (Windows 7/8.1)      13 из  109  (12 %)    1 из 155
 *   Chrome 109 (Windows 7)          3 из   49   (6 %)    0 из 143
 *   Яндекс 26 / Chrome 15x / Edge   0 из 2349            0 из ~3000
 *
 * На SIMD-ядре — 20 из 159 (12.6 %), а на части машин КАЖДЫЙ раз: человек в
 * /recording-studio жал «Экспорт MP3» восемь раз подряд — восемь падений.
 * Тот же MP3 из lamejs (mp3-encoder.js: чистый JS в воркере, без wasm) на тех
 * же машинах выходит: 930 кодирований на этой когорте за две недели, из них
 * 28 — на восьми устройствах, где libmp3lame валит вкладку.
 * Механизм ниже — в V8/ОС самой машины: на Windows 11 не воспроизводится ни
 * в Chrome 128 x64/x86, ни с эмуляцией процессоров без AVX и SSE4.2
 * (--js-flags). Поэтому правило держится ЗАМЕРА, а не догадки о механизме.
 *
 * Что делает. На таком устройстве FFmpeg пишет PCM (WAV сегментами по
 * SEG_S — главный поток держит один сегмент, а не второй экземпляр всего
 * файла), MP3 кодирует lamejs потоком, теги и обложка переносятся, результат
 * ложится в FS под ТЕМ ЖЕ именем, exec возвращает 0. Для вызывающего не
 * меняется ничего — ни у одного из ~120 тулов. Живёт на границе exec, как
 * подмена libopus и потолок битрейта: список тулов разошёлся бы.
 *
 * Какие устройства:
 *   · Windows + Chromium ≤ LEGACY_CHROMIUM_MAX (Яндекс 24.10, Chrome/Edge 109,
 *     Opera 95 — браузеры, оставшиеся на Windows 7/8.1);
 *   · Windows 7/8/8.1 по UA-CH (platformVersion 0.x) — Supermium и прочие
 *     свежие Chromium на старой системе;
 *   · ВЫУЧЕННЫЕ: вкладка уже умирала посреди кодирования MP3 в libmp3lame на
 *     этом устройстве (запись «exec в полёте» ниже; помним LEARN_MS).
 * Выход длиннее WAV_BUDGET PCM остаётся на libmp3lame, как раньше: цена
 * промежуточного WAV в памяти там выше выигрыша. Осечка самого лейна
 * (кодировщик не загрузился, WAV не разобрался) — тоже libmp3lame, как раньше.
 * Телеметрия: mp3_lane · mp3_lane_skip · mp3_lane_failed · ffmpeg_exec_died.
 * Сторожа: tests/js/ffmpeg-mp3-lane.test.mjs,
 * tests/playwright/mp3-lane-encodes-without-libmp3lame.mjs.
 */
window.FFmpegMp3Lane = (function () {
    'use strict';

    var LAME_RATES = [8000, 11025, 12000, 16000, 22050, 24000, 32000, 44100, 48000];
    var LEGACY_CHROMIUM_MAX = 128;
    var LEARN_KEY = '_tb_mp3_lane', LEARN_MS = 30 * 86400000;
    var FLIGHT_KEY = '_tb_ff_flight', FLIGHT_STALE_MS = 6 * 3600000;
    var WAV_BUDGET = 320 * 1048576;
    var SEG_S = 60;
    var CHUNK = 65536;
    /* LAME -V0…-V9 → средний битрейт той же плотности. Потоковый lamejs пишет
       CBR: VBR без Xing-кадра плееры показывают с неверной длительностью. */
    var VBR_KBPS = [245, 225, 190, 175, 165, 130, 115, 100, 85, 65];
    /* Опции без значения. Всё остальное, что начинается с «-», съедает
       следующий токен — так отличаем значение от второго выхода. */
    var BOOL = { '-y': 1, '-n': 1, '-vn': 1, '-an': 1, '-sn': 1, '-dn': 1, '-shortest': 1,
        '-nostdin': 1, '-hide_banner': 1, '-re': 1, '-copyts': 1, '-start_at_zero': 1,
        '-accurate_seek': 1, '-noaccurate_seek': 1, '-nostats': 1, '-stats': 1,
        '-ignore_unknown': 1, '-xerror': 1, '-autorotate': 1, '-noautorotate': 1, '-benchmark': 1 };
    /* Выходные опции, которые PCM-сегментам не нужны или вредны (кодек и его
       настройки, теги, картинка). Всё прочее — фильтры, -ar/-ac, -t/-ss, -map —
       едет в WAV без изменений, поэтому звук тот же, что ушёл бы в libmp3lame. */
    var DROP = { '-f': 1, '-c': 1, '-codec': 1, '-c:a': 1, '-acodec': 1, '-codec:a': 1,
        '-c:a:0': 1, '-codec:a:0': 1, '-b:a': 1, '-ab': 1, '-b:a:0': 1, '-q:a': 1, '-aq': 1,
        '-q:a:0': 1, '-qscale:a': 1, '-compression_level': 1, '-joint_stereo': 1,
        '-reservoir': 1, '-abr': 1, '-id3v2_version': 1, '-write_id3v1': 1, '-write_xing': 1,
        '-map_metadata': 1, '-sample_fmt': 1, '-cutoff': 1, '-vcodec': 1, '-vf': 1,
        '-pix_fmt': 1, '-r': 1, '-s': 1, '-crf': 1, '-preset': 1, '-tune': 1, '-movflags': 1,
        '-vframes': 1 };
    /* `-metadata` ffmpeg → ключ писателя тегов (audio-tag-writer.js). */
    var TAG_KEYS = { title: 'title', artist: 'artist', album: 'album', album_artist: 'albumArtist',
        albumartist: 'albumArtist', date: 'year', year: 'year', genre: 'genre', track: 'track',
        disc: 'disc', composer: 'composer', copyright: 'copyright', comment: 'comment',
        lyrics: 'lyrics', isrc: 'isrc' };

    var UA = (typeof navigator !== 'undefined' && navigator.userAgent) || '';
    var MOB = /Mobi|Android|iPhone|iPad/i.test(UA) ? 1 : 0;
    var seq = 0;

    /* Версия Windows из UA-CH: у 7/8/8.1 platformVersion «0.x». Асинхронна —
       до ответа решает строка браузера, которой хватает для известной когорты. */
    var _pv = null;
    try {
        var _uad = navigator.userAgentData;
        if (_uad && typeof _uad.getHighEntropyValues === 'function' && /Windows/i.test(UA)) {
            _uad.getHighEntropyValues(['platformVersion']).then(function (h) {
                var m = /^(\d+)/.exec(String((h && h.platformVersion) || ''));
                if (m) _pv = +m[1];
            }, function () {});
        }
    } catch (_) {}

    function isOpt(a) { return typeof a === 'string' && a.length > 1 && a.charAt(0) === '-' && !/^-\d/.test(a); }
    function nowMs() { return Date.now(); }
    function slugNow() {
        try { var m = document.querySelector('meta[name="tool-slug"]'); return (m && m.content) || window.__TOOL_SLUG || ''; }
        catch (_) { return ''; }
    }
    function coreNow() { return window.__ffmpegNoSimdLane ? 'nosimd' : (window.__ffmpegMtLane ? 'mt' : 'simd'); }
    function report(f, p) {
        var payload = { f: f };
        for (var k in (p || {})) if (Object.prototype.hasOwnProperty.call(p, k)) payload[k] = p[k];
        var send = function () { try { if (window.__ae) { window.__ae('feature_use', payload); return true; } } catch (_) {} return false; };
        if (!send()) setTimeout(send, 2000);
    }

    /* ── Выученное: здесь libmp3lame уже убивал вкладку ──────────────────── */
    function learned(now) {
        try { var r = JSON.parse(localStorage.getItem(LEARN_KEY) || 'null'); return !!(r && r.t && now - r.t < LEARN_MS); }
        catch (_) { return false; }
    }
    function remember(why) {
        try {
            var prev = JSON.parse(localStorage.getItem(LEARN_KEY) || 'null') || {};
            localStorage.setItem(LEARN_KEY, JSON.stringify({ t: nowMs(), n: (prev.n || 0) + 1, why: why }));
        } catch (_) {}
    }

    /** Почему MP3 кодирует lamejs; null — кодирует libmp3lame, как везде. */
    function decide(env) {
        env = env || {};
        var force = ('force' in env) ? env.force : window.__MP3_LANE_FORCE;
        if (force === 'ffmpeg') return null;
        if (force === 'lame') return 'forced';
        var ua = ('ua' in env) ? env.ua : UA;
        var pv = ('pv' in env) ? env.pv : _pv;
        if (/Windows NT/i.test(ua)) {
            var m = /(?:Chrome|Chromium)\/(\d+)/.exec(ua);
            if (m && +m[1] <= LEGACY_CHROMIUM_MAX) return 'legacy_chromium';
            if (m && typeof pv === 'number' && pv < 1) return 'legacy_windows';
        }
        if (learned(('now' in env) ? env.now : nowMs())) return 'learned';
        return null;
    }

    function parseKbps(v) {
        var m = /^(\d+(?:\.\d+)?)([kKmM]?)$/.exec(String(v));
        if (!m) return null;
        var n = parseFloat(m[1]);
        if (m[2] === 'k' || m[2] === 'K') return Math.round(n);
        if (m[2] === 'm' || m[2] === 'M') return Math.round(n * 1000);
        return Math.round(n / 1000);
    }
    function parseSeconds(v) {
        var s = String(v), m = /^(\d+):(\d+):(\d+(?:\.\d+)?)$/.exec(s);
        if (m) return (+m[1]) * 3600 + (+m[2]) * 60 + (+m[3]);
        var n = parseFloat(s);
        return isFinite(n) && n >= 0 ? n : null;
    }

    /**
     * argv → план MP3-кодирования в libmp3lame, или null: не MP3, копия
     * потока, чужой кодек, несколько выходов, сегменты, pipe. Правило
     * срабатывает ТОЛЬКО там, где уверено, что понимает команду.
     */
    function plan(argv) {
        if (!argv || argv.length < 3) return null;
        var n = argv.length - 1, out = argv[n];
        if (typeof out !== 'string' || !out || out.charAt(0) === '-' || out.indexOf('%') !== -1 || /^[a-z]{2,}:/i.test(out)) return null;
        var lastIn = -1, k;
        for (k = 0; k < n - 1; k++) if (argv[k] === '-i') lastIn = k + 1;
        if (lastIn < 0) return null;
        var fmt = null, cAll = null, cA = null, kbps = null, q = null, tags = [], vn = false, maps = 0, mapsV = false, t = null;
        for (var i = 0; i < n; i++) {
            var a = argv[i];
            if (!isOpt(a)) { if (i > lastIn) return null; continue; }   // второй выход
            if (BOOL[a]) { if (a === '-vn' && i > lastIn) vn = true; continue; }
            var v = String(argv[i + 1]);
            i++;
            if (i - 1 < lastIn) continue;                                 // опция входа
            if (a === '-f') fmt = v;
            else if (a === '-c' || a === '-codec') cAll = v;
            else if (a === '-c:a' || a === '-acodec' || a === '-codec:a' || a === '-c:a:0' || a === '-codec:a:0') cA = v;
            else if (a === '-b:a' || a === '-ab' || a === '-b:a:0') kbps = parseKbps(v);
            else if (a === '-q:a' || a === '-aq' || a === '-q:a:0' || a === '-qscale:a') q = parseFloat(v);
            else if (a === '-metadata' || a === '-metadata:g') tags.push(v);
            else if (a === '-map') { maps++; if (/(^|:)v(:|$)|^\[v/i.test(v)) mapsV = true; }
            else if (a === '-t') t = parseSeconds(v);
        }
        if (fmt && fmt !== 'mp3') return null;
        if (!fmt && !/\.mp3$/i.test(out)) return null;
        var codec = cA || cAll;
        if (codec === 'copy') return null;
        if (codec && codec !== 'libmp3lame' && codec !== 'mp3') return null;
        if (kbps === null && q !== null && isFinite(q)) kbps = VBR_KBPS[Math.max(0, Math.min(9, Math.round(q)))];
        return {
            out: out, lastIn: lastIn, kbps: kbps || 128, vbr: (q !== null && isFinite(q)) ? q : null,
            tags: tags, t: t,
            // ffmpeg сам кладёт обложку источника в .mp3, если выбор потоков
            // автоматический или видео отображено явно
            cover: !vn && (maps === 0 || mapsV)
        };
    }

    /** План → команда, пишущая PCM s16 WAV-сегментами `stem%03d.wav`. */
    function rewrite(argv, p, extra, stem) {
        var n = argv.length - 1, out = [];
        for (var i = 0; i < n; i++) {
            var a = argv[i];
            if (!isOpt(a) || BOOL[a]) { out.push(a); continue; }
            if (i > p.lastIn && (DROP[a] || /^-(metadata|disposition)(:|$)/.test(a) || /^-(c|codec|b|q|filter|frames):v/.test(a))) { i++; continue; }
            out.push(a, argv[i + 1]);
            i++;
        }
        return out.concat(extra || [], ['-vn', '-sn', '-dn', '-c:a', 'pcm_s16le', '-f', 'segment',
            '-segment_time', String(SEG_S), '-segment_format', 'wav', stem + '%03d.wav']);
    }

    /** Заголовок WAV: где лежат сэмплы и в каком виде. Бросает на чужом. */
    function parseWav(u8) {
        var dv = new DataView(u8.buffer, u8.byteOffset, u8.byteLength);
        if (u8.length < 12 || dv.getUint32(0, false) !== 0x52494646 || dv.getUint32(8, false) !== 0x57415645) throw new Error('not a WAV');
        var p = 12, fmt = null;
        while (p + 8 <= u8.length) {
            var id = dv.getUint32(p, false), size = dv.getUint32(p + 4, true), body = p + 8;
            if (id === 0x666d7420 && body + 16 <= u8.length) {
                fmt = { tag: dv.getUint16(body, true), ch: dv.getUint16(body + 2, true), sr: dv.getUint32(body + 4, true), bits: dv.getUint16(body + 14, true) };
            } else if (id === 0x64617461) {
                if (!fmt) throw new Error('WAV data before fmt');
                var len = (size === 0 || size === 0xFFFFFFFF || body + size > u8.length) ? u8.length - body : size;
                return { sampleRate: fmt.sr, channels: fmt.ch, bits: fmt.bits, tag: fmt.tag, offset: body, length: len };
            }
            p = body + size + (size & 1);
        }
        throw new Error('WAV without data');
    }

    function nearestRate(sr) {
        var best = 44100, d = Infinity;
        for (var i = 0; i < LAME_RATES.length; i++) { var x = Math.abs(LAME_RATES[i] - sr); if (x < d) { d = x; best = LAME_RATES[i]; } }
        return best;
    }

    /* Обложка источника (ID3v2 APIC), чтобы MP3 из lamejs нёс её так же, как
       нёс бы из ffmpeg. Источник — единственный файл зоны загрузки, то же
       правило, что у audio-source-tags.js. Только голова файла. */
    function apicFrom(b) {
        if (!b || b.length < 10 || b[0] !== 0x49 || b[1] !== 0x44 || b[2] !== 0x33) return null;
        var major = b[3], flags = b[5];
        if (major < 3 || (flags & 0x80)) return null;                   // v2.2 и unsync — мимо
        var size = ((b[6] & 0x7f) << 21) | ((b[7] & 0x7f) << 14) | ((b[8] & 0x7f) << 7) | (b[9] & 0x7f);
        var end = Math.min(10 + size, b.length), p = 10, found = null;
        if (flags & 0x40) p += major >= 4 ? (((b[p] & 0x7f) << 21) | ((b[p + 1] & 0x7f) << 14) | ((b[p + 2] & 0x7f) << 7) | (b[p + 3] & 0x7f)) : (4 + ((b[p] << 24) | (b[p + 1] << 16) | (b[p + 2] << 8) | b[p + 3]));
        while (p + 10 <= end) {
            var id = String.fromCharCode(b[p], b[p + 1], b[p + 2], b[p + 3]);
            if (!/^[A-Z0-9]{4}$/.test(id)) break;
            var fs = major >= 4 ? (((b[p + 4] & 0x7f) << 21) | ((b[p + 5] & 0x7f) << 14) | ((b[p + 6] & 0x7f) << 7) | (b[p + 7] & 0x7f))
                                : ((b[p + 4] << 24) | (b[p + 5] << 16) | (b[p + 6] << 8) | b[p + 7]) >>> 0;
            var body = p + 10;
            if (fs <= 0 || body + fs > end) break;
            if (id === 'APIC') {
                var enc = b[body], q = body + 1, mime = '';
                while (q < body + fs && b[q] !== 0) mime += String.fromCharCode(b[q++]);
                q++;
                var type = b[q++];
                if (enc === 1 || enc === 2) { while (q + 1 < body + fs && !(b[q] === 0 && b[q + 1] === 0)) q += 2; q += 2; }
                else { while (q < body + fs && b[q] !== 0) q++; q++; }
                if (q < body + fs) {
                    var pic = { mime: /^image\//.test(mime) ? mime : (mime === 'PNG' ? 'image/png' : 'image/jpeg'), data: b.slice(q, body + fs), type: type };
                    if (!found || (type === 3 && found.type !== 3)) found = pic;
                }
            }
            p = body + fs;
        }
        return found ? { mime: found.mime, data: found.data } : null;
    }
    async function sourceCover() {
        try {
            var zones = document.querySelectorAll('.tool-uploader'), all = [];
            for (var i = 0; i < zones.length; i++) { var d = zones[i].__deliveredFiles; if (d && d.length) all = all.concat(Array.prototype.slice.call(d)); }
            if (all.length !== 1 || !all[0] || typeof all[0].slice !== 'function') return null;
            var head = new Uint8Array(await all[0].slice(0, 10).arrayBuffer());
            if (head[0] !== 0x49 || head[1] !== 0x44 || head[2] !== 0x33) return null;
            var size = ((head[6] & 0x7f) << 21) | ((head[7] & 0x7f) << 14) | ((head[8] & 0x7f) << 7) | (head[9] & 0x7f);
            if (size > 16 * 1048576) return null;
            return apicFrom(new Uint8Array(await all[0].slice(0, 10 + size).arrayBuffer()));
        } catch (_) { return null; }
    }

    function loadOnce(path, ready) {
        if (ready()) return Promise.resolve(true);
        var src = (typeof window.__jsSrc === 'function') ? window.__jsSrc(path) : path;
        var p = (typeof window.__loadScriptsOnce === 'function')
            ? window.__loadScriptsOnce([src], 'mp3-lane').then(function () { return ready(); }, function () { return false; })
            : new Promise(function (res) {
                try {
                    var s = document.createElement('script');
                    s.src = src;
                    s.onload = function () { res(ready()); };
                    s.onerror = function () { res(false); };
                    document.head.appendChild(s);
                } catch (_) { res(false); }
            });
        return p;
    }
    var _encP = null, _tagP = null;
    function ensureEncoder() {
        var ok = function () { return !!(window.MP3Encoder && typeof window.MP3Encoder.encodeStream === 'function'); };
        if (ok()) return Promise.resolve(true);
        if (!_encP) _encP = loadOnce('/js/mp3-encoder.js', ok).then(function (r) { if (!r) _encP = null; return r; });
        return _encP;
    }
    function ensureTagWriter() {
        var ok = function () { return !!(window.AudioTag && typeof window.AudioTag.edit === 'function'); };
        if (ok()) return Promise.resolve(true);
        if (!_tagP) _tagP = loadOnce('/js/audio-tag-writer.js', ok).then(function (r) { if (!r) _tagP = null; return r; });
        return _tagP;
    }

    async function applyTags(blob, p) {
        var set = {}, n = 0;
        for (var i = 0; i < p.tags.length; i++) {
            var s = String(p.tags[i]), eq = s.indexOf('=');
            if (eq <= 0) continue;
            var key = TAG_KEYS[s.slice(0, eq).toLowerCase()], val = s.slice(eq + 1);
            if (key && val) { set[key] = val; n++; }
        }
        var cover = p.cover ? await sourceCover() : null;
        if (!n && !cover) return { blob: blob, n: 0, cover: 0 };
        if (!(await ensureTagWriter())) return { blob: blob, n: 0, cover: 0 };
        var out = await window.AudioTag.edit(blob, { set: set, cover: cover || null });
        return (out && out.size) ? { blob: out, n: n, cover: cover ? 1 : 0 } : { blob: blob, n: 0, cover: 0 };
    }

    /* ── Прогресс: один бар на оба этапа ─────────────────────────────────
       Пока ffmpeg пишет PCM, его события сжимаются в первую половину шкалы,
       кодирование lamejs даёт вторую. Без этого бар доходит до 100 % на PCM и
       стоит там, пока идёт кодирование, — а на старой машине это десятки
       секунд, и `__withStallGuard` слушает те же события. */
    function adopt(inst) {
        try {
            if (!inst || inst.__mp3LaneAdopted) return;
            var on = inst.on, off = inst.off, subs = [];
            if (typeof on !== 'function' || typeof off !== 'function') return;
            inst.__mp3LaneAdopted = true;
            inst.on = function (type, cb) {
                if (type === 'progress' && typeof cb === 'function') {
                    var px = function (ev) {
                        var s = inst.__progressScale;
                        if (s && ev) ev = { progress: typeof ev.progress === 'number' ? s.add + ev.progress * s.mul : ev.progress, time: typeof ev.time === 'number' ? ev.time * s.mul : ev.time };
                        return cb(ev);
                    };
                    subs.push({ cb: cb, px: px });
                    return on.call(inst, type, px);
                }
                return on.apply(inst, arguments);
            };
            inst.off = function (type, cb) {
                if (type === 'progress') {
                    for (var i = 0; i < subs.length; i++) if (subs[i].cb === cb) { var px = subs[i].px; subs.splice(i, 1); return off.call(inst, type, px); }
                }
                return off.apply(inst, arguments);
            };
            inst.__progressEmit = function (ev) { for (var i = 0; i < subs.length; i++) { try { subs[i].cb(ev); } catch (_) {} } };
        } catch (_) {}
    }
    function tick(inst, frac) {
        try { if (inst.__progressEmit) inst.__progressEmit({ progress: 0.5 + 0.5 * Math.max(0, Math.min(1, frac)) }); } catch (_) {}
        try { window._ffTick && window._ffTick(); } catch (_) {}
        try { window.__ffLiveTick && window.__ffLiveTick(); } catch (_) {}
    }

    /* ── «exec в полёте»: смерть страницы посреди работы движка ───────────
       Убитый рендерер не шлёт ничего, поэтому запись о начатом exec лежит в
       localStorage и снимается на его конце; `pagehide` помечает уход (это не
       смерть). Запись, найденная СЛЕДУЮЩЕЙ страницей той же вкладки (sid в
       sessionStorage переживает падение рендерера), — это смерть посреди
       exec: событие ffmpeg_exec_died с кодеком, ядром и тулом. Если умер
       libmp3lame, вкладка была видна и это не телефон (там смерть — чаще
       выгрузка по памяти), устройство запоминается, и дальше MP3 кодирует
       lamejs. Записи от прогонов lamejs тоже считаются — так видно, помог ли
       лейн, а не только то, что он включился. */
    var SID = (function () {
        try { var s = sessionStorage.getItem('_tb_ffsid'); if (!s) { s = Math.random().toString(36).slice(2, 10); sessionStorage.setItem('_tb_ffsid', s); } return s; }
        catch (_) { return ''; }
    })();
    var flight = null;
    function flightSave() { try { if (flight) localStorage.setItem(FLIGHT_KEY, JSON.stringify(flight)); } catch (_) {} }
    function flightOpen(info) {
        flight = { t: nowMs(), sid: SID, mp3: info.mp3 ? 1 : 0, lane: info.lane, core: coreNow(), out: info.out || '',
            slug: slugNow(), mob: MOB, hid: (typeof document !== 'undefined' && document.visibilityState === 'hidden') ? 1 : 0 };
        flightSave();
        var mine = flight;
        return function () { if (flight === mine) { flight = null; try { localStorage.removeItem(FLIGHT_KEY); } catch (_) {} } };
    }
    function outExt(argv) { var o = argv && argv[argv.length - 1]; var m = /\.([a-z0-9]{1,5})$/i.exec(String(o || '')); return m ? m[1].toLowerCase() : ''; }
    /** Чистая: запись полёта + текущая вкладка → вердикт (сторож её зовёт). */
    function verdict(r, env) {
        if (!r || !r.t) return null;
        if (r.left || env.now - r.t > FLIGHT_STALE_MS) return { kind: 'drop' };
        if (r.t >= env.origin) return null;          // запись ЭТОЙ страницы
        if (!r.sid || r.sid !== env.sid) return null; // другая вкладка может быть жива
        var learn = r.mp3 === 1 && r.lane === 'ffmpeg' && !r.mob && !r.hid;
        return { kind: 'died', learn: learn };
    }
    /* «Тот же sid» — ещё не «та же вкладка после смерти»: вкладка, открытая ИЗ
       идущей (ссылка в новой вкладке), наследует sessionStorage вместе с SID
       (тот же класс у __runLedger, 25.09.2026). Прод 24.09–01.10: 439 вердиктов
       ffmpeg_exec_died со страницы ДРУГОГО тула, у 210 исходная страница ещё
       работала, а 27 УЧИЛИ устройство «libmp3lame умирает» (MP3 → lamejs);
       обращение #1794 получило два, пока склейка шла. Живая вкладка отвечает за
       свой полёт по BroadcastChannel; занятая — не сразу, поэтому три вопроса за
       ~8 с, и только молчание на всех — смерть. Запись до вердикта не трогаем:
       она чужая, пока владелец жив. */
    var flightChan = null;
    try {
        if (typeof BroadcastChannel === 'function') {
            flightChan = new BroadcastChannel('tb-ff-flight');
            flightChan.addEventListener('message', function (e) {
                var d = e && e.data;
                if (d && d.q === 'alive?' && flight && flight.t === d.t) { try { flightChan.postMessage({ a: 'alive', t: d.t }); } catch (_) {} }
            });
        }
    } catch (_) { flightChan = null; }
    function askFlightAlive(t, cb) {
        if (!flightChan) { cb(false); return; }
        var waits = [600, 2500, 5000], k = 0, done = false;
        var h = function (e) { var d = e && e.data; if (!done && d && d.a === 'alive' && d.t === t) { done = true; flightChan.removeEventListener('message', h); cb(true); } };
        flightChan.addEventListener('message', h);
        (function ask() {
            if (done) return;
            try { flightChan.postMessage({ q: 'alive?', t: t }); } catch (_) {}
            setTimeout(function () {
                if (done) return;
                if (++k < waits.length) ask();
                else { done = true; flightChan.removeEventListener('message', h); cb(false); }
            }, waits[k]);
        })();
    }
    function checkFlight() {
        try {
            if (window.__ffFlightChecked) return;
            window.__ffFlightChecked = true;
            var r = JSON.parse(localStorage.getItem(FLIGHT_KEY) || 'null');
            var origin = (typeof performance !== 'undefined' && performance.timeOrigin) ? performance.timeOrigin : nowMs();
            var v = verdict(r, { now: nowMs(), origin: origin, sid: SID });
            if (!v) return;
            if (v.kind !== 'died') { localStorage.removeItem(FLIGHT_KEY); return; }
            askFlightAlive(r.t, function (alive) {
                if (alive) { report('ffmpeg_exec_alive_clone', { tool: r.slug, age_s: Math.round((nowMs() - r.t) / 1000), mob: r.mob }); return; }
                try {
                    var r2 = JSON.parse(localStorage.getItem(FLIGHT_KEY) || 'null');
                    if (!r2 || r2.t !== r.t) return;          // владелец закрыл свой exec сам — он был жив
                    localStorage.removeItem(FLIGHT_KEY);
                } catch (_) { return; }
                if (v.learn) remember('died');
                report('ffmpeg_exec_died', { mp3: r.mp3, lane: r.lane, core: r.core, out: r.out, tool: r.slug,
                    age_s: Math.round((nowMs() - r.t) / 1000), mob: r.mob, hid: r.hid, learned: v.learn ? 1 : 0 });
            });
        } catch (_) {}
    }
    try {
        document.addEventListener('visibilitychange', function () { if (flight && document.visibilityState === 'hidden' && !flight.hid) { flight.hid = 1; flightSave(); } });
        window.addEventListener('pagehide', function () { if (flight) { flight.left = 1; flightSave(); } });
        setTimeout(checkFlight, 0);
    } catch (_) {}

    /* Длительность входов — из шапки ffmpeg (null-выход, доли секунды). Нужна
       ради одного вопроса: не выйдет ли промежуточный PCM больше WAV_BUDGET. */
    async function probeSeconds(inst, orig, argv, p) {
        var names = {}, logs = [];
        for (var i = 0; i < p.lastIn; i++) if (argv[i] === '-i') names[String(argv[i + 1])] = 1;
        var cb = function (e) { logs.push(String((e && e.message) || '')); };
        try { inst.on('log', cb); } catch (_) { return null; }
        // Проба не двигает полосу: её «прогресс» — доли секунды входа, и
        // обработчик тула прочёл бы следующий настоящий старт как перезапуск.
        inst.__progressScale = { mul: 0, add: 0 };
        try { await orig.apply(inst, [argv.slice(0, p.lastIn + 1).concat(['-t', '0.05', '-f', 'null', '-'])]); }
        catch (_) { } finally { inst.__progressScale = null; try { inst.off('log', cb); } catch (_) {} }
        var best = null, ours = false;
        for (var j = 0; j < logs.length; j++) {
            var inp = /Input #\d+, .* from '([^']*)'/.exec(logs[j]);
            if (inp) { ours = !!names[inp[1]]; continue; }
            var m = ours && /Duration:\s*(\d+):(\d+):(\d+(?:\.\d+)?)/.exec(logs[j]);
            if (m) { var s = (+m[1]) * 3600 + (+m[2]) * 60 + (+m[3]); if (best === null || s > best) best = s; }
        }
        if (best !== null && p.t !== null) best = Math.min(best, p.t);
        return best;
    }
    /* Промежуточный PCM лежит в MEMFS целиком (ffmpeg пишет сегменты все разом),
       поэтому потолок — от памяти устройства: 48 МБ на гигабайт, не выше
       WAV_BUDGET. 4 ГБ → 192 МБ ≈ 17 мин стерео 48 кГц — песни и записи этой
       когорты (Windows 7/8.1, 2–4 ГБ) помещаются, час — нет и идёт в
       libmp3lame, как раньше. Выученное устройство могло умереть и от памяти:
       удваивать ему нагрузку ради лейна нельзя. */
    function budget() {
        var dm = +(navigator.deviceMemory || 0);
        return dm > 0 ? Math.min(WAV_BUDGET, dm * 48 * 1048576) : WAV_BUDGET;
    }
    function optValue(argv, p, name) {
        var v = null;
        for (var i = p.lastIn + 1; i < argv.length - 1; i++) if (argv[i] === name) v = argv[i + 1];
        return v;
    }
    async function listSegs(inst, stem) {
        var d = await inst.listDir('/');
        return d.filter(function (x) { return !x.isDir && x.name.indexOf(stem) === 0; }).map(function (x) { return x.name; }).sort();
    }
    async function dropSegs(inst, files) {
        for (var i = 0; i < files.length; i++) { try { await inst.deleteFile(files[i]); } catch (_) {} }
    }

    /* Сам лейн. Ответ: {rc} — ffmpeg отработал (0 = MP3 лёг на место выхода,
       иначе его собственная ошибка, та же, что дала бы исходная команда);
       {err} — бросил сам движок; null — осечка НАШЕЙ механики, вызывающий
       выполняет исходную команду (libmp3lame), как до этого правила. */
    async function runLane(inst, orig, args, p, why, paid) {
        var argv = args[0], rest = Array.prototype.slice.call(args, 1), stage = 'load', files = [], enc = null;
        var stem = '__mp3lane_' + (++seq) + '_';
        var t0 = nowMs(), close = null;
        var runFf = async function (a) {
            try { return { rc: await orig.apply(inst, [a].concat(rest)) }; }
            catch (e) { return { err: e }; }
        };
        try {
            if (!(await ensureEncoder())) { report('mp3_lane_failed', { stage: stage, why: why, tool: slugNow() }); return null; }
            stage = 'budget';
            var ch = parseInt(optValue(argv, p, '-ac'), 10) || 2, ar = parseInt(optValue(argv, p, '-ar'), 10) || 48000;
            var sec = await probeSeconds(inst, orig, argv, p);
            if (sec !== null && sec * Math.min(ch, 2) * ar * 2 > budget()) {
                report('mp3_lane_skip', { why: 'long', min: Math.round(sec / 60), dm: navigator.deviceMemory || 0, tool: slugNow() });
                return null;
            }
            close = flightOpen({ mp3: true, lane: 'lame', out: 'mp3' });
            stage = 'wav';
            inst.__progressScale = { mul: 0.5, add: 0 };
            var r1;
            try { r1 = await runFf(rewrite(argv, p, null, stem)); } finally { inst.__progressScale = null; }
            /* Исключение движка (отмена, terminate) — ответ вызывающему как есть:
               повторять работу после отмены нельзя. Ненулевой код — исходная
               команда: её ошибка и есть «родной» ответ тула (битый вход упадёт
               и там, и человек увидит привычный текст). */
            if (r1.err) return r1;
            if (r1.rc !== 0) { files = await listSegs(inst, stem).catch(function () { return []; }); report('mp3_lane_failed', { stage: 'wav_rc', rc: r1.rc, why: why, tool: slugNow() }); return null; }
            var tWav = nowMs();
            files = await listSegs(inst, stem);
            if (!files.length) { report('mp3_lane_failed', { stage: 'wav_empty', why: why, tool: slugNow() }); return null; }
            stage = 'read';
            var first = await inst.readFile(files[0]), w = parseWav(first), rerun = 0;
            if (w.bits !== 16 || !(w.channels >= 1)) { report('mp3_lane_failed', { stage: 'fmt', bits: w.bits, ch: w.channels, why: why, tool: slugNow() }); return null; }
            var extra = [];
            if (LAME_RATES.indexOf(w.sampleRate) === -1) extra.push('-ar', String(nearestRate(w.sampleRate)));
            if (w.channels > 2) extra.push('-ac', '2');
            if (extra.length) {
                rerun = 1;
                await dropSegs(inst, files);
                stem = '__mp3lane_' + (++seq) + '_';
                inst.__progressScale = { mul: 0.5, add: 0 };
                var r2;
                try { r2 = await runFf(rewrite(argv, p, extra, stem)); } finally { inst.__progressScale = null; }
                if (r2.err) return r2;
                if (r2.rc !== 0) { files = await listSegs(inst, stem).catch(function () { return []; }); report('mp3_lane_failed', { stage: 'wav_rc', rc: r2.rc, why: why, tool: slugNow() }); return null; }
                files = await listSegs(inst, stem);
                if (!files.length) { report('mp3_lane_failed', { stage: 'wav_empty', why: why, tool: slugNow() }); return null; }
                first = await inst.readFile(files[0]);
                w = parseWav(first);
            }
            stage = 'encode';
            enc = await window.MP3Encoder.encodeStream({ sampleRate: w.sampleRate, channels: w.channels, bitrate: p.kbps, slug: slugNow(), paid: paid });
            var frames = 0, chn = w.channels;
            for (var s = 0; s < files.length; s++) {
                /* Экземпляр погашен (отмена, сброс по ловушке) — работа кончилась
                   у вызывающего; дальше кодировать нечего и некуда писать. */
                if (inst.loaded === false) { var te = new Error('FFmpeg instance terminated'); te.__term = true; throw te; }
                var bytes = s === 0 ? first : await inst.readFile(files[s]);
                var ws = s === 0 ? w : parseWav(bytes);
                try { await inst.deleteFile(files[s]); } catch (_) {}
                var segFrames = Math.floor(ws.length / (2 * chn));
                var aligned = ((bytes.byteOffset + ws.offset) % 2) === 0;
                var pcm = aligned ? new Int16Array(bytes.buffer, bytes.byteOffset + ws.offset, segFrames * chn) : null;
                var dv = aligned ? null : new DataView(bytes.buffer, bytes.byteOffset + ws.offset, segFrames * chn * 2);
                for (var f0 = 0; f0 < segFrames; f0 += CHUNK) {
                    var nf = Math.min(CHUNK, segFrames - f0), bufs = [], c, j;
                    for (c = 0; c < chn; c++) bufs.push(new Float32Array(nf));
                    for (j = 0; j < nf; j++) {
                        for (c = 0; c < chn; c++) {
                            var idx = (f0 + j) * chn + c;
                            bufs[c][j] = (pcm ? pcm[idx] : dv.getInt16(idx * 2, true)) / 32768;
                        }
                    }
                    await enc.feed(bufs);
                    frames += nf;
                    tick(inst, (s + (f0 + nf) / Math.max(1, segFrames)) / files.length);
                }
                first = bytes = pcm = dv = null;
            }
            files = [];
            var fin = await enc.finish();
            var blob = fin && fin.blob;
            if (!blob || !blob.size) throw new Error('empty mp3');
            stage = 'tags';
            var tagged = { blob: blob, n: 0, cover: 0 };
            try { tagged = await applyTags(blob, p); } catch (_) { }
            stage = 'write';
            await inst.writeFile(p.out, new Uint8Array(await tagged.blob.arrayBuffer()));
            report('mp3_lane', { why: why, tool: slugNow(), kbps: p.kbps, sr: w.sampleRate, ch: chn,
                sec: Math.round(frames / w.sampleRate), wav_ms: tWav - t0, enc_ms: nowMs() - tWav,
                kb: Math.round(tagged.blob.size / 1024), segs: s, rerun: rerun, tags: tagged.n, cover: tagged.cover, paid: paid ? 1 : 0 });
            return { rc: 0 };
        } catch (e) {
            try { if (enc && !enc.isAborted()) enc.abort(); } catch (_) {}
            if (e && e.__term) return { err: e };
            report('mp3_lane_failed', { stage: stage, why: why, tool: slugNow(), err: String((e && e.message) || e).slice(0, 120) });
            return null;
        } finally {
            inst.__progressScale = null;
            if (files.length && inst.loaded !== false) await dropSegs(inst, files);
            if (close) close();
        }
    }

    /** Граница exec: сюда приходит КАЖДЫЙ вызов ffmpeg главного экземпляра. */
    async function exec(inst, orig, args, paid) {
        var argv = args[0], p = null, why = null;
        try { p = plan(argv); if (p) why = decide(); } catch (_) { p = null; why = null; }
        if (p && why) {
            var done = await runLane(inst, orig, args, p, why, paid);
            if (done) { if (done.err) throw done.err; return done.rc; }
        }
        var close = flightOpen({ mp3: !!p, lane: 'ffmpeg', out: outExt(argv) });
        try { return await orig.apply(inst, args); } finally { close(); }
    }

    return {
        decide: decide, plan: plan, rewrite: rewrite, parseWav: parseWav, apicFrom: apicFrom,
        verdict: verdict, exec: exec, adopt: adopt, budget: budget,
        LEGACY_CHROMIUM_MAX: LEGACY_CHROMIUM_MAX, WAV_BUDGET: WAV_BUDGET, SEG_S: SEG_S,
        LEARN_KEY: LEARN_KEY, FLIGHT_KEY: FLIGHT_KEY
    };
})();
/* ── /FFmpegMp3Lane ── */

/* ═══════ FFmpegCoreArm — which FFmpeg core THIS device gets ═══════
 *
 * The MP3 lane above cut the renderer crashes of the legacy-Chromium cohort
 * (Windows + Chromium ≤ 128: Yandex 24.10, Chrome/Edge 109) from 12–16 % of
 * ffmpeg inits (22–23.09.2026) to 2.6 % (24.09) — but not to zero, and the
 * crashes that stayed are NOT MP3: on /voice-enhancer the same cohort died in
 * 8 of 22 inits over 30 days (4 machines; complaint #7641 — four attempts in
 * seven minutes), each one 1–2 s after the `channel_export … fmt=source`
 * beacon, i.e. inside the polish+encode exec (EQ / acompressor / two-pass
 * loudnorm / alimiter → AAC), with no libmp3lame anywhere in it. What that
 * exec shares with libmp3lame is heavy wasm SIMD (FFT-bound filters).
 *
 * The crash does not reproduce on Chrome for Testing 128 on this machine
 * (memory reference_libmp3lame_kills_the_tab_on_windows7_browsers_2026_09_24),
 * so the hypothesis «the cohort's V8 mis-runs wasm SIMD» can only be tested in
 * the field: half of the cohort's devices (a coin stored once per device)
 * load the no-SIMD build of the SAME @ffmpeg/core 0.12.10, the other half
 * keep the SIMD core; devices that already died mid-exec (the MP3 lane's
 * `learned`) get the no-SIMD core outright. Price measured 25.09 on a real
 * /voice-enhancer export (20 s, podcast preset): 14.4 → 21.7 s mono,
 * 20.7 → 19.2 s stereo — inside the noise, the neural stage dominates.
 * Verdict: `ffmpeg_exec_died{mp3:0}` per `ffmpeg-init` beacon by `src`
 * (`nosimd-st` vs `local`) on the cohort; `nosimd_engine_active{why}` names
 * the arm. Modern browsers are never touched.
 * Guards: tests/js/ffmpeg-core-arm.test.mjs,
 * tests/playwright/legacy-chromium-core-arm.mjs.
 */
window.FFmpegCoreArm = (function () {
    'use strict';
    var KEY = '_tb_ff_core_arm';
    function seedArm(store) {
        try {
            var v = store.getItem(KEY);
            if (v === 'nosimd' || v === 'simd') return v;
            v = Math.random() < 0.5 ? 'nosimd' : 'simd';
            store.setItem(KEY, v);
            return v;
        } catch (_) { return 'simd'; }
    }
    /** {core:'simd'|'nosimd', why} — why: null (not in the cohort) | 'forced' | 'learned' | 'legacy_ab'. */
    function pick(env) {
        env = env || {};
        var force = ('force' in env) ? env.force : window.__FF_CORE_FORCE;
        if (force === 'nosimd' || force === 'simd') return { core: force, why: 'forced' };
        var cohort = null;
        try { cohort = (window.FFmpegMp3Lane && window.FFmpegMp3Lane.decide) ? window.FFmpegMp3Lane.decide(env.mp3 || {}) : null; }
        catch (_) { cohort = null; }
        if (!cohort || cohort === 'forced') return { core: 'simd', why: null };
        if (cohort === 'learned') return { core: 'nosimd', why: 'learned' };
        return { core: seedArm(('store' in env) ? env.store : localStorage), why: 'legacy_ab' };
    }
    return { pick: pick, KEY: KEY };
})();
/* ── /FFmpegCoreArm ── */

/* Shared FFmpeg stderr extractor — used by every exec() path. The naive
   .slice(-8) of stderr was dominated by encoder stats ([libx264 @ ...] i16,
   [aac @ ...] Qavg, '2 frames left in the queue on closing'), which pushed
   the actual error message ('Conversion failed!', 'Invalid argument',
   'No such file', etc.) past the 400-char truncation. Two-step filter:
     1. drop encoder/muxer noise lines
     2. prefer lines with error keywords; fall back to last 6 cleaned lines */
/* Best-effort string extractor for "errors with no message". WebAssembly
   compile failures, Worker spawn rejections inside FFmpeg.js, and the
   Promise.race timeout vs e.terminate() cross-fire all routinely arrive
   with err.message === "". Without this, telemetry showed 3358 empty-err
   wasm_init_attempt:fail rows in 24 h — the cascade was visible but the
   underlying signal was hidden. Walks message → name → code → cause →
   stack head → toString, filtering noise from each. */
window.__ffErrText=function(err){
    if(err==null)return"null";
    var bits=[];
    if(typeof err==='string'){bits.push(err)}
    else{
        if(err.message)bits.push(String(err.message));
        if(err.name && err.name!=='Error' && err.name!=='TypeError')bits.push(err.name);
        if(err.code!=null)bits.push('code='+err.code);
        if(err.cause){
            var cm=(err.cause&&(err.cause.message||err.cause.name||String(err.cause)))||'';
            if(cm)bits.push('cause='+cm);
        }
        if(!bits.length){
            // Last resorts: stringify directly, then a stack-head probe for
            // the "DOMException: " or "RuntimeError: " prefix browsers
            // sometimes put in the stack but not in message.
            var s=String(err);
            if(s && s!=='[object Object]')bits.push(s);
            if(err.stack){
                var firstLine=String(err.stack).split('\n',1)[0];
                if(firstLine && firstLine!==s)bits.push(firstLine);
            }
        }
    }
    var out=bits.join(' | ').replace(/\s+/g,' ').trim();
    return out||'<empty>';
};
/* How long a wasm INSTANTIATE may take before it is called hung — a function of
   the lane, the attempt and THIS MACHINE'S OWN RECORD, not a constant.

   Until 2026-09-19 it was 60 s for every lane and 120 s for the direct fallback,
   calibrated on modern CPUs — while the no-SIMD lane exists precisely for CPUs
   without SSE4.1 (Core 2 era). Report #7390 (Windows 7, Firefox 115, 2 cores,
   Premium bought an hour earlier): the engine really comes up in 91–115 s there,
   so the 60-second watchdog killed it twice on every tool, the direct fallback
   finished it with 5 s to spare, and the page said «check your internet
   connection» to a man whose bytes had all arrived — 4–5 minutes per tool, six
   tools in one evening, 15 of the fleet's 18 "Instantiate timeout" rows in 14 days.

   - the no-SIMD lane starts from 150 s (its known hang class — a COEP-blocked
     worker inside an isolated page — cannot occur there: no SAB, no isolation);
   - a retry gets MORE time than the attempt that timed out: repeating the same
     deadline on the same machine is a retry that cannot succeed;
   - a success slower than 20 s is remembered, and the next page allows 2.5x that
     (capped at 10 min) — after one slow start the first attempt is the last. */
window.__ffInstBudget=function(lane,attempt){
    var base=lane==="nosimd-st"?150000:lane==="direct"?(window.__nosimdMode===1?300000:120000):60000;
    var n=Math.max(1,Math.min(3,attempt|0));
    var ms=base*n;
    var seen=0;
    try{seen=parseInt(localStorage.getItem("ff_inst_ms")||"0",10)||0}catch(_){}
    if(seen>0)ms=Math.max(ms,Math.round(seen*2.5));
    return Math.min(600000,ms);
};
window.__ffInstSeen=function(ms){
    try{
        ms=Math.round(ms);
        if(ms>=20000)localStorage.setItem("ff_inst_ms",String(ms));
        else localStorage.removeItem("ff_inst_ms");
    }catch(_){}
};
window.__ffErrTail=function(L){
    // Strip `[name,name2 @ 0xHEX]` prefix so the real error text on the same
    // line survives the noise filter. Then drop ffmpeg version preamble +
    // progress + identification metadata k/v. KEEP Input/Output/Stream lines
    // because they identify the actual format detected (e.g. "Input #0,
    // png_pipe, from 'input.mp4'" tells us FFmpeg saw a PNG, not the MP4 the
    // user thought they uploaded). The `ek` keyword regex picks salient lines
    // including stream-identification + error markers.
    var stripPrefix = function(l){
        return (l || '').replace(/^\s*\[[\w,]+\s*@\s*0x[\da-fA-F]+\]\s*/, '');
    };
    var rxNoise=/^\s*(ffmpeg version\b|configuration:|lib(av|sw|post)\w+\s+\d|built with|Press \[q\]|frame=\s*\d|^\s*\d+\s+frames left|size=\s*\d|time=\d|bitrate=|\bDuration:\s|^\s*Side data:|^\s*Metadata:|^\s*encoder\s*:|^\s*handler_name\s*:|^\s*vendor_id\s*:|^\s*creation_time\s*:|^\s*major_brand\s*:|^\s*compatible_brands\s*:|^\s*minor_version\s*:)/i;
    var ek=/(\bError\b|\bfailed\b|\bInvalid\b|\bUnsupported\b|Cannot|Could not|No such|Aborted|out of memory|moov atom|signature mismatch|Conversion failed|Decoder error|Header missing|Permission denied|not permitted|encoder not found|codec not found|Stream specifier|division|truncated|incomplete|premature|protocol not found|disabled at compile time|insufficient memory|Cannot allocate|allocator|unspecified pixel|pixel format|codec parameters|does not contain|Output file|Stream #\d+:\d+:\s*\w+:|Input #\d+,\s+[\w_]+(?:,|\s)|^\s*Stream\s+mapping)/i;
    var clean=(L||[]).map(stripPrefix).filter(function(l){return l && !rxNoise.test(l)});
    var hits=clean.filter(function(l){return ek.test(l)});
    /* Раньше при непустых hits возвращались ТОЛЬКО они — и это теряло соседние
       строки, которые называют виновника. Замер на настоящем отказе concat:
       чистых строк было три («Impossible to open 'nope.mp4'», «l.txt: No such
       file or directory», «Aborted()»), а отдавались две — без той, где стоит
       ИМЯ файла, потому что слова «Impossible» нет в списке ключевых. Список
       ключевых слов — ранжирование, а не цензура: берём хвост чистых строк и
       доклеиваем спереди те попадания, которые в него не вошли. */
    var tail=clean.slice(-8);
    var outside=hits.filter(function(l){return tail.indexOf(l)<0;}).slice(-3);
    var picked=outside.concat(tail);
    return picked.join(" | ").substring(0,1500);
};
!function(){"use strict";var e=null,t=null,r=!1,o=!1,n=!1,_initPromise=null,i=function(){
/* Content-addressed `?v=<sha8>` query strings for the local pair. The hashes
   are emitted server-side in app.blade.php from AssetRouter::vendorHash().
   Any byte change to ffmpeg-core.{js,wasm} on origin rotates the hash → URL
   changes → every cache layer (browser, SW CacheFirst, caches.open()) misses
   → fresh fetch. Eliminates the manual SW-cacheName bump dance we used to
   do every time vendor binaries rev'd. CDN fallbacks are version-pinned by
   `@0.12.10` already, so they don't need a content hash on top.

   Defensive: if __VENDOR_HASHES is missing (unexpected race, or a non-tool
   page that somehow loaded this script), fall back to unhashed URLs. They
   still work — they just won't auto-invalidate on file rev. */
var _vh=(window.__VENDOR_HASHES||{});var _q=function(k){return _vh[k]?"?v="+_vh[k]:"";}
var _s={core:"/vendor/ffmpeg/ffmpeg-core.js"+_q('ffmpegCoreJs'),wasm:"/vendor/ffmpeg/ffmpeg-core.wasm"+_q('ffmpegCoreWasm')},_jp={core:"/cdn/jsdelivr/npm/@ffmpeg/core@0.12.10/dist/umd/ffmpeg-core.js",wasm:"/cdn/jsdelivr/npm/@ffmpeg/core@0.12.10/dist/umd/ffmpeg-core.wasm"},_up={core:"/cdn/unpkg/@ffmpeg/core@0.12.10/dist/umd/ffmpeg-core.js",wasm:"/cdn/unpkg/@ffmpeg/core@0.12.10/dist/umd/ffmpeg-core.wasm"},_j={core:"https://cdn.jsdelivr.net/npm/@ffmpeg/core@0.12.10/dist/umd/ffmpeg-core.js",wasm:"https://cdn.jsdelivr.net/npm/@ffmpeg/core@0.12.10/dist/umd/ffmpeg-core.wasm"},_u={core:"https://unpkg.com/@ffmpeg/core@0.12.10/dist/umd/ffmpeg-core.js",wasm:"https://unpkg.com/@ffmpeg/core@0.12.10/dist/umd/ffmpeg-core.wasm"};/* Multi-threaded core, first in line ONLY when the page is cross-origin
   isolated AND the tool opted in (config/coep_test.php `mt_tools`, published
   as window.__FFMPEG_MT_OK) — it is a SECOND ~33 MB wasm, so a tool that
   would not use it must not download it.

   Measured 2026-08-19 on Yandex Browser 26.6 with the hardware H.264 encoder
   disabled — the exact condition of bug #5264. The honest figure comes from
   running BOTH lanes alternately inside ONE page, because this machine drifts
   by 2x between runs (41 / 73 / 60 s for one identical job), so lanes timed
   minutes apart are not comparable: 60 s of 720p gave 65.8 / 63.6 s
   single-threaded against 11.8 / 14.6 s multi-threaded, same output size.
   A separate 1080p bench gave 132-157 s against 14-20 s; both are real, the
   ratio is what travels. Output verified as a real ftypisom MP4 that decodes
   back, never on exit code alone.

   Without isolation the MT core cannot even instantiate, so it is not in the
   list at all — the existing ladder stays exactly as it was for everyone. */
var _mt={core:"/vendor/ffmpeg-mt/ffmpeg-core.js"+_q('ffmpegMtCoreJs'),wasm:"/vendor/ffmpeg-mt/ffmpeg-core.wasm"+_q('ffmpegMtCoreWasm'),/* pthread worker via the COEP-carrying route, not static — with the same
   version query as the core it belongs to. The route ignores the query, but
   the BROWSER keys its cache on it, and without that the worker (stable URL,
   1 h) could serve a version older than the core (?v=hash, busts instantly)
   for up to an hour after a bump. Same coupling the ffmpeg JS/WASM pair has
   carried since the 2026-05-21 apply-undefined storm. */worker:"/workers/ffmpeg-mt-core-worker"+_q('ffmpegMtWorkerJs'),mt:1};
/* ONE predicate, published for the source LABELS below to reuse: when these
   two disagree the telemetry names a source that was never tried. */
/* The multithreaded core reserves its shared memory up front, and on a small machine that
   reservation is the one allocation that fails: measured on prod, 30 days to 09.09.2026,
   slideshow-maker — every local-mt success was on 8 or 16 GB, every failure was
   «WebAssembly.Memory(): could not allocate memory» on 4 GB (user 6673: two doomed attempts
   right at the memory-critical moment, then the single-threaded core loaded fine). Below
   8 GB the MT lane is skipped, not retried. */
var _iso=false;try{_iso=!!(window.crossOriginIsolated&&typeof SharedArrayBuffer!=='undefined'&&window.__FFMPEG_MT_OK&&((navigator.deviceMemory||8)>=8))}catch(_){}
window.__ffmpegMtLane=_iso;
/* No WebAssembly SIMD on this CPU → the ladder is ONE source: our own build of the SAME
   @ffmpeg/core 0.12.10 without -msimd128 (recipe: public/vendor/ffmpeg/download.sh). No CDN
   publishes such a build, so there is nothing to fall back to but our two origins. Decided
   here, at load time, from the same probe init() consults, so `i` and _srcNames agree; the
   source is also published for init() in case the probe was stubbed after load (tests). */
var _ns={core:"/vendor/ffmpeg-nosimd/ffmpeg-core.js"+_q('ffmpegNosimdCoreJs'),wasm:"/vendor/ffmpeg-nosimd/ffmpeg-core.wasm"+_q('ffmpegNosimdCoreWasm')};
window.__ffmpegNoSimdSrc=_ns;
var _cpuNoSimd=false;try{_cpuNoSimd=typeof window.__hasWasmSIMD==='function'&&!window.__hasWasmSIMD()}catch(_){}
/* The legacy-Chromium cohort may get the no-SIMD core on a SIMD-capable CPU — see FFmpegCoreArm above. */
var _arm=null;try{_arm=window.FFmpegCoreArm?window.FFmpegCoreArm.pick():null}catch(_){_arm=null}
window.__ffmpegCoreArm=_arm;
var _noSimd=_cpuNoSimd||!!(_arm&&_arm.core==='nosimd');
window.__ffmpegNoSimdWhy=_cpuNoSimd?'no_simd':(_noSimd?_arm.why:null);
window.__ffmpegNoSimdLane=_noSimd;
try{return _noSimd?[_ns]:(_iso?[_mt,_s,_jp,_up,_j,_u]:[_s,_jp,_up,_j,_u])}catch(e){return _noSimd?[_ns]:[_jp,_up,_j,_u,_s]}}(),a=window.__FFMPEG_CONFIG__||{},s=a.codecs||{},c=a.mimeTypes||{},p=a.browserFormats||[],f=a.extMap||{},l=a.lossless||[],q=a.qualityMap||{};/* Single source of truth for file bytes: FileBytes (file-buffer-cache.js) owns the
   LRU-bounded 1 GB cache across the whole app. The classic fallback stays only for
   pathological load-order failures where file-buffer-cache.js didn't execute. */
function _isFileLostErr(x){var msg=((x&&x.message)||"").toLowerCase();if(x instanceof DOMException&&x.name==='NotFoundError')return true;return msg.indexOf("not be found")!==-1||msg.indexOf("not found")!==-1||msg.indexOf("could not be read")!==-1||msg.indexOf("not allowed")!==-1||msg.indexOf("security")!==-1}
/* ── Container heal: an MP4 whose esds is not an AudioSpecificConfig ──────
   Report #7211 (15.09.2026, /add-music-to-video, iPhone): a /slideshow-maker
   export made in Safari 26 carried WebKit's AudioEncoder description — the
   AudioToolbox magic cookie, i.e. the whole MPEG-4 descriptor chain — as the
   esds DecoderSpecificInfo. FFmpeg's AAC decoder reads audioObjectType 0 from
   the 0x03 tag and refuses the input («Audio object type 0 is not
   implemented», exit code 1) on every lane that decodes the soundtrack; Apple's
   own decoders play the same file, so the person never saw anything wrong
   until they brought it to us. The door that let those bytes through is
   fixed (public/js/aac-access-unit.js), but the files exist: RU, 12–15.09,
   ~95 WebKit MP4 exports on /slideshow-maker alone, more on every other
   WebCodecs consumer. So every mp4-family INPUT of every lane passes through
   AacAccessUnit.repairMp4 here — moov read (a few hundred KB), and only when
   a DecoderSpecificInfo does not read as an ASC is one written in place (the
   media bytes are referenced, not copied). One door for the bytes path (m())
   and the WORKERFS path (_withMounts / mountInput); fail-open — a heal that
   cannot run returns the input untouched, the decoder then refuses as before.
   Reported once per input as mp4_asc_repaired {src: esds|synth, was, n}. */
var _healSeen={};
function _looksMp4(head){return !!head&&head.length>=12&&head[4]===0x66&&head[5]===0x74&&head[6]===0x79&&head[7]===0x70;}   // 'ftyp'
var _doorLoading=null;
function _ensureAacDoor(){
    if(window.AacAccessUnit&&typeof window.AacAccessUnit.repairMp4==='function')return Promise.resolve(true);
    if(_doorLoading)return _doorLoading;
    _doorLoading=new Promise(function(res){
        try{
            var o=document.createElement("script");
            o.src=(typeof window.__jsSrc==='function')?window.__jsSrc('/js/aac-access-unit.js'):'/js/aac-access-unit.js';
            o.onload=function(){res(!!(window.AacAccessUnit&&window.AacAccessUnit.repairMp4))};
            o.onerror=function(){res(false)};
            document.head.appendChild(o);
        }catch(_){res(false)}
    });
    return _doorLoading;
}
function _reportHeal(key,r,szBytes){
    try{
        if(_healSeen[key])return;_healSeen[key]=1;
        var slugEl=document.querySelector('meta[name="tool-slug"]');
        window.__ae&&window.__ae('feature_use',{f:'mp4_asc_repaired',slug:(slugEl&&slugEl.content)||window.__TOOL_SLUG||null,
            n:r.tracks.length,src:r.tracks[0]&&r.tracks[0].src,was:r.tracks[0]&&r.tracks[0].was,szMB:Math.round((szBytes||0)/1048576)});
    }catch(_){}
}
/* Verdict memo per File OBJECT (WeakMap): segment tools mount the same File for
   every exec, and the moov read is the one non-trivial cost here. Keyed by the
   object, not by name|size|lastModified — a nameless Blob rescued from the
   FileBytes cache would otherwise share the key «|size|0» with every other
   nameless Blob of that size and be handed somebody else's repaired file. */
var _healMemo=(typeof WeakMap==='function')?new WeakMap():null;
async function _healInput(file){
    try{
        if(!(file instanceof Blob)||!(file.size>64))return file;
        var hit=_healMemo&&_healMemo.get(file);
        if(hit)return hit.result||file;
        var head=new Uint8Array(await file.slice(0,12).arrayBuffer());
        if(!_looksMp4(head))return file;
        if(!(await _ensureAacDoor()))return file;
        var r=await window.AacAccessUnit.repairMp4(file);
        if(_healMemo)_healMemo.set(file,{result:(r&&r.changed)?r.result:null});
        if(!r||!r.changed)return file;
        _reportHeal((file.name||'')+'|'+file.size+'|'+(file.lastModified||0),r,file.size);
        return r.result;
    }catch(_){return file}
}
/* The WORKERFS paths live in a later IIFE (the one that owns _withMounts / mountInput)
   and cannot see this scope — the same bridge the file already uses for
   window.__ffErrTail / window._ffLogs. */
window.__ffmpegHealInput=_healInput;
async function _healBytes(bytes,src){
    try{
        if(!(bytes instanceof Uint8Array)||!_looksMp4(bytes))return bytes;
        if(!(await _ensureAacDoor()))return bytes;
        var r=await window.AacAccessUnit.repairMp4(bytes);   // patched in place
        if(r&&r.changed)_reportHeal(src?((src.name||'')+'|'+src.size+'|'+(src.lastModified||0)):('bytes|'+bytes.length),r,bytes.length);
    }catch(_){}
    return bytes;
}
async function m(e){if(e instanceof Uint8Array)return e;if(e instanceof File||e instanceof Blob){if(window.FileBytes&&typeof window.FileBytes.read==='function'){try{return await _healBytes(await window.FileBytes.read(e),e)}catch(x){if(_isFileLostErr(x))throw new DOMException("FILE_LOST: The selected file is no longer accessible. Please re-select your file.","NotFoundError");throw x}}try{return await _healBytes(new Uint8Array(await e.arrayBuffer()),e)}catch(x){if(_isFileLostErr(x))throw new DOMException("FILE_LOST: The selected file is no longer accessible. Please re-select your file.","NotFoundError");throw x}}throw new Error("Unsupported file type")}async function u(){if(!n){function _load(url){return new Promise(function(res,rej){var o=document.createElement("script");o.src=url;o.onload=function(){res(typeof FFmpegWASM!=="undefined")};o.onerror=function(){rej(new Error("load "+url))};document.head.appendChild(o)})}var _vh2=(window.__VENDOR_HASHES||{});/* Isolated pages load the wrapper from /workers/ so its class-worker chunk
   inherits that directory (webpack publicPath = dir of currentScript.src) and
   therefore the COEP header the browser demands of a worker script inside a
   credentialless page. Static /vendor/… carries no such header: measured
   2026-08-19 with the Service Worker blocked, spawning the static chunk gives
   an error event with an EMPTY message (blocked script) while the routed copy
   is alive, and ffmpeg then fails to load AT ALL — not merely slowly. */
var _iso2=false;try{_iso2=!!window.crossOriginIsolated}catch(_){}
var _base=(_iso2?"/workers/ffmpeg.js":"/vendor/ffmpeg/ffmpeg.js")+(_vh2.ffmpegJs?"?v="+_vh2.ffmpegJs:"");try{var ok=await _load(_base);if(!ok)throw new Error("FFmpegWASM not found after load")}catch(_loadErr){try{navigator.sendBeacon("/api/log-error",JSON.stringify([{type:"ffmpeg-wrapper-retry",src:(_loadErr&&_loadErr.message||"").substring(0,120),page:location.pathname,ua:navigator.userAgent.substring(0,200)}]))}catch(_b){}var _cb=_base+(_base.indexOf("?")===-1?"?":"&")+"cb="+Date.now();var ok2=await _load(_cb);if(!ok2)throw new Error("FFmpegWASM not found")}t=FFmpegWASM.FFmpeg,n=!0}}
/* Long-encode census. Every attempt to answer "which tool would the
   multi-threaded core actually help?" ran aground on the same gap: there is no
   uniform record of how long FFmpeg-WASM actually runs, per tool, per tier.
   Each tool stamps its own `lane` field with its own meaning — /trim's
   "ffmpeg" lane is a WAVEFORM DECODE, not an export — so cross-tool ranking
   from those stamps is unsound, which cost this investigation two wrong
   candidates before the field was read closely.

   So: one event per exec that ran longer than 30 s, from the ONE boundary every
   exec passes through. Carries the tool (server-side, from tool_slug), the tier
   (server-side), the duration, and whether the MT core served it — which also
   closes the loop on the tools where it is already enabled. Under 30 s nothing
   is sent: short execs are the overwhelming majority and would drown the table
   without informing any decision. */
var _LONG_EXEC_MS=30000;
/* Overridable so a test can prove the event fires without burning 30 s of CPU;
   production never sets it. */
function _execSeen(args,t0){try{var lim=window.__ffmpegLongExecMs||_LONG_EXEC_MS;var ms=Math.round(performance.now()-t0);if(ms<lim)return;var head="";try{for(var i=0;i<args.length&&head.length<60;i++){var a=String(args[i]);if(a.charAt(0)==="-"||/^(libx264|libvpx|aac|copy)/.test(a))head+=(head?" ":"")+a}}catch(_h){}
if(window.__ae)window.__ae("feature_use",{f:"wasm_exec_long",ms:ms,mt:window.__ffmpegMtActive?1:0,iso:window.crossOriginIsolated?1:0,args:head.substring(0,60)})}catch(_e){}}
/* ── A wasm trap is the END of the instance, not of one call ──────────────
   Measured 2026-09-05 (tests/scratch/ff-trap-poison-scratch.mjs): after ONE
   `RuntimeError: memory access out of bounds` (libvpx-vp9 on any content),
   the very next exec on the same instance — a 1-second lavfi test pattern —
   dies with the identical trap, readFile answers «FS error», and only
   reinit() brings the engine back. Emscripten's heap and libc state are
   undefined after a trap; FFmpeg's own globals are never reset, so every
   later main() inherits the wreck.
   Before this, the poisoned instance simply stayed: /video-colorize kept it
   for 17.5 hours after a segment encode trapped (Firefox 155, 04.09.2026),
   and the user's next attempt died at the FIRST FFmpeg call, 30 s in, on a
   job that could not have run out of memory — the fallback transcode of a
   720×400 clip. Chrome sessions show the same shape: one Android session
   retried five times in a row and got the same trap five times.
   So the trap is handled where every exec passes: the engine is discarded
   on the spot, and the next init() (idempotent in every caller) builds a
   fresh one. The rejection the caller sees is unchanged — the honest one
   from the worker (a STRING, see __ffErrText) — and terminate() is marked
   intentional so its own «called FFmpeg.terminate()» echoes stay in the
   cancel class instead of becoming a second error. */
function _isTrapText(s){return /RuntimeError|out of bounds|memory access|unreachable executed|null function or function signature mismatch|table index is out of bounds/i.test(String(s||''))}
window.__ffIsTrap=function(err){var t=err&&err.message?err.message:String(err||'');return _isTrapText(t)};
function _trapReset(err,args){try{var txt=err&&err.message?err.message:String(err||'');if(!_isTrapText(txt))return;var inst=e;if(!inst)return;window.__ffmpegIntentionalTerminateAt=Date.now();e=null;r=!1;o=!1;try{inst.terminate()}catch(_){}
var head="";try{for(var i=0;i<(args||[]).length&&head.length<60;i++){var a=String(args[i]);if(a.charAt(0)==="-"||/^(libx264|libvpx|aac|copy)/.test(a))head+=(head?" ":"")+a}}catch(_h){}
try{window.__ae&&window.__ae("feature_use",{f:"wasm_trap_reset",msg:String(txt).substring(0,120),args:head.substring(0,60),n:inst.__execN||0,glue:window.__ffGlueSp||""})}catch(_a){}
console.warn("[ffmpeg] wasm trap — engine discarded, the next init() builds a fresh one:",txt)}catch(_){}}
/* Say "work happened" to whatever is watching for silence. The stall guard
   (telemetry-tier0.js __withStallGuard) listens for `stall-tick` exactly so a
   phase that produces no ffmpeg progress can still prove it is alive.

   ⚠️ On `window`, not a bare `function`, because this file is SIX sibling
   IIFEs: a helper declared here is invisible from the lane bodies below
   (processStreaming lives in the IIFE that opens at "the streaming lanes").
   It shipped as a bare declaration on 2026-08-31 and every streamed run —
   audio >10 MB, video >8 MB — died with "_liveTick is not defined" AFTER a
   successful encode. Same convention as __ffErrText / __ffErrTail above.
   Guarded by tests/playwright/js-scope-leak.mjs (static) and
   ffmpeg-lane-bodies-run.mjs (runtime). */
window.__ffLiveTick=function(){try{window.dispatchEvent(new CustomEvent('stall-tick'))}catch(_){}};
var CACHE_NAME='ffmpeg-wasm-v3';
/* Stream a URL with a stall-timeout: we abort only if NO bytes have arrived
   for `stallMs` milliseconds. A slow-but-alive connection (e.g. 1-2 Mbps
   downloading a 31 MB WASM) keeps going instead of hitting a wall-clock
   cutoff that was shorter than the download time. Reports bytes via onByte
   so the UI can show a real percentage. */
/* ── engine load: every phase is bounded and cancellable (2026-09-17) ──────
   Report #16.09 (Edge 153, 2 cores / 4 GB): the FFmpeg lane of the export sat in
   `wasm_load` for 73 minutes — no `wasm_ready`, no `wasm_load_failed`, six
   clicks on Cancel changed nothing. The body stream has had a 15-s no-bytes
   stall guard for months; the phases BEFORE the body — caches.open / match,
   the fetch header wait, the wrapper <script> — had none, and the field shows
   them wedging: single attempts of 982 s, 327 s and 4139 s ending in «Failed
   to fetch» (RU, 14 d: 82 sessions alive 5+ min after wasm_load with no
   outcome). A wedge is not a slow link: bytes reset the clock, silence trips
   it. `document.hidden` re-anchors like __withStallGuard does — a background
   throttled timer of a background tab must not read a slow download as silence.
   The message carries the phase and byte count so telemetry can name the
   wedged subsystem next time instead of guessing (`wasm_init_attempt.err`). */
var ENGINE_IDLE_MS=30000;      /* silence, never duration */
/* One attempt = one telemetry row AND one DOM event. The cascade watcher in
   wasm-health.js listens to the event: hooking window.__ae was a race it lost
   (see the note there). */
function _attemptEvent(p){try{window.dispatchEvent(new CustomEvent('wasm-init-attempt',{detail:p}))}catch(_){}if(window.__ae)try{window.__ae('wasm_init_attempt',p)}catch(_){}}
var ENGINE_WRAPPER_MS=45000;   /* <script> has no progress: total bound, two attempts inside u() */
function _engineLiveness(idleMs){
    var ac=null;try{if(typeof AbortController!=='undefined')ac=new AbortController()}catch(_){}
    var last=Date.now(),phase='cache-lookup',bytes=0,stopped=false,rej=null;
    var p=new Promise(function(_,r){rej=r});p.catch(function(){});
    function onStatus(ev){var d=(ev&&ev.detail)||{};last=Date.now();if(d.phase)phase=d.phase;if(typeof d.bytes==='number')bytes=d.bytes}
    function onTick(){last=Date.now()}
    function onVis(){if(!document.hidden)last=Date.now()}
    window.addEventListener('ffmpeg-status',onStatus);window.addEventListener('stall-tick',onTick);document.addEventListener('visibilitychange',onVis);
    function stop(){if(stopped)return;stopped=true;clearInterval(iv);window.removeEventListener('ffmpeg-status',onStatus);window.removeEventListener('stall-tick',onTick);document.removeEventListener('visibilitychange',onVis)}
    var iv=setInterval(function(){
        if(stopped)return;
        if(document.hidden){last=Date.now();return}
        var idle=Date.now()-last;
        if(idle>idleMs){
            var e=new Error('Engine load timeout: no progress for '+Math.round(idle/1000)+'s (phase='+phase+', bytes='+bytes+', sw='+((navigator.serviceWorker&&navigator.serviceWorker.controller)?1:0)+')');
            e.code='ENGINE_LOAD_TIMEOUT';e.phase=phase;
            stop();try{ac&&ac.abort()}catch(_){}rej(e);
        }
    },1000);
    return {signal:ac?ac.signal:null,stop:stop,race:function(pr){return Promise.race([pr,p])}};
}
/* The person's sentence for «the engine could not be loaded» — one copy for both ends of
   _doInit: INIT_FAILED (every source failed) and INIT_ERROR (failed before the loop: the
   wrapper <script> never answered, FFmpegWASM missing). */
function _engineLoadMessage(){var _im={en:"Failed to load the processing engine. Check your internet connection and reload the page.",ru:"Не удалось загрузить движок обработки. Проверьте подключение к интернету и перезагрузите страницу.",ko:"처리 엔진 로드 실패. 인터넷 확인 또는 Chrome 사용.",ar:"تعذر تحميل المحرك. تحقق من الاتصال.",id:"Gagal memuat mesin. Periksa koneksi atau coba Chrome.",pt:"Falha ao carregar. Verifique a conexão ou tente o Chrome.",de:"Verarbeitungs-Engine konnte nicht geladen werden. Prüfen Sie die Verbindung und laden Sie die Seite neu.",es:"No se pudo cargar el motor de procesamiento. Comprueba la conexión y recarga la página.",fr:"Impossible de charger le moteur de traitement. Vérifiez la connexion et rechargez la page.", uk: "Не вдалося завантажити обробник. Перевірте підключення до інтернету й перезавантажте сторінку.", tr: "İşleme motoru yüklenemedi. İnternet bağlantınızı kontrol edip sayfayı yeniden yükleyin."};return _im[window.__LOCALE]||"Could not load processing engine. Check your internet connection and reload the page."}
/* A promise that must settle within `ms` — for waits that publish no progress
   at all (a <script> tag). Not for downloads: those are judged by silence. */
function _withDeadline(pr,ms,label){
    var t=null;var d=new Promise(function(_,rej){t=setTimeout(function(){var e=new Error('Engine load timeout: '+label+' did not answer in '+Math.round(ms/1000)+'s (sw='+((navigator.serviceWorker&&navigator.serviceWorker.controller)?1:0)+')');e.code='ENGINE_LOAD_TIMEOUT';e.phase=label;rej(e)},ms)});
    return Promise.race([pr,d]).finally(function(){clearTimeout(t)});
}
/* init(n,{signal}) — the CALLER detaches on abort. The shared init keeps
   going (another caller, or the warmer, may still want the engine); this
   await of this caller rejects with AbortError at once, which is what lets a Cancel
   button end an export that is waiting on the engine. Before this the abort() of the export
   abort() reached FFmpegProcessor.cancel(), which nulls an instance that does
   not exist yet during a download, and the pending await never noticed. */
function _initWithSignal(pr,opts){
    var sig=opts&&opts.signal;
    if(!sig)return pr;
    function abortErr(){try{return new DOMException('Aborted','AbortError')}catch(_){var e=new Error('Aborted');e.name='AbortError';return e}}
    if(sig.aborted)return Promise.reject(abortErr());
    return new Promise(function(res,rej){
        var onAbort=function(){rej(abortErr())};
        try{sig.addEventListener('abort',onAbort,{once:true})}catch(_){}
        pr.then(function(v){try{sig.removeEventListener('abort',onAbort)}catch(_){}res(v)},function(e){try{sig.removeEventListener('abort',onAbort)}catch(_){}rej(e)});
    });
}
async function fetchStream(url,onByte,stallMs,extSignal){
    stallMs=stallMs||15000;
    /* Chunks arriving IS the engine being alive — see the _emit note above. A
       phase-only heartbeat leaves a single multi-minute download as one silent
       span, which is exactly the case a slow connection produces. */
    var _obOrig=onByte;
    onByte=function(){try{window.dispatchEvent(new CustomEvent('stall-tick'))}catch(_){}
        if(_obOrig)return _obOrig.apply(this,arguments)};
    /* AbortController plumbing — the global watchdog at layouts/app.blade.php
       sets window.__wasmInitAborted=true on 2 consecutive cross-source fails
       (or any timeout). Before, that flag was only checked BETWEEN attempts
       in _doInit, so a fetch already in flight (the 32 MB ffmpeg-core.wasm)
       kept running for its full duration before the cascade reacted. We
       now propagate the abort INTO the in-flight fetch via AbortSignal —
       cuts wall-clock by ~30 s on every aborted attempt, ~3 min when the
       in-flight blob is the giant wasm. The 60 s instantiate timeout race
       upstream is unaffected; this only attacks the wait-on-download phase. */
    var ac=null;
    try{ if(typeof AbortController!=='undefined') ac=new AbortController(); }catch(_){}
    var abortPoll=setInterval(function(){
        if(window.__wasmInitAborted && ac){ try{ac.abort();}catch(_){} clearInterval(abortPoll);}
    },200);
    if(extSignal&&ac){
        if(extSignal.aborted){clearInterval(abortPoll);throw new Error('aborted-by-caller: '+url);}
        try{extSignal.addEventListener('abort',function(){try{ac.abort()}catch(_){}},{once:true})}catch(_){}
    }
    var res;
    try{
        res=await fetch(url, ac ? {signal:ac.signal} : undefined);
    }catch(fetchErr){
        clearInterval(abortPoll);
        if(window.__wasmInitAborted) throw new Error('aborted-by-watcher: '+url);
        if(extSignal&&extSignal.aborted) throw new Error('aborted-by-caller: '+url);
        throw fetchErr;
    }
    if(!res.ok){clearInterval(abortPoll);throw new Error('HTTP '+res.status+' '+url);}
    if(!res.body||!res.body.getReader){
        clearInterval(abortPoll);
        // Older browsers / proxies that strip the ReadableStream — fall back
        // to a single blob read. No progress, but still works.
        var b=await res.blob();
        if(onByte)try{onByte(b.size,b.size)}catch(_){}
        return b;
    }
    var total=parseInt(res.headers.get('content-length'),10)||0;
    var reader=res.body.getReader();
    var chunks=[],received=0,lastByte=Date.now(),aborted=false,watcherAborted=false;
    var stallCheck=setInterval(function(){
        if(Date.now()-lastByte>stallMs){aborted=true;try{reader.cancel('stall')}catch(_){}}
        else if(window.__wasmInitAborted){watcherAborted=true;try{reader.cancel('aborted-by-watcher')}catch(_){}}
    },2000);
    try{
        while(true){
            var step=await reader.read();
            if(step.done)break;
            chunks.push(step.value);
            received+=step.value.length;
            lastByte=Date.now();
            if(onByte)try{onByte(received,total)}catch(_){}
        }
    }finally{clearInterval(stallCheck);clearInterval(abortPoll)}
    if(watcherAborted)throw new Error('aborted-by-watcher: '+url);
    if(aborted)throw new Error('Stream stalled (no bytes for '+Math.round(stallMs/1000)+'s): '+url);
    // Server closed connection before sending the full body. Without this
    // check, fetchCached would happily store the truncated bytes — every
    // future init would use the broken cached blob and fail at instantiate
    // with no obvious "your network was flaky once" signal.
    if(total>0 && received<total){
        throw new Error('Stream truncated: '+url+' got '+received+'/'+total+' bytes');
    }
    return new Blob(chunks);
}
/* Per-asset minimum size. The old check was a flat 1024 bytes — fine for
   "definitely empty" but lets through every kind of partial-fetch garbage
   (a 100 KB blob "looks fine" but is a truncated 32 MB WASM that fails at
   instantiate with no useful error). Real sizes:
     ffmpeg-core.js   ≈ 112 KB   →  floor at 50 KB
     ffmpeg-core.wasm ≈ 32 MB    →  floor at 25 MB
   Anything below the floor is treated as corrupt: evicted from the app
   cache, refetched from origin/CDN, and (if still wrong) skipped entirely
   instead of being cached. This stops the "stuck on broken cache forever"
   symptom that caused multi-minute retry loops with empty err strings. */
function _expectedMinBytes(url){
    /* The no-SIMD build of the same core is smaller (25 955 570 B on 2026-09-02:
       no vector code) and sat 260 KB BELOW the 25 MiB floor tuned for the SIMD
       build — every fetch was branded "short", evicted and refetched, and the
       lane only came up through the un-cached direct fallback after FIVE
       downloads of the same file (measured by the preflight test, B5). */
    if(url.indexOf('ffmpeg-nosimd/ffmpeg-core.wasm')!==-1) return 20*1024*1024;
    if(url.indexOf('ffmpeg-core.wasm')!==-1) return 25*1024*1024;
    if(url.indexOf('ffmpeg-core.js')!==-1) return 50*1024;
    return 1024;
}
async function fetchCached(url,onByte,extSignal){
    var minBytes=_expectedMinBytes(url);
    try{
        var cache=await caches.open(CACHE_NAME);
        var resp=await cache.match(url);
        if(resp){
            var cachedBlob=await resp.blob();
            if(cachedBlob && cachedBlob.size>=minBytes){
                // Dedupe console spam: cache hits are noisy on tools that
                // (re)initialize ffmpeg many times per session (vocal-remover
                // with chip-clicks + cancel cascades hits this hard). Log
                // each URL once per page-load.
                if(!window.__ffLogged)window.__ffLogged={};
                var _hk='hit:'+url;
                if(!window.__ffLogged[_hk]){window.__ffLogged[_hk]=1;console.log('[ffmpeg] cache hit:',url.substring(url.lastIndexOf('/')+1),'('+cachedBlob.size+'b)');}
                // Emit a single instant 100% tick so the UI can snap to full for
                // cache hits (otherwise the bar sits at 0 while we blob-parse).
                if(onByte)try{onByte(cachedBlob.size,cachedBlob.size)}catch(_){}
                return {blob:cachedBlob,fromCache:true};
            }
            // Below the per-asset floor — almost certainly truncated. Evict
            // and refetch (the user's previous failed init may have cached
            // a partial blob; without eviction every retry hits the same
            // corrupt entry forever).
            console.warn('[ffmpeg] cache entry below floor ('+(cachedBlob?cachedBlob.size:0)+'b<'+minBytes+'b), evicting:',url.substring(url.lastIndexOf('/')+1));
            try{await cache.delete(url)}catch(_){}
            try{navigator.sendBeacon('/api/log-error',JSON.stringify([{type:'ffmpeg-cache-evict',src:'corrupt|'+url+'|size='+(cachedBlob?cachedBlob.size:0)+'|min='+minBytes,page:location.pathname,ua:navigator.userAgent.substring(0,200)}]))}catch(_){}
            // Mirror to the analytics dashboard so the corrupt-cache class is
            // visible in "real bugs" — sendBeacon to log-error only lands in
            // /storage/logs/client-errors.log (file-grep, not SQL queryable).
            if(window.__aeToolError)try{window.__aeToolError({error_type:'cache_corrupt',method:'fetchCached',err_msg:'evict|'+url.substring(url.lastIndexOf('/')+1)+'|size='+(cachedBlob?cachedBlob.size:0)+'|min='+minBytes,asset:url.substring(url.lastIndexOf('/')+1)})}catch(_){}
        }
        var blob=await fetchStream(url,onByte,15000,extSignal);
        // Refuse to cache a sub-floor blob — it would just relock the next
        // init into the same broken state. Throwing here surfaces the real
        // network/CDN problem to init's catch and lets it move to the next
        // source instead of "succeeding" with garbage.
        if(blob && blob.size>=minBytes){
            try{await cache.put(url,new Response(blob.slice(0)))}catch(ce){console.warn('[ffmpeg] cache put failed:',ce.message)}
            console.log('[ffmpeg] cached:',url.substring(url.lastIndexOf('/')+1),'('+blob.size+'b)');
            return {blob:blob,fromCache:false};
        }
        console.warn('[ffmpeg] fetched blob below floor, refusing to cache:',url.substring(url.lastIndexOf('/')+1),'('+(blob?blob.size:0)+'b<'+minBytes+'b)');
        try{navigator.sendBeacon('/api/log-error',JSON.stringify([{type:'ffmpeg-fetch-short',src:url+'|size='+(blob?blob.size:0)+'|min='+minBytes,page:location.pathname,ua:navigator.userAgent.substring(0,200)}]))}catch(_){}
        // Same dashboard-mirror: short-fetch is a CDN/proxy/HTTP problem class.
        // Distinguishable from cache_corrupt above (which is "we already had a
        // bad blob cached") by error_type, so we can tell them apart in SQL.
        if(window.__aeToolError)try{window.__aeToolError({error_type:'cache_short_fetch',method:'fetchStream',err_msg:'short|'+url.substring(url.lastIndexOf('/')+1)+'|size='+(blob?blob.size:0)+'|min='+minBytes,asset:url.substring(url.lastIndexOf('/')+1)})}catch(_){}
        throw new Error('fetched blob below floor: '+(blob?blob.size:0)+'b < '+minBytes+'b');
    }catch(e){
        console.warn('[ffmpeg] streaming fetch failed, falling back:',e.message);
        // A caller that abandoned the download (liveness trip, cancel) gets no second, unbounded fetch.
        if(extSignal&&extSignal.aborted)throw e;
        var r=await fetch(url,extSignal?{signal:extSignal}:undefined);
        if(!r.ok)throw new Error('HTTP '+r.status+' '+url);
        var b=await r.blob();
        // Final-fallback path also gets the floor check — otherwise a 200-
        // with-empty-body proxy response would still be passed to .load()
        // and waste an attempt slot.
        if(b && b.size<minBytes){
            throw new Error('fallback blob below floor: '+b.size+'b < '+minBytes+'b for '+url);
        }
        if(onByte)try{onByte(b.size,b.size)}catch(_){}
        return {blob:b,fromCache:false};
    }
}
async function toBlobCached(url,mime,onByte,extSignal){
    var res=await fetchCached(url,onByte,extSignal);
    return URL.createObjectURL(new Blob([res.blob],{type:mime}))
}
/* ── ffmpeg.wasm 0.12 loses 224 bytes of WASM STACK on every exec ─────────────
   The core ends each run of FFmpeg's main() by calling abort() — the glue sets
   Module.ret, aborts, and exec() swallows the «Aborted(...)» RuntimeError (the
   core even filters that line out of stderr). An exception unwinding wasm
   frames does not restore the __stack_pointer global, so every exec leaves the
   stack pointer where abort() found it. Measured 2026-09-27 on this very core:
   224 bytes per exec, on a 64 KiB stack. After ~147 execs what is left is shallower than one FFmpeg run
   needs, the next run writes past the stack into the static data below it, and
   the instance dies with «memory access out of bounds» (Chromium), «index out
   of bounds» (Firefox) or «table index is out of bounds» (a clobbered function
   pointer) — with a 38 MB heap, so it is not memory. It does not depend on the
   codec (rawvideo→nut dies at 148 too; mpeg4, whose run is deeper, at 101), the
   frame count per exec (12, 48, 240: all 148) or the resolution.
   /audio-to-video's frame lane needs one exec per 2 s of video at 720p (0.9 s
   at 1080p): every export longer than ~5 min (~2 min at 1080p) died there —
   #788 got 0 of 6 after 16.09 and 7 of 7 before, when 10-s batches kept the
   lane under the ceiling. /video-trim spends one exec per thumbnail.
   Saving the stack pointer before main() and restoring it after: 600 execs in
   a row on x264 and on mpeg4, stack pointer constant; 810 mixed execs on one
   instance byte for byte as on a fresh one. Guard, running the real no-SIMD
   core in Node: tests/js/ffmpeg-core-keeps-its-stack.test.mjs.
   The fix lives HERE, on the glue text, so it holds for every core that loads
   as a blob — our SIMD and no-SIMD builds and the CDN fallbacks alike, whatever
   is on the disk of either origin. The MT core loads by URL (its pthreads
   import the same address); for it, and for the files themselves,
   scripts/ffmpeg-core-glue-patch.mjs applies this same function on disk
   (public/vendor/ffmpeg/download.sh). «unknown» = the glue is not the 0.12
   shape this was measured on: nothing is touched. */
/* Each wrapper is patched INSIDE its own function: the npm/CDN build of
   0.12.10 carries an ffprobe() wrapper with the same tail as exec(), and the
   first version of this function saw two tails, answered «unknown» and left
   the CDN fallbacks unprotected (found by running it on the real jsDelivr
   file, 27.09.2026). exec() is required; ffprobe() is patched when present. */
function _patchCoreGlueStack(src){
    if(src.indexOf('__tmbSp')!==-1)return{src:src,state:'had'};
    if(src.indexOf('var stackSave=')===-1||src.indexOf('var stackRestore=')===-1)return{src:src,state:'unknown'};
    var out=src,done={},TAIL='{throw e}}return Module["ret"]}';
    var wrappers=[['exec','_ffmpeg'],['ffprobe','_ffprobe']];
    for(var k=0;k<wrappers.length;k++){
        var open='function '+wrappers[k][0]+'(..._args){',call='try{Module["'+wrappers[k][1]+'"](';
        var i=out.indexOf(open);
        if(i===-1)continue;
        if(out.indexOf(open,i+1)!==-1)return{src:src,state:'unknown'};
        var j=out.indexOf(TAIL,i),next=out.indexOf('function ',i+open.length);
        if(j===-1||(next!==-1&&next<j))return{src:src,state:'unknown'};
        var body=out.slice(i,j),c=body.indexOf(call);
        if(c===-1||body.indexOf(call,c+1)!==-1)return{src:src,state:'unknown'};
        out=out.slice(0,i)+body.slice(0,c)+'const __tmbSp=stackSave();'+body.slice(c)
            +'{throw e}}finally{stackRestore(__tmbSp)}return Module["ret"]}'+out.slice(j+TAIL.length);
        done[wrappers[k][0]]=1;
    }
    if(!done.exec)return{src:src,state:'unknown'};
    return{src:out,state:'patched'};
}
/* WORKERFS reads ahead on a big file (30.09.2026). Emscripten's WORKERFS
   answers every read FFmpeg makes with one FileReaderSync round trip for
   exactly the bytes asked — 32 KB, the size of FFmpeg's I/O buffer. Where the
   sound of a video is interleaved one AAC frame per chunk (FFmpeg's own mux,
   editors, remuxes), a soundtrack render that reads only [0:a] seeks to every
   frame: 75 000 round trips for 27 min of 1080p120, and the render of a 3.2 GB
   file took ~650 s against 134 s for the same sound in a file of its own
   (measured on /video-audio and /add-music-to-video, Edge 154). A sequential
   read of a big input pays the same toll in 32 KB steps.
   On a node of 1 MB and more the read keeps one block per file and grows it
   while reads keep landing just past it (up to 8 MB), and falls back to a
   small block on a far jump — so a forward walk costs a few hundred reads, a
   jump to the moov costs 128 KB. The bytes handed out are the same; only how
   many trips fetch them changes. A file under 1 MB keeps the original read.
   The line stood at 64 MB until 01.10.2026: the trip costs the same on any
   file (~15 ms in desktop Chrome, ~50 ms on the phone of comment #1794,
   whose 201 MB clip stood at «18 %» for 135 s on /video-merge before this
   patch existed). Measured on a 56 MB 1080×1920@60 clip, the audio window of
   24 s: 723 trips / 14 s under the old line, 14 trips / 0.9 s now. Applied
   on the glue text like _patchCoreGlueStack: every core that loads as a blob;
   the MT core (loaded by URL) keeps the original. «unknown» = not the 0.12
   WORKERFS text: nothing is touched. window.__FF_RA_OFF = true skips it (A/B). */
function _patchCoreWorkerfsReadAhead(src){
    /* The core's own WORKERFS read call, found in its glue and written back into it —
       not a file input. Spelled in two pieces because the no-upload scan
       (NoUploadOptOutTest) reads this bundle as text on pages that drop the
       uploader stack. */
    var RD='WORKERFS.reader.read'+'AsArrayBuffer';
    var OLD='stream_ops:{read:function(stream,buffer,offset,length,position){if(position>=stream.node.size)return 0;var chunk=stream.node.contents.slice(position,position+length);var ab='+RD+'(chunk);buffer.set(new Uint8Array(ab),offset);return chunk.size}';
    if(src.indexOf('__tmbRa')!==-1)return{src:src,state:'had'};
    var at=src.indexOf(OLD);
    if(at===-1||src.indexOf(OLD,at+1)!==-1)return{src:src,state:'unknown'};
    var NEW='stream_ops:{read:function(stream,buffer,offset,length,position){var node=stream.node,size=node.size;if(position>=size)return 0;var end=Math.min(position+length,size);'
        +'if(size<1048576){var chunk=node.contents.slice(position,end);var ab='+RD+'(chunk);buffer.set(new Uint8Array(ab),offset);return chunk.size}'
        +'var ra=node.__tmbRa||(node.__tmbRa={at:0,len:0,u8:null,win:0});'
        +'if(!(ra.u8&&position>=ra.at&&end<=ra.at+ra.len)){var near=!!ra.u8&&position>=ra.at&&position-(ra.at+ra.len)<1048576;'
        +'ra.win=near?Math.min((ra.win||131072)*2,8388608):131072;var stop=Math.min(position+Math.max(end-position,ra.win),size);'
        +'var ab2='+RD+'(node.contents.slice(position,stop));ra.at=position;ra.len=ab2.byteLength;ra.u8=new Uint8Array(ab2)}'
        +'buffer.set(ra.u8.subarray(position-ra.at,end-ra.at),offset);return end-position}';
    return{src:src.slice(0,at)+NEW+src.slice(at+OLD.length),state:'patched'};
}
async function toCoreBlobURL(url,onByte,extSignal){
    var res=await fetchCached(url,onByte,extSignal);
    var p=null;
    try{p=_patchCoreGlueStack(await res.blob.text())}catch(_){}
    window.__ffGlueSp=p?p.state:'error';
    if(p&&!window.__FF_RA_OFF){try{var ra=_patchCoreWorkerfsReadAhead(p.src);window.__ffWorkerfsRa=ra.state;if(ra.state==='patched')p={src:ra.src,state:p.state==='unknown'?'ra-only':p.state}}catch(_){window.__ffWorkerfsRa='error'}}
    if(p&&p.state!=='unknown')return URL.createObjectURL(new Blob([p.src],{type:'text/javascript'}));
    return URL.createObjectURL(new Blob([res.blob],{type:'text/javascript'}))
}
/* WebAssembly SIMD pre-flight. The @ffmpeg/core@0.12.10 build we ship uses
   SIMD instructions; CPUs without SSE 4.1 (pre-2008 Intel/AMD) cannot
   compile it — WebAssembly.instantiate throws "Wasm SIMD unsupported" at
   function #81. Until 2026-05-03 we burned 11 source-attempts × 32 MB =
   ~350 MB of wasted bandwidth per affected session and showed a misleading
   "audio engine failed" banner with a useless "try again" button (hardware
   can't change between retries). 1.3% of sessions hit this class.

   This probe is ~5 ms and decisive: WebAssembly.validate() runs the SIMD
   feature-detection module that v8/SpiderMonkey/JSC implement against the
   *runtime* CPU capability, not just the engine version. Cached on first
   call. Returns true if the host can compile SIMD instructions. */
// Idempotent: layouts/app.blade.php inline-bootstraps an identical impl
// before any defer script. Re-defining here would clobber that (and any
// test/page override). Skip when it's already set.
if (!window.__hasWasmSIMD) {
    window.__hasWasmSIMD=(function(){
        var cached=null;
        return function(){
            if(cached!==null)return cached;
            try{
                // Phase Y (2026-06-04) — CORRECTED canonical SIMD probe.
                // Previous bytecode tested `i8x16.popcnt` (0xfd 0x62) which
                // is a LATE-added SIMD opcode (Chrome 90+ / Safari 16.4+ /
                // Firefox 89+). EVERY pre-2023 iPhone (Safari 14/15/16.0-16.3)
                // and Chromebooks / older laptops on Chrome 76-89 reported
                // `simd_unsupported` falsely → 443 events / 7d, users told
                // "device too old" when their actual hardware was 100% fine.
                //
                // Canonical wasm-feature-detect probe uses only the EARLIEST
                // SIMD opcode `i8x16.splat` (available in EVERY browser that
                // ships WASM SIMD at all) and drops the result instead of
                // returning v128 from JS-exposed function (broader engine
                // support). Source: github.com/GoogleChromeLabs/wasm-feature-
                // detect/blob/main/src/detectors/simd/module.wat
                cached=typeof WebAssembly!=='undefined'&&typeof WebAssembly.validate==='function'&&WebAssembly.validate(new Uint8Array([
                    0,97,115,109,1,0,0,0,1,4,1,96,0,0,3,2,1,0,
                    10,9,1,7,0,65,0,253,15,26,11
                ]));
            }catch(e){cached=false;}
            return cached;
        };
    })();
}
var _EXT_ALIASES_FB={weba:'webm',aif:'aiff',wave:'wav',mpga:'mp3',m4b:'m4a',m4p:'m4a','3gpp':'3gp'};
function normEx(e){e=String(e||'').toLowerCase();var m=(window.__FFMPEG_CONFIG__&&window.__FFMPEG_CONFIG__.inputAliases)||_EXT_ALIASES_FB;return m[e]||e;}
window.FFmpegProcessor={CODECS:s,MIME_TYPES:c,BROWSER_FORMATS:p,_srcNames:(window.__ffmpegNoSimdLane?["nosimd-st"]:(window.__ffmpegMtLane?["local-mt","local","jsdelivr-proxy","unpkg-proxy","jsdelivr","unpkg"]:["local","jsdelivr-proxy","unpkg-proxy","jsdelivr","unpkg"])),_lastError:null,/* Promise-mutex: every init() shares one in-flight Promise. Without this,
   tool catch-blocks that call FFmpegProcessor.reinit() race on the module-
   level `e` and kill each other's worker mid-load — surfacing as "called
   FFmpeg.terminate()" / "Cannot read properties of null" / empty-msg
   errors (~780/day in telemetry). reinit() now waits for in-flight init
   to settle before terminating, so the cascade is impossible. */
/* prefetch(onProgress) — положить БАЙТЫ ядра в кэш приложения, не создавая
   инстанс. Замер 03.09.2026 (tests/playwright/ffmpeg-instantiate-cost-scratch.mjs):
   init целиком стоит +188 МБ, из них САМО инстанцирование — 104 МБ, а после
   прогрева байтов оно занимает 204 мс. Прогрев по выбору файла существует, чтобы
   спрятать скачивание 30 МБ на медленной связи; держать ради этого лишние 100-190
   МБ на устройстве, у которого их нет, — это и есть убитая вкладка (жалоба 01.09,
   Redmi Note 9 Pro / 4 ГБ: «после того, как ввожу видео, постоянно перезагружает
   страницу»). Поэтому на слабой памяти греем байты, а инстанс поднимаем в момент
   нажатия — за те самые 204 мс. */
async prefetch(n){if(r)return!0;var _src=null;for(var _pi=0;_pi<i.length;_pi++){if(!i[_pi].mt){_src=i[_pi];break}}if(!_src)return!1;try{var _tot={core:0,wasm:0},_rec={core:0,wasm:0};var _cb=function(w){return function(rc,tt){_rec[w]=rc;_tot[w]=tt||rc;if(n)try{n((_rec.core+_rec.wasm)/Math.max(1,_tot.core+_tot.wasm))}catch(_){}}};var _live=_engineLiveness(ENGINE_IDLE_MS);try{await _live.race(fetchCached(_src.core,_cb('core'),_live.signal));await _live.race(fetchCached(_src.wasm,_cb('wasm'),_live.signal));}finally{_live.stop()}if(window.__ae)try{window.__ae("feature_use",{f:"ffmpeg_bytes_prefetched",dm:(window.__memBudget&&window.__memBudget.gb)?window.__memBudget.gb():0})}catch(_){}return!0}catch(e){console.warn("[ffmpeg] prefetch failed:",e&&e.message);return!1}},
async init(n,opts){if(r)return!0;if(_initPromise)return _initWithSignal(_initPromise,opts);
/* Phase Y (2026-06-04): pre-aborted short-circuit. If a prior cascade in
   this session already determined the engine broken, window.__wasmInitAborted
   is set by the interceptor at app.blade.php:2197 AND sessionStorage.
   __wasm_health is cached as "0" by the worker probe in timbrica-core.js.
   Pre-fix, subsequent init() calls still entered _doInit, paid the SIMD
   check + wrapper-script load + 2 array iterations, then bailed at the
   first __wasmInitAborted check inside the loop — emitting a DUPLICATE
   wasm_init_failed event with trace "INIT_FAILED | aborted-by-watcher@
   source0 | aborted-by-watcher@direct". 60 events/7d were this exact
   shape. Short-circuit here: re-show the banner (it's the user's UX
   channel), return a typed ENGINE_PRE_ABORTED error that __aeToolError
   respects alreadyReported on, no duplicate telemetry. */
var _preAb=window.__wasmInitAborted===true;
if(!_preAb){try{_preAb=sessionStorage.getItem('__wasm_health')==='0'}catch(_){}}
if(_preAb){
    try{window.__wasmBrokenBanner&&window.__wasmBrokenBanner()}catch(_){}
    var _eaErr=new Error('FFmpeg engine previously determined broken in this session.');
    _eaErr.code='ENGINE_PRE_ABORTED';
    _eaErr.alreadyReported=true;
    _eaErr.expected=true;
    return Promise.reject(_eaErr);
}
_initPromise=this._doInit(n).finally(function(){_initPromise=null});return _initWithSignal(_initPromise,opts)},async _doInit(n){o=!0;var _initStart=performance.now();/* `ffmpeg-status` is a liveness signal, not just a UI feed: the stall guard
   listens to it so a cold start — which runs INSIDE the guarded lane, because
   wrapOp calls init() there — cannot be mistaken for silence. */
var _emit=function(d){window.dispatchEvent(new CustomEvent("ffmpeg-status",{detail:d}))};/* Auto-stage: every tool that calls init() gets a wasm_load transition for free. No per-tool wiring. */if(window.__stage)try{window.__stage("wasm_load")}catch(_){}/* SIMD pre-flight — fail in <5 ms when the CPU can't compile the SIMD
   instructions our FFmpeg core build uses, instead of cycling through 11
   source-attempts × 32 MB. Distinct telemetry tag (reason:'simd_unsupported')
   so we can count the hardware-incompatible cohort separately from network/
   memory failures. Banner picks a hardware-specific message and hides the
   "Try again" button (retrying doesn't change the CPU). *//* WebAssembly itself unavailable — Mobile Safari iOS in some private/
   restricted-context modes, or very old Yandex/Samsung Internet. Same
   fail-fast story as SIMD: no point cycling sources. expected:true so
   engine-warmer doesn't rethrow it as a Sentry-grade error. */
/* ⭐Проверять надо не НАЛИЧИЕ API, а ВОЗМОЖНОСТЬ СКОМПИЛИРОВАТЬ.
   `WebAssembly.validate()` разбирает байты БЕЗ генерации кода, поэтому там,
   где движок запрещён окружением (наш CSP без 'unsafe-eval' — а wasm требовал
   его до Chrome 97), validate спокойно отвечает true, и SIMD-проба рядом тоже
   отвечает true. Замер 17.08 на настоящем CSP: validate(simd)=true,
   validate(empty)=true, при этом `new WebAssembly.Module()` и `instantiate()`
   бросают CompileError «Wasm code generation disallowed by embedder».
   Из-за этого 97 сессий за 30 дней (42 тула, 88 из них мобильные, devMem 2,
   3g/4g) скачивали 26 МБ ядра, ждали — и получали совет «попробуйте обновить
   страницу», который не мог им помочь. Проба ниже стоит 8 байт и доли
   миллисекунды и отвечает на тот самый вопрос, который решает исход. */
var _wasmCompiles=(function(){try{if(typeof WebAssembly==='undefined')return false;new WebAssembly.Module(new Uint8Array([0,97,115,109,1,0,0,0]));return true;}catch(e){return false;}})();
if(typeof WebAssembly==='undefined'||!_wasmCompiles){var _wasmWhy=(typeof WebAssembly==='undefined')?"wasm_unsupported":"wasm_blocked";this._lastError="WASM_UNSUPPORTED | "+(_wasmWhy==="wasm_blocked"?"WebAssembly compilation blocked by environment":"WebAssembly API not available");_emit({phase:"failed",error:this._lastError,reason:_wasmWhy});if(window.__aeToolError)try{window.__aeToolError({error_type:"wasm_init_failed",method:"wasm_preflight",err_msg:_wasmWhy,reason:_wasmWhy,dm:navigator.deviceMemory||0,br:(window.__brOf?window.__brOf(navigator.userAgent):"other"),mob:/Mobi|Android|iPhone|iPad/i.test(navigator.userAgent)?1:0})}catch(_){}var _wm={en:"This browser does not support WebAssembly. Try the latest Chrome or Firefox.",ru:"Этот браузер не поддерживает WebAssembly. Откройте сайт в актуальном Chrome или Firefox.",ko:"이 브라우저는 WebAssembly를 지원하지 않습니다. 최신 Chrome 또는 Firefox를 사용해 주세요.",ar:"هذا المتصفح لا يدعم WebAssembly. جرّب أحدث إصدار من Chrome أو Firefox.",id:"Browser ini tidak mendukung WebAssembly. Gunakan versi terbaru Chrome atau Firefox.",pt:"Este navegador não suporta WebAssembly. Use a versão mais recente do Chrome ou Firefox.",de:"Dieser Browser unterstützt WebAssembly nicht. Verwenden Sie die neueste Version von Chrome oder Firefox.",es:"Este navegador no es compatible con WebAssembly. Usa la versión más reciente de Chrome o Firefox.",fr:"Ce navigateur ne prend pas en charge WebAssembly. Utilisez la dernière version de Chrome ou Firefox.", uk: "Цей браузер не підтримує WebAssembly. Спробуйте актуальну версію Chrome або Firefox.", tr: "Bu tarayıcı WebAssembly'yi desteklemiyor. En güncel Chrome veya Firefox'u deneyin."};var _wasmErr=new Error(_wm[window.__LOCALE]||_wm.en);_wasmErr.code="WASM_UNSUPPORTED";_wasmErr.expected=true;_wasmErr.alreadyReported=true;o=!1;throw _wasmErr;}
/* The published predicate, not the raw CPU probe: the legacy-Chromium arm (FFmpegCoreArm) takes this branch on a SIMD-capable CPU too. */
var _noSimd=!!window.__ffmpegNoSimdLane||(typeof window.__hasWasmSIMD==='function'&&!window.__hasWasmSIMD());
if(_noSimd){/* No SIMD on this device. Until 2026-09-02 this branch built a legacy 0.11 adapter
   around @ffmpeg/core-st 0.11.1 — FFmpeg 4.3 from 2020 — and returned. Tools are written for
   the main core (FFmpeg 5.1.4), so every filter option younger than 2020 died there with
   "Error initializing filter": amix normalize=0 in 12 tools, xfade hblur in /video-merge —
   #1527 (Yury, 2 GB / 1 core / no SIMD) got 4 failed exports in /add-music-to-video and 9 in
   /video-audio. Now the ladder below loads OUR build of the SAME 0.12.10 core compiled without
   -msimd128, through the same wrapper, blob cache, WORKERFS and telemetry as everyone else:
   one FFmpeg, two compilations. The legacy adapter is gone: measured 2026-09-02 in real
   Chromium 83 and 86, every browser old enough to lack BigInt<->i64 is already refused by the
   site CSP ("Wasm code generation disallowed by embedder" — wasm needs 'unsafe-eval' before
   Chrome 97), so nothing that runs today could need FFmpeg 4.3 back. */
window.__nosimdMode=1;
if(!window.__ffmpegNoSimdLane&&window.__ffmpegNoSimdSrc){/* probe flipped after load (test stub / late polyfill): rebuild the ladder to match */i=[window.__ffmpegNoSimdSrc];this._srcNames=["nosimd-st"];window.__ffmpegNoSimdLane=true;}
console.log("[ffmpeg] no-SIMD device — loading the no-SIMD build of the main core");}var errors=[];try{await _withDeadline(u(),ENGINE_WRAPPER_MS,'wrapper-script');_emit({phase:"downloading",source:this._srcNames[0],sourceIndex:1,totalSources:i.length});for(var a=0;a<i.length;a++){if(window.__wasmInitAborted){errors.push("aborted-by-watcher@source"+a);break}var srcName=this._srcNames[a]||"source"+a;for(var attempt=1;attempt<=2;attempt++){if(window.__wasmInitAborted){errors.push("aborted-by-watcher@"+srcName+"#"+attempt);break}var _attemptT0=performance.now();try{if(attempt>1){_emit({phase:"retrying",source:srcName,attempt:attempt,sourceIndex:a+1,totalSources:i.length});await new Promise(function(res){setTimeout(res,1500)})}else if(a>0){_emit({phase:"downloading",source:srcName,sourceIndex:a+1,totalSources:i.length})}e=_instrumentExec(new t);/* Opus — по FFmpegOpusRule вверху файла: libopus падает на стерео при 48 кГц (замер 08.10.2026 в трёх движках), поэтому не-моно уходит во встроенный `opus` + -strict -2; моно остаётся libopus. Встроенный кодировщик сводит >2 каналов в стерео — это раскрывает max_channels в config/formats.php. */(function(_i){var _x=_i.exec.bind(_i);_i.exec=function(u,_tmo){try{u=window.FFmpegOpusRule.apply(u)}catch(_t){}/* частота выхода — та, что примет кодировщик (FFmpegSampleRateRule вверху файла) — после правила opus */try{u=window.FFmpegSampleRateRule.apply(u)}catch(_t){}/* время кадров исходника — у кодирования видео в mp4/mkv/webm (FFmpegFrameTimingRule вверху файла) */try{u=window.FFmpegFrameTimingRule.apply(u)}catch(_t){}/* RIFF/IFF не объявляют кодировку текстовых чанков — не наследуем туда тег (см. FFmpegContainerTagRule вверху файла) */try{u=window.FFmpegContainerTagRule.apply(u)}catch(_t){}/* Теги источника — ПОСЛЕ правила выше: оно снимает тег у wav/aiff и пропускает вызывающего с -metadata, поэтому наш `-metadata` не имеет права появиться раньше (см. FFmpegSourceTagRule вверху файла) */try{if(window.__audioSourceTags)u=window.__audioSourceTags.ffmpegArgs(u)}catch(_t){}
/* The multi-threaded core does NOT use threads unless told to: ffmpeg asks the
   OS for a CPU count and WASM answers 1, so an MT build with no -threads runs
   exactly like the single-threaded one (and, on some arg sets, worse). Measured
   2026-08-19, same 12.3 MB file: no flag at all, and the flag written BEFORE
   -i (where it is a DECODER option) both ran past a 240 s timeout — WORSE than
   single-threaded; in the output slot it finished in 14 s against 41-76 s.
   Position, not presence, is the whole trick. WORKERFS was suspected and
   cleared: MEMFS and a WORKERFS mount both complete in 8 s. */
try{if(window.__ffmpegMtActive&&u&&u.length>1&&u.indexOf("-threads")===-1){var _n=window.__ffmpegMtThreads||Math.max(2,Math.min(4,(navigator.hardwareConcurrency||4)));u=u.slice(0,u.length-1).concat(["-threads",String(_n)],[u[u.length-1]]);}}catch(_th){}
var _t0=performance.now();var _p=_x(u,_tmo);try{if(_p&&_p.then)_p.then(function(){_execSeen(u,_t0)},function(err){_execSeen(u,_t0);_trapReset(err,u)});else _execSeen(u,_t0)}catch(_ex){}return _p};})(e);e.on("log",function(e){console.log("[ffmpeg]",e.message);window._ffTick&&window._ffTick();if(window._ffLogs){window._ffLogs.push(e.message);var _lc=window.__ffLogsCapOverride||20;if(window._ffLogs.length>_lc)window._ffLogs.splice(0,window._ffLogs.length-_lc)}});if(!window.__ffLogged)window.__ffLogged={};var _tk='try:'+srcName+'#'+attempt;if(!window.__ffLogged[_tk]){window.__ffLogged[_tk]=1;console.log("[ffmpeg] trying",srcName,"attempt",attempt);}var _rec={core:0,wasm:0},_tot={core:0,wasm:0},_lastEmitBytes=0;function _onByte(which){return function(r,t){_rec[which]=r;_tot[which]=t||r;var rec=_rec.core+_rec.wasm,tot=_tot.core+_tot.wasm;if(tot>0&&n)try{n(rec/tot)}catch(_){}if(Date.now()-_lastEmitBytes>200){_lastEmitBytes=Date.now();_emit({phase:"downloading",source:srcName,sourceIndex:a+1,totalSources:i.length,attempt:attempt,bytes:rec,total:tot})}}}var _coreBlob=null,_wasmBlob=null;if(!i[a].mt){/* download phases under the liveness watch (see _engineLiveness); instantiate keeps its own 60-s race below */var _live=_engineLiveness(ENGINE_IDLE_MS);try{_coreBlob=await _live.race(toCoreBlobURL(i[a].core,_onByte("core"),_live.signal));_wasmBlob=await _live.race(toBlobCached(i[a].wasm,"application/wasm",_onByte("wasm"),_live.signal));}finally{_live.stop()}}_emit({phase:"instantiating",source:srcName,sourceIndex:a+1,totalSources:i.length,attempt:attempt});/* The MT core loads by DIRECT same-origin URL, never as a blob. Its core
   spawns nested pthread workers relative to its OWN url, and from a blob: base
   that resolution dies silently — the wrapper swallows the worker error and
   load() hangs forever. That is precisely the "core-mt still broken, 0 network
   requests to mt worker.js" verdict recorded on 2026-07-16: the probe never
   passed workerURL and the nested spawn had no reachable base. Measured today
   with direct URLs + explicit workerURL: pthread pool comes up, exec returns 0,
   132-157 s → 14-20 s. Same-origin needs no blob anyway (the blob dance exists
   for the CDN fallbacks); the SW's _withCoep plugin puts the COEP header on the
   worker response, which is what makes it loadable inside an isolated page. */
var _loadOpts;
if(i[a].mt){_loadOpts={coreURL:i[a].core,wasmURL:i[a].wasm,workerURL:i[a].worker};window.__ffmpegMtActive=1;window.__ffGlueSp="url";}
else{_loadOpts={coreURL:_coreBlob,wasmURL:_wasmBlob};window.__ffmpegMtActive=0;}
var _it0=performance.now();await Promise.race([e.load(_loadOpts),new Promise(function(_,rej){setTimeout(function(){rej(new Error("Instantiate timeout"))},window.__ffInstBudget(srcName,attempt))})]);window.__ffInstSeen(performance.now()-_it0);r=!0;o=!1;this._lastError=null;this._loadedCoreUrl=(typeof _coreBlob!=="undefined"?_coreBlob:null)||(typeof _directSrc!=="undefined"?_directSrc.core:null);this._loadedWasmUrl=(typeof _wasmBlob!=="undefined"?_wasmBlob:null)||(typeof _directSrc!=="undefined"?_directSrc.wasm:null);if(window.__nosimdMode===1){try{window.__ae&&window.__ae("feature_use",{f:"nosimd_engine_active",why:window.__ffmpegNoSimdWhy||"no_simd",dm:navigator.deviceMemory||0,sab:typeof SharedArrayBuffer!=='undefined'?1:0})}catch(_){}}_emit({phase:"ready"});if(this._progressHandler&&e&&e.on)try{e.on("progress",this._progressHandler)}catch(_){};if(e&&e.on)try{e.on("progress",function(p){try{window.dispatchEvent(new CustomEvent("ffmpeg-progress",{detail:p&&typeof p.progress==="number"?p.progress:0}))}catch(_){}})}catch(_){};if(window.__stage)try{window.__stage("wasm_ready")}catch(_){}try{_attemptEvent({src:srcName,attempt:attempt,outcome:"ok",ms:Math.round(performance.now()-_attemptT0),prevFails:errors.length,glue:window.__ffGlueSp||""})}catch(_){}try{var _dur=Math.round(performance.now()-_initStart);navigator.sendBeacon("/api/log-error",JSON.stringify([{type:"ffmpeg-init",src:srcName+"#"+attempt+"|ms="+_dur+(errors.length?"|errs="+errors.join(";").substring(0,150):""),page:location.pathname,ua:navigator.userAgent.substring(0,200)}]))}catch(_fb){}return!0}catch(err){var _eTxt=window.__ffErrText(err);var errMsg=srcName+"#"+attempt+": "+_eTxt;console.warn("[ffmpeg]",errMsg);errors.push(errMsg);try{_attemptEvent({src:srcName,attempt:attempt,outcome:/timeout/i.test(_eTxt)?"timeout":"fail",ms:Math.round(performance.now()-_attemptT0),err:_eTxt.substring(0,200)})}catch(_){}try{navigator.sendBeacon("/api/log-error",JSON.stringify([{type:"ffmpeg-src-fail",src:errMsg.substring(0,200),errName:(err&&err.name)||"",errStack:(err&&err.stack||"").replace(/\s+/g," ").substring(0,300),coreURL:(i[a]&&i[a].core||"").substring(0,200),wasmURL:(i[a]&&i[a].wasm||"").substring(0,200),swCtrl:!!(navigator.serviceWorker&&navigator.serviceWorker.controller),page:location.pathname,ua:navigator.userAgent.substring(0,200)}]))}catch(_sf){}window.__ffmpegIntentionalTerminateAt=Date.now();try{e.terminate()}catch(x){}e=null;continue}}}if(window.__wasmInitAborted){errors.push("aborted-by-watcher@direct");}else{var _directT0=performance.now();try{var _directSrc=i[0];_emit({phase:"downloading",source:"direct-fallback",sourceIndex:1,totalSources:1});e=_instrumentExec(new t);/* та же дверь, что у init (FFmpegOpusRule, FFmpegSampleRateRule): reinit строит свежий экземпляр и обязан её нести */(function(_i){var _x=_i.exec.bind(_i);_i.exec=function(u,_tmo){try{u=window.FFmpegOpusRule.apply(u)}catch(_t){}/* частота выхода — та, что примет кодировщик (FFmpegSampleRateRule вверху файла) — после правила opus */try{u=window.FFmpegSampleRateRule.apply(u)}catch(_t){}/* время кадров исходника — у кодирования видео в mp4/mkv/webm (FFmpegFrameTimingRule вверху файла) */try{u=window.FFmpegFrameTimingRule.apply(u)}catch(_t){}/* RIFF/IFF не объявляют кодировку текстовых чанков — не наследуем туда тег (см. FFmpegContainerTagRule вверху файла) */try{u=window.FFmpegContainerTagRule.apply(u)}catch(_t){}/* Теги источника — ПОСЛЕ правила выше: оно снимает тег у wav/aiff и пропускает вызывающего с -metadata, поэтому наш `-metadata` не имеет права появиться раньше (см. FFmpegSourceTagRule вверху файла) */try{if(window.__audioSourceTags)u=window.__audioSourceTags.ffmpegArgs(u)}catch(_t){}
/* The multi-threaded core does NOT use threads unless told to: ffmpeg asks the
   OS for a CPU count and WASM answers 1, so an MT build with no -threads runs
   exactly like the single-threaded one (and, on some arg sets, worse). Measured
   2026-08-19, same 12.3 MB file: no flag at all, and the flag written BEFORE
   -i (where it is a DECODER option) both ran past a 240 s timeout — WORSE than
   single-threaded; in the output slot it finished in 14 s against 41-76 s.
   Position, not presence, is the whole trick. WORKERFS was suspected and
   cleared: MEMFS and a WORKERFS mount both complete in 8 s. */
try{if(window.__ffmpegMtActive&&u&&u.length>1&&u.indexOf("-threads")===-1){var _n=window.__ffmpegMtThreads||Math.max(2,Math.min(4,(navigator.hardwareConcurrency||4)));u=u.slice(0,u.length-1).concat(["-threads",String(_n)],[u[u.length-1]]);}}catch(_th){}
var _t0=performance.now();var _p=_x(u,_tmo);try{if(_p&&_p.then)_p.then(function(){_execSeen(u,_t0)},function(err){_execSeen(u,_t0);_trapReset(err,u)});else _execSeen(u,_t0)}catch(_ex){}return _p};})(e);e.on("log",function(e2){console.log("[ffmpeg]",e2.message);window._ffTick&&window._ffTick();if(window._ffLogs){window._ffLogs.push(e2.message);var _lc2=window.__ffLogsCapOverride||20;if(window._ffLogs.length>_lc2)window._ffLogs.splice(0,window._ffLogs.length-_lc2)}});_emit({phase:"instantiating",source:"direct-fallback",sourceIndex:1,totalSources:1});var _dt0=performance.now();window.__ffGlueSp="url";await Promise.race([e.load({coreURL:_directSrc.core,wasmURL:_directSrc.wasm}),new Promise(function(_,rej){setTimeout(function(){rej(new Error("Direct load timeout"))},window.__ffInstBudget("direct",1))})]);window.__ffInstSeen(performance.now()-_dt0);r=!0;o=!1;this._lastError=null;this._loadedCoreUrl=(typeof _coreBlob!=="undefined"?_coreBlob:null)||(typeof _directSrc!=="undefined"?_directSrc.core:null);this._loadedWasmUrl=(typeof _wasmBlob!=="undefined"?_wasmBlob:null)||(typeof _directSrc!=="undefined"?_directSrc.wasm:null);if(window.__nosimdMode===1){try{window.__ae&&window.__ae("feature_use",{f:"nosimd_engine_active",why:window.__ffmpegNoSimdWhy||"no_simd",dm:navigator.deviceMemory||0,sab:typeof SharedArrayBuffer!=='undefined'?1:0})}catch(_){}}_emit({phase:"ready"});if(this._progressHandler&&e&&e.on)try{e.on("progress",this._progressHandler)}catch(_){};if(e&&e.on)try{e.on("progress",function(p){try{window.dispatchEvent(new CustomEvent("ffmpeg-progress",{detail:p&&typeof p.progress==="number"?p.progress:0}))}catch(_){}})}catch(_){};if(window.__stage)try{window.__stage("wasm_ready")}catch(_){}try{_attemptEvent({src:"direct-fallback",attempt:1,outcome:"ok",ms:Math.round(performance.now()-_directT0),prevFails:errors.length,glue:window.__ffGlueSp||""})}catch(_){}try{navigator.sendBeacon("/api/log-error",JSON.stringify([{type:"ffmpeg-init",src:"direct-fallback|ms="+Math.round(performance.now()-_initStart)+"|errs="+errors.join(";").substring(0,150),page:location.pathname,ua:navigator.userAgent.substring(0,200)}]))}catch(_fb2){}return!0}catch(_directErr){var _dTxt=window.__ffErrText(_directErr);errors.push("direct: "+_dTxt);try{_attemptEvent({src:"direct-fallback",attempt:1,outcome:/timeout/i.test(_dTxt)?"timeout":"fail",ms:Math.round(performance.now()-_directT0),err:_dTxt.substring(0,200)})}catch(_){}window.__ffmpegIntentionalTerminateAt=Date.now();try{e.terminate()}catch(x){}e=null}}this._lastError="INIT_FAILED | "+errors.join(" | ");_emit({phase:"failed",error:this._lastError});this._reportInitFailure("INIT_FAILED",errors);o=!1;if(window.__stage)try{window.__stage("wasm_load_failed",{errs:errors.length})}catch(_){}/* Emit tool_error so init-failures surface in the "real bugs" dashboard
   alongside process-failures. Pre-fix the dashboard counted only tool_error,
   so 312 wasm_init failures/day for extract-audio (and similar across other
   FFmpeg tools) were invisible — they only existed in wasm_init_attempt rows
   that the dashboard didn't read. From the user's POV, init-failure IS the
   bug: tool literally won't load, no recovery path. */if(window.__aeToolError)try{var _ic=navigator.connection||navigator.mozConnection||{};window.__aeToolError({error_type:"wasm_init_failed",method:"init",err_msg:this._lastError.substring(0,300),sources_tried:errors.length,dm:navigator.deviceMemory||0,sab:typeof SharedArrayBuffer!=="undefined"?1:0,ct:_ic.effectiveType||"",dl:_ic.downlink||0,br:(window.__brOf?window.__brOf(navigator.userAgent):"other"),mob:/Mobi|Android|iPhone|iPad/i.test(navigator.userAgent)?1:0})}catch(_){}var _initErr=new Error(_engineLoadMessage());_initErr.code="INIT_FAILED";_initErr.expected=true;_initErr.alreadyReported=true;/* tools render e.userMessage when present (video-merge, join, …): name the CAUSE — engine could not be loaded / connection — instead of their generic "did not finish" text. The no-SIMD legacy adapter used to carry its own userMessage; the ladder is the only engine path now, so it carries one too. */_initErr.userMessage=_initErr.message;throw _initErr/* expected=true matches the WASM_UNSUPPORTED / SIMD_UNSUPPORTED contract above — beforeSend drops; user UX already covered via __aeToolError + localized toast. (TIMBRICA-FRONTEND-93) */}catch(ex){var _xTxt=window.__ffErrText(ex);this._lastError="INIT_ERROR | "+_xTxt;_emit({phase:"failed",error:this._lastError});this._reportInitFailure("INIT_ERROR",[_xTxt]);o=!1;/* Same dashboard-visibility reason as wasm_init_failed: init_error covers
   the catch-before-loop path (wrapper script load, FFmpegWASM not found, etc.). */if(window.__aeToolError)try{var _ec=navigator.connection||navigator.mozConnection||{};window.__aeToolError({error_type:"wasm_init_error",method:"init",err_msg:_xTxt.substring(0,300),dm:navigator.deviceMemory||0,sab:typeof SharedArrayBuffer!=="undefined"?1:0,ct:_ec.effectiveType||"",dl:_ec.downlink||0,br:(window.__brOf?window.__brOf(navigator.userAgent):"other"),mob:/Mobi|Android|iPhone|iPad/i.test(navigator.userAgent)?1:0})}catch(_){}/* Reported just above (wasm_init_error + ffmpeg-status «failed»). INIT_FAILED already left with
   expected + alreadyReported + userMessage; this end did not, so the SAME environmental
   failure — the wrapper <script> that never answered (408 events / 30 days, RU) — reached
   Sentry as a bare unhandled rejection whenever a caller dropped the promise (Sentry
   TIMBRICA-FRONTEND-QP) and gave tools nothing to tell the person. Now both ends match. */
try{if(ex&&typeof ex==='object'){ex.alreadyReported=true;if(/^ENGINE_/.test(ex.code||'')||/FFmpegWASM not found|^load [/]/.test(String(ex.message||''))){ex.expected=true;if(!ex.userMessage)ex.userMessage=_engineLoadMessage()}}}catch(_){}throw ex}},/* onProgress(cb, opts) — honest progress.

   FFmpeg's own `progress` ratio is `out_time / <duration FFmpeg assumed>`,
   and that assumption is the LONGEST INPUT — not the output. Any job whose
   output is shorter than its longest input therefore has a bar with a
   ceiling below 100 %:

     ceiling = outputDuration / longestInputDuration

   Александр #1229 (2026-07-30, sid 6298c54e, installed PWA on Android 10)
   attached a 2 min 40 s music track to a 19-second 4K clip. 19/160 = 0.1189,
   so his bar climbed to 12 % in a couple of seconds and then FROZE there for
   the minutes the 75 MB container copy + AAC encode actually took. He
   rage-clicked the frozen «Экспорт видео… 12%», cancelled, retried, cancelled
   — three times — and wrote «Останавливается на 12%. В ноутбуке было
   оперативно. В приложении — тормоз!!!». The laptop was not faster in any
   meaningful sense; it just finished before the frozen bar had time to look
   broken. Measured end to end in tests/playwright/add-music-progress-trace.mjs.

   The event also carries `time` (output position in MICROSECONDS — verified
   empirically: a 19.017 s output reports 19017143), which the old
   implementation threw away. So a caller that knows its true output length
   can have an exact bar; one that doesn't keeps the previous behaviour.

     opts.outDurationSec  true output duration → ratio = time / outDuration
     cb(ratio, info)      info = { timeSec, rawRatio } for ETA/telemetry

   Monotonic by construction: a progress bar that walks backwards reads as a
   glitch, and FFmpeg does emit the occasional out-of-order tick. */
onProgress(t,_opts){/* Pre-init registration must STORE the handler, not bail: init's
ready-hook re-attaches this._progressHandler once the instance exists, so the
old `if(!e)return` silently dropped any callback registered during a cold
start — the whole run then showed a dead 0%→100% bar (intermittent: warm
starts had `e` by click time). Seen as the video-fps fallback-suite flake;
affects every FFmpeg tool's progress under cold-start timing. */this._progressHandler&&e&&e.off("progress",this._progressHandler);/* Keep the RAW callback so a lane that must borrow the subscription can give it back (reverseChunked). Without this, "restore what was there" is not expressible and the borrower has to leave its own mapping installed for the rest of the run. */this._progressRaw=t;var _outDur=(_opts&&+_opts.outDurationSec>0)?+_opts.outDurationSec:0;var _hi=0,_prev=-1;this._progressHandler=function(ev){/* An output with no timestamps (rawvideo, the null muxer of a probe) reports its time as INT64_MAX µs — 9.2e12 s. Taken for a time it made time ÷ length = 100 % and pinned the high-water mark there for the rest of the subscription (the sound pass of /enhance-video's hybrid lane: 80 → 93 % at once, then frozen; 2026-10-02). Such an event carries no position — skip it. */if(ev&&typeof ev.time==="number"&&Math.abs(ev.time)>=1e15)return;var _tSec=(ev&&typeof ev.time==="number"&&isFinite(ev.time))?ev.time/1e6:NaN;var _raw=(ev&&typeof ev.progress==="number"&&isFinite(ev.progress))?ev.progress:NaN;/* A retry (reinit + re-exec, e.g. the codec-mux fallback) restarts the
   job from zero while THIS subscription survives — init() re-attaches the
   stored handler. Without noticing that, the high-water mark below would pin
   the bar at whatever the failed attempt reached and freeze it for the whole
   retry: the very symptom this function exists to remove. A raw position that
   jumps meaningfully BACKWARDS is the restart signal; reset the mark. */
if(isFinite(_raw)&&_prev>=0&&_raw<_prev-0.02)_hi=0;if(isFinite(_raw))_prev=_raw;var r;if(_outDur>0&&isFinite(_tSec)&&_tSec>=0){r=_tSec/_outDur}else{r=_raw}if(typeof r!=="number"||!isFinite(r)||r<0)r=0;if(r>1)r=1;if(r<_hi)r=_hi;_hi=r;try{t(r,{timeSec:isFinite(_tSec)?_tSec:null,rawRatio:isFinite(_raw)?_raw:null})}catch(_){}};if(e)e.on("progress",this._progressHandler)},async process(t,o,n,i,a,_retry){if(!r||!e)await FFmpegProcessor.init();if(!r||!e)throw new Error("FFmpeg not initialized");if(!_retry&&window.__stage)try{window.__stage("processing",{out:n})}catch(_){}try{o=window.FFmpegDelayCompensation.apply(o);o=window.FFmpegResampleQuality.apply(o)}catch(_){}/* Компенсация задержки фильтров с lookahead — ЕДИНСТВЕННАЯ точка на все браузерные тулы. Идемпотентна: на ретрае повторно не применится (пометка asetpts=PTS-STARTPTS). fail-open: сбой компенсации не должен ронять экспорт. */var s="tmp";t.name&&(s=t.name.split(".").pop()||"tmp");s=s.toLowerCase();/* Default input name is UNIQUE per call (same rule as analyzeLoudness's
   lnprobe_N): concurrent background flows (thumbnails, decode shim) sharing
   the fixed "input.<ext>" clobbered each other in MEMFS — one flow's
   finally-cleanup deleted another's in-flight input ("input.mp4: No such
   file or directory", prod 07-15). Callers passing an explicit name keep it. */
FFmpegProcessor._inSeq=(FFmpegProcessor._inSeq||0)+1;
var p=i?_ffCallFsName(i,FFmpegProcessor._inSeq):("input_"+FFmpegProcessor._inSeq+"."+s),_on=_ffCallFsName(n,FFmpegProcessor._inSeq),f=t.size||t.byteLength||0;var _fmtHints={m4a:"mp4",aac:"aac","3gp":"3gp",caf:"caf"};if(_fmtHints[s]){if(!a)a=[];if(a.indexOf("-f")===-1)a=["-f",_fmtHints[s]].concat(a);}var _outExt=n.split(".").pop();/* Alias output ext (defensive): outName "output.weba" would hit
   "Unable to find a suitable output format" - map muxer explicitly. */
var _outCanon=normEx(_outExt);if(_outCanon!==(_outExt||"").toLowerCase()&&o.indexOf("-f")===-1){o=o.concat(["-f",_outCanon]);}/* Auto -movflags +faststart for MP4-family output (mp4/m4a/m4b/m4r/m4p/mov/3gp/3gpp). Without this, FFmpeg's default writes the moov atom at the END of the file. For files >~50 MB the moov box itself grows past the 512 KB tail window our Tier 0 moov-missing probe (audio-recover.js::detectMoovMissing) reads, producing a FALSE-POSITIVE "moov atom missing" rejection on a file that is structurally fine — and crucially affecting files we just emitted from /repair-audio + /extract-audio (olgs-ra@mail.ru 2026-06-17: 58.6 MB session 5_repaired.m4a from our OWN repair tool rejected by our OWN trim tool, user gave up). +faststart costs a second mux pass (~0.5-1 s on 58 MB WASM) and produces output that is universally streamable: HTML5 <audio> demuxer accepts it (currently rejects moov-at-end), mobile players accept it, Tier 0 probe finds moov in the head. Skip if caller already passed -movflags. */var _isMp4Family=/^(mp4|m4a|m4b|m4r|m4p|mov|3gp|3gpp)$/i.test(_outExt||"");if(_isMp4Family&&o.indexOf("-movflags")===-1&&(!a||a.indexOf("-movflags")===-1))o=o.concat(["-movflags","+faststart"]);/* Auto -ar/-ac for mp3 outputs covers the re-encode case where caller didn't specify sr/channels. But when args already contain `-c copy` (re-mux, no decode), -ar/-ac are NOT free flags — FFmpeg applies them via implicit filter graph on top of -c copy and for VBR MP3 with broken/missing LAME header the graph picks up time_base=1/0 from the source → throws "Error setting option time_base to value 1/0 | Error applying options to the filter". audio-metadata save uses -c copy for every metadata-only edit, so this auto-injection turned every borderline VBR-MP3 into a save failure (3 events / 2 sessions / 7 d on /audio-metadata pre-fix). Skip auto-injection in copy mode; re-encode callers still get the defaults. */var _copyIdx=o.indexOf("-c");var _isCopyMode=_copyIdx!==-1&&o[_copyIdx+1]==="copy";if(!_isCopyMode){/* 2026-08-13: ЗДЕСЬ СТОЯЛА ПОДСТАНОВКА `-ar 44100` и `-ac 2` для любого mp3-вывода без явных значений. Она появилась 2026-03-31 (3004d6cdac) против 8 телеметрических ошибок "96kHz sample rate" и с тех пор молча переопределяла НАМЕРЕНИЕ вызывающего: отсутствие `-ar` значит "я не знаю частоту", а не "поставь 44100". ЗАМЕРЕНО на нашей же WASM-сборке 2026-08-13 (tests/playwright/ffmpeg-processor-no-injection.mjs): без `-ar` libmp3lame сам выбирает 48000 для источников 192/96/48 кГц (exit 0), сам сводит 5.1 в стерео и сам оставляет моно моно. То есть подстановка ничего не страховала, а делала три вещи: роняла 48 кГц до 44.1 у всех, кто частоту не передаёт (music-mastering, equalizer, midi, multi-track, morse-generator, audio-to-video), поднимала МОНО до стерео, тратя половину битрейта на дубль канала, и расходилась с lite-лейном, который сохранял 48 кГц — одна кнопка, два ответа. Кодек-ограничения теперь остаются за FFmpeg (он их знает и применяет), а тот, кому нужно ПРЕДСКАЗАТЬ результат заранее, спрашивает window.__audioCodecLimits. Не возвращать константы: если снова всплывёт формат, который FFmpeg не свёл сам, — передавайте значение ЯВНО со стороны вызывающего, который знает источник. *//* loudnorm internally upsamples the whole filter graph to 192 kHz and leaves it there: WAV/FLAC/OGG outputs ship at 192 kHz (4x size bloat), AAC mutates to its 96 kHz cap. Safety net for audio outputs whose -af/-filter_complex contains loudnorm and no explicit rate: pin 48 kHz. Explicit -ar in args/preInputArgs always wins; chains that already carry their own aresample are trusted; copy mode already excluded by the branch above. NOTE: the codec map closure var is shadowed here by process()'s local `s` (input ext string) — gate on the config map / an audio-ext list instead. */var _audioOut=!!((window.__FFMPEG_CONFIG__&&window.__FFMPEG_CONFIG__.codecs&&window.__FFMPEG_CONFIG__.codecs[_outExt])||/^(mp3|wav|flac|ogg|oga|m4a|aac|opus|wma|aiff|aif|amr|mka|m4r|caf|gsm|awb|ac3)$/.test(_outExt||""));/* 2026-09-12: the net used to be gated on `_audioOut` — a VIDEO container with
   a loudnorm chain (video-audio's export) sailed past it and shipped 96 kHz AAC
   from a 44.1 kHz source. Any output whose chain carries loudnorm is re-encoding
   its audio, so the pin is right for all of them. */if(o.indexOf("-ar")===-1&&(!a||a.indexOf("-ar")===-1)){var _afi=o.indexOf("-af");if(_afi===-1)_afi=o.indexOf("-filter_complex");var _afv=String((_afi!==-1&&o[_afi+1])||"");if(/(^|,|\[|\]|;)loudnorm/.test(_afv)&&!/aresample/.test(_afv))o=o.concat(["-ar","48000"]);}}var _devMem=navigator.deviceMemory||0;if(_devMem>0&&f>0){var _needMB=Math.ceil(f/1048576)*3;if(_needMB>_devMem*1024*0.5){console.warn("[ffmpeg] file needs ~"+_needMB+"MB but device has "+_devMem+"GB RAM");if(window.__toast){var _loc=window.__LOCALE||"en";var _memWarn={en:"This file may be too large for your device's memory. Processing may fail.",ru:"\u042d\u0442\u043e\u0442 \u0444\u0430\u0439\u043b \u043c\u043e\u0436\u0435\u0442 \u0431\u044b\u0442\u044c \u0441\u043b\u0438\u0448\u043a\u043e\u043c \u0431\u043e\u043b\u044c\u0448\u0438\u043c \u0434\u043b\u044f \u043f\u0430\u043c\u044f\u0442\u0438 \u0432\u0430\u0448\u0435\u0433\u043e \u0443\u0441\u0442\u0440\u043e\u0439\u0441\u0442\u0432\u0430. \u041e\u0431\u0440\u0430\u0431\u043e\u0442\u043a\u0430 \u043c\u043e\u0436\u0435\u0442 \u043d\u0435 \u0443\u0434\u0430\u0442\u044c\u0441\u044f.",ko:"\uc774 \ud30c\uc77c\uc740 \uae30\uae30 \uba54\ubaa8\ub9ac\uc5d0 \ube44\ud574 \ub108\ubb34 \ud074 \uc218 \uc788\uc2b5\ub2c8\ub2e4.",ar:"\u0647\u0630\u0627 \u0627\u0644\u0645\u0644\u0641 \u0642\u062f \u064a\u0643\u0648\u0646 \u0643\u0628\u064a\u0631\u064b\u0627 \u062c\u062f\u064b\u0627 \u0644\u0630\u0627\u0643\u0631\u0629 \u062c\u0647\u0627\u0632\u0643.",id:"File ini mungkin terlalu besar untuk memori perangkat Anda.",pt:"Este arquivo pode ser grande demais para a mem\u00f3ria do seu dispositivo.",de:"Diese Datei ist m\u00f6glicherweise zu gro\u00df f\u00fcr den Speicher Ihres Ger\u00e4ts.",es:"Este archivo puede ser demasiado grande para la memoria de tu dispositivo.",fr:"Ce fichier est peut-\u00eatre trop volumineux pour la m\u00e9moire de votre appareil.", uk: "Файл може бути надто великим для пам’яті вашого пристрою. Обробка може не завершитися.", tr: "Bu dosya, cihazınızın belleği için çok büyük olabilir. İşlem başarısız olabilir."};window.__toast(_memWarn[_loc]||_memWarn.en,"warning")}}}console.log("[ffmpeg] process:",p,"→",n,"| input size:",f,"| args:",o.join(" "),a?"| pre-input: "+a.join(" "):"");var l=await m(t);/* snapshot first 64 bytes BEFORE writeFile — emscripten FS.writeFile can detach the input ArrayBuffer, leaving l.length===0 by the time an exec error fires __enrichFFmpegError. .slice() copies into an own buffer that survives detach (header_hex was 0/227 in prod telemetry before this). */var _hdr64=null;try{if(l&&l.length)_hdr64=l.slice(0,Math.min(64,l.length))}catch(_h){}if(l.length===0){try{navigator.sendBeacon("/api/log-error",JSON.stringify([{type:"ffmpeg-critical",src:"empty-input|"+p+"|fileSize="+f+"|cached=fb",page:location.pathname,ua:navigator.userAgent.substring(0,200)}]))}catch(_e){}throw new Error("Input file is empty (0 bytes). Please re-upload your file.")};console.log("[ffmpeg] writeFile:",p,"| bytes:",l.length),await e.writeFile(p,l);try{var u=[];a&&a.length&&(u=u.concat(a)),u.push("-i",p),u=u.concat(o).concat(["-y",_on]),console.log("[ffmpeg] exec:",u.join(" "));window._ffLogs=[];var x=await e.exec(u);console.log("[ffmpeg] exec done, exit code:",x);if(x!==0){var _tail=window.__ffErrTail(window._ffLogs);var _exitErr="FFmpeg exit code "+x+(_tail?": "+_tail:"");if(!window.__suppressWasmLog){try{navigator.sendBeacon("/api/log-error",JSON.stringify([{type:"ffmpeg-exit",src:p+"→"+n+"|code="+x+"|"+(_tail||"").substring(0,150),page:location.pathname,ua:navigator.userAgent.substring(0,200)}]))}catch(_e){}}throw new Error(_exitErr)};try{await e.deleteFile(p)}catch(_dp){}console.log("[ffmpeg] reading output...");var g=await e.readFile(_on);console.log("[ffmpeg] output size:",g.length,"| buffer size:",g.buffer.byteLength);if(g.length===0&&!window.__suppressWasmLog){try{navigator.sendBeacon("/api/log-error",JSON.stringify([{type:"ffmpeg-critical",src:"empty-output|"+p+"→"+n+"|inputSize="+f,page:location.pathname,ua:navigator.userAgent.substring(0,200)}]))}catch(_e){}}/* free the MEMFS output BEFORE the Blob copy: otherwise the output exists 3x at once (MEMFS + readFile buffer + Blob) — the 2 GB-phone OOM class from /video-loop 2026-08-12 (28 MB x3 -> ~330 MB peak, 12-min crawl, empty-message death). Input p freed above for the same reason; finally-deletes remain as no-op safety nets. */try{await e.deleteFile(_on)}catch(_dn){}var w=n.split(".").pop();/* WAV: тег обязан лежать ПОСЛЕ чанка `data` — иначе Проводник Windows не показывает НИ ОДНОГО поля в свойствах файла (замер 2026-09-07, Windows 11 26200, обработчик mfsrcsnk.dll: те же байты INFO читаются до `fmt ` и после `data`, между ними — пусто). FFmpeg кладёт LIST/INFO именно между ними, поэтому у тула, который печатает исполнителя рядом с выбором «WAV» (/extract-audio), тег до свойств не доезжал. Правило живёт ОДНИМ куском в audio-tag-writer.js — здесь только вызов, второй копии обхода чанков нет. Функция отдаёт КУСКИ исходных байтов (Blob склеит без лишней полной копии — экспорт WAV бывает в сотни МБ) и null, когда делать нечего: не-WAV, тег уже за data, врущий размер data, или в INFO только подпись кодировщика. Fail-open: любая осечка оставляет прежнюю выдачу. */var _wavParts=null;if(w==="wav"&&window.AudioTag&&window.AudioTag.riffTagsAfterDataParts){try{_wavParts=window.AudioTag.riffTagsAfterDataParts(g)}catch(_rt){}}var d=new Blob(_wavParts||[g],{type:c[w]||"application/octet-stream"});_wavParts=null;g=null;return console.log("[ffmpeg] blob size:",d.size,"| success"),{blob:d,name:n,url:URL.createObjectURL(d),size:d.size}}catch(_procErr){var _retryCount=typeof _retry==='number'?_retry:(_retry?1:0);/* "memory access out of bounds" joined the corrupted-arena retry class 2026-07-23: measured on prod, 120/127 OOBs enter via process(), 94% of sized ones are files ≤100 MB on 8 GB devices (video-crop died on a 4 MB file) — a WEDGED arena after prior ops, not real OOM; users healed themselves with F5, which is exactly reinit(). Genuine big-file OOM just fails again and surfaces after the bounded 2 retries; a fragmented-arena big file may even pass on the fresh arena. */if(_retryCount<2&&_procErr&&_procErr.message&&(/apply/.test(_procErr.message)||/undefined/.test(_procErr.message)||/memory access out of bounds/i.test(_procErr.message))){console.warn("[ffmpeg] WASM corrupted, reinitializing and retrying ("+(_retryCount+1)+"/2)…");try{navigator.sendBeacon("/api/log-error",JSON.stringify([{type:"ffmpeg-reinit",src:p+"→"+n+"|attempt="+(_retryCount+1)+"|"+(_procErr&&_procErr.message||"").substring(0,100),page:location.pathname,ua:navigator.userAgent.substring(0,200)}]))}catch(_b){}try{await e.deleteFile(p)}catch(_x){}try{await e.deleteFile(_on)}catch(_x){}await FFmpegProcessor.reinit();/* Second attempt also releases the cached file bytes — emscripten FS.writeFile can detach ArrayBuffer after several consecutive ops, and the next read re-loads from the File handle. Without this 2nd attempt = guaranteed repeat of 1st. */if(_retryCount===1&&t instanceof File&&window.FileBytes&&typeof window.FileBytes.release==='function'){try{window.FileBytes.release(t)}catch(_ev){}}return FFmpegProcessor.process(t,o,n,i,a,_retryCount+1)}try{if(/FILE_LOST/i.test(_procErr&&_procErr.message)){navigator.sendBeacon("/api/log-error",JSON.stringify([{type:"ffmpeg-critical",src:"file_lost|"+p+"→"+n+"|size="+f+"|cached=fb",page:location.pathname,ua:navigator.userAgent.substring(0,200)}]))}if(window.__aeToolError&&!window.__suppressWasmLog&&!(/terminate/i.test(_procErr&&_procErr.message))){var _errMsg=(_procErr&&_procErr.message||"").substring(0,200);if(_errMsg){var _now=Date.now();if(!window.__lastWasmErrTs||_now-window.__lastWasmErrTs>60000){window.__lastWasmErrTs=_now;window.__aeToolError(window.__enrichFFmpegError?window.__enrichFFmpegError({error_type:"wasm_process",method:"process",err_msg:_errMsg,file_size:f,file_type:t.type||"",file_name:(t.name||n).split(".").pop(),out_name:n,br:(window.__brOf?window.__brOf(navigator.userAgent):"other"),mob:/Mobi|Android|iPhone/i.test(navigator.userAgent)?1:0,devMem:navigator.deviceMemory||0,hintMB:(typeof window.__effectiveFileLimit==="function")?Math.round(window.__effectiveFileLimit(/video/i.test(t.type||"")?"video":/image/i.test(t.type||"")?"image":"audio")/1048576):0,fileMB:Math.round(f/1048576)},{file:t,bytes:_hdr64,logs:window._ffLogs}):{error_type:"wasm_process",method:"process",err_msg:_errMsg,file_size:f,file_type:t.type||"",file_name:(t.name||n).split(".").pop(),out_name:n,br:(window.__brOf?window.__brOf(navigator.userAgent):"other"),mob:/Mobi|Android|iPhone/i.test(navigator.userAgent)?1:0,devMem:navigator.deviceMemory||0,hintMB:(typeof window.__effectiveFileLimit==="function")?Math.round(window.__effectiveFileLimit(/video/i.test(t.type||"")?"video":/image/i.test(t.type||"")?"image":"audio")/1048576):0,fileMB:Math.round(f/1048576)})}}}}catch(_te){}try{var _cls=FFmpegProcessor.classifyError(_procErr);_procErr.errorType=_cls;if(_cls==="memory")_procErr.wasmOOM=true;_procErr.userMessage=FFmpegProcessor.getErrorMessage(_procErr,f)}catch(_em){}throw _procErr}finally{try{await e.deleteFile(p)}catch(e){}try{await e.deleteFile(_on)}catch(e){}}},async processMulti(t,o,n){if(!r||!e)await FFmpegProcessor.init();if(!r||!e)throw new Error("FFmpeg not initialized");try{o=window.FFmpegDelayCompensation.apply(o);o=window.FFmpegResampleQuality.apply(o)}catch(_){}/* Компенсация задержки фильтров с lookahead. process() — не единственная дверь в ffmpeg: processMulti/processMultiStreaming строят аргументы сами и exec-ают напрямую, поэтому и до них правка иначе не доходила. Идемпотентна, fail-open. */for(var i=[],a=0;a<t.length;a++){var _ext=t[a].name?t[a].name.split(".").pop():"";if(!_ext||_ext===t[a].name)_ext="tmp";var s="input"+a+"."+_ext;i.push(s);var _d=await m(t[a]);if(_d.length===0)throw new Error("Input file #"+a+" is empty (0 bytes). Please re-upload.");await e.writeFile(s,_d)}for(var p=[],f=0;f<i.length;f++)p.push("-i",i[f]);p=p.concat(o).concat(["-y",n]);window._ffLogs=[];var x2=await e.exec(p);if(x2!==0){var _tail=window.__ffErrTail(window._ffLogs);throw new Error("FFmpeg exit code "+x2+(_tail?": "+_tail:""))};for(var l=await e.readFile(n),u=0;u<i.length;u++)await e.deleteFile(i[u]);await e.deleteFile(n);var g=n.split(".").pop();/* WAV: тот же перенос тега за чанк `data`, что и в process() — иначе Проводник Windows не показывает полей. Эта дверь тоже отдаёт WAV с тегом пользователя: /audio-watermark пишет сюда `-metadata comment=`. */var _wmParts=null;if(g==="wav"&&window.AudioTag&&window.AudioTag.riffTagsAfterDataParts){try{_wmParts=window.AudioTag.riffTagsAfterDataParts(l)}catch(_rt){}}var w=new Blob(_wmParts||[l],{type:c[g]||"application/octet-stream"});_wmParts=null;return{blob:w,name:n,url:URL.createObjectURL(w),size:w.size}},async processSegments(t,s,o,n){if(!r||!e)await FFmpegProcessor.init();if(!r||!e)throw new Error("FFmpeg not initialized");try{o=window.FFmpegDelayCompensation.apply(o);o=window.FFmpegResampleQuality.apply(o)}catch(_){}/* Компенсация задержки фильтров с lookahead. process() — не единственная дверь в ffmpeg: processMulti/processMultiStreaming строят аргументы сами и exec-ают напрямую, поэтому и до них правка иначе не доходила. Идемпотентна, fail-open. */var p="tmp";t.name&&(p=t.name.split(".").pop()||"tmp");var f="input."+p,d=t.size||t.byteLength||0;console.log("[ffmpeg] processSegments:",s.length,"segments | input:",f,"| size:",d);var l=await m(t);if(l.length===0){try{navigator.sendBeacon("/api/log-error",JSON.stringify([{type:"ffmpeg-critical",src:"empty-input|"+p+"|fileSize="+f+"|cached=fb",page:location.pathname,ua:navigator.userAgent.substring(0,200)}]))}catch(_e){}throw new Error("Input file is empty (0 bytes). Please re-upload your file.")};await e.writeFile(f,l);try{var u=[];for(var i=0;i<s.length;i++)u.push("-ss",s[i].start.toFixed(6),"-to",s[i].end.toFixed(6),"-i",f);u=u.concat(o).concat(["-y",n]),console.log("[ffmpeg] exec:",u.join(" "));window._ffLogs=[];var x=await e.exec(u);if(x!==0){var _tail=window.__ffErrTail(window._ffLogs);var _exitErr="FFmpeg exit code "+x+(_tail?": "+_tail:"");if(!window.__suppressWasmLog){try{navigator.sendBeacon("/api/log-error",JSON.stringify([{type:"ffmpeg-exit",src:p+"→"+n+"|code="+x+"|"+(_tail||"").substring(0,150),page:location.pathname,ua:navigator.userAgent.substring(0,200)}]))}catch(_e){}}throw new Error(_exitErr)};var g=await e.readFile(n),w=n.split(".").pop(),b=new Blob([g],{type:c[w]||"application/octet-stream"});return console.log("[ffmpeg] segments done | output size:",b.size),{blob:b,name:n,url:URL.createObjectURL(b),size:b.size}}finally{try{await e.deleteFile(f)}catch(e){}try{await e.deleteFile(n)}catch(e){}}},async concatSegments(t,s,n,o){if(!r||!e)await FFmpegProcessor.init();if(!r||!e)throw new Error("FFmpeg not initialized");var p="tmp";t.name&&(p=t.name.split(".").pop()||"tmp");var f="input."+p;console.log("[ffmpeg] concatSegments (copy):",s.length,"segments | input:",f);var l=await m(t);if(l.length===0){try{navigator.sendBeacon("/api/log-error",JSON.stringify([{type:"ffmpeg-critical",src:"empty-input|"+p+"|fileSize="+f+"|cached=fb",page:location.pathname,ua:navigator.userAgent.substring(0,200)}]))}catch(_e){}throw new Error("Input file is empty (0 bytes). Please re-upload your file.")};await e.writeFile(f,l);var temps=[];try{for(var i=0;i<s.length;i++){var seg="seg_"+i+"."+p;temps.push(seg);var a=["-ss",s[i].start.toFixed(6),"-to",s[i].end.toFixed(6),"-i",f,"-c","copy"];if(o&&o.muteAudio)a.push("-an");a.push("-y",seg);console.log("[ffmpeg] extract seg",i,":",s[i].start.toFixed(2),"-",s[i].end.toFixed(2));window._ffLogs=[];var x=await e.exec(a);if(x!==0){var _tail=window.__ffErrTail(window._ffLogs);throw new Error("Segment "+i+" extraction failed (exit code "+x+(_tail?": "+_tail:"")+")")}}var list="";for(var j=0;j<temps.length;j++)list+="file '"+temps[j]+"'\n";await e.writeFile("list.txt",new TextEncoder().encode(list));var _oe=(n.split(".").pop()||"").toLowerCase(),_mp4f=_oe==="mp4"||_oe==="mov"||_oe==="m4v";var ca=["-f","concat","-safe","0","-i","list.txt","-c","copy"];if(_mp4f)ca.push("-avoid_negative_ts","make_zero","-movflags","+faststart");ca.push("-y",n);console.log("[ffmpeg] concat:",ca.join(" "));var x2=await e.exec(ca);if(x2!==0)throw new Error("Concat failed (exit code "+x2+")");var g=await e.readFile(n),w=n.split(".").pop(),b=new Blob([g],{type:c[w]||"application/octet-stream"});return console.log("[ffmpeg] concatSegments done | output:",b.size),{blob:b,name:n,url:URL.createObjectURL(b),size:b.size}}finally{for(var k=0;k<temps.length;k++){try{await e.deleteFile(temps[k])}catch(e){}}try{await e.deleteFile("list.txt")}catch(e){}try{await e.deleteFile(f)}catch(e){}try{await e.deleteFile(n)}catch(e){}}},async reencodeAndConcat(t,s,o,n,i){if(!r||!e)await FFmpegProcessor.init();if(!r||!e)throw new Error("FFmpeg not initialized");try{o=window.FFmpegDelayCompensation.apply(o);o=window.FFmpegResampleQuality.apply(o)}catch(_){}/* Компенсация задержки фильтров с lookahead. process() — не единственная дверь в ffmpeg: processMulti/processMultiStreaming строят аргументы сами и exec-ают напрямую, поэтому и до них правка иначе не доходила. Идемпотентна, fail-open. */var p="tmp";t.name&&(p=t.name.split(".").pop()||"tmp");var f="input."+p,d=n.split(".").pop();console.log("[ffmpeg] reencodeAndConcat:",s.length,"segments | input:",f);var l=await m(t);if(l.length===0){try{navigator.sendBeacon("/api/log-error",JSON.stringify([{type:"ffmpeg-critical",src:"empty-input|"+p+"|fileSize="+f+"|cached=fb",page:location.pathname,ua:navigator.userAgent.substring(0,200)}]))}catch(_e){}throw new Error("Input file is empty (0 bytes). Please re-upload your file.")};await e.writeFile(f,l);var temps=[];try{for(var j=0;j<s.length;j++){var seg="seg_"+j+"."+d;temps.push(seg);var a=["-ss",s[j].start.toFixed(6),"-to",s[j].end.toFixed(6),"-i",f];if(j===0&&i&&i.firstArgs)a=a.concat(i.firstArgs);if(j===s.length-1&&i&&i.lastArgs)a=a.concat(i.lastArgs);a=a.concat(o);if(i&&i.muteAudio)a.push("-an");a.push("-y",seg);console.log("[ffmpeg] encode seg",j,":",s[j].start.toFixed(2),"-",s[j].end.toFixed(2));window._ffLogs=[];var x=await e.exec(a);if(x!==0){var _tail=window.__ffErrTail(window._ffLogs);throw new Error("Segment "+j+" encoding failed (exit code "+x+(_tail?": "+_tail:"")+")")}/* Wave 15 (2026-06-04) per-segment progress — fire i.onSegmentDone(idxComplete,total) after each successful segment so callers (enhance-video chip strip) can light up a chip per segment. Swallow exceptions: a UI bug in the chip render must not kill the encode. */if(i&&typeof i.onSegmentDone==='function')try{i.onSegmentDone(j+1,s.length)}catch(_seg){}/* Wave 16 (2026-06-04) per-segment cumulative partial — when caller passes i.onPartialReady, build a fast `-c copy` concat of segments[0..j] into a playable mp4 blob covering "0 .. current_time" so the caller can persist it to IDB and surface a recovery banner if the tab dies mid-encode. Pattern lifted from /video-upscaler `_buildPartial` (ai-upscale-pipeline.js:204). Throttle via i.partialMinIntervalMs (default 25 s — matches video-upscaler's IDB_SAVE_THROTTLE_MS) so we don't write a partial after every 1-s segment. Partial-build failures are swallowed: the main encode keeps going, the caller doesn't get a partial for that segment, the next segment may succeed. */if(i&&typeof i.onPartialReady==='function'){var _w16Now=performance.now?performance.now():new Date().getTime();var _w16Throttle=typeof i.partialMinIntervalMs==='number'?i.partialMinIntervalMs:25000;var _w16IsLast=j+1===s.length;if(!i._w16LastT||(_w16Now-i._w16LastT)>=_w16Throttle||_w16IsLast){i._w16LastT=_w16Now;try{var _w16List='';for(var _w16K=0;_w16K<=j;_w16K++)_w16List+="file 'seg_"+_w16K+"."+d+"'\n";await e.writeFile('partial_list.txt',new TextEncoder().encode(_w16List));var _w16OutExt=(n.split('.').pop()||'mp4').toLowerCase();var _w16OutName='partial_w16.'+_w16OutExt;var _w16IsMp4=_w16OutExt==='mp4'||_w16OutExt==='mov'||_w16OutExt==='m4v';var _w16Args=['-f','concat','-safe','0','-i','partial_list.txt','-c','copy'];if(_w16IsMp4)_w16Args.push('-avoid_negative_ts','make_zero','-movflags','+faststart');_w16Args.push('-y',_w16OutName);var _w16Rc=await e.exec(_w16Args);if(_w16Rc===0){var _w16Bytes=await e.readFile(_w16OutName);var _w16Copy=_w16Bytes&&_w16Bytes.slice?_w16Bytes.slice():new Uint8Array(_w16Bytes);var _w16Blob=new Blob([_w16Copy],{type:c[_w16OutExt]||'video/mp4'});var _w16SecsDone=0;for(var _w16Si=0;_w16Si<=j&&_w16Si<s.length;_w16Si++)_w16SecsDone+=Math.max(0,(s[_w16Si].end||0)-(s[_w16Si].start||0));var _w16SecsTotal=0;for(var _w16Ti=0;_w16Ti<s.length;_w16Ti++)_w16SecsTotal+=Math.max(0,(s[_w16Ti].end||0)-(s[_w16Ti].start||0));try{i.onPartialReady(_w16Blob,_w16SecsDone,_w16SecsTotal,j+1,s.length)}catch(_w16Cb){}}try{await e.deleteFile(_w16OutName)}catch(_){}try{await e.deleteFile('partial_list.txt')}catch(_){}}catch(_w16E){console.warn('[ffmpeg] partial build failed (non-fatal):',_w16E&&_w16E.message)}}}}var list="";for(var k=0;k<temps.length;k++)list+="file '"+temps[k]+"'\n";await e.writeFile("list.txt",new TextEncoder().encode(list));var _oe=(n.split(".").pop()||"").toLowerCase(),_mp4f=_oe==="mp4"||_oe==="mov"||_oe==="m4v";var ca=["-f","concat","-safe","0","-i","list.txt","-c","copy"];if(_mp4f)ca.push("-avoid_negative_ts","make_zero","-movflags","+faststart");ca.push("-y",n);console.log("[ffmpeg] concat:",ca.join(" "));var x2=await e.exec(ca);if(x2!==0)throw new Error("Concat failed (exit code "+x2+")");var g=await e.readFile(n),w=n.split(".").pop(),b=new Blob([g],{type:c[w]||"application/octet-stream"});return console.log("[ffmpeg] reencodeAndConcat done | output:",b.size),{blob:b,name:n,url:URL.createObjectURL(b),size:b.size}}finally{for(var k=0;k<temps.length;k++){try{await e.deleteFile(temps[k])}catch(e){}}try{await e.deleteFile("list.txt")}catch(e){}try{await e.deleteFile(f)}catch(e){}try{await e.deleteFile(n)}catch(e){}}},/* Two-pass loudnorm, pass 1: run `-af [afChain,]loudnorm=<ln>:print_format=json` to a null sink and return the measured stats. Why this exists: one-pass loudnorm is ALWAYS dynamic (linear=true without measured_* is silently ignored) — dynamic mode pumps gated pauses back up (returns denoised hiss) and resamples the graph to 192 kHz. Callers wanting clean static normalization measure here, then encode with measured_*+linear=true and pin the rate after the filter. Uses its own log listener — window._ffLogs keeps only the last 20 lines. */async analyzeLoudness(t,afChain,ln){
/* ── The measure pass is the expensive half, and it is repeatable ──────────
   Two-pass loudnorm runs the WHOLE chain over the WHOLE file once just to
   produce five numbers, and only then encodes. Measured natively on 360 s of
   audio, single-threaded, medians of three alternating runs:
       the filter chain alone                 4.0 s
       + ebur128 (measurement)                5.0 s
       + loudnorm DYNAMIC  (= this pass)     11.3 s
       + loudnorm linear   (= the encode)     4.5 s
   The same shape shows in the product's own telemetry: on a 42-minute file the
   tool spends 92 s here and 54 s encoding.

   Those five numbers are a pure function of (file, pre-chain, loudnorm target).
   Nothing about them is per-attempt — yet bug report #6590 paid for them SEVEN
   times in fifty minutes: a Премиум user on an iPhone whose tab was killed
   90-120 s into each export, i.e. inside or just after this pass, and who
   started again from zero every time. Remembering the answer turns his second
   attempt from 146 s of exposure into ~54 s.

   It also covers the ordinary case that produced the same waste without any
   crash: he changed the OUTPUT FORMAT between attempts (mp3 → m4a). The
   pre-chain did not change, so pass 1 was recomputed for nothing.

   localStorage, not memory: the tab death is the case this exists for.
   The key carries everything the answer depends on — the platform's file
   identity triple plus the exact chain and target text — so a changed preset,
   a changed noise setting or a different file cannot collide. Fail-open at
   every step: this must never be the reason an export does not run. */
var _lnMemoKey=null;
try{
    if(t&&typeof t.size==='number'){
        var _kraw=(t.name||'')+'|'+t.size+'|'+(t.lastModified||0)+'|'+(afChain||'')+'|'+(ln||'');
        var _h=5381,_i2=0;for(;_i2<_kraw.length;_i2++)_h=((_h*33)^_kraw.charCodeAt(_i2))>>>0;
        _lnMemoKey='tmb:ln:'+_h.toString(36)+'.'+(_kraw.length.toString(36));
        var _hit=JSON.parse(localStorage.getItem(_lnMemoKey)||'null');
        if(_hit&&isFinite(_hit.input_i)&&(Date.now()-(_hit._at||0))<604800000){
            if(window.__ae)try{window.__ae('feature_use',{f:'loudnorm_memo',hit:1,
                slug:(window.__TOOL_SLUG||(document.querySelector('meta[name="tool-slug"]')||{}).content||''),
                ageMin:Math.round((Date.now()-(_hit._at||0))/60000)})}catch(_){}
            return{input_i:_hit.input_i,input_tp:_hit.input_tp,input_lra:_hit.input_lra,
                   input_thresh:_hit.input_thresh,target_offset:_hit.target_offset};
        }
    }
}catch(_lnm){_lnMemoKey=null;}
if(!r||!e)await FFmpegProcessor.init();if(!r||!e)throw new Error("FFmpeg not initialized");var _ext="tmp";t.name&&(_ext=(t.name.split(".").pop()||"tmp").toLowerCase());/* unique probe name: a cancelled measure's finally-delete must never race a successor's input */var p="lnprobe_"+(FFmpegProcessor._lnSeq=(FFmpegProcessor._lnSeq||0)+1)+"."+_ext,l=await m(t);if(!l||l.length===0)throw new Error("Input file is empty (0 bytes). Please re-upload your file.");await e.writeFile(p,l);var lines=[],cap=function(ev){lines.push(ev.message);if(lines.length>120)lines.splice(0,lines.length-120)};try{e.on("log",cap);var chain=(afChain?afChain+",":"")+"loudnorm="+(ln||"I=-16:TP=-1.5:LRA=11")+":print_format=json";var _lnPre=[];var _lnHints={m4a:"mp4",aac:"aac","3gp":"3gp",caf:"caf"};if(_lnHints[_ext])_lnPre=["-f",_lnHints[_ext]];var x=await e.exec(_lnPre.concat(["-i",p,"-af",chain,"-f","null","-"]));if(x!==0)throw new Error("loudnorm measure failed (exit code "+x+")");var txt=lines.join("\n"),mk=txt.lastIndexOf("Parsed_loudnorm"),js=txt.indexOf("{",mk),je=txt.indexOf("}",js);if(mk===-1||js===-1||je===-1)throw new Error("loudnorm stats not found in ffmpeg log");var st=JSON.parse(txt.substring(js,je+1));var _out={input_i:parseFloat(st.input_i),input_tp:parseFloat(st.input_tp),input_lra:parseFloat(st.input_lra),input_thresh:parseFloat(st.input_thresh),target_offset:parseFloat(st.target_offset)};/* Store only a finite answer, and keep the shelf short: these entries are    worth ~80 bytes each and a browser that refuses the write must not break    the export that just succeeded. */try{if(_lnMemoKey&&isFinite(_out.input_i)){var _rec={};for(var _k in _out)_rec[_k]=_out[_k];_rec._at=Date.now();localStorage.setItem(_lnMemoKey,JSON.stringify(_rec));var _keys=[];for(var _n=0;_n<localStorage.length;_n++){var _kk=localStorage.key(_n);if(_kk&&_kk.indexOf("tmb:ln:")===0)_keys.push(_kk);}if(_keys.length>24){var _aged=_keys.map(function(k){var v=0;try{v=(JSON.parse(localStorage.getItem(k)||"{}")._at)||0}catch(_){}return{k:k,at:v}});_aged.sort(function(a,b){return a.at-b.at});for(var _d=0;_d<_aged.length-24;_d++){try{localStorage.removeItem(_aged[_d].k)}catch(_){}}}if(window.__ae)try{window.__ae("feature_use",{f:"loudnorm_memo",hit:0,slug:(window.__TOOL_SLUG||(document.querySelector("meta[name=\"tool-slug\"]")||{}).content||"")})}catch(_){}}}catch(_lnw){}return _out}finally{try{e.off("log",cap)}catch(_){}try{await e.deleteFile(p)}catch(_){}}},getCodecArgs(e,t,_o){e=normEx(e);var r=s[e];if(!r)return[];var out;if(t){/* ONE door for the paid quality axis (Farid 2026-07-19 "cap source too", restated 2026-09-18 "качество снижается для тех кто не премиум"). Every tool that encodes audio arrives here with the bitrate it wants, and until now the ceiling was applied only where a tool happened to route through QualityModule.getArgs: measured 2026-09-18 on prod, 29 of 30 audio tools handed an anonymous user the full 192k, while their own limit block claimed 128. Clamping HERE means the rule cannot be forgotten by the next tool, and it is the same clamp everywhere: Premium passes through untouched, and a tier snapshot that has not landed yet never clamps (fail-open — otherwise a paying user who exports in the first second gets the guest ceiling). The clamped value is disclosed, not applied quietly: noteCeilingApplied publishes the plan line into the shared limit block. */try{if(window.__qualityTier&&typeof window.__qualityTier.clamp==="function"){var _capped=window.__qualityTier.clamp("kbps",t,_o);if(_capped!==t){t=_capped;if(typeof window.__qualityTier.noteCeilingApplied==="function")window.__qualityTier.noteCeilingApplied("kbps");}}}catch(_){}out=[];for(var n=0;n<r.length;n+=2)"-q:a"!==r[n]&&"-b:a"!==r[n]&&out.push(r[n],r[n+1]);if(q[e]){var qv=q[e][t];if(qv===undefined)qv=Math.round((t-32)/36);qv=Math.max(0,Math.min(10,qv));out.push("-q:a",String(qv))}else{out.push("-b:a",t+"k")}}else{out=r.slice()}if(!(window.ChannelModule&&window.ChannelModule.getArgs)){var ch=window.FormatSmart&&FormatSmart.getChannels?FormatSmart.getChannels():"auto";if(ch&&ch!=="auto"){var _fmt=(e||"").toLowerCase(),_n=parseInt(ch,10);/* per-format channel ceiling — single source of truth is config/formats.php 'max_channels' via __FFMPEG_CONFIG__ (this used to be a third hardcoded copy of the lists, and the copies had drifted) */var _mc=window.__FFMPEG_CONFIG__&&window.__FFMPEG_CONFIG__.maxChannels;var _cap=(_mc&&typeof _mc[_fmt]==="number"&&_mc[_fmt]>0)?_mc[_fmt]:(_mc?2:(["mp3","amr","gsm","g722","m4r","wma","opus","webm","mp2"].indexOf(_fmt)!==-1?2:(["ac3","eac3","ogg","oga"].indexOf(_fmt)!==-1?6:8)));if(_n>_cap)_n=_cap;if(!isNaN(_n)&&_n>0)out.push("-ac",String(_n))}}return out},isLossless:e=>-1!==l.indexOf(normEx(e)),isBrowserFormat:e=>-1!==p.indexOf(normEx(e)),/* Canonicalize real-world alias extensions (weba->webm, aif->aiff, ...).
   Single source of truth: config/formats.php input_aliases via
   __FFMPEG_CONFIG__.inputAliases; inline fallback covers early calls.
   Prod driver 2026-07-22: isBrowserFormat('weba') was false -> WASM
   path silently skipped for a 66.7 MB audio-WebM (see trim). */
normalizeExt:function(e){return normEx(e)},_getFFmpeg(){return e},isReady:()=>r&&null!==e,
/* Spawn a secondary FFmpeg instance running in a dedicated Worker.
   Tools that benefit from running 2 ops in parallel (e.g. /join tree-merge
   stage-1 prep on N≥4 tracks with sufficient memory + cores) can use it
   to halve wall-clock for that stage. Each secondary holds its OWN
   ffmpeg-core+wasm instance — no shared state with main thread.

   The Worker reuses main thread's already-cached core+wasm blob URLs
   (set during init in `this._loadedCoreUrl` / `_loadedWasmUrl`), so no
   re-download. WASM compile happens once per Worker — typical cost
   ~500-1500 ms on desktop, longer on mobile.

   Returns: Promise<{
     process(file, args, name, preInputArgs?) → { blob, name, size },
     processMulti(files[], args, name) → { blob, name, size },
     terminate() → void
   }>

   Caller is responsible for matching .terminate() to balance the spawn.
   Does NOT register with FFmpegProcessor's main-thread state machine —
   __withStallGuard, ffmpeg-progress events, smart reinit etc apply only
   to the main instance. Worker keeps its own state, designed to be
   short-lived (one tool's pipeline). */
async spawnSecondary(){
    if(!this._loadedCoreUrl||!this._loadedWasmUrl){
        if(typeof this.init==="function"){await this.init();}
        if(!this._loadedCoreUrl||!this._loadedWasmUrl)throw new Error("Main FFmpeg instance not initialized — cannot spawn secondary");
    }
    var _vhW=(window.__VENDOR_HASHES||{});
    var workerUrl="/vendor/ffmpeg/ffmpeg-worker.js"+(_vhW.ffmpegWorker?"?v="+_vhW.ffmpegWorker:"");
    var w;
    try{w=new Worker(workerUrl);}catch(spawnErr){throw new Error("Worker spawn failed: "+(spawnErr&&spawnErr.message||spawnErr));}
    var pending=Object.create(null);
    var nextId=1;
    w.onmessage=function(ev){
        var d=ev.data||{};
        if(d.type==="log"){window._ffTick&&window._ffTick();if(window._ffLogs){window._ffLogs.push("[w] "+d.message);var _cap=window.__ffLogsCapOverride||40;if(window._ffLogs.length>_cap)window._ffLogs.splice(0,window._ffLogs.length-_cap)}return;}
        if(d.id&&pending[d.id]){var entry=pending[d.id];delete pending[d.id];if(d.ok)entry.resolve(d);else entry.reject(new Error(d.error||"worker error"));}
    };
    w.onerror=function(ev){
        // Bubble up unhandled worker errors to all pending callers.
        var keys=Object.keys(pending);for(var k=0;k<keys.length;k++){var entry=pending[keys[k]];delete pending[keys[k]];try{entry.reject(new Error("Worker error: "+(ev&&ev.message||"unknown")))}catch(_){}}
    };
    function send(cmd,payload,transfer){
        var id=nextId++;
        return new Promise(function(resolve,reject){
            pending[id]={resolve:resolve,reject:reject};
            w.postMessage(Object.assign({id:id,cmd:cmd},payload||{}),transfer||[]);
        });
    }
    // Init phase — load FFmpeg in the worker reusing main's blob URLs.
    await send("init",{coreURL:this._loadedCoreUrl,wasmURL:this._loadedWasmUrl});
    var FP=this;
    return {
        process: async function(file,args,name,preInputArgs){
            var bytes;
            if(file instanceof Uint8Array)bytes=file;
            else if(file instanceof ArrayBuffer)bytes=new Uint8Array(file);
            else if(file&&typeof file.arrayBuffer==="function")bytes=new Uint8Array(await file.arrayBuffer());
            else throw new Error("Unsupported file type for worker process");
            var inputName=(file&&file.name)?file.name:"input.tmp";
            // Transfer the underlying buffer to avoid a copy.
            var transfer=[bytes.buffer];
            var resp,__t0=Date.now();try{resp=await send("process",{inputName:inputName,inputBytes:bytes,args:args,outputName:name,preInputArgs:preInputArgs||null},transfer);}finally{_execWorkAdd(__t0);}
            var blob=new Blob([resp.bytes],{type:c[(name||"").split(".").pop()]||"application/octet-stream"});
            return {blob:blob,name:name,url:URL.createObjectURL(blob),size:blob.size};
        },
        processMulti: async function(files,args,name){
            var inputs=[];
            var transfer=[];
            for(var i=0;i<files.length;i++){
                var f=files[i];
                var b;
                if(f instanceof Uint8Array)b=f;
                else if(f instanceof ArrayBuffer)b=new Uint8Array(f);
                else b=new Uint8Array(await f.arrayBuffer());
                var nm=(f&&f.name)?f.name:("input"+i+".tmp");
                inputs.push({name:nm,bytes:b});
                transfer.push(b.buffer);
            }
            var resp,__t0=Date.now();try{resp=await send("processMulti",{inputs:inputs,args:args,outputName:name},transfer);}finally{_execWorkAdd(__t0);}
            var blob=new Blob([resp.bytes],{type:c[(name||"").split(".").pop()]||"application/octet-stream"});
            return {blob:blob,name:name,url:URL.createObjectURL(blob),size:blob.size};
        },
        terminate: function(){
            try{send("terminate").catch(function(){});}catch(_){}
            try{w.terminate();}catch(_){}
        },
    };
},
/* spawnHelper — one more ffmpeg.wasm beside the main instance, for work that
   runs IN PARALLEL with it (first user: the per-frame lane of /audio-to-video —
   x264 on raw frame batches while the page draws the next batch).
   Unlike spawnSecondary, every helper instantiates ONE WebAssembly.Module the
   page compiles once (public/js/ffmpeg-helper-worker.js). Measured 27.09.2026,
   Firefox 115, the real page: a secondary costs ~270 MB before it does
   anything — its own compiled copy of the 32 MB core — and three encoders on
   secondaries took an export from +1.0 GB to +2.6 GB; a helper costs ~10 MB,
   the shared Module +248 MB once, dropped with the last helper. (Chromium's V8
   shares compiled code between workers by itself: 16–70 MB either way.)
   Also one worker instead of a wrapper around @ffmpeg/ffmpeg's worker, inputs
   owned by MEMFS without a copy, and the input buffers come BACK with the
   answer, so a caller can draw into them again.
   Returns Promise<{
     run(args, inputs:[{name, bytes}], output) → { bytes, inputs:[Uint8Array] }
       — args is the whole ffmpeg command, inputs referenced by name; their
       buffers are transferred in and returned,
     terminate()
   }>. A failed run rejects; after a wasm trap the helper is dead — terminate
   it. Helpers skip the main instance's exec boundary (codec translation, the
   audio-quality clamp, container tags): they are for video frames. */
_helperModuleP:null,_helperModuleWasm:null,_helperLive:0,
async spawnHelper(){
    if(!this._loadedCoreUrl||!this._loadedWasmUrl){
        if(typeof this.init==="function"){await this.init();}
        if(!this._loadedCoreUrl||!this._loadedWasmUrl)throw new Error("Main FFmpeg instance not initialized — cannot spawn a helper");
    }
    var FP=this,coreURL=this._loadedCoreUrl,wasmURL=this._loadedWasmUrl;
    if(!FP._helperModuleP||FP._helperModuleWasm!==wasmURL){
        FP._helperModuleWasm=wasmURL;
        var mp=fetch(wasmURL).then(function(r){if(!r.ok)throw new Error("helper core: HTTP "+r.status);return r.arrayBuffer()}).then(function(b){return WebAssembly.compile(b)});
        FP._helperModuleP=mp;
        mp.catch(function(){if(FP._helperModuleP===mp)FP._helperModuleP=null});
    }
    FP._helperLive++;
    var released=false;
    function release(){if(released)return;released=true;FP._helperLive--;if(FP._helperLive<=0){FP._helperLive=0;FP._helperModuleP=null;FP._helperModuleWasm=null}}
    var w=null,pending=Object.create(null),nextId=1,dead=false;
    function rejectAll(msg){var k=Object.keys(pending);for(var i=0;i<k.length;i++){var p=pending[k[i]];delete pending[k[i]];try{p.reject(new Error(msg))}catch(_){}}}
    function send(cmd,payload,transfer){
        if(dead)return Promise.reject(new Error("helper is gone"));
        var id=nextId++;
        return new Promise(function(resolve,reject){pending[id]={resolve:resolve,reject:reject};w.postMessage(Object.assign({id:id,cmd:cmd},payload||{}),transfer||[])});
    }
    try{
        var mod=await FP._helperModuleP;
        w=new Worker(typeof window.__jsSrc==="function"?window.__jsSrc("/js/ffmpeg-helper-worker.js"):"/js/ffmpeg-helper-worker.js");
        w.onmessage=function(ev){var d=ev.data||{};if(d.id&&pending[d.id]){var p=pending[d.id];delete pending[d.id];if(d.ok)p.resolve(d);else p.reject(new Error(d.error||"helper error"))}};
        w.onerror=function(ev){dead=true;rejectAll("helper worker error: "+(ev&&ev.message||"unknown"))};
        await send("init",{coreURL:coreURL,wasmURL:wasmURL,module:mod});
        mod=null;   // the worker holds it now; the page's copy goes with the last helper
    }catch(err){dead=true;try{w&&w.terminate()}catch(_){}release();throw err}
    return {
        run:async function(args,inputs,output){
            var list=[],transfer=[];
            for(var i=0;i<(inputs||[]).length;i++){list.push({name:inputs[i].name,bytes:inputs[i].bytes});transfer.push(inputs[i].bytes.buffer)}
            var t0=Date.now(),resp;
            try{resp=await send("run",{args:args,inputs:list,output:output},transfer)}finally{_execWorkAdd(t0)}
            return {bytes:resp.bytes,inputs:resp.inputs||[]};
        },
        terminate:function(){dead=true;rejectAll("helper terminated");try{w.terminate()}catch(_){}release()}
    };
},
/* Caller-side smart reinit primitive. Multi-step pipelines (join's tree-merge,
   audio-enhancer multipass, repair-video stages) used to call FFmpegProcessor.reinit()
   after EVERY operation as defensive cleanup, paying ~200-2000ms per cycle.
   For 19-track join that was 37 reinits = ~30s of pure dead time.
   maybeReinit lets callers track cumulative I/O and ops since last reinit
   and reinit only when pressure is real:
     state = { bytes: 0, ops: 0 }   // mutated by caller
     state.bytes += inputSz + outputSz; state.ops++;
     await FFmpegProcessor.maybeReinit(state, { minBytes: 400*1024*1024, minOps: 8, force: false });
   When the threshold trips OR force=true, reinit fires AND state is reset.
   Returns true if reinit happened, false if skipped. */
async maybeReinit(state,opts){
    opts=opts||{};
    var minBytes=opts.minBytes||400*1024*1024;
    var minOps=opts.minOps||8;
    var force=!!opts.force;
    if(!force&&(state.bytes||0)<minBytes&&(state.ops||0)<minOps)return false;
    var reason=force?"force":((state.bytes||0)>=minBytes?"bytes":"ops");
    if(window.__ae)try{window.__ae("feature_use",{f:"maybe_reinit",reason:reason,bytes_mb:Math.round((state.bytes||0)/1048576),ops:state.ops||0,slug:opts.slug||(window.__currentSlug||"")})}catch(_){}
    state.bytes=0;state.ops=0;
    await this.reinit();
    await this.init();
    return true;
},
cancel(_c){/* {notUser:true} — the stall guard stopping a wedged run is not the user's Cancel */if(!(_c&&_c.notUser))FFmpegProcessor._userCancelAt=Date.now();if(e){window.__ffmpegIntentionalTerminateAt=Date.now();try{e.terminate()}catch(x){}}e=null;r=!1;o=!1},async writeFile(n,t){if(!r||!e)await FFmpegProcessor.init();if(!r||!e)throw new Error("FFmpeg not initialized");await e.writeFile(n,await m(t))},async removeFile(n){if(!e)return;try{await e.deleteFile(n)}catch(x){}},
/* ── Memory-safe REVERSE (chunked) ───────────────────────────────────────
   FFmpeg's `reverse`/`areverse` filters buffer EVERY decoded frame in RAM,
   so on the single-thread WASM build (no SharedArrayBuffer) they blow the
   ~2 GB wasm address space on any 50 MB+ clip → "x264 malloc failed /
   Out of memory" (the #1 video-speed prod failure, even on 8 GB desktops).

   Root fix, not symptom: split the source into contiguous chunks (segment
   muxer, stream-copy — cheap), reverse + apply speed to each chunk
   independently (so `reverse` only ever buffers ONE chunk's frames), then
   concat the reversed chunks in REVERSE order (stream-copy). Output is
   frame-identical to a monolithic reverse (validated on real 720p/1080p
   clips: within 1 frame, A/V in sync) but peak memory is bounded to a
   single chunk regardless of clip length.

   Caller (tool blade) owns filter SEMANTICS and passes ready strings:
     o.videoFilter  e.g. "reverse,setpts=0.666667*PTS"  (must include reverse)
     o.audioFilter  e.g. "areverse,atempo=1.5"          (omit ⇒ video-only)
     o.codecArgs    final per-chunk codec args (NO -movflags; added at concat)
     o.outName / o.inputName / o.chunkSec (target sec, blade picks by res)
     o.onProgress   fn(0..1)
   Same division of labour as process()/processSegments(): memory + FS
   orchestration here, speed/pitch/scale semantics in the tool. */
async processReverse(t,o){
        /* Обе общие политики argv: компенсация задержки фильтров с lookahead и качество ресемплера. Дверь собирает argv сама, поэтому правка, сделанная в соседней, до неё не доходит. Обе идемпотентны, обе fail-open. */
        try { o = window.FFmpegDelayCompensation.apply(o); } catch (_) {}
        try { o = window.FFmpegResampleQuality.apply(o); } catch (_) {}
    if(!r||!e)await FFmpegProcessor.init();if(!r||!e)throw new Error("FFmpeg not initialized");
    o=o||{};
    if(window.__stage)try{window.__stage("processing",{out:o.outName})}catch(_){}
    var ext=(t.name&&t.name.split(".").pop()||"mp4").toLowerCase();
    var inName=o.inputName||("input."+ext);
    var bytes=await m(t);
    if(bytes.length===0){try{navigator.sendBeacon("/api/log-error",JSON.stringify([{type:"ffmpeg-critical",src:"empty-input|reverse|"+ext,page:location.pathname,ua:navigator.userAgent.substring(0,200)}]))}catch(_e){}throw new Error("Input file is empty (0 bytes). Please re-upload your file.")}
    await e.writeFile(inName,bytes);
    var outName=o.outName||"output.mp4";
    var oe=(outName.split(".").pop()||"mp4").toLowerCase();
    var chunkSec=Math.max(1,Math.min(30,Math.round(o.chunkSec||4)));
    var onP=typeof o.onProgress==="function"?o.onProgress:null;
    var vFilt=o.videoFilter||"reverse";
    var aFilt=o.audioFilter||null;
    var codecArgs=o.codecArgs||["-c:v","libx264","-preset","fast","-crf","23","-c:a","aac","-b:a","192k"];
    var manifest="vsr_manifest.txt",listFile="vsr_list.txt";
    var temps=[manifest,listFile];
    console.log("[ffmpeg] processReverse:",inName,"→",outName,"| chunkSec:",chunkSec,"| vf:",vFilt,"| af:",aFilt||"(none)");
    try{
        if(onP)onP(0.02);
        /* 1) split into contiguous chunks (stream-copy → fast, no decode-all).
           -map 0:v:0 + optional first audio keeps the chunk graph to the two
           streams reverse needs; segment_list flat gives a deterministic
           manifest so we never have to guess the chunk count. */
        // o.preInputArgs (e.g. ["-ss",S,"-to",E]) windows the split so we reverse
        // only a sub-range — used by segments mode to reverse one segment safely.
        var preIn=(o.preInputArgs&&o.preInputArgs.length)?o.preInputArgs:[];
        var splitArgs=preIn.concat(["-i",inName,"-map","0:v:0","-map","0:a:0?","-c","copy",
            "-f","segment","-segment_time",String(chunkSec),"-reset_timestamps","1",
            "-segment_list",manifest,"-segment_list_type","flat","-y","vsr_src_%03d."+ext]);
        window._ffLogs=[];
        var xs=await e.exec(splitArgs);
        if(xs!==0){var _ts=window.__ffErrTail?window.__ffErrTail(window._ffLogs):"";throw new Error("reverse split failed (exit "+xs+(_ts?": "+_ts:"")+")")}
        var manTxt=new TextDecoder().decode(await e.readFile(manifest));
        var chunkNames=manTxt.split(/\r?\n/).map(function(x){return x.trim()}).filter(Boolean);
        if(chunkNames.length===0)throw new Error("reverse split produced no chunks");
        for(var ci=0;ci<chunkNames.length;ci++)temps.push(chunkNames[ci]);
        /* 2) reverse + speed each chunk independently (bounded memory).
           Smooth progress: route each chunk's internal ffmpeg progress into its
           own slice of 5–90% so the bar advances CONTINUOUSLY, not one jump per
           chunk (matters on long jobs — a 6-min reverse must not look frozen).
           This also overrides the per-exec handler the caller's ensureFFmpeg
           installed, which would otherwise drive the bar 0→100 on every chunk. */
        var revNames=[],nC=chunkNames.length,curChunk=0;
        if(onP){try{FFmpegProcessor.onProgress(function(rp){onP(0.05+(curChunk+(rp||0))/nC*0.85)})}catch(_){}}
        for(var i=0;i<nC;i++){
            curChunk=i;
            var rev="vsr_rev_"+(i<100?(i<10?"00":"0"):"")+i+"."+oe;
            var fc,mapArgs;
            if(aFilt){fc="[0:v]"+vFilt+"[v];[0:a]"+aFilt+"[a]";mapArgs=["-map","[v]","-map","[a]"]}
            else{fc="[0:v]"+vFilt+"[v]";mapArgs=["-map","[v]","-an"]}
            var revArgs=["-i",chunkNames[i],"-filter_complex",fc].concat(mapArgs).concat(codecArgs).concat(["-y",rev]);
            window._ffLogs=[];
            var xr=await e.exec(revArgs);
            if(xr!==0){var _tr=window.__ffErrTail?window.__ffErrTail(window._ffLogs):"";throw new Error("reverse chunk "+i+"/"+nC+" failed (exit "+xr+(_tr?": "+_tr:"")+")")}
            revNames.push(rev);temps.push(rev);
            if(onP)onP(0.05+(i+1)/nC*0.85); // snap to boundary (covers sparse-progress chunks)
        }
        // detach the per-chunk mapping before the fast copy-concat
        if(onP){try{FFmpegProcessor.onProgress(function(){})}catch(_){}}
        /* 3) concat reversed chunks in REVERSE order (stream-copy). */
        var listTxt="";for(var j=revNames.length-1;j>=0;j--)listTxt+="file '"+revNames[j]+"'\n";
        await e.writeFile(listFile,new TextEncoder().encode(listTxt));
        var concatArgs=["-f","concat","-safe","0","-i",listFile,"-c","copy"];
        if(oe==="mp4"||oe==="m4v"||oe==="mov")concatArgs=concatArgs.concat(["-avoid_negative_ts","make_zero","-movflags","+faststart"]);
        concatArgs=concatArgs.concat(["-y",outName]);
        window._ffLogs=[];
        var xc=await e.exec(concatArgs);
        if(xc!==0){var _tc=window.__ffErrTail?window.__ffErrTail(window._ffLogs):"";throw new Error("reverse concat failed (exit "+xc+(_tc?": "+_tc:"")+")")}
        if(onP)onP(0.99);
        var outBytes=await e.readFile(outName);
        if(outBytes.length===0)throw new Error("reverse produced empty output");
        var blob=new Blob([outBytes],{type:c[oe]||"application/octet-stream"});
        if(onP)onP(1);
        return{blob:blob,name:outName,url:URL.createObjectURL(blob),size:blob.size};
    }finally{
        try{await e.deleteFile(inName)}catch(_){}
        try{await e.deleteFile(outName)}catch(_){}
        for(var k=0;k<temps.length;k++){try{await e.deleteFile(temps[k])}catch(_){}}
    }
},
/* Decode a video to RAW FRAMES, a bounded chunk at a time.
   ────────────────────────────────────────────────────────────────────────────
   For the lane that hands frames to the browser's own hardware encoder when
   WebCodecs cannot DECODE the source (mpeg4, HEVC on Firefox, …). FFmpeg is the
   only thing that can read such a file at all; the encoder is where the time
   goes, and that part the browser does in hardware.

   Why this is a method here and not a loop in the tool — three measurements,
   each of which killed the obvious approach:

   1. PER-SEGMENT SEEK IS THE EXPENSIVE PART, not the input write. A call that
      decodes one frame from the start costs 0.05–0.13 s including writing the
      whole 50 MB input; the SAME call seeking to 16 s costs 1.67–3.29 s,
      because `-ss` on a long-GOP codec decodes forward from the previous
      keyframe. Ten segments that way spend ~20 s re-decoding what they already
      decoded. Measured end to end: seek-per-segment 142 s against split-first
      49 s, on a 93–159 s baseline.
   2. SO THE SPLIT IS A STREAM COPY — `-f segment` with `-c copy` touches no
      pixels, and its chunks TOGETHER CONTAIN EVERY FRAME. Cutting with
      `-ss/-t -c copy` per chunk instead loses frames at the boundaries: 510 of
      540 arrived, one second of video gone and the audio after it out of sync.
      That is a correctness bug, not a tuning detail.
   3. RAW, NOT MJPEG. A 1080p frame is 3.1 MB raw and ~0.3 MB as JPEG, so the
      small transport looks obviously right. Measured, it is slower (74 s vs
      49 s — per-frame JPEG decode costs more than the I/O it saves), it wedged
      the wasm arena, and it puts a generation of lossy compression inside a
      tool whose whole job is picture quality. `pixFmt` is still a parameter,
      because on a low-memory phone a 7 MB chunk against a 160 MB one may yet
      be worth its own decision — but that decision needs its own measurement.

   Contract: `onChunk(bytes, index, total)` is awaited, so the caller can push
   frames into an encoder before the next chunk is decoded — peak memory is ONE
   chunk, not the whole video (20 s of 1080p raw is 1.6 GB).

   o.videoFilter  filter chain, or '' to decode only (the caller may prefer to
                  filter on the GPU — that choice is the caller's)
   o.chunkSec     target seconds per chunk (memory ↔ call-overhead trade)
   o.pixFmt       rawvideo pixel format; 'yuv420p' feeds VideoFrame's I420
   o.onChunk      async (Uint8Array, i, total) — REQUIRED
   o.onProgress   fn(0..1)
   o.signal       AbortSignal */
async processFrameChunks(t,o){
        /* Обе общие политики argv: компенсация задержки фильтров с lookahead и качество ресемплера. Дверь собирает argv сама, поэтому правка, сделанная в соседней, до неё не доходит. Обе идемпотентны, обе fail-open. */
        try { o = window.FFmpegDelayCompensation.apply(o); } catch (_) {}
        try { o = window.FFmpegResampleQuality.apply(o); } catch (_) {}
    if(!r||!e)await FFmpegProcessor.init();if(!r||!e)throw new Error("FFmpeg not initialized");
    o=o||{};
    var onChunk=typeof o.onChunk==="function"?o.onChunk:null;
    if(!onChunk)throw new Error("processFrameChunks: onChunk is required");
    var onP=typeof o.onProgress==="function"?o.onProgress:null;
    var ext=((t&&t.name&&t.name.split(".").pop())||o.ext||"mp4").toLowerCase();
    /* o.mountedPath — the source is ALREADY on a WORKERFS mount (mountInput):
       read it in place, never copy it into MEMFS. /video-colorize's fallback
       decode hands 600 MB films here; the copy that `m(t)` makes is exactly
       the heap the phone does not have. The caller owns the mount's dispose().
       o.maxSeconds — stop the split after N seconds of output (`-t` as an
       OUTPUT option of the copy split), so a capped render never splits — or
       stores — the hour it will not touch. */
    var mounted=typeof o.mountedPath==="string"&&o.mountedPath.length>0;
    var inName=mounted?o.mountedPath:"hfc_in."+ext;
    var maxSec=(typeof o.maxSeconds==="number"&&o.maxSeconds>0)?o.maxSeconds:0;
    var chunkSec=Math.max(1,Math.min(30,Math.round(o.chunkSec||2)));
    var vf=o.videoFilter||"";
    var pixFmt=o.pixFmt||"yuv420p";
    var rawName="hfc_seg.raw",manifest="hfc_manifest.txt";
    var temps=mounted?[rawName,manifest]:[inName,rawName,manifest];
    var aborted=function(){return o.signal&&o.signal.aborted;};
    var bail=function(){var _e=new Error("aborted");_e.name="AbortError";return _e;};

    if(!mounted){
        var bytes=await m(t);
        if(!bytes||bytes.length===0)throw new Error("Input file is empty (0 bytes). Please re-upload your file.");
        await e.writeFile(inName,bytes);
    }
    console.log("[ffmpeg] processFrameChunks:",inName,"| chunkSec:",chunkSec,"| vf:",vf||"(decode only)");
    try{
        if(aborted())throw bail();
        /* 1) Cut with a stream copy — no decode, and the chunks together are the
              whole video. `-segment_list flat` gives a deterministic manifest so
              the count is read, never guessed. */
        window._ffLogs=[];
        var xs=await e.exec(["-i",inName,"-map","0:v:0","-c","copy"].concat(maxSec?["-t",String(maxSec)]:[]).concat(["-f","segment",
            "-segment_time",String(chunkSec),"-reset_timestamps","1",
            "-segment_list",manifest,"-segment_list_type","flat","-y","hfc_%04d."+ext]));
        if(xs!==0){var _ts=window.__ffErrTail?window.__ffErrTail(window._ffLogs):"";
            throw new Error("frame-chunk split failed (exit "+xs+(_ts?": "+_ts:"")+")")}
        var manTxt=new TextDecoder().decode(await e.readFile(manifest));
        var chunks=manTxt.split(/\r?\n/).map(function(x){return x.trim()}).filter(Boolean);
        for(var ci=0;ci<chunks.length;ci++)temps.push(chunks[ci]);
        if(!chunks.length)throw new Error("frame-chunk split produced no chunks");
        /* The input is not needed once the chunks exist — free it before the
           first raw buffer appears, so peak = chunks + one raw, not + the source. */
        if(!mounted){try{await e.deleteFile(inName)}catch(_di){}}

        for(var i=0;i<chunks.length;i++){
            if(aborted())throw bail();
            var args=["-i",chunks[i],"-an"];
            if(vf)args=args.concat(["-vf",vf]);
            args=args.concat(["-f","rawvideo","-pix_fmt",pixFmt,"-y",rawName]);
            window._ffLogs=[];
            var xr=await e.exec(args);
            if(xr!==0){var _tr=window.__ffErrTail?window.__ffErrTail(window._ffLogs):"";
                throw new Error("frame-chunk "+i+"/"+chunks.length+" failed (exit "+xr+(_tr?": "+_tr:"")+")")}
            var raw=await e.readFile(rawName);
            /* ⚠️ COPY before anything else runs. readFile hands back a view into
               the wasm heap; the next exec (or a growth of that heap) moves the
               bytes under the caller while it is still reading them. */
            var copy=(raw&&raw.slice)?raw.slice():new Uint8Array(raw);
            try{await e.deleteFile(rawName)}catch(_dr){}
            try{await e.deleteFile(chunks[i])}catch(_dc){}
            await onChunk(copy,i,chunks.length);
            if(onP)onP((i+1)/chunks.length);
        }
        return {chunks:chunks.length};
    }finally{
        for(var k=0;k<temps.length;k++){try{await e.deleteFile(temps[k])}catch(_){}}
    }
},
/* Concat already-encoded parts (Blobs/Files, all in the SAME codec/container)
   via the demuxer copy path. Used by segments mode: each segment is processed to
   its own bounded-memory blob, then stitched here without a re-encode. */
async concatParts(parts,outName){
    if(!r||!e)await FFmpegProcessor.init();if(!r||!e)throw new Error("FFmpeg not initialized");
    var oe=(outName.split(".").pop()||"mp4").toLowerCase();
    var names=[];
    try{
        for(var i=0;i<parts.length;i++){
            var nm="cp_"+(i<100?(i<10?"00":"0"):"")+i+"."+oe;
            var bytes=await m(parts[i]);
            if(bytes.length===0)throw new Error("concatParts: part "+i+" is empty");
            await e.writeFile(nm,bytes);
            names.push(nm);
        }
        var list="";for(var j=0;j<names.length;j++)list+="file '"+names[j]+"'\n";
        await e.writeFile("cp_list.txt",new TextEncoder().encode(list));
        var ca=["-f","concat","-safe","0","-i","cp_list.txt","-c","copy"];
        if(oe==="mp4"||oe==="m4v"||oe==="mov")ca=ca.concat(["-avoid_negative_ts","make_zero","-movflags","+faststart"]);
        ca=ca.concat(["-y",outName]);
        window._ffLogs=[];
        var xx=await e.exec(ca);
        if(xx!==0){var _tt=window.__ffErrTail?window.__ffErrTail(window._ffLogs):"";throw new Error("concatParts failed (exit "+xx+(_tt?": "+_tt:"")+")")}
        var g=await e.readFile(outName);
        if(g.length===0)throw new Error("concatParts produced empty output");
        var blob=new Blob([g],{type:c[oe]||"application/octet-stream"});
        return{blob:blob,name:outName,url:URL.createObjectURL(blob),size:blob.size};
    }finally{
        for(var k=0;k<names.length;k++){try{await e.deleteFile(names[k])}catch(_){}}
        try{await e.deleteFile("cp_list.txt")}catch(_){}
        try{await e.deleteFile(outName)}catch(_){}
    }
},/* If init is in-flight, await it first — terminating its worker mid-load
   is exactly the race we're closing. If it succeeds, we're already
   initialized and reinit becomes a no-op. If it fails, we proceed with
   the fresh init below. */
async reinit(){if(_initPromise){try{return await _initPromise}catch(_){}}if(e){window.__ffmpegIntentionalTerminateAt=Date.now();try{e.terminate()}catch(_){}}e=null;r=!1;o=!1;return this.init()},
/* release() — отдать память движка БЕЗ повторной инициализации. Отличие от
   reinit(): тот сразу поднимает новый инстанс (и WASM-память снова растёт),
   а release() оставляет движок мёртвым до следующего явного init() — который
   у всех вызывающих идемпотентен. Зачем: WASM linear memory назад не
   отдаётся, и инстанс, раздутый извлечением из большого видео, держит сотни
   МБ всё время, пока ASR-модель работает рядом, — на iOS эта сумма убивает
   вкладку (замер 2026-08-03: пик 1437 МБ на 52 МБ файле, profanity-remover).
   Безопасность: с работой в полёте (_inFlight>0) НЕ трогаем — это класс
   «reinit убивал чужие операции» (≈477 событий/14д, чинено 2026-07-24). */
release(){if(FFmpegProcessor._inFlight>0){if(window.__ae)try{window.__ae("feature_use",{f:"engine_release_skipped_busy",n:FFmpegProcessor._inFlight})}catch(_){}return!1}if(_initPromise)return!1;if(e){window.__ffmpegIntentionalTerminateAt=Date.now();try{e.terminate()}catch(_){}}e=null;r=!1;o=!1;return!0},configure(e){e.codecs&&(s=e.codecs),e.mimeTypes&&(c=e.mimeTypes),e.browserFormats&&(p=e.browserFormats),e.extMap&&(f=e.extMap)},getOutputExt:e=>f[e]||e,async probe(t){if(!r||!e)await FFmpegProcessor.init();if(!r||!e)throw new Error("FFmpeg not initialized");var _ext=t.name?t.name.split(".").pop():"tmp",_fn="probe_"+Date.now()+"_"+Math.random().toString(36).slice(2,8)+"."+_ext,_logs=[],_logCb=function(ev){_logs.push(ev.message)};e.on("log",_logCb);try{await e.writeFile(_fn,await m(t))}catch(x){throw x}try{await e.exec(["-i",_fn])}catch(x){}try{e.off("log",_logCb)}catch(x){}try{await e.deleteFile(_fn)}catch(x){}/* Слушатель "log" ОБЩИЙ на весь экземпляр: чужой exec, ещё идущий в воркере, кладёт свои строки в наш захват, и первая "Audio:" из чужого хвоста становится дорожкой не того файла. Замер 16.09.2026 на /add-music-to-video: у видео БЕЗ звука проба подхватывала строку от пробы добавленной музыки и объявляла, что звук есть, — а граф FFmpeg тогда ссылается на несуществующий поток. Лечение то же, что у probeStreaming (10.09): захват начинается со строки, называющей НАШ файл; имя файла теперь уникально не только по миллисекунде. *//* 25.09.2026: не со строки с именем файла, а с баннера НАШЕГО запуска — демуксер печатает «moov atom not found» раньше неё (см. ownRunLog). */_logs=FFmpegProcessor._ownRunLog?FFmpegProcessor._ownRunLog(_logs,_fn):_logs;var result=_logs.join("\n");if(result.indexOf("Aborted")!==-1){if(FFmpegProcessor._inFlight>1){/* 2026-07-24 ETALON: somebody else is mid-exec. The log stream is SHARED, so this "Aborted" may well be their normal end-of-run line — and even if it is ours, tearing the engine down now kills THEIR operation with "called FFmpeg.terminate()". Defer: flag it and let the next idle op reinit. Root cause of 477 terminate events across 15 tools in 14 days. */console.log("[ffmpeg] probe: Aborted seen but engine busy — deferring reinit");FFmpegProcessor._needsReinit=1;}else{console.log("[ffmpeg] probe done — reinitializing instance");window.__ffmpegIntentionalTerminateAt=Date.now();try{e.terminate()}catch(x){}e=null;r=!1;o=!1;try{await FFmpegProcessor.init()}catch(x){console.warn("[ffmpeg] reinit after probe failed:",x.message)}}}return result},download(e,t){if(!e||e.size===0){if(window.__toast)window.__toast(((window.__commonStrings||{}).js_output_empty || "Processing error — output file is empty. Please try again."),"error");try{window.__aeToolError({error_type:"empty_download",msg:"blob.size=0",file_name:t})}catch(_){}return Promise.resolve(false)}var _evt=function(){try{window.dispatchEvent(new CustomEvent("file-downloaded",{detail:{name:t,size:e.size}}))}catch(_){}};if(typeof window.__downloadFile==="function"){/* The primitive owns the delivery signal — it dispatches `file-downloaded` ONLY when bytes really reached the device. Calling _evt() here (as this did until 2026-07-10) popped "Файл сохранён!" for every dead WebView fallback: bug-report egorkaravaev11, 13 clicks / 13 lies / 0 files. */return Promise.resolve(window.__downloadFile(e,t))}var r=URL.createObjectURL(e),o=document.createElement("a");o.href=r;o.download=t;o.setAttribute("data-rawdl","1");document.body.appendChild(o);o.click();o.remove();_evt();setTimeout(function(){URL.revokeObjectURL(r)},4e3);return Promise.resolve(true)},async cacheFile(file,opts){if(!(file instanceof File)&&!(file instanceof Blob))return;var throwOnFail=opts&&opts.throwOnFail;if(window.FileBytes&&typeof window.FileBytes.prime==='function'){try{return await window.FileBytes.prime(file)}catch(e){console.warn("[ffmpeg] cacheFile failed:",e.message);if(throwOnFail)throw e}return}try{return await file.arrayBuffer()}catch(e){console.warn("[ffmpeg] cacheFile failed:",e.message);if(throwOnFail)throw e}},_reportInitFailure(type,errors){try{var c=navigator.connection||navigator.mozConnection||{};var diag={sab:typeof SharedArrayBuffer!=="undefined",wasm:typeof WebAssembly!=="undefined",dm:navigator.deviceMemory||0,ct:c.effectiveType||"",dl:c.downlink||0,sv:c.saveData||false,hc:navigator.hardwareConcurrency||0,errors:errors.slice(0,6).join(" | ").substring(0,400)};navigator.sendBeacon("/api/log-error",JSON.stringify([{type:"ffmpeg-init-fail",src:type+"|"+JSON.stringify(diag),page:location.pathname,ua:navigator.userAgent}]))}catch(e){}},reportError(tool,err,fileSize,attempt){try{navigator.sendBeacon("/api/log-error",JSON.stringify([{type:"wasm-error",src:tool+"|"+(err&&err.message||String(err)).substring(0,200)+"|size="+fileSize+"|attempt="+attempt,page:location.pathname,ua:navigator.userAgent}]))}catch(e){}},classifyError(err){if(err&&err.code==="INIT_FAILED")return"init";var msg=(err&&err.message||String(err)).toLowerCase();if(msg.includes("called ffmpeg.terminate")||msg.includes("terminate()"))return"cancelled";/* Phase Y (2026-06-04) — cross-tool file_lost detection gap. Pre-fix
   classifyError matched only "file_lost", "no longer accessible",
   NotFoundError DOMException, and "empty (0 bytes)" / "re-upload".
   The string "could not be read" appeared in `_isFileLostErr` (used in
   the JS-side `m()` file→bytes conversion) but NOT here, so when
   FFmpeg's worker WORKERFS path threw NotReadableError from
   FileReaderSync, the error reached classifyError as a string and
   fell through to default "processing" classification → 58 events / 7d
   misclassified as wasm_process instead of file_lost. Tools' catch
   blocks that branch on classify === 'file_lost' couldn't route to
   the file-recovery UX. Same gap for "permission problems" wording
   (Firefox/Safari NotReadableError variant) and the NotReadableError
   DOMException name itself (defence-in-depth). Single line keeps the
   classifyError surface area tight. */
if(msg.includes("file_lost")||msg.includes("no longer accessible")||msg.includes("could not be read")||msg.includes("permission problems")||(err instanceof DOMException&&(err.name==="NotFoundError"||err.name==="NotReadableError")))return"file_lost";if(msg.includes("empty (0 bytes)")||msg.includes("re-upload"))return"file_lost";if(msg.includes("init_error")||msg.includes("init_failed")||msg.includes("init failed")||msg.includes("not initialized")||msg.includes("ffmpegwasm not found")||msg.includes("is not loaded"))return"init";if(msg.includes("cannot read properties of null"))return"init";/* `apply` on undefined = emscripten lazy trampoline `Module["asm"]["…"].apply(…)` evaluated to undefined. Real root cause (parallel session 2026-05-21, `4b288223e` + `e2b97c1a1`): VPS served a JS+WASM pair from DIFFERENT ffmpeg-core builds — custom JS expected export "ya", upstream WASM exported "ta" → undefined. SW cache eviction + content-addressed URLs closed it at the source. This classification stays as defence-in-depth in case a future build-vendoring slip ever produces a similar cross-version pair: user gets a refresh CTA instead of generic "Ошибка". */if(msg.includes("cannot read properties of undefined (reading 'apply'")||msg.includes("cannot read properties of undefined (reading apply"))return"wasm_state";/* memory = GENUINE out-of-memory only. Bare "memory"/"aborted()"/"runtimeerror"
   and a bare RangeError are generic WASM failures (corrupt input, asserts, codec
   faults) — classifying them as OOM showed a false "Недостаточно памяти" modal on
   tiny files (bug #432: 4.85 MB MP3). Require an explicit allocation/heap phrase;
   route ambiguous aborts to "processing". */
if(msg.includes("out of memory")||msg.includes("oom")||msg.includes("cannot allocate")||msg.includes("allocation")||msg.includes("enlarge memory")||msg.includes("malloc")||msg.includes("memory access out of bounds")||msg.includes("insufficient memory")||(err instanceof RangeError&&/alloc|array buffer|array length|too large/.test(msg)))return"memory";/* Файл без оглавления — САМАЯ ЧАСТАЯ поименованная причина отказов на сайте: замер 1-7.09.2026 дал 422 события и 254 сессии в 19 тулах. До этой ветки такие ошибки попадали в "processing" и человек читал «попробуйте другой формат или загрузите файл заново» — совет неверный дважды: формат ни при чём, а «заново» даст тот же неполный файл. Запись оборвалась (телефон разрядился, приложение упало, копирование не доехало), и в контейнере нет индекса. Отдельный класс нужен, чтобы ответ назвал причину и путь. */if(msg.includes("moov atom not found")||msg.includes("ebml header parsing failed"))return"broken_container";if(msg.includes("exit code")||msg.includes("ffmpeg failed")||msg.includes("encoding failed")||msg.includes("concat failed")||msg.includes("codec")||msg.includes("invalid data")||msg.includes("aborted()")||msg.includes("runtimeerror"))return"processing";if(msg.includes("load")||msg.includes("blocked")||msg.includes("csp"))return"init";return"unknown"},getErrorMessage(err,fileSize,ctx){/* The engine-level stall guard (bottom of this file) can now fire in ANY FFmpeg tool, so its message has to live where every tool already looks. Without this the nine non-English locales would read the raw throw text, "Processing stalled (no progress for 300s)". The wording says what was and was not lost, because the guard cancels a run the user may have been watching for an hour. */if(err&&err.errorType==="stalled"){var ST={en:"Processing stopped responding and was cancelled. Nothing was lost — try again, or use a smaller file or lower resolution.",ru:"Обработка перестала отвечать и была остановлена. Ничего не потеряно — попробуйте ещё раз, файл поменьше или разрешение пониже.",ko:"처리가 응답을 멈춰 중단했습니다. 잃어버린 것은 없습니다 — 다시 시도하거나 더 작은 파일 또는 낮은 해상도를 사용해 보세요.",ar:"توقفت المعالجة عن الاستجابة وتم إيقافها. لم يُفقد شيء — أعد المحاولة، أو استخدم ملفًا أصغر أو دقة أقل.",id:"Pemrosesan berhenti merespons dan dihentikan. Tidak ada yang hilang — coba lagi, atau gunakan berkas lebih kecil atau resolusi lebih rendah.",pt:"O processamento parou de responder e foi interrompido. Nada foi perdido — tente de novo, ou use um ficheiro menor ou resolução mais baixa.",de:"Die Verarbeitung reagierte nicht mehr und wurde abgebrochen. Es ging nichts verloren — versuchen Sie es erneut, mit kleinerer Datei oder niedrigerer Auflösung.",es:"El procesamiento dejó de responder y se detuvo. No se perdió nada — inténtalo de nuevo, con un archivo más pequeño o menor resolución.",fr:"Le traitement ne répondait plus et a été interrompu. Rien n’a été perdu — réessayez, avec un fichier plus petit ou une résolution plus basse.",uk:"Обробка перестала відповідати й була зупинена. Нічого не втрачено — спробуйте ще раз, менший файл або нижчу роздільну здатність.",tr:"İşlem yanıt vermeyi durdurdu ve iptal edildi. Hiçbir şey kaybolmadı — tekrar deneyin veya daha küçük bir dosya ya da daha düşük çözünürlük kullanın."};return ST[window.__LOCALE]||ST.en}var type=this.classifyError(err);if(type==="cancelled")return"";if(type==="wasm_state"){/* Engine pair-mismatch (cached old JS + new WASM, or vice-versa). Auto-retry already attempted. Refresh forces SW + browser to re-fetch the current pair from origin. */var WS={en:"Processing engine version mismatch — your browser cached an older copy. Please refresh the page (F5) to get the current engine.",ru:"Несовпадение версий движка обработки — браузер сохранил старую копию. Обновите страницу (F5), чтобы получить актуальную версию.",ko:"처리 엔진 버전 불일치 — 브라우저가 이전 버전을 캐시했습니다. 페이지를 새로 고침(F5)하여 최신 엔진을 가져오세요.",ar:"عدم تطابق إصدار محرك المعالجة — قام المتصفح بتخزين نسخة قديمة. حدّث الصفحة (F5) للحصول على المحرك الحالي.",id:"Versi engine pemrosesan tidak cocok — browser men-cache versi lama. Muat ulang halaman (F5) untuk mendapatkan engine saat ini.",pt:"Versão do motor de processamento incompatível — seu navegador armazenou uma cópia antiga. Atualize a página (F5) para obter o motor atual.",de:"Engine-Versionskonflikt — Ihr Browser hat eine ältere Kopie zwischengespeichert. Seite neu laden (F5) für die aktuelle Engine.",es:"Versión del motor de procesamiento incompatible — el navegador guardó una copia antigua. Actualiza la página (F5) para obtener el motor actual.",fr:"Version du moteur de traitement incompatible — le navigateur a mis en cache une ancienne copie. Actualisez la page (F5) pour obtenir le moteur actuel.", uk: "Невідповідність версії рушія обробки — ваш браузер зберіг у кеші застарілу копію. Оновіть сторінку (F5), щоб отримати актуальний рушій.", tr: "İşleme motoru sürüm uyuşmazlığı — tarayıcınız eski bir kopyayı önbelleğe almış. Güncel motoru almak için sayfayı yenileyin (F5)."};return WS[window.__LOCALE||"en"]||WS.en}var loc=window.__LOCALE||"en";var big=fileSize>50*1024*1024;var M={en:{file_lost:"The selected file is no longer accessible. This can happen if the file was moved, renamed, or your browser tab was inactive for too long. Please re-select the file.",init:"Could not load the processing engine. Check your internet connection or try a different browser (Chrome, Firefox).",memory:"Not enough RAM (working memory) on your device to process this file. Close unnecessary tabs and apps, or try a shorter selection.",memory_big:"This file is too large for your device\u2019s RAM (working memory). Processing uses RAM, not disk space. Try a shorter selection or a compressed format like MP3.",processing:"Processing error. Try a different output format or re-upload your file.",unknown:"An error occurred during processing. Try refreshing the page or using a different browser.",broken_container:"The recording is incomplete: the file has no index, so no player can open it. A different format will not help — repair the file first in the Video Repair tool."},ru:{file_lost:"\u0412\u044b\u0431\u0440\u0430\u043d\u043d\u044b\u0439 \u0444\u0430\u0439\u043b \u0431\u043e\u043b\u044c\u0448\u0435 \u043d\u0435\u0434\u043e\u0441\u0442\u0443\u043f\u0435\u043d. \u0424\u0430\u0439\u043b \u043c\u043e\u0433 \u0431\u044b\u0442\u044c \u043f\u0435\u0440\u0435\u043c\u0435\u0449\u0451\u043d, \u043f\u0435\u0440\u0435\u0438\u043c\u0435\u043d\u043e\u0432\u0430\u043d \u0438\u043b\u0438 \u0432\u043a\u043b\u0430\u0434\u043a\u0430 \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0430 \u0431\u044b\u043b\u0430 \u043d\u0435\u0430\u043a\u0442\u0438\u0432\u043d\u0430 \u0441\u043b\u0438\u0448\u043a\u043e\u043c \u0434\u043e\u043b\u0433\u043e. \u041f\u043e\u0436\u0430\u043b\u0443\u0439\u0441\u0442\u0430, \u0432\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u0444\u0430\u0439\u043b \u0437\u0430\u043d\u043e\u0432\u043e.",init:"\u041d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044c \u043e\u0431\u0440\u0430\u0431\u043e\u0442\u0447\u0438\u043a. \u041f\u0440\u043e\u0432\u0435\u0440\u044c\u0442\u0435 \u043f\u043e\u0434\u043a\u043b\u044e\u0447\u0435\u043d\u0438\u0435 \u043a \u0438\u043d\u0442\u0435\u0440\u043d\u0435\u0442\u0443 \u0438\u043b\u0438 \u043f\u043e\u043f\u0440\u043e\u0431\u0443\u0439\u0442\u0435 \u0434\u0440\u0443\u0433\u043e\u0439 \u0431\u0440\u0430\u0443\u0437\u0435\u0440 (Chrome, Firefox).",memory:"\u041d\u0430 \u0432\u0430\u0448\u0435\u043c \u0443\u0441\u0442\u0440\u043e\u0439\u0441\u0442\u0432\u0435 \u043d\u0435 \u0445\u0432\u0430\u0442\u0438\u043b\u043e \u043e\u043f\u0435\u0440\u0430\u0442\u0438\u0432\u043d\u043e\u0439 \u043f\u0430\u043c\u044f\u0442\u0438 (\u041e\u0417\u0423) \u0434\u043b\u044f \u043e\u0431\u0440\u0430\u0431\u043e\u0442\u043a\u0438. \u0417\u0430\u043a\u0440\u043e\u0439\u0442\u0435 \u043b\u0438\u0448\u043d\u0438\u0435 \u0432\u043a\u043b\u0430\u0434\u043a\u0438 \u0438 \u043f\u0440\u0438\u043b\u043e\u0436\u0435\u043d\u0438\u044f \u0438\u043b\u0438 \u0432\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u0431\u043e\u043b\u0435\u0435 \u043a\u043e\u0440\u043e\u0442\u043a\u0438\u0439 \u0444\u0440\u0430\u0433\u043c\u0435\u043d\u0442.",memory_big:"\u0424\u0430\u0439\u043b \u0441\u043b\u0438\u0448\u043a\u043e\u043c \u0431\u043e\u043b\u044c\u0448\u043e\u0439 \u0434\u043b\u044f \u043e\u043f\u0435\u0440\u0430\u0442\u0438\u0432\u043d\u043e\u0439 \u043f\u0430\u043c\u044f\u0442\u0438 (\u041e\u0417\u0423) \u0432\u0430\u0448\u0435\u0433\u043e \u0443\u0441\u0442\u0440\u043e\u0439\u0441\u0442\u0432\u0430. \u041e\u0431\u0440\u0430\u0431\u043e\u0442\u043a\u0430 \u0438\u0441\u043f\u043e\u043b\u044c\u0437\u0443\u0435\u0442 \u041e\u0417\u0423, \u0430 \u043d\u0435 \u043c\u0435\u0441\u0442\u043e \u043d\u0430 \u0434\u0438\u0441\u043a\u0435. \u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u0431\u043e\u043b\u0435\u0435 \u043a\u043e\u0440\u043e\u0442\u043a\u0438\u0439 \u0444\u0440\u0430\u0433\u043c\u0435\u043d\u0442 \u0438\u043b\u0438 \u0444\u043e\u0440\u043c\u0430\u0442 \u0441\u043e \u0441\u0436\u0430\u0442\u0438\u0435\u043c, \u043d\u0430\u043f\u0440\u0438\u043c\u0435\u0440 MP3.",processing:"\u041e\u0448\u0438\u0431\u043a\u0430 \u043e\u0431\u0440\u0430\u0431\u043e\u0442\u043a\u0438. \u041f\u043e\u043f\u0440\u043e\u0431\u0443\u0439\u0442\u0435 \u0434\u0440\u0443\u0433\u043e\u0439 \u0444\u043e\u0440\u043c\u0430\u0442 \u0438\u043b\u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u0435 \u0444\u0430\u0439\u043b \u0437\u0430\u043d\u043e\u0432\u043e.",unknown:"\u041f\u0440\u043e\u0438\u0437\u043e\u0448\u043b\u0430 \u043e\u0448\u0438\u0431\u043a\u0430. \u041f\u043e\u043f\u0440\u043e\u0431\u0443\u0439\u0442\u0435 \u043e\u0431\u043d\u043e\u0432\u0438\u0442\u044c \u0441\u0442\u0440\u0430\u043d\u0438\u0446\u0443 \u0438\u043b\u0438 \u0438\u0441\u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u044c \u0434\u0440\u0443\u0433\u043e\u0439 \u0431\u0440\u0430\u0443\u0437\u0435\u0440.",broken_container:"Запись неполная: в файле нет оглавления, поэтому его не открывает ни один плеер. Другой формат не поможет — сначала восстановите файл в инструменте «Восстановление видео»."},ko:{file_lost:"\uc120\ud0dd\ud55c \ud30c\uc77c\uc5d0 \ub354 \uc774\uc0c1 \uc561\uc138\uc2a4\ud560 \uc218 \uc5c6\uc2b5\ub2c8\ub2e4. \ud30c\uc77c\uc744 \ub2e4\uc2dc \uc120\ud0dd\ud574 \uc8fc\uc138\uc694.",init:"\ucc98\ub9ac \uc5d4\uc9c4\uc744 \ub85c\ub4dc\ud560 \uc218 \uc5c6\uc2b5\ub2c8\ub2e4. \uc778\ud130\ub137 \uc5f0\uacb0\uc744 \ud655\uc778\ud558\uac70\ub098 \ub2e4\ub978 \ube0c\ub77c\uc6b0\uc800(Chrome, Firefox)\ub97c \uc0ac\uc6a9\ud574 \ubcf4\uc138\uc694.",memory:"\uae30\uae30\uc758 RAM(\uc791\uc5c5 \uba54\ubaa8\ub9ac)\uc774 \ubd80\uc871\ud569\ub2c8\ub2e4. \ubd88\ud544\uc694\ud55c \ud0ed\uacfc \uc571\uc744 \ub2eb\uac70\ub098 \ub354 \uc9e7\uc740 \uad6c\uac04\uc744 \uc120\ud0dd\ud574 \ubcf4\uc138\uc694.",memory_big:"\ud30c\uc77c\uc774 \uae30\uae30\uc758 RAM\uc5d0 \ube44\ud574 \ub108\ubb34 \ud07d\ub2c8\ub2e4. \ucc98\ub9ac\ub294 \ub514\uc2a4\ud06c\uac00 \uc544\ub2cc RAM\uc744 \uc0ac\uc6a9\ud569\ub2c8\ub2e4. \ub354 \uc9e7\uc740 \uad6c\uac04\uc774\ub098 MP3 \ud615\uc2dd\uc744 \uc0ac\uc6a9\ud574 \ubcf4\uc138\uc694.",processing:"\ucc98\ub9ac \uc624\ub958\uc785\ub2c8\ub2e4. \ub2e4\ub978 \ucd9c\ub825 \ud615\uc2dd\uc744 \uc0ac\uc6a9\ud558\uac70\ub098 \ud30c\uc77c\uc744 \ub2e4\uc2dc \uc5c5\ub85c\ub4dc\ud574 \ubcf4\uc138\uc694.",unknown:"\ucc98\ub9ac \uc911 \uc624\ub958\uac00 \ubc1c\uc0dd\ud588\uc2b5\ub2c8\ub2e4. \ud398\uc774\uc9c0\ub97c \uc0c8\ub85c\uace0\uce68\ud558\uac70\ub098 \ub2e4\ub978 \ube0c\ub77c\uc6b0\uc800\ub97c \uc0ac\uc6a9\ud574 \ubcf4\uc138\uc694.",broken_container:"녹화가 완료되지 않았습니다. 파일에 색인이 없어 어떤 플레이어도 열 수 없습니다. 형식을 바꿔도 해결되지 않습니다 — 먼저 동영상 복구 도구에서 파일을 복구해 보세요."},ar:{file_lost:"\u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u0645\u062d\u062f\u062f \u0644\u0645 \u064a\u0639\u062f \u0645\u062a\u0627\u062d\u064b\u0627. \u064a\u0631\u062c\u0649 \u0625\u0639\u0627\u062f\u0629 \u0627\u062e\u062a\u064a\u0627\u0631 \u0627\u0644\u0645\u0644\u0641.",init:"\u062a\u0639\u0630\u0631 \u062a\u062d\u0645\u064a\u0644 \u0645\u062d\u0631\u0643 \u0627\u0644\u0645\u0639\u0627\u0644\u062c\u0629. \u062a\u062d\u0642\u0642 \u0645\u0646 \u0627\u062a\u0635\u0627\u0644\u0643 \u0628\u0627\u0644\u0625\u0646\u062a\u0631\u0646\u062a \u0623\u0648 \u062c\u0631\u0628 \u0645\u062a\u0635\u0641\u062d\u064b\u0627 \u0622\u062e\u0631 (Chrome\u060c Firefox).",memory:"\u0644\u0627 \u062a\u0648\u062c\u062f \u0630\u0627\u043a\u0631\u0629 \u0648\u0635\u0648\u0644 \u0639\u0634\u0648\u0627\u0626\u064a (RAM) \u043a\u0627\u0641\u064a\u0629 \u0639\u0644\u0649 \u062c\u0647\u0627\u0632\u043a. \u0623\u063a\u0644\u0642 \u0627\u0644\u062a\u0628\u0648\u064a\u0628\u0627\u062a \u0648\u0627\u0644\u062a\u0637\u0628\u064a\u0642\u0627\u062a \u063a\u064a\u0631 \u0627\u0644\u0636\u0631\u0648\u0631\u064a\u0629 \u0623\u0648 \u0627\u062e\u062a\u0631 \u0645\u0642\u0637\u0639\u064b\u0627 \u0623\u0642\u0635\u0631.",memory_big:"\u0627\u0644\u0645\u0644\u0641 \u0643\u0628\u064a\u0631 \u062c\u062f\u064b\u0627 \u0628\u0627\u0644\u0646\u0633\u0628\u0629 \u0644\u0630\u0627\u0643\u0631\u0629 RAM \u0641\u064a \u062c\u0647\u0627\u0632\u0643. \u0627\u0644\u0645\u0639\u0627\u0644\u062c\u0629 \u062a\u0633\u062a\u062e\u062f\u0645 RAM \u0648\u0644\u064a\u0633 \u0645\u0633\u0627\u062d\u0629 \u0627\u0644\u0642\u0631\u0635. \u062c\u0631\u0628 \u0645\u0642\u0637\u0639\u064b\u0627 \u0623\u0642\u0635\u0631 \u0623\u0648 \u0635\u064a\u063a\u0629 MP3.",processing:"\u062e\u0637\u0623 \u0641\u064a \u0627\u0644\u0645\u0639\u0627\u0644\u062c\u0629. \u062c\u0631\u0628 \u0635\u064a\u063a\u0629 \u0625\u062e\u0631\u0627\u062c \u0645\u062e\u062a\u0644\u0641\u0629 \u0623\u0648 \u0623\u0639\u062f \u0631\u0641\u0639 \u0627\u0644\u0645\u0644\u0641.",unknown:"\u062d\u062f\u062b \u062e\u0637\u0623 \u0623\u062b\u0646\u0627\u0621 \u0627\u0644\u0645\u0639\u0627\u0644\u062c\u0629. \u062d\u0627\u0648\u0644 \u062a\u062d\u062f\u064a\u062b \u0627\u0644\u0635\u0641\u062d\u0629 \u0623\u0648 \u0627\u0633\u062a\u062e\u062f\u0627\u0645 \u0645\u062a\u0635\u0641\u062d \u0622\u062e\u0631.",broken_container:"التسجيل غير مكتمل: لا يحتوي الملف على فهرس، لذلك لا يستطيع أي مشغّل فتحه. تغيير الصيغة لن يساعد — أصلِح الملف أولًا في أداة إصلاح الفيديو."},id:{file_lost:"File yang dipilih tidak lagi dapat diakses. Silakan pilih ulang file Anda.",init:"Gagal memuat mesin pemrosesan. Periksa koneksi internet Anda atau coba browser lain (Chrome, Firefox).",memory:"RAM (memori kerja) perangkat Anda tidak cukup untuk memproses file ini. Tutup tab dan aplikasi yang tidak perlu, atau pilih bagian yang lebih pendek.",memory_big:"File ini terlalu besar untuk RAM perangkat Anda. Pemrosesan menggunakan RAM, bukan ruang disk. Coba bagian yang lebih pendek atau format MP3.",processing:"Kesalahan pemrosesan. Coba format output lain atau unggah ulang file Anda.",unknown:"Terjadi kesalahan saat pemrosesan. Coba muat ulang halaman atau gunakan browser lain.",broken_container:"Rekaman tidak lengkap: berkas tidak punya indeks, sehingga tidak ada pemutar yang bisa membukanya. Format lain tidak membantu — perbaiki dulu berkasnya di alat perbaikan video."},pt:{file_lost:"O arquivo selecionado não está mais acessível. O arquivo pode ter sido movido ou a aba do navegador ficou inativa por muito tempo. Selecione o arquivo novamente.",init:"N\u00e3o foi poss\u00edvel carregar o motor de processamento. Verifique sua conex\u00e3o ou tente outro navegador.",memory:"RAM insuficiente no dispositivo. Feche abas desnecessárias ou selecione um trecho mais curto.",memory_big:"Este arquivo é grande demais para a RAM do seu dispositivo. Tente um trecho mais curto ou formato MP3.",processing:"Erro no processamento. Tente outro formato ou reenvie o arquivo.",unknown:"Ocorreu um erro durante o processamento. Tente recarregar a página ou usar outro navegador.",broken_container:"A gravação está incompleta: o arquivo não tem índice, por isso nenhum player consegue abri-lo. Outro formato não ajuda — repare o arquivo primeiro na ferramenta de reparo de vídeo."},de:{file_lost:"Die ausgewählte Datei ist nicht mehr zugänglich. Die Datei wurde eventuell verschoben oder der Browser-Tab war zu lange inaktiv. Bitte wählen Sie die Datei erneut aus.",init:"Die Verarbeitungs-Engine konnte nicht geladen werden. Pr\u00fcfen Sie Ihre Verbindung oder versuchen Sie einen anderen Browser.",memory:"Nicht genug RAM auf dem Gerät. Schließen Sie unnötige Tabs oder wählen Sie einen kürzeren Abschnitt.",memory_big:"Diese Datei ist zu groß für den RAM Ihres Geräts. Versuchen Sie einen kürzeren Abschnitt oder das MP3-Format.",processing:"Fehler bei der Verarbeitung. Versuchen Sie ein anderes Format oder laden Sie die Datei erneut hoch.",unknown:"Bei der Verarbeitung ist ein Fehler aufgetreten. Laden Sie die Seite neu oder verwenden Sie einen anderen Browser.",broken_container:"Die Aufnahme ist unvollständig: Die Datei hat kein Inhaltsverzeichnis, deshalb kann kein Player sie öffnen. Ein anderes Format hilft nicht — reparieren Sie die Datei zuerst im Werkzeug zur Videoreparatur."},es:{file_lost:"El archivo seleccionado ya no está accesible. Puede que se haya movido o que la pestaña del navegador estuviera inactiva demasiado tiempo. Vuelve a seleccionar el archivo.",init:"No se pudo cargar el motor de procesamiento. Comprueba tu conexi\u00f3n o prueba otro navegador.",memory:"RAM insuficiente en el dispositivo. Cierra pestañas innecesarias o elige un fragmento más corto.",memory_big:"Este archivo es demasiado grande para la RAM de tu dispositivo. Prueba un fragmento más corto o el formato MP3.",processing:"Error al procesar el archivo. Prueba otro formato o vuelve a subir el archivo.",unknown:"Ocurrió un error durante el procesamiento. Recarga la página o usa otro navegador.",broken_container:"La grabación está incompleta: el archivo no tiene índice, por eso ningún reproductor puede abrirlo. Otro formato no ayuda: repara primero el archivo en la herramienta de reparación de video."},fr:{file_lost:"Le fichier sélectionné n’est plus accessible. Il a peut-être été déplacé, ou l’onglet du navigateur est resté inactif trop longtemps. Veuillez resélectionner le fichier.",init:"Impossible de charger le moteur de traitement. V\u00e9rifiez votre connexion ou essayez un autre navigateur.",memory:"RAM insuffisante sur l’appareil. Fermez les onglets inutiles ou choisissez un extrait plus court.",memory_big:"Ce fichier est trop volumineux pour la RAM de votre appareil. Essayez un extrait plus court ou le format MP3.",processing:"Erreur de traitement. Essayez un autre format ou t\u00e9l\u00e9versez \u00e0 nouveau le fichier.",unknown:"Une erreur s’est produite pendant le traitement. Rechargez la page ou utilisez un autre navigateur.",broken_container:"L’enregistrement est incomplet : le fichier n’a pas d’index, aucun lecteur ne peut donc l’ouvrir. Un autre format n’y changera rien — réparez d’abord le fichier dans l’outil de réparation vidéo."},uk:{file_lost:"\u041e\u0431\u0440\u0430\u043d\u0438\u0439 \u0444\u0430\u0439\u043b \u0431\u0456\u043b\u044c\u0448\u0435 \u043d\u0435\u0434\u043e\u0441\u0442\u0443\u043f\u043d\u0438\u0439. \u0424\u0430\u0439\u043b \u043c\u043e\u0433\u043b\u0438 \u043f\u0435\u0440\u0435\u043c\u0456\u0441\u0442\u0438\u0442\u0438, \u043f\u0435\u0440\u0435\u0439\u043c\u0435\u043d\u0443\u0432\u0430\u0442\u0438, \u0430\u0431\u043e \u0432\u043a\u043b\u0430\u0434\u043a\u0430 \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0430 \u0431\u0443\u043b\u0430 \u043d\u0435\u0430\u043a\u0442\u0438\u0432\u043d\u0430 \u043d\u0430\u0434\u0442\u043e \u0434\u043e\u0432\u0433\u043e. \u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u0432\u0438\u0431\u0435\u0440\u0456\u0442\u044c \u0444\u0430\u0439\u043b \u0449\u0435 \u0440\u0430\u0437.",init:"\u041d\u0435 \u0432\u0434\u0430\u043b\u043e\u0441\u044f \u0437\u0430\u0432\u0430\u043d\u0442\u0430\u0436\u0438\u0442\u0438 \u043e\u0431\u0440\u043e\u0431\u043d\u0438\u043a. \u041f\u0435\u0440\u0435\u0432\u0456\u0440\u0442\u0435 \u043f\u0456\u0434\u043a\u043b\u044e\u0447\u0435\u043d\u043d\u044f \u0434\u043e \u0456\u043d\u0442\u0435\u0440\u043d\u0435\u0442\u0443 \u0430\u0431\u043e \u0441\u043f\u0440\u043e\u0431\u0443\u0439\u0442\u0435 \u0456\u043d\u0448\u0438\u0439 \u0431\u0440\u0430\u0443\u0437\u0435\u0440 (Chrome, Firefox).",memory:"\u041d\u0430 \u0432\u0430\u0448\u043e\u043c\u0443 \u043f\u0440\u0438\u0441\u0442\u0440\u043e\u0457 \u043d\u0435 \u0432\u0438\u0441\u0442\u0430\u0447\u0438\u043b\u043e \u043e\u043f\u0435\u0440\u0430\u0442\u0438\u0432\u043d\u043e\u0457 \u043f\u0430\u043c\u2019\u044f\u0442\u0456 (\u041e\u0417\u041f) \u0434\u043b\u044f \u043e\u0431\u0440\u043e\u0431\u043a\u0438. \u0417\u0430\u043a\u0440\u0438\u0439\u0442\u0435 \u0437\u0430\u0439\u0432\u0456 \u0432\u043a\u043b\u0430\u0434\u043a\u0438 \u0442\u0430 \u043f\u0440\u043e\u0433\u0440\u0430\u043c\u0438 \u0430\u0431\u043e \u0432\u0438\u0431\u0435\u0440\u0456\u0442\u044c \u043a\u043e\u0440\u043e\u0442\u0448\u0438\u0439 \u0444\u0440\u0430\u0433\u043c\u0435\u043d\u0442.",memory_big:"\u0424\u0430\u0439\u043b \u0437\u0430\u0432\u0435\u043b\u0438\u043a\u0438\u0439 \u0434\u043b\u044f \u043e\u043f\u0435\u0440\u0430\u0442\u0438\u0432\u043d\u043e\u0457 \u043f\u0430\u043c\u2019\u044f\u0442\u0456 (\u041e\u0417\u041f) \u0432\u0430\u0448\u043e\u0433\u043e \u043f\u0440\u0438\u0441\u0442\u0440\u043e\u044e. \u041e\u0431\u0440\u043e\u0431\u043a\u0430 \u0432\u0438\u043a\u043e\u0440\u0438\u0441\u0442\u043e\u0432\u0443\u0454 \u041e\u0417\u041f, \u0430 \u043d\u0435 \u043c\u0456\u0441\u0446\u0435 \u043d\u0430 \u0434\u0438\u0441\u043a\u0443. \u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044c \u043a\u043e\u0440\u043e\u0442\u0448\u0438\u0439 \u0444\u0440\u0430\u0433\u043c\u0435\u043d\u0442 \u0430\u0431\u043e \u0444\u043e\u0440\u043c\u0430\u0442 \u0437\u0456 \u0441\u0442\u0438\u0441\u043d\u0435\u043d\u043d\u044f\u043c, \u043d\u0430\u043f\u0440\u0438\u043a\u043b\u0430\u0434 MP3.",processing:"\u041f\u043e\u043c\u0438\u043b\u043a\u0430 \u043e\u0431\u0440\u043e\u0431\u043a\u0438. \u0421\u043f\u0440\u043e\u0431\u0443\u0439\u0442\u0435 \u0456\u043d\u0448\u0438\u0439 \u0444\u043e\u0440\u043c\u0430\u0442 \u0430\u0431\u043e \u0437\u0430\u0432\u0430\u043d\u0442\u0430\u0436\u0442\u0435 \u0444\u0430\u0439\u043b \u0449\u0435 \u0440\u0430\u0437.",unknown:"\u041f\u0456\u0434 \u0447\u0430\u0441 \u043e\u0431\u0440\u043e\u0431\u043a\u0438 \u0441\u0442\u0430\u043b\u0430\u0441\u044f \u043f\u043e\u043c\u0438\u043b\u043a\u0430. \u0421\u043f\u0440\u043e\u0431\u0443\u0439\u0442\u0435 \u043e\u043d\u043e\u0432\u0438\u0442\u0438 \u0441\u0442\u043e\u0440\u0456\u043d\u043a\u0443 \u0430\u0431\u043e \u0441\u043a\u043e\u0440\u0438\u0441\u0442\u0430\u0442\u0438\u0441\u044f \u0456\u043d\u0448\u0438\u043c \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u043e\u043c.",broken_container:"\u0417\u0430\u043f\u0438\u0441 \u043d\u0435\u043f\u043e\u0432\u043d\u0438\u0439: \u0443 \u0444\u0430\u0439\u043b\u0456 \u043d\u0435\u043c\u0430\u0454 \u043f\u043e\u043a\u0430\u0436\u0447\u0438\u043a\u0430, \u0442\u043e\u043c\u0443 \u0436\u043e\u0434\u0435\u043d \u043f\u043b\u0435\u0454\u0440 \u0439\u043e\u0433\u043e \u043d\u0435 \u0432\u0456\u0434\u043a\u0440\u0438\u0454. \u0406\u043d\u0448\u0438\u0439 \u0444\u043e\u0440\u043c\u0430\u0442 \u043d\u0435 \u0434\u043e\u043f\u043e\u043c\u043e\u0436\u0435 \u2014 \u0441\u043f\u043e\u0447\u0430\u0442\u043a\u0443 \u043f\u043e\u043b\u0430\u0433\u043e\u0434\u044c\u0442\u0435 \u0444\u0430\u0439\u043b \u0443 \u0456\u043d\u0441\u0442\u0440\u0443\u043c\u0435\u043d\u0442\u0456 \u00ab\u0420\u0435\u043c\u043e\u043d\u0442 \u0432\u0456\u0434\u0435\u043e\u00bb."}};/* iOS WebKit init-failure messaging (2026-06-13 To_li_man feedback on /join). Chrome iOS / Firefox iOS / Yandex iOS all run on WebKit by App Store policy and inherit the same FFmpeg WASM Instantiate-timeout class — suggesting "another browser" sends users in circles. iOS-specific honest message: fewer tracks, MP3, desktop. */if(type==="init"&&/iP(hone|ad|od)/.test(navigator.userAgent||"")){var II={en:"On iPhone/iPad browser audio processing is limited and the engine sometimes won’t start. Try: reduce the number of tracks, switch the output format to MP3, or use the tool on a desktop computer.",ru:"На iPhone/iPad обработка аудио в браузере ограничена и движок иногда не запускается. Попробуйте: уменьшить количество треков, выбрать MP3 в качестве формата, или открыть инструмент на компьютере.",ko:"iPhone/iPad에서는 브라우저 오디오 처리가 제한되어 엔진이 시작되지 않을 수 있습니다. 트랙 수를 줄이거나, 출력 형식을 MP3로 변경하거나, PC에서 사용해 보세요.",ar:"على iPhone/iPad معالجة الصوت في المتصفح محدودة وقد لا يبدأ المحرك. جرّب: تقليل عدد المقاطع، تغيير الصيغة إلى MP3، أو استخدام الأداة على كمبيوتر مكتبي.",id:"Di iPhone/iPad pemrosesan audio di browser terbatas dan mesin terkadang tidak dapat dijalankan. Coba: kurangi jumlah trek, ubah format keluaran ke MP3, atau gunakan alat ini di komputer.",pt:"No iPhone/iPad o processamento de áudio no navegador é limitado e o motor às vezes não inicia. Tente: reduzir o número de faixas, mudar o formato de saída para MP3, ou usar a ferramenta em um computador.",de:"Auf iPhone/iPad ist die Audioverarbeitung im Browser begrenzt und die Engine startet manchmal nicht. Versuchen Sie: Anzahl der Spuren reduzieren, das Ausgabeformat auf MP3 umstellen, oder das Tool auf einem Desktop-Computer verwenden.",es:"En iPhone/iPad el procesamiento de audio en el navegador es limitado y el motor a veces no se inicia. Pruebe: reducir el número de pistas, cambiar el formato de salida a MP3, o usar la herramienta en un ordenador.",fr:"Sur iPhone/iPad le traitement audio dans le navigateur est limité et le moteur ne démarre pas toujours. Essayez : réduire le nombre de pistes, passer la sortie en MP3, ou utiliser l’outil sur un ordinateur.", uk: "У браузері на iPhone/iPad обробка аудіо обмежена, і обробник іноді не запускається. Спробуйте: зменшити кількість доріжок, змінити формат виведення на MP3 або скористатися інструментом на настільному комп’ютері.", tr: "iPhone/iPad'de tarayıcıda ses işleme sınırlıdır ve motor bazen başlamaz. Deneyin: parça sayısını azaltın, çıktı biçimini MP3'e dönüştürün veya aracı bir masaüstü bilgisayarda kullanın."};return II[loc]||II.en;}var m=M[loc]||M.en;if(type==="memory"&&big)return m.memory_big;/* Отказ /join своими словами (2026-06-08, переписано 2026-08-24).

   Многофайловому склейщику бесполезен общий совет «возьмите отрезок покороче»,
   поэтому здесь свой текст. Но ветка ловила `memory` И `processing` разом, а
   `processing` — это ЛЮБОЙ ненулевой код возврата ffmpeg. Обоснование в старом
   комментарии («OOM под деревом слияния часто выходит generic-кодом») ЗАМЕРЕНО
   и не подтвердилось: за 60 дней на /join класс `processing` — это 25 отказов
   сборки фильтр-графа (наш дефект от 21.08) и один «0 channels», то есть НИ
   ОДНОГО случая нехватки памяти; настоящие OOM (10 событий) несут явную фразу
   и классифицируются как `memory` сами.

   Цена ошибки была не косметическая: человеку с 8 ГБ и пиком 6–18 МБ трое
   суток предлагали закрыть вкладки и убавить треки, пока падал наш граф.
   «Джойнер просто не сводит выставленные треки… я воспринимаю это просто как
   ошибка, ошибка, ошибка — именно в работе программы» (24.08) — и он был прав.
   Поэтому: про память говорим ТОЛЬКО когда это память. */
if(ctx&&ctx.slug==="join"&&(type==="memory"||type==="processing")){
var _jt=Math.max(2,parseInt(ctx.trackCount,10)||4);
if(type==="processing"){var JP={
en:"Couldn’t finish the join — processing failed. This isn’t about your device’s memory. Reload the page and try again; if it happens again, tell us — the error report has already been sent.",
ru:"Не удалось собрать склейку — сбой обработки. Память устройства тут ни при чём. Обновите страницу и попробуйте ещё раз; если повторится — напишите нам, отчёт об ошибке уже отправлен.",
ko:"결합을 마치지 못했습니다 — 처리 중 오류입니다. 기기 메모리와는 무관합니다. 페이지를 새로고침하고 다시 시도해 보세요. 반복되면 알려주세요 — 오류 보고는 이미 전송되었습니다.",
ar:"تعذّر إكمال الدمج — فشل أثناء المعالجة. الأمر لا علاقة له بذاكرة جهازك. أعد تحميل الصفحة وحاول مرة أخرى؛ وإذا تكرر فأخبرنا — تم إرسال تقرير الخطأ بالفعل.",
id:"Penggabungan tidak selesai — pemrosesan gagal. Ini bukan soal memori perangkat Anda. Muat ulang halaman dan coba lagi; jika terulang, beri tahu kami — laporan galat sudah terkirim.",
pt:"Não foi possível concluir a união — falha no processamento. Isto não tem a ver com a memória do seu dispositivo. Recarregue a página e tente de novo; se repetir, avise-nos — o relatório de erro já foi enviado.",
de:"Das Zusammenführen konnte nicht abgeschlossen werden — Fehler bei der Verarbeitung. Das liegt nicht am Arbeitsspeicher Ihres Geräts. Laden Sie die Seite neu und versuchen Sie es erneut; wenn es wieder passiert, sagen Sie uns Bescheid — der Fehlerbericht wurde bereits gesendet.",
es:"No se pudo terminar la unión — fallo de procesamiento. No tiene que ver con la memoria de su dispositivo. Recargue la página e inténtelo de nuevo; si se repite, avísenos — el informe de error ya se ha enviado.",
fr:"Impossible de terminer la fusion — échec du traitement. Cela ne vient pas de la mémoire de votre appareil. Rechargez la page et réessayez ; si cela se reproduit, dites-le-nous — le rapport d’erreur a déjà été envoyé.", uk: "Об’єднання не завершилося — сталася помилка обробника. Це не пов’язано з пам’яттю вашого пристрою. Перезавантажте сторінку і спробуйте ще раз; якщо помилка повториться, повідомте нам — звіт про помилку вже надіслано.", tr: "Birleştirme tamamlanamadı — işlem başarısız oldu. Bu cihazınızın belleğiyle ilgili değil. Sayfayı yeniden yükleyip tekrar deneyin; tekrarlanırsa bize bildirin — hata raporu zaten gönderildi."};return JP[loc]||JP.en;}
/* Дальше — НАСТОЯЩАЯ нехватка памяти. Совет «уберите N дорожек» при наборе из
   двух невыполним (склеивать нечего) — «до скольки убавить, если для склейки
   нужно минимум две части?» — поэтому на двух дорожках клауза уходит совсем. */
var _drop=Math.max(1,Math.ceil(_jt/3));
var _plRu=function(n,a,b,c){var n10=n%10,n100=n%100;return (n10===1&&n100!==11)?a:((n10>=2&&n10<=4&&(n100<10||n100>=20))?b:c);};
var _many=_jt<=2;
var _rmEn=_many?"":"remove "+_drop+" track"+(_drop===1?"":"s")+", ";
var _rmRu=_many?"":"удалить "+_drop+" "+_plRu(_drop,"трек","трека","треков")+", ";
var _rmKo=_many?"":_drop+"개 트랙을 제거하거나, ";
var _rmAr=_many?"":"إزالة "+_drop+" مقاطع، ";
var _rmId=_many?"":"hapus "+_drop+" trek, ";
var _rmPt=_many?"":"remover "+_drop+" faixa"+(_drop===1?"":"s")+", ";
var _rmDe=_many?"":_drop+" Spur"+(_drop===1?"":"en")+" entfernen, ";
var _rmEs=_many?"":"quitar "+_drop+" pista"+(_drop===1?"":"s")+", ";
var _rmFr=_many?"":"retirer "+_drop+" piste"+(_drop===1?"":"s")+", ";
var _rmTr=_many?"":_drop+" parça çıkarın, ";
var _fmt=String(ctx.format||"").toLowerCase();var _fmtAdvice=(_fmt==="wav"||_fmt==="flac")?"switch the output format to MP3 (uses ~10\xD7 less memory than WAV/FLAC), ":"";var _fmtRu=(_fmt==="wav"||_fmt==="flac")?"переключить формат вывода на MP3 (требует в ~10 раз меньше памяти, чем WAV/FLAC), ":"";var _fmtKo=(_fmt==="wav"||_fmt==="flac")?"출력 형식을 MP3로 변경하거나(메모리 약 10배 절약), ":"";var _fmtAr=(_fmt==="wav"||_fmt==="flac")?"تغيير الصيغة إلى MP3 (تستهلك ذاكرة أقل بـ10 مرات من WAV/FLAC)، ":"";var _fmtId=(_fmt==="wav"||_fmt==="flac")?"ubah keluaran ke MP3 (~10\xD7 lebih hemat memori dari WAV/FLAC), ":"";var _fmtPt=(_fmt==="wav"||_fmt==="flac")?"mudar a saída para MP3 (~10\xD7 menos memória que WAV/FLAC), ":"";var _fmtDe=(_fmt==="wav"||_fmt==="flac")?"Ausgabe auf MP3 umstellen (~10\xD7 weniger Speicher als WAV/FLAC), ":"";var _fmtEs=(_fmt==="wav"||_fmt==="flac")?"cambiar la salida a MP3 (~10\xD7 menos memoria que WAV/FLAC), ":"";var _fmtFr=(_fmt==="wav"||_fmt==="flac")?"passer la sortie en MP3 (~10\xD7 moins de mémoire que WAV/FLAC), ":"";var _fmtTr=(_fmt==="wav"||_fmt==="flac")?"çıktı biçimini MP3'e dönüştürün (WAV/FLAC dosyalarına göre ~10\xD7 daha az bellek kullanır), ":"";var JH={en:"Couldn’t finish joining "+_jt+" tracks — ran out of working memory. Try: "+_rmEn+_fmtAdvice+"close other browser tabs, or split the job into batches and merge results.",ru:"Не удалось завершить склейку "+_jt+" треков — закончилась оперативная память. Попробуйте: "+_rmRu+_fmtRu+"закрыть лишние вкладки браузера или объединить файлы партиями.",ko:_jt+"개 트랙 결합을 끝내지 못했습니다 — 작업 메모리가 부족합니다. "+_rmKo+_fmtKo+"다른 브라우저 탭을 닫거나, 여러 번에 나눠 진행해 결과를 합치세요.",ar:"تعذّر إكمال دمج "+_jt+" مقطعاً — نفدت ذاكرة العمل. جرّب: "+_rmAr+_fmtAr+"إغلاق علامات تبويب أخرى، أو القسمة على دفعات ودمج النتائج.",id:"Tidak dapat menyelesaikan penggabungan "+_jt+" trek — memori kerja habis. Coba: "+_rmId+_fmtId+"tutup tab browser lain, atau bagi proses menjadi beberapa kelompok lalu gabungkan hasilnya.",pt:"Não foi possível concluir a união de "+_jt+" faixas — memória de trabalho esgotada. Tente: "+_rmPt+_fmtPt+"fechar outras abas do navegador ou dividir em lotes e juntar os resultados.",de:"Konnte das Zusammenführen von "+_jt+" Spuren nicht abschließen — Arbeitsspeicher voll. Versuchen Sie: "+_rmDe+_fmtDe+"andere Browser-Tabs schließen oder in Stapeln zusammenführen und die Ergebnisse vereinen.",es:"No se pudo terminar de unir "+_jt+" pistas — memoria de trabajo agotada. Pruebe: "+_rmEs+_fmtEs+"cerrar otras pestañas del navegador, o dividir en lotes y unir los resultados.",fr:"Impossible de terminer la fusion de ", uk: "Не вдалося завершити об’єднання "+_jt+" pistes — mémoire de travail saturée. Essayez : "+_rmFr+_fmtFr+"fermer d’autres onglets, ou diviser en lots et fusionner les résultats.",tr:_jt+" parça birleştirme tamamlanamadı — çalışma belleği yetersiz kaldı. Deneyin: "+_rmTr+_fmtTr+"diğer tarayıcı sekmelerini kapatın veya işi gruplara bölüp sonuçları birleştirin."};return JH[loc]||JH.en;}return m[type]||m.unknown},_fs:{async write(name,data){if(!e)await FFmpegProcessor._ensureReady();if(!e)throw new Error("FFmpeg not initialized");var d=data instanceof Uint8Array?data:await m(data);/* Длину читаем ДО записи: ffmpeg.wasm ПЕРЕДАЁТ буфер воркеру (transferable), после чего наш Uint8Array отсоединён и `d.length` равен нулю. Дверь обещает «сколько байт записано» и до 2026-09-10 возвращала 0 ВСЕГДА — читателей у значения не было, поэтому ложь никого не сломала, но следующий, кто на неё обопрётся, увидит «записалось ноль» на успешной записи. Та же ловушка ловит и вызывающего, который пишет ОДИН массив дважды: второй раз уедет пусто. */var _n=d.length;await e.writeFile(name,d);return _n},async read(name){if(!e)await FFmpegProcessor._ensureReady();if(!e)throw new Error("FFmpeg not initialized");return await e.readFile(name)},async del(name){try{if(e)await e.deleteFile(name)}catch(_){}},/* `logs` здесь — СЫРОЙ хвост, и это не недосмотр: семь мест вытаскивают из
   него значения регулярками (`Duration:` в /denoise ×4, `NNNN Hz`, счёт строк
   декодера в /repair-video, темп кадров в video-vitals). Замер 08.09.2026:
   прогон через __ffErrTail теряет `Duration:` — он в списке шума, — то есть
   «починка двери» молча сломала бы определение длительности у /denoise.
   Баннер FFmpeg мешает не читателю логов, а ТРАНСПОРТУ: телеметрия режет
   сообщение по первым 200 символам, и туда уезжали 11 строк версий вместо
   причины. Поэтому обрезка живёт там, где живёт бюджет, — telemetry-tier0.js
   (__ffStripBanner), и покрывает все места разом, включая будущие. */
/* timeoutMs — a WORK-time bound the core checks inside its own loop: the run ends by itself with code 1, everything it printed and wrote up to that moment is there, and the instance stays alive (measured 13.10.2026 on the shipped core: 4 s and 9 s cuts of a 63 s decode, a normal run right after). Nothing else on the page can end a run without terminating the engine. */async exec(args,timeoutMs){if(!e)await FFmpegProcessor._ensureReady();if(!e)throw new Error("FFmpeg not initialized");window._ffLogs=[];var code=await e.exec(args,timeoutMs>0?Math.round(timeoutMs):undefined);return{code:code,logs:(window._ffLogs||[]).slice(-10).join(" | ")}}},async initWithProgress(textEl,barEl,labels){var _isFn=typeof textEl==="function";var _cb=_isFn?textEl:null;var L=(_isFn?barEl:labels)||{};var loadTxt=L.loading||"Loading\u2026";var procTxt=L.processing||"Processing";if(_isFn){barEl=null}var _cur=0,_target=0,_raf=null,_phase="load";function _set(t,p){_target=p;if(!_cb&&textEl)textEl.textContent=t;if(!_raf)_tick()}function _tick(){var diff=_target-_cur;if(Math.abs(diff)<0.3){_cur=_target}else{_cur+=diff*0.15}var pct=Math.round(_cur);if(_cb){_cb(_phase,pct)}else{if(barEl)barEl.style.width=pct+"%";if(textEl){var label=_phase==="load"?loadTxt:procTxt;textEl.textContent=label+" "+pct+"%"}}if(Math.abs(_target-_cur)>0.3){_raf=requestAnimationFrame(_tick)}else{_raf=null}}var _self=this;/* 2026-09-03 #1518 (Андрей, «25 % и стопорит»). Два дефекта в ОДНОЙ функции, общей для всех FFmpeg-тулов:  (a) при УЖЕ загруженном движке был ранний выход до this.onProgress(...) — а в video-trim движок к моменту «Сохранить» тёплый ВСЕГДА (миниатюры + волна его инициализируют), поэтому подписки на прогресс не возникало ни разу;  (b) сам коллбэк ставил _target, но не будил rAF-цикл, а тот останавливает себя, когда _cur догнал _target (конец фазы загрузки) — так что даже подписанный прогресс не рисовался. Замер на проде: ffmpeg отдаёт 0→0.14→0.33→0.64→1.0 за 4.6 с, а пользователь видит [14%, 25%] и 25% висит 7.5 с из 8.7 (86% времени). После правки: [25,44,62,86,91,95]. Сосед _stopFakeProgress про пробуждение цикла помнил — этот коллбэк нет. */function _wireProc(){_self.onProgress(function(p){_target=Math.round(25+p*70);if(!_raf)_tick()})}if(r){_phase="proc";_cur=25;_set(procTxt,25);_wireProc();_self._stopFakeProgress=function(){_target=95;if(!_raf)_tick()};return true}if(textEl)textEl.textContent=loadTxt;_phase="load";var ok=await this.init(function(p){_target=Math.round(p*25);if(!_raf)_tick()});if(!ok)return false;_phase="proc";_target=25;_cur=25;if(textEl)textEl.textContent=procTxt;if(barEl)barEl.style.width="25%";/* No fake asymptotic progress during processing: the bar moves on real
   FFmpeg progress events only. When processing briefly has no reported
   progress (e.g. two-pass loudnorm's first pass), the bar stays put —
   an honest signal. A stall for >30s is caught by the per-tool
   watchdog (see audio-enhancer runWasm) and surfaces as tool_stalled. */
_wireProc();this._stopFakeProgress=function(){_target=95;if(!_raf)_tick()};return true},
async probeDuration(file){try{if(!this.isReady())await this.init();var log=await this.probe(file);var m=log.match(/Duration:\s*(\d+):(\d+):(\d+(?:\.\d+)?)/);if(m)return parseInt(m[1])*3600+parseInt(m[2])*60+parseFloat(m[3])}catch(e){}return 0},
async probeAudioBitrate(file){try{await this.init();var log=await this.probe(file);var lines=log.split('\n');for(var i=0;i<lines.length;i++){if(/Stream\s+#\d+:\d+.*?:\s*Audio/i.test(lines[i])){var m=lines[i].match(/(\d+)\s*kb\/s/);if(m)return parseInt(m[1])}}}catch(e){}return 0},
/* Sample rate of the FIRST audio stream, in Hz. Used by tools (e.g.
   acx-mastering) that need to display the FILE's actual sample rate in a
   pre-decode analysis — `AudioBuffer.sampleRate` always returns the
   AudioContext's rate (typically 48 kHz on desktop browsers) regardless
   of the source file's actual rate, so it can't be trusted for "is this
   file at 44.1 kHz?" checks. Mirrors the regex shape of probeAudioBitrate
   so the two stay in sync if ffmpeg's stream-line format ever changes. */
async probeAudioSampleRate(file){try{await this.init();var log=await this.probe(file);var lines=log.split('\n');for(var i=0;i<lines.length;i++){if(/Stream\s+#\d+:\d+.*?:\s*Audio/i.test(lines[i])){var m=lines[i].match(/(\d+)\s*Hz/);if(m)return parseInt(m[1])}}}catch(e){}return 0},
/* Sample rate AND channel count of the first audio stream, from ONE probe.
   Used where a tool must match the SOURCE layout/rate in an export filtergraph
   (e.g. profanity-remover's silence/beep atrim+concat). Replaces the fragile
   pattern of slicing the first 512 KB and decodeAudioData-ing it for the
   channel count — a moov-at-end MP4 head simply does not decode, so channels
   fell back to stereo on exactly those files, AND the headless slice tripped
   the global decodeAudioData→FFmpeg fallback into a spurious "moov atom not
   found" error on every video upload. Returns {sampleRate, channels} with 0
   for anything not found so the caller keeps its own default. */
async probeAudioStream(file){var out={sampleRate:0,channels:0,startSec:null};try{await this.init();/* probeStreaming: the file is MOUNTED, not copied. probe() reads the whole file into memory first, and for a video past ~2 GB that read throws (no JS buffer is that big) - every value below then silently fell back to its default (30.09.2026: the censor and sound-of-video zones now take such files - see soundtrack-splice.js). */var log;try{log=typeof this.probeStreaming==='function'&&(file instanceof File||file instanceof Blob)?await this.probeStreaming(file):await this.probe(file)}catch(_ps){log=await this.probe(file)}/* startSec — the input's start_time as FFmpeg reports it («Duration: …, start: X»). Without -copyts every run renders from THAT zero, so a lane that puts a rendered soundtrack back into the original container (profanity-remover-video, zero-copy) has to know where that zero sits. null = not reported. */var st=log.match(/Duration:[^\n]*?,\s*start:\s*(-?\d+(?:\.\d+)?)/);if(st)out.startSec=parseFloat(st[1]);var lines=log.split('\n');for(var i=0;i<lines.length;i++){if(/Stream\s+#\d+:\d+.*?:\s*Audio/i.test(lines[i])){var hz=lines[i].match(/(\d+)\s*Hz/);if(hz)out.sampleRate=parseInt(hz[1],10);out.channels=this._parseChannelLayout(lines[i]);break}}}catch(e){}return out},
_parseChannelLayout(line){var m=line.match(/Hz,\s*([^,]+)/i);if(!m)return 0;var tok=m[1].toLowerCase().replace(/\([^)]*\)/g,'').trim();var map={mono:1,stereo:2,'2.1':3,'3.0':3,quad:4,'4.0':4,'4.1':5,'5.0':5,'5.1':6,'6.1':7,'7.1':8,downmix:2};if(map[tok]!=null)return map[tok];var n=tok.match(/(\d+)\s*channels?/);if(n)return parseInt(n[1],10);var d=tok.match(/^(\d+)\.(\d+)$/);if(d)return parseInt(d[1],10)+parseInt(d[2],10);return 0},
getLastAudioBitrate(){var logs=window._ffLogs||[];for(var i=0;i<logs.length;i++){if(/Stream\s+#\d+:\d+.*?:\s*Audio/i.test(logs[i])){var m=logs[i].match(/(\d+)\s*kb\/s/);if(m)return parseInt(m[1])}}return 0},
/* Keyframe (I-frame) timestamp extraction — fallback tier for the shared
   video-keyframe-probe.js module. mp4-family files go through mp4box's
   stss+stts box parse (~50 ms, in-browser, no WASM). This is the universal
   fallback for AVI/MKV/TS/FLV/WMV/OGV/WebM containers (which mp4box can't
   read) — runs FFmpeg with `-skip_frame nokey` (demux-level skip of
   non-keyframe packets) + `-vf showinfo` (emits a log line per surviving
   frame) + `-f null -` (no output mux). The showinfo line for each I-frame
   carries `pts_time:NN.NNN`; we parse and sort. */
async probeKeyframesNative(file){
    /* The probe copies the WHOLE input into the engine's memory, so above the
       engine's own ceiling (__WASM_OUTPUT_MAX, 1600 MiB) it can only fail — and
       it did, reading the file first: RU 13–27.09, /video-trim, 25 sessions of
       1.9–8.8 GB recordings answered RangeError, and FileBytes then marked a
       healthy file as lost. No keyframe list is the answer those files already
       got (the trim stays a stream copy); now without the doomed read.
       ⚠️ Measured 27.09.2026 and rejected: probing through a WORKERFS mount.
       It works at any size (2.3 GB MKV → 510 keyframes) but reads ~50 MB/s —
       932 MB took 18.5 s against 4.5 s here — and for MKV/AVI a keyframe list
       sends a trim that is off a keyframe to a FULL re-encode (planSplice needs
       mp4 frame tables), so on a multi-GB file it would buy a wait of minutes. */
    var _kfCap = (typeof window !== 'undefined' && window.__WASM_OUTPUT_MAX) || (1600 * 1048576);
    if (file && file.size > _kfCap) {
        try { window.__ae && window.__ae('feature_use', { f: 'kf_probe_too_big', szMB: Math.round(file.size / 1048576) }); } catch(_){}
        return null;
    }
    try {
        if (!this.isReady()) await this.init();
        var inputName = 'kfprobe.' + (((file && file.name) || '').match(/\.\w+$/) || ['.mp4'])[0].slice(1);
        await this._fs.write(inputName, file);
        /* Raise the _ffLogs ring buffer cap for the duration of this probe —
           the default trunc would lose all but the last few keyframes (1 line
           per I-frame). ⚠️ Until 2026-09-25 only the worker bridge read this
           override; the two main-thread engines kept a hard 20-line cap, and
           this probe returned the LAST 8 of 25 keyframes of a 120 s file
           (mkv/avi/ts and every mp4 mp4box could not parse got a smart-trim
           split planned from a list missing its first 17 keyframes). */
        var _prevCap = window.__ffLogsCapOverride;
        window.__ffLogsCapOverride = 100000;
        window._ffLogs = [];
        try {
            await this._fs.exec(['-skip_frame','nokey','-i',inputName,'-vf','showinfo','-fps_mode','passthrough','-f','null','-']);
        } catch(_) { /* swallow — `-f null` emits expected warnings on stderr */ }
        var allLogs = (window._ffLogs || []).join('\n');
        window.__ffLogsCapOverride = _prevCap;
        await this._fs.del(inputName);
        var keyframes = [];
        var re = /pts_time:([\d.]+)/g;
        var m;
        while ((m = re.exec(allLogs))) {
            var t = parseFloat(m[1]);
            if (!isNaN(t) && isFinite(t)) keyframes.push(t);
        }
        keyframes.sort(function(a,b){ return a - b; });
        var durMatch = allLogs.match(/Duration:\s*(\d+):(\d+):(\d+(?:\.\d+)?)/);
        var duration = durMatch ? (parseInt(durMatch[1])*3600 + parseInt(durMatch[2])*60 + parseFloat(durMatch[3])) : 0;
        return { keyframes: keyframes, duration: duration };
    } catch(_) { return null; }
},

/**
 * Rotation-metadata handling — fixes "video came out upside down" / sideways
 * for iPhone/iPad recordings whose container carries a displaymatrix or
 * legacy rotate metadata. The HTML5 `<video>` element auto-rotates for
 * preview, so the user sees the right orientation; FFmpeg, when invoked
 * with `-vf …`, disables auto-rotation and processes raw frames, producing
 * output that does NOT match the preview. Trigger: 2026-05-06 feedback on
 * /en/video-flip "My video came out upside down" (Mac Safari user, iPhone
 * source assumed). Same class affects every -vf-using video tool
 * (video-flip, video-trim, video-crop, enhance-video, …).
 *
 *   parseRotation(probeLog) — read the FFmpeg `-i` log, return rotation in
 *     degrees CW (0/90/180/270) using the rotate-metadata convention
 *     (positive = display rotates CW). Handles both displaymatrix
 *     (modern, sign-inverted from rotate convention) and legacy
 *     "rotate : 90" Metadata key.
 *
 *   probeRotation(file) — convenience: probes a file with FFmpeg `-i` and
 *     returns the rotation. Cheap (no transcode), but requires FFmpeg
 *     loaded; safe-fail to 0 on probe error.
 *
 *   getRotationFilterPrefix(rotation) — filter graph prefix that brings
 *     raw frames to display orientation (matches what the user sees in
 *     the preview <video>). Empty string for rotation 0. Caller composes
 *     with their own `-vf` chain so user transforms apply on top.
 *
 *   getRotationPreInputArgs() — `-noautorotate` so FFmpeg never silently
 *     auto-rotates (otherwise our explicit prefix double-applies on
 *     versions that auto-rotate even with -vf present).
 *
 *   getRotationStripPostArgs() — strips both rotate metadata and side data
 *     so the player doesn't re-rotate the output a second time.
 *
 * Wire-up pattern for callers:
 *     var rot = await FFmpegProcessor.probeRotation(file);
 *     var pre = FFmpegProcessor.getRotationPreInputArgs();         // -> ['-noautorotate']
 *     var pfx = FFmpegProcessor.getRotationFilterPrefix(rot);      // -> 'transpose=1' / 'hflip,vflip' / ''
 *     var vf  = pfx ? (pfx + (userVf ? ',' + userVf : '')) : userVf;
 *     var strip = FFmpegProcessor.getRotationStripPostArgs();      // -> ['-metadata:s:v:0','rotate=0',...]
 *     await FFmpegProcessor.process(file, ['-vf', vf].concat(codecArgs).concat(strip), out, undefined, pre);
 */
parseRotation(probeLog){
    if(!probeLog||typeof probeLog!=='string')return 0;
    // Modern FFmpeg side-data: "displaymatrix: rotation of -90.00 degrees".
    // The displaymatrix sign is inverted from the rotate-metadata convention
    // (the matrix represents the CCW rotation FFmpeg would apply during
    // decode to bring frames to display); negate to get rotate-equivalent.
    var m=probeLog.match(/displaymatrix:\s*rotation of\s*(-?\d+(?:\.\d+)?)\s*degrees/i);
    if(m){var deg=-Math.round(parseFloat(m[1]));return((deg%360)+360)%360;}
    // Legacy "rotate : 90" line under Metadata. Same convention as our output.
    m=probeLog.match(/^\s*rotate\s*:\s*(-?\d+)/im);
    if(m){var deg2=parseInt(m[1],10);return((deg2%360)+360)%360;}
    return 0;
},
async probeRotation(file){
    try{
        if(!this.isReady())await this.init();
        var log=await this.probe(file);
        return this.parseRotation(log);
    }catch(_){return 0;}
},
getRotationFilterPrefix(rotation){
    var r=((parseInt(rotation,10)||0)%360+360)%360;
    if(r===90)return 'transpose=1';        // 90° CW
    if(r===180)return 'hflip,vflip';       // 180° (equiv. transpose=1,transpose=1; this form is faster + libavfilter-canonical)
    if(r===270)return 'transpose=2';       // 90° CCW (= 270° CW)
    return '';
},
getRotationPreInputArgs(){
    // -noautorotate is an INPUT option (must precede -i). Caller passes via
    // process()'s 5th arg `a`. Keeps behaviour deterministic across FFmpeg
    // versions: some auto-rotate when -vf is present, some don't.
    // Note: -display_rotation 0 would be cleaner (stops the matrix from
    // reaching the encoder) but @ffmpeg/core@0.12.10's WASM build returns
    // "Option not found" for that flag — confirmed by group-a-rotation
    // test 2026-05-07. Stripping is done post-encode via getRotationStripPostArgs.
    return ['-noautorotate'];
},
getRotationStripPostArgs(args){
    // Strip the rotation metadata so the player doesn't double-rotate the
    // already-display-oriented frames our filter graph produced. Three layers:
    //   1. -metadata:s:v:0 rotate=0 — clears the LEGACY container tag (older
    //      mov/mp4 files use this; modern iPhone files don't but doesn't hurt).
    //   2. -metadata:s:v rotate=0 — same as above, all video streams.
    //   3. -bsf:v {codec}_metadata=rotation=0 — clears the modern displaymatrix
    //      side data via codec-specific bitstream filter. Without this, the
    //      side data propagates from input through to output container even
    //      when re-encoding (libavformat copies stream-level side data to
    //      output streams by default). h264_metadata + hevc_metadata are
    //      both confirmed present in @ffmpeg/core@0.12.10 (FFmpeg 5.1.4 WASM
    //      build, probed 2026-05-07). vp9_metadata + av1_metadata do exist
    //      but don't expose rotation; we skip BSF for those codecs and rely
    //      on the legacy tag — webm/av1 displaymatrix in the output is rare
    //      enough that the gap is acceptable until we hit a real complaint.
    var posts=['-metadata:s:v:0','rotate=0','-metadata:s:v','rotate=0'];
    if(!args)return posts;
    var codecIdx=args.indexOf('-c:v');
    if(codecIdx===-1)codecIdx=args.indexOf('-vcodec');
    var codec=(codecIdx>=0&&args[codecIdx+1])?args[codecIdx+1]:'';
    // h264_metadata in FFmpeg 5.1 (our @ffmpeg/core build) uses
    // display_orientation=remove to strip the SEI; the rotation= shorthand
    // was added in FFmpeg 6.0 and errors out as "Option not found" here.
    // hevc_metadata has the same display_orientation pass|insert|remove enum.
    var bsfMap={
        'libx264':'h264_metadata=display_orientation=remove',
        'h264':'h264_metadata=display_orientation=remove',
        'libx265':'hevc_metadata=display_orientation=remove',
        'hevc':'hevc_metadata=display_orientation=remove',
        'h265':'hevc_metadata=display_orientation=remove'
    };
    if(bsfMap[codec])posts.push('-bsf:v',bsfMap[codec]);
    return posts;
},
/**
 * applyRotationCorrection — one-shot helper that probes the source, injects
 * the rotation-correction prefix into the user's filter chain, appends the
 * metadata-strip args, and returns {args, preInputArgs, sourceRotation}
 * ready to feed into process(). Designed so each adopting tool is a single-
 * line wire-up at the call site.
 *
 * Filter graph handling:
 *   - If `args` already contains `-vf <chain>`, the rotation prefix is
 *     prepended to that chain (rotPrefix + ',' + chain) so user transforms
 *     apply on top of display-oriented frames.
 *   - If `args` contains `-filter_complex <fc>`, the prefix is injected as
 *     `[0:v]<rotPrefix>[v_rot];` and any unnamed `[0:v]` reference in the
 *     fc is rewritten to `[v_rot]`. Caller-provided named-pad layouts are
 *     left untouched (advanced users using e.g. `[0:v]split=…` are still
 *     correct because we replace `[0:v]` only on lookups before the first
 *     graph node).
 *   - If `args` has neither `-vf` nor `-filter_complex` AND the source has
 *     non-zero rotation, we add `-vf <rotPrefix>` at the front. For sources
 *     with rotation 0, args are returned unchanged (zero overhead).
 *
 * Tool wire-up:
 *     var corr = await FFmpegProcessor.applyRotationCorrection(file, args);
 *     result = await FFmpegProcessor.process(file, corr.args, outName,
 *                                            undefined, corr.preInputArgs);
 *
 * If the caller already passes its own preInputArgs (e.g. video-trim's
 * `-ss/-to`), pass an `extraPreInput` array that this function will merge
 * with the rotation pre-input args:
 *     var corr = await FFmpegProcessor.applyRotationCorrection(file, args, ['-ss','5','-to','10']);
 *     // corr.preInputArgs = ['-noautorotate','-ss','5','-to','10']
 */
/**
 * processWithRotationFix — high-level orchestrator that fully closes the
 * iPhone-rotation-metadata bug for a single export.
 *
 * The naive approach (probe rotation → inject filter prefix → strip metadata
 * tag) does NOT work in @ffmpeg/core@0.12.10 because:
 *   - The displaymatrix side data sits at CONTAINER level (mp4 tkhd, mkv tags),
 *     not inside the codec stream.
 *   - libavformat copies stream-level side data from input demuxer to output
 *     muxer regardless of -c:v re-encode and regardless of -metadata flags.
 *   - h264_metadata BSF clears the SEI display orientation INSIDE the H.264
 *     stream, but does not touch the container-level matrix.
 *   - -display_rotation 0 (FFmpeg 6+) would override the matrix at demuxer
 *     time, but is "Option not found" in the 5.1.4 build we ship.
 *
 * The empirically-verified workaround (probed 2026-05-07): when output is
 * encoded to a fresh Matroska intermediate, libavformat does NOT propagate
 * the source's tkhd matrix into the matroska Tags element. Then a second
 * pass that simply remuxes (-c copy) MKV → user's requested container has
 * no matrix to copy from, producing a clean output with NO rotation
 * metadata at all. Output frames are display-oriented (because we applied
 * the rotation prefix in pass 1), and players show them as-is — no double
 * rotation, no axis confusion.
 *
 * Single-pass cases (no MKV intermediate needed, saves ~25 % time):
 *   - Source rotation = 0 (no fix needed at all).
 *   - Output container has no rotation concept (gif, png, jpg, webp).
 *
 * Two-pass cases (rotation fix required):
 *   - mp4 / mov / m4v / mkv / webm / avi outputs from rotated sources.
 *
 * Wire-up at the call site is one line:
 *     result = await FFmpegProcessor.processWithRotationFix(file, args, outName);
 *
 * extraPreInput is merged with the rotation pre-input args (-noautorotate)
 * if the caller already has -ss/-to or similar input-side flags.
 */
async processWithRotationFix(file,args,outName,inputName,extraPreInput){
    var rot=0;
    try{rot=await this.probeRotation(file)}catch(_){}
    var rotPrefix=this.getRotationFilterPrefix(rot);
    var basePreInput=this.getRotationPreInputArgs();
    var preInput=extraPreInput&&extraPreInput.length?basePreInput.concat(extraPreInput):basePreInput;
    var stage1Args=this._injectRotationPrefix((args||[]).slice(),rotPrefix);
    var outExt=(outName.split('.').pop()||'').toLowerCase();
    // Single-pass formats: gif/png/jpg/webp etc. don't have a rotation
    // matrix concept, so writing direct output is safe + fast.
    var noContainerRotation={gif:1,png:1,jpg:1,jpeg:1,webp:1,bmp:1,tiff:1};
    if(rot===0||noContainerRotation[outExt]){
        // Still pass extraPreInput through (caller's -ss/-to etc.).
        var directPreInput=rot===0?(extraPreInput||[]):preInput;
        return this.process(file,stage1Args.concat(this.getRotationStripPostArgs(stage1Args)),outName,inputName,directPreInput);
    }
    // Two-pass: stage 1 encodes through MKV intermediate (libavformat
    // doesn't propagate the source tkhd matrix to matroska Tags); stage 2
    // remuxes to the user's container with -c copy (no source matrix).
    var stage1Out='__rotfix_stage1.mkv';
    var stage1Result=await this.process(file,stage1Args,stage1Out,inputName,preInput);
    var stage1File=new File([stage1Result.blob],stage1Out,{type:'video/x-matroska'});
    return this.process(stage1File,['-c','copy'],outName);
},
_injectRotationPrefix(args,rotPrefix){
    if(!rotPrefix)return args;
    var newArgs=args.slice();
    var vfIdx=newArgs.indexOf('-vf');
    var fcIdx=newArgs.indexOf('-filter_complex');
    if(vfIdx>=0){
        newArgs[vfIdx+1]=rotPrefix+','+newArgs[vfIdx+1];
    }else if(fcIdx>=0){
        var fc=newArgs[fcIdx+1];
        newArgs[fcIdx+1]='[0:v]'+rotPrefix+'[v_rot];'+fc.replace(/\[0:v\]/g,'[v_rot]');
    }else{
        newArgs=['-vf',rotPrefix].concat(newArgs);
    }
    return newArgs;
},
async applyRotationCorrection(file,args,extraPreInput){
    var rot=0;
    try{rot=await this.probeRotation(file)}catch(_){}
    var rotPrefix=this.getRotationFilterPrefix(rot);
    var preInput=this.getRotationPreInputArgs();
    if(extraPreInput&&extraPreInput.length)preInput=preInput.concat(extraPreInput);
    var newArgs=(args||[]).slice();
    if(rotPrefix){
        var vfIdx=newArgs.indexOf('-vf');
        var fcIdx=newArgs.indexOf('-filter_complex');
        if(vfIdx>=0){
            newArgs[vfIdx+1]=rotPrefix+','+newArgs[vfIdx+1];
        }else if(fcIdx>=0){
            // Inject a named pad in front: [0:v]<rotPrefix>[v_rot]; then rewrite
            // [0:v] references in the original chain to [v_rot]. We replace ONLY
            // direct [0:v] usages, not [0:v:0] / [0:v:1] / [v_rot] / etc.
            var fc=newArgs[fcIdx+1];
            var injected='[0:v]'+rotPrefix+'[v_rot];'+fc.replace(/\[0:v\]/g,'[v_rot]');
            newArgs[fcIdx+1]=injected;
        }else{
            newArgs=['-vf',rotPrefix].concat(newArgs);
        }
    }
    // Always strip rotation metadata in output, even when rotation is 0 — keeps
    // output containers consistent and protects against re-mux pipelines down
    // the line that might otherwise pick up stale matrix data. Pass newArgs
    // so the strip helper can pick a codec-appropriate bitstream filter.
    newArgs=newArgs.concat(this.getRotationStripPostArgs(newArgs));
    return {args:newArgs,preInputArgs:preInput,sourceRotation:rot};
},
}}();

/**
 * WORKERFS streaming suite — mount input File(s) via a lazy filesystem so FFmpeg
 * reads bytes through File.slice() on demand instead of copying the whole blob
 * into WASM heap. Any multi-megabyte-to-multi-gigabyte video/audio operation
 * (extract, enhance, trim, crop, join, probe) runs in memory bounded by codec
 * state, not by input duration.
 *
 * Coverage:
 *   processStreaming           — single input, single exec (the common case)
 *   processSegmentsStreaming   — single input, one exec with multiple -ss/-to
 *   concatSegmentsStreaming    — extract N segments with -c copy, then concat
 *   reencodeAndConcatStreaming — extract N segments with re-encode, then concat
 *   reverseChunked             — chunked -vf reverse / -af areverse, concat reversed
 *   processMultiStreaming      — multiple inputs mounted simultaneously
 *   probeStreaming             — fast media probe without writing to heap
 *
 * All of these throw on FFmpeg exit code != 0 and on mount-setup failure.
 * Callers use `if (sMsg.indexOf('mount')!==-1||sMsg.indexOf('workerfs')!==-1)` to
 * tell "mount didn't work, fall back to in-memory" from real FFmpeg errors that
 * shouldn't silently downgrade.
 */
(function(){
    function _safeExt(file, fallback){
        if (!file || !file.name) return fallback || 'tmp';
        var ext = file.name.split('.').pop();
        if (!ext || ext === file.name) return fallback || 'tmp';
        return ext.toLowerCase();
    }

    function _makeMountPath(){
        return '/_mnt_' + Math.random().toString(36).slice(2, 8);
    }

    /* MIME_TYPES is built from config/formats.php — the AUDIO catalogue. It has
       no mp4/mov/mkv/avi at all, so every VIDEO output fell through to
       application/octet-stream. Not cosmetic: a blob with the wrong type fails
       any `accept="video/*"` check. Measured over 30 d before this fix, the
       "what next" rail hid a chip for reason `format` in 11 313 events / 4 987
       sessions on /add-music-to-video (plus /video-merge) — the cross-tool
       handoff was half-dead on exactly the tools that produce video.

       ⚠️ ORDER MATTERS: the audio map is consulted FIRST and is left untouched.
       `webm` lives in BOTH catalogues (audio/webm for an Opus-in-WebM export,
       video/webm for a VP9 one) and the extension alone cannot tell them apart,
       so giving video precedence would move the same defect onto every audio
       tool. Measured on /add-music-to-video, 30 d: mp4 5071, mov 791, avi 29,
       mkv 21, m4v 20, wmv 1 — and ZERO webm, so nothing is lost by leaving the
       ambiguous one alone. A webm VIDEO still reports audio/webm; that is a
       known, deliberate remainder, not an oversight.

       Video containers have their own registry, config/video-formats.php. It is
       used when the page ships it (window.VideoFormats renders only where
       <x-video-format-select> does — NOT on add-music-to-video or video-merge),
       else the mirror below, which FfmpegVideoMimeMirrorTest keeps in step with
       the config. */
    var _VIDEO_MIME_MIRROR = {
        mp4: 'video/mp4', webm: 'video/webm', mkv: 'video/x-matroska',
        mov: 'video/quicktime', avi: 'video/x-msvideo'
    };
    /* Containers this build can WRITE that the registry does not list (it
       catalogues what tools may OFFER, which is a smaller set). Without these
       they stay application/octet-stream. */
    var _VIDEO_MIME_EXTRA = { m4v: 'video/x-m4v', wmv: 'video/x-ms-wmv', '3gp': 'video/3gpp' };
    function _mimeFor(outputName){
        var outExt = String(outputName || '').split('.').pop().toLowerCase();
        var mimeMap = FFmpegProcessor.MIME_TYPES || {};
        if (mimeMap[outExt]) return mimeMap[outExt];        // audio catalogue wins
        var reg = window.VideoFormats;
        if (reg && typeof reg.get === 'function') {
            try { var r = reg.get(outExt); if (r && r.mime) return r.mime; } catch (_) {}
        }
        return _VIDEO_MIME_MIRROR[outExt] || _VIDEO_MIME_EXTRA[outExt] || 'application/octet-stream';
    }

    function _logTail(){
        return window.__ffErrTail(window._ffLogs);
    }

    function _execError(code, contextMsg){
        return new Error('FFmpeg exit code ' + code + (contextMsg ? ': ' + contextMsg : ''));
    }

    /* ── «Инициализируйся по требованию» — контракт ВСЕХ дверей ──────────────
       Движок выбрасывается НАМЕРЕННО в трёх местах: wasm-трап (`_trapReset`),
       `cancel()` (кнопка «Отмена» и сторож зависания в telemetry-tier0) и
       `release()`. Классические двери это переживают — каждая начинается с
       `if(!r||!e) await FFmpegProcessor.init()`, и комментарий у `_trapReset`
       обещает ровно это: «следующий init() (идемпотентный у всех вызывающих)
       поднимет новый». У стриминговых дверей обещание не выполнялось: они
       отвечали `throw new Error('FFmpeg not initialized')`, classifyError
       переводил «not initialized» в класс `init`, и человек читал «Не удалось
       загрузить обработчик аудио. Проверьте подключение к интернету или
       попробуйте другой браузер (Chrome, Firefox)» — на ВИДЕО-туле, чей движок
       секундой раньше загрузился (wasm_init_attempt outcome:ok) и нарисовал
       превью. Совет был неверен трижды: интернет ни при чём, браузер ни при чём
       (замер 30 д: у Яндекса доля сессий с ошибкой на /video-merge 3.6% против
       3.3% у Chrome, а доводят до результата 31.7% против 27.7%), и обновление
       страницы «чинило» то, что движок мог починить сам.

       Часть дверей спасалась случайно: обёртка `wrapOp` внизу файла делает
       ensure-ready и одну прозрачную переинициализацию — но её список ПИШЕТСЯ
       РУКАМИ и отстал от API. `processMultiStreaming` в нём не было, и в
       телеметрии за 30 дней «FFmpeg not initialized» приходит ровно от двух
       тулов — /video-merge и /add-music-to-video, единственных, кто зовёт эту
       дверь напрямую. Все остальные попадают в тот же лейн через `process()`,
       который переинициализируется сам.

       Поэтому проверка живости живёт здесь, в ОДНОЙ функции, и её зовёт каждая
       дверь. fail-open по форме: если init не поднялся, дверь по-прежнему
       бросает — но теперь это честное «движок не загрузился», а не «его кто-то
       выбросил, и никто не позвал init». Сторож — ffmpeg-doors-self-heal.mjs
       (проверен возвратом дефекта) + FFmpegDoorsSelfHealTest на исходнике. */
    FFmpegProcessor._ensureReady = async function(){
        if (FFmpegProcessor.isReady()) return true;
        try { await FFmpegProcessor.init(); } catch (_) {}
        return FFmpegProcessor.isReady();
    };

    /* Probe File handle aliveness before mounting WORKERFS. If the OS-level
       handle has been revoked (mobile browser tab inactive, file moved on
       OneDrive/iCloud, low-memory pressure), FileReaderSync inside the worker
       will hang on every slice read — the watchdog catches it 120s later as
       STALL_TIMEOUT. A 4-KB pre-read surfaces the failure in milliseconds and
       lets us throw a typed FILE_LOST error the user can act on. */
    async function _verifyHandle(file){
        if (!file || !(file instanceof File) && !(file instanceof Blob)) return;
        try {
            await file.slice(0, 4096).arrayBuffer();
        } catch (err) {
            var msg = (err && err.message) || '';
            try {
                throw new DOMException(
                    'FILE_LOST: The selected file is no longer accessible. Please re-select your file.' +
                    (msg ? ' (' + msg + ')' : ''),
                    'NotFoundError'
                );
            } catch(_){
                var e = new Error('FILE_LOST: The selected file is no longer accessible. Please re-select your file.');
                e.name = 'NotFoundError';
                throw e;
            }
        }
    }

    /**
     * Живой хэндл — или спасённые байты. ЕДИНСТВЕННАЯ точка, через которую
     * WORKERFS-пути проверяют файл.
     *
     * ⚠️ Спасение существовало с 2026-07-02, но было подключено ровно к ОДНОМУ
     * из трёх мест — к многофайловому `mountInputs`. Одиночный `mountInput` и
     * `processStreaming` звали голый `_verifyHandle` и падали с FILE_LOST, хотя
     * байты лежали рядом, в RAM-кэше или в OPFS-спилле.
     *
     * Цена этой асимметрии (замер 30 дней, RU-шард = оба домена): FILE_LOST в
     * 496 сессиях /enhance-video, 143 /extract-audio, 119 /video-frames,
     * 94 /mute-video и хвост ещё по десятку тулов — почти всё мобильные, где ОС
     * отзывает хэндл пикера за минуты. В 94% случаев это ПЕРВАЯ ошибка сессии,
     * то есть не следствие наших ретраев, а прямой отказ на первой же попытке.
     * Средний размер такого файла 11–35 МБ — заведомо внутри лимитов прайма,
     * то есть байты почти всегда были на месте.
     *
     * `hasPersisted` — чистый peek по обоим ярусам: файл, которого нет НИ В
     * ОДНОМ, по-прежнему честно падает с FILE_LOST, а не тянет сотни мегабайт
     * в кучу ради проверки.
     */
    async function _verifyOrRescue(file, idx){
        try { await _verifyHandle(file); return file; }
        catch (vErr) {
            var rescued = null;
            var peek = window.FileBytes && (typeof FileBytes.hasPersisted === 'function'
                ? FileBytes.hasPersisted(file)
                : (typeof FileBytes.hasCached === 'function' && FileBytes.hasCached(file)));
            if (peek && typeof FileBytes.asFile === 'function') {
                try { rescued = await FileBytes.asFile(file); } catch(_){}
            }
            if (!rescued) throw vErr;
            try { window.__ae && window.__ae('feature_use', {
                f: 'workerfs_ram_rescue', idx: (idx == null ? 0 : idx),
                szMB: Math.round((rescued.size || 0) / 1048576)
            }); } catch(_){}
            return rescued;
        }
    }

    function _annotateErr(err, fileSize){
        try {
            var cls = FFmpegProcessor.classifyError(err);
            err.errorType = cls;
            if (cls === 'memory') err.wasmOOM = true;
            err.userMessage = FFmpegProcessor.getErrorMessage(err, fileSize || 0);
        } catch(_){}
    }

    /**
     * _withMounts — mount one or more Files under WORKERFS, hand the caller the
     * in-FS paths, and unmount on the way out. `files` accepts either a File/Blob
     * or an array of them. Callback receives an array of absolute paths, one per
     * file, in the same order.
     */
    async function _withMounts(files, callback){
        if (!(await FFmpegProcessor._ensureReady())) throw new Error('FFmpeg not initialized');
        var ffmpeg = FFmpegProcessor._getFFmpeg();
        if (!ffmpeg) throw new Error('FFmpeg instance not available');

        /* .slice(): the RAM-rescue below may swap entries for cache-backed
           Files — never mutate the caller's array. */
        var arr = Array.isArray(files) ? files.slice() : [files];
        for (var i = 0; i < arr.length; i++) {
            if (!(arr[i] instanceof File) && !(arr[i] instanceof Blob)) {
                throw new Error('Streaming input must be File or Blob (index ' + i + ')');
            }
        }
        /* Verify each handle is alive — and when it is NOT, rescue from the
           FileBytes RAM cache instead of failing. Parity fix (Бу #898,
           sid 689fbcbf 2026-07-02): the classic in-memory path already
           falls back to cached bytes when a handle dies mid-session
           (FileBytes.read "tries the cache one last time"), but the
           streaming WORKERFS path probed the LIVE handle and threw
           FILE_LOST even though the exact bytes sat in cache (video is
           primed at pick, music tracks at decode). On Android/mobile
           the OS revokes picker handles within minutes, so users who
           spent time arranging tracks lost the export. Cohort 407
           events / 328 sids / 14 d — 66% under the 100 MB RAM prime cap
           (rescued from the RAM tier), 26% above it (rescued from the
           OPFS spill tier the uploader now fills at pick). hasPersisted
           is a pure peek across both tiers — a file in NEITHER tier
           still fails fast with the honest FILE_LOST rather than
           pulling hundreds of MB into the heap. */
        for (var vi = 0; vi < arr.length; vi++) {
            arr[vi] = await _verifyOrRescue(arr[vi], vi);
            arr[vi] = await window.__ffmpegHealInput(arr[vi]);   // esds that is not an ASC → see _healInput (top-level scope)
        }

        var MOUNT = _makeMountPath();
        var mounted = false;
        var paths = [];
        var blobs = arr.map(function(f, idx){
            var ext = _safeExt(f);
            var name = 'input' + (arr.length > 1 ? idx : '') + '.' + ext;
            paths.push(MOUNT + '/' + name);
            return { name: name, data: f };
        });

        try {
            try { await ffmpeg.createDir(MOUNT); } catch(_){}
            await ffmpeg.mount('WORKERFS', { blobs: blobs }, MOUNT);
            mounted = true;
            return await callback(paths, MOUNT);
        } finally {
            if (mounted) { try { await ffmpeg.unmount(MOUNT); } catch(_){} }
            try { await ffmpeg.deleteDir(MOUNT); } catch(_){}
        }
    }

    /**
     * mountInput — public WORKERFS façade. Returns `{path, dispose}` so
     * tools with their own multi-step exec flow (denoise's chunked AI loop,
     * for instance) can stream from a multi-hundred-MB File without ever
     * copying it into the WASM heap. Use the returned `path` as `-i` arg to
     * any number of `_fs.exec()` calls; call `dispose()` once when done.
     *
     * Why this exists: denoise was calling `_fs.write(name, file)` for the
     * source, which `m(file)` materialises as a Uint8Array — a 413 MB MP4
     * blew the JS heap with `RangeError: Array buffer allocation failed`
     * before any segment got to AI. Mount is constant-RAM regardless of
     * input size; segments are read on demand via FileReaderSync.slice.
     */
    FFmpegProcessor.mountInput = async function(file, opts){
        if (!(await FFmpegProcessor._ensureReady())) throw new Error('FFmpeg not initialized');
        if (!(file instanceof File) && !(file instanceof Blob)) {
            throw new Error('mountInput requires File or Blob');
        }
        // Спасение из кэша, а не голая проверка живости — см. _verifyOrRescue.
        file = await _verifyOrRescue(file);
        file = await window.__ffmpegHealInput(file);
        var ffmpeg = this._getFFmpeg();
        var name = (opts && opts.name) || ('input.' + _safeExt(file));
        var MOUNT = _makeMountPath();
        var mounted = false;
        try {
            try { await ffmpeg.createDir(MOUNT); } catch(_){}
            await ffmpeg.mount('WORKERFS', { blobs: [{ name: name, data: file }] }, MOUNT);
            mounted = true;
            return {
                path: MOUNT + '/' + name,
                dispose: async function(){
                    if (!mounted) return;
                    mounted = false;
                    try { await ffmpeg.unmount(MOUNT); } catch(_){}
                    try { await ffmpeg.deleteDir(MOUNT); } catch(_){}
                }
            };
        } catch (err) {
            if (mounted) { try { await ffmpeg.unmount(MOUNT); } catch(_){} }
            try { await ffmpeg.deleteDir(MOUNT); } catch(_){}
            throw err;
        }
    };

    /* ── Output contract for the STREAMING path ──────────────────────────
       `process()` auto-appends `-movflags +faststart` to every mp4-family
       output that didn't ask for its own `-movflags`, so the moov atom lands
       at the file HEAD. That injection lived ONLY in process() — and
       ffmpeg-auto-guard routes every input ≥50 MB (video ops) here instead,
       i.e. exactly the files the injection was written for.

       Consequence, MEASURED 2026-08-06 on /video-flip's FFmpeg lane with a
       137 MB source: `ftyp | free | mdat(139 MB) | moov@end`. Our own Tier-0
       "moov missing" probe reads a 512 KB TAIL window, and a big file's moov
       exceeds it — so our own tools reject a file we just produced. That is
       the olgs-ra@mail.ru class from 2026-06-17 (a 58 MB repair-tool output
       rejected by our own trim tool); +faststart was the fix, and the whole
       ≥50 MB cohort has been bypassing it ever since streaming was added.

       Same guards as process(): mp4-family only, never override a caller's
       own -movflags (in args OR pre-input). */
    function _streamOutputContract(args, outputName, preInputArgs){
        var a = (args || []).slice();
        var ext = String(outputName || '').split('.').pop().toLowerCase();
        if (!/^(mp4|m4a|m4b|m4r|m4p|mov|3gp|3gpp)$/.test(ext)) return a;
        if (a.indexOf('-movflags') !== -1) return a;
        if (preInputArgs && preInputArgs.indexOf('-movflags') !== -1) return a;
        return a.concat(['-movflags', '+faststart']);
    }

    FFmpegProcessor.processStreaming = async function(file, args, outputName, inputName, preInputArgs){
        /* Компенсация задержки фильтров с lookahead. Дверь строит argv сама,
           поэтому правка иначе до неё не доходит; идемпотентна (метка в цепочке),
           fail-open. */
        try { args = window.FFmpegDelayCompensation.apply(args); } catch (_) {}
        /* Качество ресемплера — общее умолчание, а не свойство двери. */
        try { args = window.FFmpegResampleQuality.apply(args); } catch (_) {}
        if (!(await FFmpegProcessor._ensureReady())) throw new Error('FFmpeg not initialized');
        if (!(file instanceof File) && !(file instanceof Blob)) throw new Error('processStreaming requires File or Blob');
        // ⚠️ Именно этот путь и терял файлы: `process()` для File-входов сам
        // уходит в стриминг, поэтому сюда приходит подавляющее большинство
        // тяжёлых видео-прогонов — и до этой правки они падали с FILE_LOST,
        // хотя байты лежали в кэше (496 сессий /enhance-video за 30 дней).
        file = await _verifyOrRescue(file);
        var ffmpeg = this._getFFmpeg();
        // When the caller supplies an explicit inputName, respect it (format hints via extension).
        var useInputName = inputName || ('input.' + _safeExt(file));
        var MOUNT = _makeMountPath();
        var mounted = false;
        try {
            try { await ffmpeg.createDir(MOUNT); } catch(_){}
            await ffmpeg.mount('WORKERFS', { blobs: [{ name: useInputName, data: file }] }, MOUNT);
            mounted = true;
            var u = [];
            if (preInputArgs && preInputArgs.length) u = u.concat(preInputArgs);
            u.push('-i', MOUNT + '/' + useInputName);
            u = u.concat(_streamOutputContract(args, outputName, preInputArgs)).concat(['-y', outputName]);
            console.log('[ffmpeg] processStreaming:', u.join(' '), '| input size:', file.size);
            window._ffLogs = [];
            var code = await ffmpeg.exec(u);
            if (code !== 0) throw _execError(code, _logTail());
            /* From here to the Blob nothing emits a progress tick — the
               faststart rewrite, the readFile and the copy are all silent, and
               they scale with OUTPUT size and device (measured 8.6 s for a
               57 MB output on a warm desktop; a phone with a 1 GB output is a
               different number entirely). Left unmarked, the engine-level stall
               guard would have to treat that whole span as possible death and
               carry a floor sized for the worst machine we never measured.
               Marking the boundaries says the true thing instead: work
               happened, the clock restarts, and the floor only has to cover one
               phase rather than all of them. */
            window.__ffLiveTick();
            var data = await ffmpeg.readFile(outputName);
            window.__ffLiveTick();
            /* Free the MEMFS copy BEFORE constructing the Blob: otherwise the
               output exists 3× at once (MEMFS + readFile buffer + Blob) and the
               peak is what kills 2 GB phones — measured 4× output with the
               faststart pass on /video-loop (28 MB input ×3 → ~330 MB peak,
               12-minute crawl then empty-message OOM, report 2026-08-12).
               The finally-delete below stays as a no-op safety net. */
            try { await ffmpeg.deleteFile(outputName); } catch(_){}
            var blob = new Blob([data], { type: _mimeFor(outputName) });
            data = null;
            return { blob: blob, name: outputName, url: URL.createObjectURL(blob), size: blob.size };
        } catch(err){
            _annotateErr(err, file.size);
            throw err;
        } finally {
            if (mounted) { try { await ffmpeg.unmount(MOUNT); } catch(_){} }
            try { await ffmpeg.deleteDir(MOUNT); } catch(_){}
            try { await ffmpeg.deleteFile(outputName); } catch(_){}
        }
    };

    /**
     * analyzeLoudnessStreaming — pass 1 of two-pass linear loudnorm for inputs
     * that must NOT be copied into MEMFS: video containers and anything big.
     *
     * analyzeLoudness() writes the whole file into wasm memory and, on a video,
     * decodes every frame just to measure the audio. Here the input is
     * WORKERFS-mounted (same as processStreaming) and `-vn` drops the video
     * stream. `opts.preInputArgs` (e.g. -ss/-to) go before -i so a trimmed
     * export measures the trimmed range. Same return shape as analyzeLoudness:
     * { input_i, input_tp, input_lra, input_thresh, target_offset }.
     *
     * Why two passes at all: one-pass loudnorm is ALWAYS dynamic (`linear=true`
     * without measured_* is ignored) — it re-lifts quiet passages between
     * phrases and, with no explicit output rate, leaves the graph at 192 kHz
     * (AAC clamps to 96 kHz — the support file of 2026-09-12 came back as
     * 96 000 Hz AAC from a 44.1 kHz source). The caller still has to pass -ar.
     */
    FFmpegProcessor.analyzeLoudnessStreaming = async function(file, afChain, ln, opts){
        opts = opts || {};
        try {
            return await _withMounts(file, async function(paths){
                var ffmpeg = FFmpegProcessor._getFFmpeg();
                var chain = (afChain ? afChain + ',' : '') + 'loudnorm=' + (ln || 'I=-16:TP=-1.5:LRA=11') + ':print_format=json';
                var u = [];
                if (opts.preInputArgs && opts.preInputArgs.length) u = u.concat(opts.preInputArgs);
                u.push('-i', paths[0], '-vn', '-af', chain, '-f', 'null', '-');
                /* Own capture: window._ffLogs is a 20-line ring and the JSON
                   block loudnorm prints is ~14 lines after its banner. */
                var lines = [];
                var cap = function(ev){ lines.push(ev.message); if (lines.length > 160) lines.splice(0, lines.length - 160); };
                ffmpeg.on('log', cap);
                window._ffLogs = [];
                var code;
                try { code = await ffmpeg.exec(u); }
                finally { try { ffmpeg.off('log', cap); } catch(_){} }
                if (code !== 0) throw _execError(code, _logTail());
                var txt = lines.join('\n'), mk = txt.lastIndexOf('Parsed_loudnorm'), js = txt.indexOf('{', mk), je = txt.indexOf('}', js);
                if (mk === -1 || js === -1 || je === -1) throw new Error('loudnorm stats not found in ffmpeg log');
                var st = JSON.parse(txt.substring(js, je + 1));
                return {
                    input_i: parseFloat(st.input_i), input_tp: parseFloat(st.input_tp),
                    input_lra: parseFloat(st.input_lra), input_thresh: parseFloat(st.input_thresh),
                    target_offset: parseFloat(st.target_offset)
                };
            });
        } catch(err){ _annotateErr(err, file && file.size); throw err; }
    };

    /**
     * analyzeLoudnessSeries — ONE pass over the whole input through `afChain`
     * that returns the loudness of what the chain produces as a time series:
     * momentary (400 ms) and short-term (3 s) loudness every 100 ms, plus the
     * integrated loudness, its gate threshold, LRA and (opts.peak) true peak.
     *
     * It exists so that a tool can decide its loudness stage ONCE and give the
     * same answer to its preview and to its export (LoudnessStage in
     * loudness-stage.js). The loudnorm measure pass answers five numbers and
     * costs a dynamic-mode loudnorm at 192 kHz over the whole file; measured
     * 2026-09-27 in this build on a 200 s song: 45.2 s against 6.0 s for this
     * pass (ebur128 behind the same chain), 35.1 s against 8.0 s on a 147 s one.
     *
     * The input is WORKERFS-mounted (no MEMFS copy); `-vn` drops a video
     * stream; `opts.preInputArgs` (-ss/-t) go before -i, so a caller can measure
     * a window.
     *
     * The series leaves FFmpeg as a FILE, not as log lines: ebur128 hands on
     * 100-ms frames carrying their values (metadata=1) and ametadata prints
     * them into MEMFS; the log carries the summary only. Until the evening of
     * 2026-09-27 it was framelog=info — a log line every 100 ms, each posted
     * from the worker and walked through every log listener on the main
     * thread, and that backlog, not the filters, was the price on phones: an
     * Android phone measured a 5-min song for 23–30 s while its whole export
     * of the same file took 17 s. Same 5-min file on this machine with the main
     * thread throttled ×4: 19.2 s by log lines, 9.0 s by file, the same 3000
     * values (the log line rounds them to 0.1).
     */
    FFmpegProcessor.analyzeLoudnessSeries = async function(file, afChain, opts){
        opts = opts || {};
        try {
            return await _withMounts(file, async function(paths){
                var ffmpeg = FFmpegProcessor._getFFmpeg();
                var dump = '_r128_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7) + '.txt';
                var meter = 'ebur128=metadata=1' + (opts.peak ? ':peak=true' : '') + ',ametadata=mode=print:file=' + dump;
                var u = [];
                if (opts.preInputArgs && opts.preInputArgs.length) u = u.concat(opts.preInputArgs);
                u.push('-i', paths[0], '-vn', '-af', (afChain ? afChain + ',' : '') + meter, '-f', 'null', '-');
                var tail = [];
                var cap = function(ev){
                    var s = ev && ev.message;
                    if (!s) return;
                    tail.push(s); if (tail.length > 60) tail.splice(0, tail.length - 60);
                };
                ffmpeg.on('log', cap);
                window._ffLogs = [];
                var code, raw = null;
                try {
                    code = await ffmpeg.exec(u);
                    if (code === 0) raw = await ffmpeg.readFile(dump);
                } finally {
                    try { ffmpeg.off('log', cap); } catch(_){}
                    try { await ffmpeg.deleteFile(dump); } catch(_){}
                }
                if (code !== 0) throw _execError(code, _logTail());
                /* One record per 100-ms frame: its header, then M and S first.
                   A frame's values are those at its END — the time framelog
                   printed as `t:`. */
                var text = typeof raw === 'string' ? raw : new TextDecoder().decode(raw || new Uint8Array(0));
                var t = [], M = [], S = [];
                var rec = /pts_time:([\d.]+)[ \t]*\r?\nlavfi\.r128\.M=([^\r\n]*)\r?\nlavfi\.r128\.S=([^\r\n]*)/g, r;
                while ((r = rec.exec(text))) {
                    var mm = parseFloat(r[2]), ss = parseFloat(r[3]);
                    t.push(parseFloat(r[1]));
                    M.push(isFinite(mm) ? mm : -120);
                    S.push(isFinite(ss) ? ss : -120);
                }
                var step = t.length > 1 ? Math.round((t[1] - t[0]) * 1000) / 1000 : 0.1;
                for (var k = 0; k < t.length; k++) t[k] += step;
                var txt = tail.join('\n');
                var sum = txt.lastIndexOf('Summary:');
                if (sum === -1 || !t.length) throw new Error('ebur128 series not found (' + t.length + ' frames, summary ' + (sum !== -1) + ')');
                txt = txt.slice(sum);
                var num = function(re){ var m = re.exec(txt); return m ? parseFloat(m[1]) : NaN; };
                return {
                    dt: step,
                    t: Float32Array.from(t), M: Float32Array.from(M), S: Float32Array.from(S),
                    I: num(/Integrated loudness:\s*\n\s*I:\s*(-?[\d.]+|-?inf)/),
                    thresh: num(/Integrated loudness:\s*\n\s*I:[^\n]*\n\s*Threshold:\s*(-?[\d.]+)/),
                    LRA: num(/Loudness range:\s*\n\s*LRA:\s*(-?[\d.]+)/),
                    TP: opts.peak ? num(/True peak:\s*\n\s*Peak:\s*(-?[\d.]+|-?inf)/) : NaN
                };
            });
        } catch(err){ _annotateErr(err, file && file.size); throw err; }
    };

    /**
     * processSegmentsStreaming — one ffmpeg exec with multiple -ss/-to/-i pairs
     * reading from the mounted input. Matches processSegments() semantics.
     */
    FFmpegProcessor.processSegmentsStreaming = async function(file, segments, args, outputName){
        /* Компенсация задержки фильтров с lookahead. Дверь строит argv сама,
           поэтому правка иначе до неё не доходит; идемпотентна (метка в цепочке),
           fail-open. */
        try { args = window.FFmpegDelayCompensation.apply(args); } catch (_) {}
        /* Качество ресемплера — общее умолчание, а не свойство двери. */
        try { args = window.FFmpegResampleQuality.apply(args); } catch (_) {}
        try {
            return await _withMounts(file, async function(paths){
                var ffmpeg = FFmpegProcessor._getFFmpeg();
                var u = [];
                for (var i = 0; i < segments.length; i++) {
                    u.push('-ss', segments[i].start.toFixed(6), '-to', segments[i].end.toFixed(6), '-i', paths[0]);
                }
                u = u.concat(args).concat(['-y', outputName]);
                console.log('[ffmpeg] processSegmentsStreaming:', segments.length, 'segments |', u.join(' '));
                window._ffLogs = [];
                var code = await ffmpeg.exec(u);
                if (code !== 0) throw _execError(code, _logTail());
                var data = await ffmpeg.readFile(outputName);
                try { await ffmpeg.deleteFile(outputName); } catch(_){}
                var blob = new Blob([data], { type: _mimeFor(outputName) });
                return { blob: blob, name: outputName, url: URL.createObjectURL(blob), size: blob.size };
            });
        } catch(err){ _annotateErr(err, file && file.size); throw err; }
    };

    /**
     * concatSegmentsStreaming — extract each segment with -c copy reading from
     * mounted input, then concat the small temp segments into the final output.
     * Memory footprint stays bounded: the big source is never in heap; each temp
     * segment is the size of its own slice, deleted immediately after concat.
     */
    FFmpegProcessor.concatSegmentsStreaming = async function(file, segments, outputName, opts){
        opts = opts || {};
        try {
            return await _withMounts(file, async function(paths){
                var ffmpeg = FFmpegProcessor._getFFmpeg();
                var ext = _safeExt(file);
                var temps = [];
                try {
                    for (var i = 0; i < segments.length; i++) {
                        var seg = 'seg_' + i + '.' + ext;
                        temps.push(seg);
                        var a = ['-ss', segments[i].start.toFixed(6), '-to', segments[i].end.toFixed(6),
                                 '-i', paths[0], '-c', 'copy'];
                        if (opts.muteAudio) a.push('-an');
                        a.push('-y', seg);
                        console.log('[ffmpeg] concatSegmentsStreaming seg', i, ':', segments[i].start.toFixed(2), '-', segments[i].end.toFixed(2));
                        window._ffLogs = [];
                        var x = await ffmpeg.exec(a);
                        if (x !== 0) throw _execError(x, 'segment ' + i + ': ' + _logTail());
                    }
                    var list = '';
                    for (var j = 0; j < temps.length; j++) list += "file '" + temps[j] + "'\n";
                    await ffmpeg.writeFile('list.txt', new TextEncoder().encode(list));
                    var _outExt = (outputName.split('.').pop() || '').toLowerCase();
                    var _mp4Family = _outExt === 'mp4' || _outExt === 'mov' || _outExt === 'm4v';
                    var ca = ['-f', 'concat', '-safe', '0', '-i', 'list.txt', '-c', 'copy'];
                    if (_mp4Family) ca.push('-avoid_negative_ts', 'make_zero', '-movflags', '+faststart');
                    ca.push('-y', outputName);
                    window._ffLogs = [];
                    var x2 = await ffmpeg.exec(ca);
                    if (x2 !== 0) throw _execError(x2, 'concat: ' + _logTail());
                    var data = await ffmpeg.readFile(outputName);
                    var blob = new Blob([data], { type: _mimeFor(outputName) });
                    return { blob: blob, name: outputName, url: URL.createObjectURL(blob), size: blob.size };
                } finally {
                    for (var k = 0; k < temps.length; k++) { try { await ffmpeg.deleteFile(temps[k]); } catch(_){} }
                    try { await ffmpeg.deleteFile('list.txt'); } catch(_){}
                    try { await ffmpeg.deleteFile(outputName); } catch(_){}
                }
            });
        } catch(err){ _annotateErr(err, file && file.size); throw err; }
    };

    /**
     * reencodeAndConcatStreaming — like concatSegmentsStreaming but each segment
     * is re-encoded (args apply per-segment), then copy-concatenated. Used when
     * callers need filters on each segment (e.g. enhance-video OOM retry chain).
     */
    FFmpegProcessor.reencodeAndConcatStreaming = async function(file, segments, args, outputName, opts){
        /* Компенсация задержки фильтров с lookahead. Дверь строит argv сама,
           поэтому правка иначе до неё не доходит; идемпотентна (метка в цепочке),
           fail-open. */
        try { args = window.FFmpegDelayCompensation.apply(args); } catch (_) {}
        /* Качество ресемплера — общее умолчание, а не свойство двери. */
        try { args = window.FFmpegResampleQuality.apply(args); } catch (_) {}
        opts = opts || {};
        try {
            return await _withMounts(file, async function(paths){
                var ffmpeg = FFmpegProcessor._getFFmpeg();
                var segExt = outputName.split('.').pop();
                var temps = [];
                try {
                    for (var j = 0; j < segments.length; j++) {
                        var seg = 'seg_' + j + '.' + segExt;
                        temps.push(seg);
                        var a = ['-ss', segments[j].start.toFixed(6), '-to', segments[j].end.toFixed(6), '-i', paths[0]];
                        if (j === 0 && opts.firstArgs) a = a.concat(opts.firstArgs);
                        if (j === segments.length - 1 && opts.lastArgs) a = a.concat(opts.lastArgs);
                        a = a.concat(args);
                        if (opts.muteAudio) a.push('-an');
                        a.push('-y', seg);
                        console.log('[ffmpeg] reencodeAndConcatStreaming seg', j, ':', segments[j].start.toFixed(2), '-', segments[j].end.toFixed(2));
                        window._ffLogs = [];
                        var x = await ffmpeg.exec(a);
                        if (x !== 0) throw _execError(x, 'segment ' + j + ': ' + _logTail());
                    }
                    var list = '';
                    for (var k = 0; k < temps.length; k++) list += "file '" + temps[k] + "'\n";
                    await ffmpeg.writeFile('list.txt', new TextEncoder().encode(list));
                    var _outExt = (outputName.split('.').pop() || '').toLowerCase();
                    var _mp4Family = _outExt === 'mp4' || _outExt === 'mov' || _outExt === 'm4v';
                    var ca = ['-f', 'concat', '-safe', '0', '-i', 'list.txt', '-c', 'copy'];
                    if (_mp4Family) ca.push('-avoid_negative_ts', 'make_zero', '-movflags', '+faststart');
                    ca.push('-y', outputName);
                    window._ffLogs = [];
                    var x2 = await ffmpeg.exec(ca);
                    if (x2 !== 0) throw _execError(x2, 'concat: ' + _logTail());
                    var data = await ffmpeg.readFile(outputName);
                    var blob = new Blob([data], { type: _mimeFor(outputName) });
                    return { blob: blob, name: outputName, url: URL.createObjectURL(blob), size: blob.size };
                } finally {
                    for (var t = 0; t < temps.length; t++) { try { await ffmpeg.deleteFile(temps[t]); } catch(_){} }
                    try { await ffmpeg.deleteFile('list.txt'); } catch(_){}
                    try { await ffmpeg.deleteFile(outputName); } catch(_){}
                }
            });
        } catch(err){ _annotateErr(err, file && file.size); throw err; }
    };

    /**
     * encodeWindowsStreaming — a WHOLE-FILE video re-encode in time windows that
     * join EXACTLY, its sound encoded ONCE, the result assembled on disk.
     *
     * Why (2026-10-02, bug report on /es/enhance-video: a 2 h 12 min DivX film
     * came back as 86 s «with glitches»). The lane this replaces for long files —
     * reencodeAndConcatStreaming, `-ss S -to E -i` per minute — is wrong in three
     * independent ways, each measured on the site's own FFmpeg-WASM over six
     * containers (DivX AVI, DVD VOB, MPEG-TS, WMV, FLV, DV):
     *   1. `-ss 0` on an AVI with packed B-frames (every DivX/XviD rip) and on FLV
     *      starts decoding on a non-key packet: the first GOP comes out as grey
     *      blocks (298 of the first 494 frames wrong) and frames go missing.
     *   2. `-to E` then `-ss E` doubles the frame at the join on AVI and WMV. On the
     *      tool's real output: 4 extra frames in the first minute, 4 more after the
     *      join — the picture 160 ms, then 320 ms behind the sound, growing with
     *      every minute of a film.
     *   3. each window carried its own AAC stream: +34 ms and a click at the join.
     * It also kept every window AND the joined copy in the wasm heap, so the
     * ceiling on the result was memory, not disk.
     *
     * Here the windows are cut IN THE FILTER GRAPH on the file's own clock
     * (`-copyts` + absolute `trim`), the edges half a frame BETWEEN frames, so each
     * frame lands in exactly one window whatever the demuxer's seek does: 0 lost,
     * 0 doubled on all six containers (tests/playwright/encode-windows-are-exact.mjs).
     * A window decodes from `preRollSec` earlier — an MPEG-PS/TS seek lands NEAR a
     * time, not on a keyframe — and its filters run on `warmSec` of frames that
     * are then cut, so a temporal denoiser does not restart cold at every join.
     * A finished window leaves the heap as a Blob at once; the sound is one pass
     * over the whole file, its zero placed on the first picture; the file is put
     * together by Mp4CopyTrim.concat (byte ranges, moov first) — none of the
     * result passes through the wasm heap. Windows run until one comes back
     * EMPTY past the probe's end — a length that came up short cannot cut the
     * film, one that came up long costs one empty window.
     *
     * opts: vf · videoArgs (the picture's encoder argv, no audio flags) ·
     *       audioArgs (the sound's encoder argv, may carry -af; null = no sound) ·
     *       audioMap (none = FFmpeg's own pick, as a single run would) · durationS (plans the windows) ·
     *       fps (only when the file states no rate — the rate is the FILE's, see _ewClock) ·
     *       windowSec (60) · preRollSec (3) · warmSec (0.2) · name ·
     *       onWindowDone(done, planned) · onPartial(file, secsDone, secsTotal) +
     *       partialMinIntervalMs (120000) · signal / isCancelled
     * Returns { blob, name, url, size, windows, durationS, fps, rate, vfr } — `blob` is a File;
     * the picture is constant-rate at `rate` (a variable-rate source at its average).
     * The caller keeps FFmpegProcessor.onProgress: it receives ONE 0..1 for the
     * whole run, never a per-window bar that resets.
     */
    var _ewLoading = {};
    function _ewLoadGlobal(name, path) {
        if (window[name] && !window[name].__isStub) return Promise.resolve(window[name]);
        if (!_ewLoading[name]) {
            _ewLoading[name] = new Promise(function (res) {
                var el = document.createElement('script');
                var n = document.querySelector('script[nonce]');
                if (n && n.nonce) el.setAttribute('nonce', n.nonce);
                el.src = typeof window.__jsSrc === 'function' ? window.__jsSrc(path) : path;
                el.async = true;
                el.onload = function () { res(window[name] || null); };
                el.onerror = function () { _ewLoading[name] = null; res(null); };
                document.head.appendChild(el);
            });
        }
        return _ewLoading[name];
    }
    /* The sound's own filter (-af / -filter:a) out of an encoder argv, so the
       alignment filters can run in front of it in ONE chain. */
    function _ewSplitAudio(args) {
        var rest = [], af = '';
        for (var i = 0; i < (args || []).length; i++) {
            var k = args[i];
            if ((k === '-af' || k === '-filter:a') && i + 1 < args.length) { af = af ? af + ',' + args[i + 1] : String(args[i + 1]); i++; continue; }
            rest.push(k);
        }
        return { args: rest, af: af };
    }
    /* FFmpeg prints a frame rate with two decimals: «23.98 fps» is 24000/1001,
       and a lane that dates frames as n / 23.98 drifts 0.017 % — 1.2 s over a
       two-hour film. The NTSC family snaps to its exact fraction. */
    function _ewExactFps(fps) {
        fps = +fps;
        if (!(fps > 0 && fps < 1000)) return 0;
        var ntsc = [24000 / 1001, 30000 / 1001, 48000 / 1001, 60000 / 1001, 120000 / 1001];
        for (var i = 0; i < ntsc.length; i++) if (Math.abs(fps - ntsc[i]) < 0.006) return ntsc[i];
        return fps;
    }
    FFmpegProcessor.exactFps = _ewExactFps;
    /* A rate as FFmpeg's `fps` filter should read it: the NTSC family as its exact fraction. */
    function _ewRateText(fps) {
        var ntsc = [24000, 30000, 48000, 60000, 120000];
        for (var i = 0; i < ntsc.length; i++) if (Math.abs(fps - ntsc[i] / 1001) < 1e-9) return ntsc[i] + '/1001';
        return fps === Math.round(fps) ? String(fps) : String(+fps.toFixed(6));
    }
    /* The file's own clock (-copyts): where its first PICTURE is, where the
       container starts, whether it has sound — and the rate the windows EMIT,
       decided from the file, not from the caller. One frame decoded.

       The rate (2026-10-02): a raw/CFR output runs at FFmpeg's GUESS of the rate
       (r_frame_rate), and a lane that dates frames n / fps must date them at the
       rate they really come at. On a variable-rate file the two part: a clip at
       15 fps for 30 s, then 30 fps, is printed «22.48 fps, 15 tbr» — the guess is
       its SLOWEST stretch — and the hybrid lane, dating 907 frames at 1/22.48,
       made 40.3 s of fast motion out of 60 s and cut the sound to match; a phone
       clip (29.70 fps, 30 tbr) came out 0.6 s long. So every window starts with
       `fps=<rate>` on the file's ABSOLUTE grid (slot n = n / rate): a constant-
       rate file at its own exact rate (the graph's rational — a no-op, every frame
       passes), a variable-rate one at its average. */
    async function _ewClock(ffmpeg, path, fpsHint) {
        var out = { t0: 0, st: 0, hasAudio: false, fps: 0, rate: '', vfr: false, g0: 0, z: 0 };
        var capPrev = window.__ffLogsCapOverride;
        try {
            window.__ffLogsCapOverride = 400; window._ffLogs = [];
            try { await ffmpeg.exec(['-copyts', '-i', path, '-map', '0:v:0', '-frames:v', '1', '-vf', 'showinfo', '-f', 'null', '-']); } catch (_) {}
            var lines = (window._ffLogs || []).slice(), joined = lines.join('\n');
            var mt = /pts_time:\s*(-?[\d.]+)/.exec(joined);
            if (!mt) throw new Error('windows: no picture in the file');
            out.t0 = parseFloat(mt[1]) || 0;
            var ms = /Duration:[^\n]*?start:\s*(-?[\d.]+)/.exec(joined);
            out.st = ms ? (parseFloat(ms[1]) || 0) : 0;
            out.hasAudio = lines.some(function (l) { return /Stream #\d+:\d+.*: Audio:/.test(String(l)); });
            /* What the filter graph is given (showinfo «config in … frame_rate: N/D») — exact;
               and the stream's average, «N fps», two decimals. They agree on a constant rate. */
            var mg = /config in time_base:\s*\d+\/\d+,\s*frame_rate:\s*(\d+)\/(\d+)/.exec(joined);
            var graph = (mg && +mg[1] > 0 && +mg[2] > 0) ? +mg[1] / +mg[2] : 0;
            var ma = /Video:[^\n]*?([\d.]+)\s*fps/.exec(joined);
            var avg = ma ? parseFloat(ma[1]) : 0;
            if (graph > 0 && graph < 1000 && (!(avg > 0) || Math.abs(graph / avg - 1) < 0.001)) {
                out.fps = graph; out.rate = +mg[1] + '/' + +mg[2];
            } else if (avg > 0 && avg < 1000) {
                out.fps = _ewExactFps(avg); out.vfr = graph > 0;
            } else if (+fpsHint > 0 && +fpsHint < 1000) {
                out.fps = _ewExactFps(+fpsHint);
            }
        } finally { window.__ffLogsCapOverride = capPrev; }
        if (!(out.fps > 0)) out.fps = 25;
        if (!out.rate) out.rate = _ewRateText(out.fps);
        /* The first picture's slot on that grid (the filter rounds to the nearest);
           the picture's zero — the sound's zero goes there too. */
        out.g0 = Math.round(out.t0 * out.fps);
        out.z = out.g0 / out.fps;
        return out;
    }
    /* Window k on that grid: slots [g0 + k·n, g0 + (k+1)·n), the edges half a slot
       BETWEEN frames, so a frame belongs to exactly one window whatever the seek
       lands on. The seek starts `pre` seconds early (MPEG-PS/TS land NEAR a time,
       not on a keyframe); the caller's filters see `warm` seconds of frames that
       the second trim then drops (a temporal denoiser does not restart cold). */
    function _ewWindow(k, W, clk, pre, warm, vf) {
        var n = Math.max(1, Math.round(W * clk.fps));
        var A = k === 0 ? null : (clk.g0 + k * n - 0.5) / clk.fps;
        var B = (clk.g0 + (k + 1) * n - 0.5) / clk.fps;
        var seek = [];
        if (A !== null) { var P = A - warm - clk.st - pre; if (P > 0) seek = ['-ss', P.toFixed(6)]; }
        var chain = ['fps=fps=' + clk.rate + ':round=near',
            'trim=' + (A !== null ? 'start=' + (A - warm).toFixed(6) + ':' : '') + 'end=' + B.toFixed(6)];
        if (vf) chain.push(vf);
        if (A !== null && warm > 0) chain.push('trim=start=' + A.toFixed(6));
        chain.push('setpts=PTS-STARTPTS');
        return { A: A, B: B, seek: seek, chain: chain.join(',') };
    }
    /* The file's length as FFmpeg reads it from the mounted whole file — asked again
       when the walk outlives its plan: the caller's number came from a probe that had
       not finished (or a guess), and a progress bar that sits at 97 % for an hour is a
       lie of its own. 0 when the container does not say. */
    async function _ewLength(ffmpeg, path) {
        var capPrev = window.__ffLogsCapOverride;
        try {
            window.__ffLogsCapOverride = 400; window._ffLogs = [];
            try { await ffmpeg.exec(['-i', path, '-t', '0', '-f', 'null', '-']); } catch (_) {}
            var m = /Duration:\s*(\d+):(\d+):(\d+(?:\.\d+)?)/.exec((window._ffLogs || []).join('\n'));
            return m ? (+m[1]) * 3600 + (+m[2]) * 60 + parseFloat(m[3]) : 0;
        } finally { window.__ffLogsCapOverride = capPrev; }
    }
    /* Past the end, or a hole in the middle? An empty window stops the walk only
       where the probe says the file is over (or after a run of empties — a broken
       file must not loop); before that it is a gap and the walk goes on. */
    function _ewPastEnd(win, clk, durationS, emptyRun) {
        if (emptyRun >= 10) return true;
        if (!(durationS > 0)) return true;
        return win.A !== null && win.A >= clk.t0 + durationS - 1;
    }
    /* The sound, ONE pass over the whole file, its zero on the first picture:
       asetpts moves the clock so the first picture is 0, aresample first_pts=0
       trims what came before it and pads a sound that starts later — the A/V
       offset of the source survives. Plus a second of THIS sound's silence
       (same encoder, same format): a join fills a shortfall with it. */
    async function _ewSound(ffmpeg, path, clk, audioArgs, aMap, run, take) {
        var aa = _ewSplitAudio(audioArgs);
        var af = 'asetpts=PTS-' + clk.z.toFixed(6) + '/TB,aresample=async=1:first_pts=0' + (aa.af ? ',' + aa.af : '');
        await run(['-copyts', '-i', path].concat(aMap, ['-vn', '-sn', '-dn', '-af', af], aa.args, ['-y', 'ew_a.m4a']), 'sound');
        var audio = await take('ew_a.m4a', 'audio/mp4');
        await run(['-i', path].concat(aMap, ['-vn', '-sn', '-dn', '-t', '1', '-af', 'volume=0' + (aa.af ? ',' + aa.af : '')], aa.args, ['-y', 'ew_s.m4a']), 'silence');
        var silence = await take('ew_s.m4a', 'audio/mp4');
        return { audio: audio, silence: silence };
    }
    function _ewRunner(ffmpeg) {
        return {
            run: async function (args, what) {
                window._ffLogs = [];
                var x = await ffmpeg.exec(args);
                if (x !== 0) throw _execError(x, what + ': ' + _logTail());
            },
            take: async function (name, type) {
                var data = await ffmpeg.readFile(name);
                /* readFile hands back a view into the wasm heap — copy before the next exec. */
                var blob = new Blob([data && data.slice ? data.slice() : new Uint8Array(data)], { type: type });
                try { await ffmpeg.deleteFile(name); } catch (_) {}
                return blob;
            },
            frames: function () {
                var logs = window._ffLogs || [], n = -1;
                for (var i = 0; i < logs.length; i++) { var m = /frame=\s*(\d+)/.exec(String(logs[i])); if (m) n = +m[1]; }
                return n;
            }
        };
    }
    /* The caller's FFmpegProcessor.onProgress keeps receiving ONE 0..1 for the
       whole run — a per-window bar that climbs and resets is how /reverse-video
       lost people at «95 %, again». */
    function _ewProgress(FP) {
        var prev = FP._progressRaw || null, unit = 0, units = 1, unitLen = 1, hi = 0;
        var p = {
            set: function (u, n, len) { unit = u; units = Math.max(1, n); unitLen = len > 0 ? len : 1; },
            revise: function () { hi = 0; },
            report: function (frac) {
                if (!prev) return;
                var f = (typeof frac === 'number' && isFinite(frac)) ? Math.max(0, Math.min(1, frac)) : 0;
                var g = (unit + f) / units;
                if (g < hi) g = hi; else hi = g;
                try { prev(Math.min(1, g), { timeSec: null, rawRatio: null }); } catch (_) {}
            },
            restore: function () { if (prev) { try { FP.onProgress(prev); } catch (_) {} } }
        };
        if (prev) { try { FP.onProgress(function (r, info) {
            var t = info && typeof info.timeSec === 'number' ? info.timeSec : null;
            p.report(t !== null ? t / unitLen : 0);
        }); } catch (_) {} }
        return p;
    }

    FFmpegProcessor.encodeWindowsStreaming = async function(file, opts){
        opts = opts || {};
        if (!(file instanceof File) && !(file instanceof Blob)) throw new Error('encodeWindowsStreaming requires File or Blob');
        var videoArgs = (opts.videoArgs || []).slice();
        var audioArgs = opts.audioArgs ? opts.audioArgs.slice() : null;
        /* Обе общие политики argv — дверь собирает argv сама, правка соседней двери до неё не доходит. */
        try { videoArgs = window.FFmpegDelayCompensation.apply(videoArgs); } catch (_) {}
        try { videoArgs = window.FFmpegResampleQuality.apply(videoArgs); } catch (_) {}
        /* The output contract the guard pins on the other doors (`-pix_fmt yuv420p` for an
           8-bit encoder): this door's argv lives in `opts`, out of PINNED's reach. */
        try { if (window.CodecMuxRules && CodecMuxRules.enforceVideoOutputContract) videoArgs = CodecMuxRules.enforceVideoOutputContract(videoArgs); } catch (_) {}
        if (audioArgs) {
            try { audioArgs = window.FFmpegDelayCompensation.apply(audioArgs); } catch (_) {}
            try { audioArgs = window.FFmpegResampleQuality.apply(audioArgs); } catch (_) {}
        }
        var W = Math.max(4, +opts.windowSec || 60);
        var PRE = opts.preRollSec != null ? Math.max(0, +opts.preRollSec) : 3;
        var WARM = opts.warmSec != null ? Math.max(0, +opts.warmSec) : 0.2;
        var vf = String(opts.vf || '');
        var outName = opts.name || 'output.mp4';
        var aMap = opts.audioMap ? ['-map', String(opts.audioMap)] : [];
        var durationS = +opts.durationS > 0 ? +opts.durationS : 0;
        var partialEvery = opts.partialMinIntervalMs != null ? +opts.partialMinIntervalMs : 120000;
        function cancelled() { return !!((opts.signal && opts.signal.aborted) || (typeof opts.isCancelled === 'function' && opts.isCancelled())); }
        function abortErr() { var e = new Error('aborted'); e.name = 'AbortError'; return e; }

        var MCT = await _ewLoadGlobal('Mp4CopyTrim', '/js/mp4-copy-trim.js');
        if (!MCT || typeof MCT.concat !== 'function') throw new Error('encode-windows: Mp4CopyTrim is not available');
        if (!(await FFmpegProcessor._ensureReady())) throw new Error('FFmpeg not initialized');
        var prog = _ewProgress(FFmpegProcessor);
        var mh = null, ffmpeg = null, temps = ['ew_a.m4a', 'ew_s.m4a'];
        try {
            mh = await FFmpegProcessor.mountInput(file);
            ffmpeg = FFmpegProcessor._getFFmpeg();
            var R = _ewRunner(ffmpeg);
            var clk = await _ewClock(ffmpeg, mh.path, opts.fps);
            /* A whole number of frame periods per window: every edge lands half-way between two frames. */
            W = Math.max(1, Math.round(W * clk.fps)) / clk.fps;
            var nPlan = durationS > 0 ? Math.max(1, Math.ceil(durationS / W)) : 1;
            var withAudio = !!(audioArgs && clk.hasAudio);
            var base = withAudio ? 1 : 0;
            var units = function (k) { return base + Math.max(nPlan, k + 1) + 1; };

            var snd = null;
            if (withAudio) {
                prog.set(0, units(0), Math.max(1, durationS || 1));
                snd = await _ewSound(ffmpeg, mh.path, clk, audioArgs, aMap, R.run, R.take);
            }

            var wins = [], winSecs = [], lastPartial = Date.now(), emptyRun = 0, replanned = false;
            var assemble = async function (list, name) {
                var video = list.length === 1
                    ? new File([list[0]], 'ew_video.mp4', { type: 'video/mp4' })
                    : await MCT.concat({ clips: list.map(function (b) { return { video: b, audio: null }; }), silence: null, brand: 'mp4', name: 'ew_video.mp4' });
                if (!snd) return new File([video], name, { type: 'video/mp4' });
                return await MCT.concat({ clips: [{ video: video, audio: snd.audio }], silence: snd.silence, brand: 'mp4', name: name });
            };
            for (var k = 0; ; k++) {
                if (cancelled()) throw abortErr();
                var win = _ewWindow(k, W, clk, PRE, WARM, vf);
                var vName = 'ew_v' + k + '.mp4';
                temps.push(vName);
                prog.set(base + k, units(k), W);
                console.log('[ffmpeg] encodeWindows ' + (k + 1) + '/' + nPlan + ':', (win.A === null ? 'start' : win.A.toFixed(2)), '-', win.B.toFixed(2));
                /* -noautorotate: a re-encode auto-rotates the PIXELS and still copies the
                   source's rotation matrix into the mp4 — a phone clip would turn twice.
                   Kept as stored, the matrix travels with it (the splice measured this). */
                await R.run(['-noautorotate'].concat(win.seek, ['-copyts', '-i', mh.path, '-map', '0:v:0', '-an', '-sn', '-dn', '-vf', win.chain], videoArgs, ['-y', vName]), 'window ' + (k + 1));
                var frames = R.frames();
                var vb = await R.take(vName, 'video/mp4');
                if (frames === 0 || vb.size < 512) {
                    if (k === 0) throw new Error('encode-windows: no picture in the file');
                    emptyRun++;
                    if (_ewPastEnd(win, clk, durationS, emptyRun)) break;
                    try { window.__ae && window.__ae('feature_use', { slug: window.__TOOL_SLUG || '', f: 'windows_gap', k: k, at: Math.round(win.A || 0) }); } catch (_) {}
                    continue;
                }
                emptyRun = 0;
                wins.push(vb);
                winSecs.push(W);
                if (!replanned && k + 1 >= nPlan) {
                    replanned = true;
                    var realLen = await _ewLength(ffmpeg, mh.path);
                    if (realLen > durationS + W) {
                        try { window.__ae && window.__ae('feature_use', { slug: window.__TOOL_SLUG || '', f: 'windows_replan', planned_s: Math.round(durationS), file_s: Math.round(realLen) }); } catch (_) {}
                        durationS = realLen; nPlan = Math.max(1, Math.ceil(durationS / W)); prog.revise();
                    }
                }
                if (typeof opts.onWindowDone === 'function') { try { opts.onWindowDone(wins.length, Math.max(nPlan, k + 1)); } catch (_) {} }
                if (typeof opts.onPartial === 'function' && Date.now() - lastPartial >= partialEvery) {
                    lastPartial = Date.now();
                    try {
                        var pf = await assemble(wins, 'partial_' + outName);
                        var done = 0; for (var q = 0; q < winSecs.length; q++) done += winSecs[q];
                        opts.onPartial(pf, Math.min(done, durationS || done), durationS);
                    } catch (pe) { console.warn('[ffmpeg] encodeWindows partial skipped:', pe && pe.message); }
                }
            }

            /* ── the file: byte ranges on disk, moov first ── */
            prog.set(base + Math.max(nPlan, wins.length), units(wins.length), 1); prog.report(0);
            var out = await assemble(wins, outName);
            prog.report(1);
            var info = out.concatInfo || null;
            return {
                blob: out, name: outName, url: URL.createObjectURL(out), size: out.size,
                windows: wins.length, durationS: info && info.durationMs ? info.durationMs / 1000 : null,
                audioErrMs: info && info.clips && info.clips[0] ? info.clips[0].audioErrMs : null,
                fps: clk.fps, rate: clk.rate, vfr: clk.vfr
            };
        } catch (err) {
            _annotateErr(err, file && file.size);
            throw err;
        } finally {
            if (ffmpeg) for (var ti = 0; ti < temps.length; ti++) { try { await ffmpeg.deleteFile(temps[ti]); } catch (_) {} }
            if (mh) { try { await mh.dispose(); } catch (_) {} }
            prog.restore();
        }
    };

    /**
     * decodeWindowsStreaming — the same exact windows, handed out as RAW frames
     * (for a lane whose encoder is the browser's: hybrid-encode-lane).
     *
     * It replaces processFrameChunks for that lane, whose stream-copy split was
     * measured on the six containers above: an AVI with packed B-frames is not
     * split AT ALL (its packets carry no pts, the segment muxer never cuts — the
     * whole film became one chunk and one raw buffer: a 20-minute DivX hung at
     * «95 %» for 40 minutes), with +genpts it cuts at the 6-byte N-VOP that the
     * AVI flags as a keyframe (1183 of 1485 frames grey), and a DVD VOB loses ~2
     * frames at every 2-second cut (1441 of 1500 in a minute — the picture ran 4 %
     * short of the sound). It also wrote the whole source into the heap first:
     * «Array buffer allocation failed» on a 699 MB film.
     *
     * The input is mounted; a window is as long as `rawBudgetBytes` of frames
     * allows (≤ 10 s); FFmpeg's auto-rotation stays ON (raw frames carry no
     * rotation matrix — they must arrive upright).
     *
     * opts: vf (the full chain, ending in the output size) · frameBytes (one raw
     *       frame) · pixFmt ('yuv420p') · durationS · fps (fallback only) · rawBudgetBytes (192 MB) ·
     *       preRollSec (3) · warmSec (0.2) · onClock({fps, rate, vfr, t0, z, hasAudio}) —
     *       awaited, before the first frame: frame n of the run is at n / fps ·
     *       onChunk(bytes, k, planned) — awaited · onProgress(0..1) · signal
     * Returns { windows, frames, windowSec, fps, rate, vfr }.
     */
    FFmpegProcessor.decodeWindowsStreaming = async function(file, opts){
        opts = opts || {};
        if (!(file instanceof File) && !(file instanceof Blob)) throw new Error('decodeWindowsStreaming requires File or Blob');
        if (typeof opts.onChunk !== 'function') throw new Error('decodeWindowsStreaming: onChunk is required');
        var frameBytes = +opts.frameBytes || 0;
        if (!(frameBytes > 0)) throw new Error('decodeWindowsStreaming: frameBytes is required');
        var pixFmt = opts.pixFmt || 'yuv420p';
        var PRE = opts.preRollSec != null ? Math.max(0, +opts.preRollSec) : 3;
        var WARM = opts.warmSec != null ? Math.max(0, +opts.warmSec) : 0.2;
        var vf = String(opts.vf || '');
        var durationS = +opts.durationS > 0 ? +opts.durationS : 0;
        var budget = +opts.rawBudgetBytes > 0 ? +opts.rawBudgetBytes : 192 * 1048576;
        function aborted() { return !!(opts.signal && opts.signal.aborted); }
        function abortErr() { var e = new Error('aborted'); e.name = 'AbortError'; return e; }
        if (!(await FFmpegProcessor._ensureReady())) throw new Error('FFmpeg not initialized');
        var mh = null, ffmpeg = null, raw = 'dw_raw.' + pixFmt;
        try {
            mh = await FFmpegProcessor.mountInput(file);
            ffmpeg = FFmpegProcessor._getFFmpeg();
            var R = _ewRunner(ffmpeg);
            var clk = await _ewClock(ffmpeg, mh.path, opts.fps);
            /* The rate the frames come at is the door's, not the caller's guess: the
               lane dates frame n at n / clk.fps, so it hears it before the first frame. */
            if (typeof opts.onClock === 'function') await opts.onClock({ fps: clk.fps, rate: clk.rate, vfr: clk.vfr, t0: clk.t0, z: clk.z, hasAudio: clk.hasAudio });
            /* A whole number of frames per window: the lane dates frames n / fps, and a
               window of N slots of the grid holds exactly N frames. */
            var nFr = Math.max(12, Math.min(Math.round(10 * clk.fps), Math.floor(budget / frameBytes)));
            var W = nFr / clk.fps;
            var nPlan = durationS > 0 ? Math.max(1, Math.ceil(durationS / W)) : 0;
            var frames = 0, chunks = 0, emptyRun = 0, replanned = false;
            for (var k = 0; ; k++) {
                if (aborted()) throw abortErr();
                var win = _ewWindow(k, W, clk, PRE, WARM, vf);
                await R.run(win.seek.concat(['-copyts', '-i', mh.path, '-map', '0:v:0', '-an', '-sn', '-dn', '-vf', win.chain,
                    '-f', 'rawvideo', '-pix_fmt', pixFmt, '-y', raw]), 'window ' + (k + 1));
                var bytes = await ffmpeg.readFile(raw);
                /* readFile hands back a view into the wasm heap — copy before the next exec. */
                var copy = (bytes && bytes.slice) ? bytes.slice() : new Uint8Array(bytes);
                try { await ffmpeg.deleteFile(raw); } catch (_) {}
                if (!copy.length) {
                    if (k === 0) throw new Error('decode-windows: no picture in the file');
                    emptyRun++;
                    if (_ewPastEnd(win, clk, durationS, emptyRun)) break;
                    continue;
                }
                emptyRun = 0;
                if (copy.length % frameBytes !== 0) throw new Error('decode-windows: ' + copy.length + ' B is not whole frames of ' + frameBytes);
                if (!replanned && nPlan && k + 1 >= nPlan) {
                    replanned = true;
                    var realLen = await _ewLength(ffmpeg, mh.path);
                    if (realLen > durationS + W) { durationS = realLen; nPlan = Math.max(1, Math.ceil(durationS / W)); }
                }
                await opts.onChunk(copy, chunks, nPlan);
                chunks++;
                frames += copy.length / frameBytes;
                if (typeof opts.onProgress === 'function') { try { opts.onProgress(nPlan ? Math.min(1, (k + 1) / nPlan) : 0); } catch (_) {} }
            }
            return { windows: chunks, frames: frames, windowSec: W, fps: clk.fps, rate: clk.rate, vfr: clk.vfr };
        } catch (err) {
            _annotateErr(err, file && file.size);
            throw err;
        } finally {
            if (ffmpeg) { try { await ffmpeg.deleteFile(raw); } catch (_) {} }
            if (mh) { try { await mh.dispose(); } catch (_) {} }
        }
    };

    /**
     * soundForPictureStreaming — the sound of a file as ONE AAC pass, its zero on
     * the file's first picture, plus a second of its own silence; for a lane that
     * makes the picture elsewhere and joins the two with Mp4CopyTrim.concat.
     * opts: audioArgs (default AAC 160k) · audioMap · durationS + onProgress(0..1)
     * — the pass is the length of the film (27 min for a 140-min AVI, measured
     * 02.10.2026), and a bar that stands still for it reads as a hang. Returns
     * {audio, silence} or null when the file has no sound.
     */
    FFmpegProcessor.soundForPictureStreaming = async function(file, opts){
        opts = opts || {};
        var audioArgs = opts.audioArgs ? opts.audioArgs.slice() : ['-c:a', 'aac', '-b:a', '160k'];
        try { audioArgs = window.FFmpegDelayCompensation.apply(audioArgs); } catch (_) {}
        try { audioArgs = window.FFmpegResampleQuality.apply(audioArgs); } catch (_) {}
        var aMap = opts.audioMap ? ['-map', String(opts.audioMap)] : [];
        var durationS = +opts.durationS > 0 ? +opts.durationS : 0;
        var onP = typeof opts.onProgress === 'function' ? opts.onProgress : null;
        if (!(await FFmpegProcessor._ensureReady())) throw new Error('FFmpeg not initialized');
        /* Borrow the progress subscription for the pass, give it back after (the
           output clock starts at 0 on the first picture: time / length). */
        var prevRaw = onP ? (FFmpegProcessor._progressRaw || null) : null, hi = 0;
        if (onP && durationS > 0) {
            try { FFmpegProcessor.onProgress(function (r, info) {
                var t = info && typeof info.timeSec === 'number' && isFinite(info.timeSec) ? info.timeSec : null;
                /* A time past the film is not a position (a timestamp-less output reports INT64_MAX µs). */
                if (t === null || t < 0 || t > durationS * 1.05 + 30) return;
                var f = Math.max(0, Math.min(1, t / durationS));
                if (f <= hi) return;
                hi = f;
                try { onP(f); } catch (_) {}
            }); } catch (_) {}
        }
        var mh = null, ffmpeg = null;
        try {
            mh = await FFmpegProcessor.mountInput(file);
            ffmpeg = FFmpegProcessor._getFFmpeg();
            var R = _ewRunner(ffmpeg);
            var clk = await _ewClock(ffmpeg, mh.path, opts.fps);
            if (!clk.hasAudio) return null;
            var snd = await _ewSound(ffmpeg, mh.path, clk, audioArgs, aMap, R.run, R.take);
            if (onP) { try { onP(1); } catch (_) {} }
            return snd;
        } catch (err) {
            _annotateErr(err, file && file.size);
            throw err;
        } finally {
            if (onP && durationS > 0) { try { FFmpegProcessor.onProgress(prevRaw || function () {}); } catch (_) {} }
            if (ffmpeg) { try { await ffmpeg.deleteFile('ew_a.m4a'); } catch (_) {} try { await ffmpeg.deleteFile('ew_s.m4a'); } catch (_) {} }
            if (mh) { try { await mh.dispose(); } catch (_) {} }
        }
    };

    /**
     * smartTwoPassTrimStreaming — etalon trim for non-keyframe selStart.
     *
     * Problem: `-ss BEFORE -i + -c copy` silently SNAPS selStart back to the
     * nearest preceding keyframe (Aleksandr #718 / Eldar #640 root cause).
     * Full re-encode IS exact but on a 4 GB Android Yandex / Redmi-class
     * device a 306 MB file takes 10+ minutes — the 2026-06-19 mobile user
     * "Не обрезает мгновенно" report.
     *
     * Smart fix: re-encode ONLY the head GOP [selStart, splitAt] where
     * splitAt is the next keyframe at or after selStart. Then stream-copy
     * [splitAt, selEnd] — bulk of the file, near-instant. Concat both into
     * the final output. For long-GOP files this can be 10-30x faster than a
     * full re-encode while giving frame-accurate start.
     *
     * Args contract:
     *   file        — source File (mounted via WORKERFS; never written to heap)
     *   selStart    — requested start in seconds (between keyframes)
     *   splitAt     — keyframe at or after selStart (head re-encode ends here)
     *   selEnd      — requested end
     *   encArgs     — encoder args for the head (e.g. ['-c:v','libx264','-preset','veryfast','-crf','23','-c:a','aac','-b:a','128k'])
     *                 — its AUDIO part is used only when opts.audioCopy === false
     *   outputName  — final blob name (extension determines container fixups)
     *   opts.muteAudio — no audio in the output (whether the source HAS
     *                    audio the engine reads from the file itself)
     *   opts.audioCopy — false re-encodes the (continuous) audio with encArgs'
     *                    audio options: the output container cannot hold the
     *                    source codec
     *
     * The tail is only decodable after the head when splitAt is an IDR frame
     * of an 8-bit H.264 track — the caller picks it with
     * window.__spliceKeyframeAfter. Implementation and measurements:
     * _spliceStreaming.
     */
    /* The «2 min saved as 14 min» report (2026-07-23) proved the mp4box
       format-duration gate is blind to TRACK-level inflation: mvhd can be
       correct while an audio trak mdhd carries a wildly longer duration —
       players show the track number. Hence the player-truth gate below, now
       also checking the short side and the picture past the join. */
    /* _playerTruthProbe — the output as the USER'S browser will open it: the
       duration a player shows (the longest track, not mvhd) and, when `seekTo`
       is given, whether a frame decodes there. `decodeError` is set ONLY for
       MEDIA_ERR_DECODE after metadata — a browser that cannot play the codec
       at all (Playwright's Chromium, some Linux builds) answers
       SRC_NOT_SUPPORTED and that is "cannot verify", never "broken".
       Measured on the open-GOP splice (2026-09-25): Chrome loads metadata and
       then fails with PIPELINE_ERROR_DECODE — exactly this signal. */
    async function _playerTruthProbe(blob, seekTo, timeoutMs){
        return new Promise(function(resolve){
            var v, url, done = false, res = { duration: null, decodeError: null };
            var finish = function(){
                if (done) return; done = true;
                try { if (v) { v.removeAttribute('src'); v.load(); } } catch(_){}
                try { if (url) URL.revokeObjectURL(url); } catch(_){}
                resolve(res);
            };
            try {
                v = document.createElement('video');
                v.preload = 'metadata'; v.muted = true;
                url = URL.createObjectURL(blob);
                v.onloadedmetadata = function(){
                    var d = v.duration;
                    res.duration = isFinite(d) && d > 0 ? d : null;
                    if (seekTo == null) { finish(); return; }
                    try { v.currentTime = Math.max(0, Math.min(seekTo, (res.duration || seekTo) - 0.05)); } catch(_) { finish(); }
                };
                v.onseeked = function(){
                    /* Give the decoder a beat past the seek to hit the frame. */
                    setTimeout(finish, 400);
                };
                v.onerror = function(){
                    var e = v.error;
                    if (e && e.code === 3 && res.duration !== null) res.decodeError = String(e.message || 'decode').slice(0, 120);
                    finish();
                };
                setTimeout(finish, timeoutMs || 6000);
                v.src = url;
            } catch(_) { finish(); }
        });
    }

    /* Split a head encoder argv into what the VIDEO pass needs and what an
       audio re-encode would need. Container-level flags are dropped: the
       pieces are intermediates, and `-avoid_negative_ts make_zero` on a piece
       moves its zero off the frame it was cut at (the whole reason the old
       splice drifted). */
    function _splitSpliceArgs(args){
        var AUD = { '-c:a':1, '-codec:a':1, '-acodec':1, '-b:a':1, '-ab':1, '-ac':1, '-ar':1, '-af':1, '-filter:a':1, '-q:a':1, '-aq':1, '-profile:a':1, '-filter_size':1 };
        var DROP = { '-avoid_negative_ts':1, '-movflags':1, '-y':0 };
        var v = [], a = [];
        for (var i = 0; i < (args || []).length; i++) {
            var k = args[i];
            if (Object.prototype.hasOwnProperty.call(DROP, k)) { if (DROP[k]) i++; continue; }
            if (AUD[k]) { a.push(k, args[i + 1]); i++; continue; }
            v.push(k);
        }
        return { video: v, audio: a };
    }

    /* _spliceStreaming — frame-exact trim/cut without re-encoding the bulk.
       ONE implementation for the smart trim (2 pieces) and the smart cut
       (N pieces). 2026-09-25 (bug report, 2 h concert recordings): the old
       doors spliced audio+video files head-to-tail, and the join was wrong in
       three independent ways, each measured on the real WASM engine:

       1. The head was cut `-to splitAt` and so INCLUDED the keyframe the tail
          starts with — one frame played twice.
       2. The copied tail was written with `-avoid_negative_ts make_zero`,
          which moves a B-frame file's zero to its first DECODE time: the tail
          video sat the composition delay (80 ms at 3 B-frames) behind its own
          audio. Net after the join: picture 44–59 ms behind the sound for the
          rest of the clip, on ordinary camera / YouTube / OBS files.
       3. The audio was re-encoded for the head and copied for the tail — two
          encoders' priming and two containers' rounding meeting at the join,
          and an HE-AAC source failing the head outright (`Input contains
          (near) NaN`) into a full re-encode.

       So now: VIDEO is spliced alone (head encoded [start, splitAt) without
       audio, tail copied without make_zero, joined with an exact `duration`
       per piece), and AUDIO is never cut at a video join. One kept range (a
       trim): one continuous stream copy, cut without pre-roll (re-encoded with
       the caller's audio args only when the output container cannot hold the
       source codec). Several kept ranges (a cut): decoded, cut to the sample,
       joined, encoded once — a copied AAC stream can only break on its frames.
       Measured on x264 sources with and without B-frames: head frame count
       exact, the tail starts on its keyframe to the millisecond, audio vs
       picture equals the SOURCE's own offset (±5 ms), in ffmpeg, Chrome and
       Media Foundation alike.

       Which keyframes a tail may start on is the PLANNER's job (the
       keyframe probe's splice check — IDR only, H.264 only). This function
       still refuses to hand back a file the user's browser cannot decode past
       the join, or whose length is not the length asked for: both throw, and
       every caller falls back to the full re-encode.

       pieces: [{ start, end, mode: 'encode'|'copy' }] in output order, with
       `start` of the first encode piece on a frame boundary (the planner
       snaps it) so picture and sound start at the same instant. */
    async function _spliceStreaming(file, pieces, encArgs, outputName, opts, tag){
        opts = opts || {};
        tag = tag || 'splice';
        if (!pieces || !pieces.length) throw new Error(tag + ': empty piece list');
        return await _withMounts(file, async function(paths){
            var ffmpeg = FFmpegProcessor._getFFmpeg();
            var outExt = (outputName.split('.').pop() || 'mp4').toLowerCase();
            var mp4Fam = outExt === 'mp4' || outExt === 'mov' || outExt === 'm4v';
            /* 2026-08-09 Petr #1330: one canonical video timescale on EVERY
               piece. libx264 picks its own mp4 timescale (e.g. 15360), a copy
               keeps the muxer's (90000 / 16000), and the concat wrote the
               joined track under one timescale while pasting the other half's
               sample deltas verbatim — that half stretched by the ratio
               (video trak 583.48 s vs audio 99.63 s, 5.86 = 90000/15360).
               90000 divides 24/25/30/50/60 and 29.97; a `-c copy` remux
               rescales to it exactly. ⚠️ The WebCodecs path pins 120000
               (MUX_VIDEO_TIMEBASE in webcodecs-pipeline.js) and that is
               deliberate: 90000 is not exact for 23.976 / 59.94, which only
               matters there. Do not "unify" them. mkv/webm have a fixed
               container timescale — mp4 family only. */
            var vts = mp4Fam ? ['-video_track_timescale', '90000'] : [];
            var split = _splitSpliceArgs(encArgs);
            var temps = [];
            var run = async function(args, what){
                window._ffLogs = [];
                var x = await ffmpeg.exec(args);
                if (x !== 0) throw _execError(x, what + ': ' + _logTail());
            };
            try {
                /* ── does the SOURCE carry sound? ── Asked here, not taken from
                   the caller: the old splice copied whatever audio there was,
                   and a caller's "no audio" flag must not be able to turn that
                   into a silent file. With sound in the source, a missing audio
                   pass is an error (→ the caller's full re-encode). */
                var srcHasAudio = true;
                try {
                    var _capPrev = window.__ffLogsCapOverride;
                    window.__ffLogsCapOverride = 400; window._ffLogs = [];
                    try { await ffmpeg.exec(['-hide_banner', '-i', paths[0]]); } catch (_) {}
                    var _probeLines = (window._ffLogs || []).slice();
                    window.__ffLogsCapOverride = _capPrev;
                    var _streams = _probeLines.filter(function (l) { return /Stream #\d+:\d+/.test(l); });
                    if (_streams.length) srcHasAudio = _streams.some(function (l) { return /: Audio:/.test(l); });
                } catch (_) { srcHasAudio = true; }
                var withAudio = !opts.muteAudio && srcHasAudio;
                var ranges = [];
                for (var r = 0; r < pieces.length; r++) {
                    var lastR = ranges[ranges.length - 1];
                    if (lastR && Math.abs(pieces[r].start - lastR.end) < 0.002) lastR.end = pieces[r].end;
                    else ranges.push({ start: pieces[r].start, end: pieces[r].end });
                }
                var aEnc = split.audio.length ? split.audio : ['-c:a', 'aac', '-b:a', '160k'];
                var aOut = null;
                /* ── video ── */
                var vlist = '';
                for (var i = 0; i < pieces.length; i++) {
                    var p = pieces[i];
                    var vName = 'spv' + i + '.' + outExt;
                    temps.push(vName);
                    var vArgs;
                    if (p.mode === 'encode') {
                        /* End 1 ms short of the next piece: the frame AT `end`
                           belongs to the copied keyframe that follows.
                           `-noautorotate` (Petr #1330 follow-up): ffmpeg-WASM 5.x
                           AUTO-ROTATES a re-encode — a phone video (landscape
                           pixels + 90° matrix) came out portrait with no matrix
                           next to a copied landscape+matrix tail, and the join
                           played sideways. Kept landscape, the matrix survives
                           (measured 640×360 + rotation=90). */
                        vArgs = ['-noautorotate', '-ss', p.start.toFixed(6), '-to', Math.max(p.start + 0.001, p.end - 0.001).toFixed(6), '-i', paths[0], '-an']
                            .concat(split.video, vts, ['-y', vName]);
                    } else {
                        /* `frames`: the planner's exact frame count for a copy
                           that must stop on a keyframe inside the output — `-to`
                           cuts by decode time and lets that keyframe in. */
                        vArgs = ['-ss', p.start.toFixed(6), '-to', p.end.toFixed(6), '-i', paths[0], '-an', '-c', 'copy']
                            .concat(p.frames > 0 ? ['-frames:v', String(p.frames)] : [], vts, ['-y', vName]);
                    }
                    console.log('[ffmpeg] ' + tag + ' video ' + p.mode + ' ' + (i + 1) + '/' + pieces.length + ':', p.start.toFixed(3), '-', p.end.toFixed(3));
                    await run(vArgs, 'video piece ' + i + ' (' + p.mode + ')');
                    vlist += "file '" + vName + "'\nduration " + Math.max(0.001, p.end - p.start).toFixed(6) + "\n";
                    if (opts.onPieceProgress) { try { opts.onPieceProgress(i + 1, pieces.length); } catch(_){} }
                }
                var vOut = 'spV.' + outExt;
                temps.push(vOut, 'spvlist.txt');
                await ffmpeg.writeFile('spvlist.txt', new TextEncoder().encode(vlist));
                await run(['-f', 'concat', '-safe', '0', '-i', 'spvlist.txt', '-c', 'copy'].concat(vts, ['-y', vOut]), 'video concat');
                for (var dv = 0; dv < pieces.length; dv++) { try { await ffmpeg.deleteFile('spv' + dv + '.' + outExt); } catch(_){} }

                /* ── audio ── */
                if (withAudio) {
                    if (ranges.length === 1) {
                        /* ONE kept range: the sound is copied, untouched
                           (re-encoded only when the output container cannot
                           hold the codec). Coarse seek on the INPUT, exact cut
                           on the OUTPUT. An input `-ss` alone lands on the
                           video keyframe before the point, and a copied audio
                           stream carries that whole pre-roll into the file
                           behind a discard flag and an edit list. Media
                           Foundation (Windows players) does not read audio
                           edit lists: measured on a 20.02 s track, it played
                           21.04 s — the sound a second late for the whole clip.
                           Even from 0: the first packet is the encoder priming
                           the source hid with an edit list (kept, the sound
                           came 22 ms late).
                           ⛔ Measured and rejected: this copy and the video
                           tail out of ONE read (two outputs, output `-ss` on
                           the video too) — the output seek dropped a B-frame
                           file's first tail GOP (video 15.24 s of 20.04), and
                           the time saved was inside the noise (median 11 s vs
                           13.5 s on a 2-hour source). */
                        var rg1 = ranges[0];
                        var pre1 = Math.max(0, rg1.start - 3);
                        aOut = 'spa0.' + outExt;
                        temps.push(aOut);
                        await run((pre1 > 0 ? ['-ss', pre1.toFixed(6)] : []).concat(['-i', paths[0], '-vn',
                            '-ss', Math.max(0, rg1.start - pre1).toFixed(6), '-to', (rg1.end - pre1).toFixed(6)],
                            opts.audioCopy === false ? aEnc : ['-c:a', 'copy'], ['-y', aOut]), 'audio');
                    } else {
                        /* SEVERAL kept ranges: decoded, cut to the sample, joined,
                           encoded once. A copied AAC stream can only be cut on its
                           1024-sample frames, so every join carried a clipped frame
                           (measured: 3.6 ms left of 23.2) that a player playing
                           whole frames turns into a ~20 ms slip plus a click — at
                           EVERY cut, adding up. */
                        var inArgs = [], lab = '';
                        for (var j = 0; j < ranges.length; j++) {
                            inArgs.push('-ss', ranges[j].start.toFixed(6), '-to', ranges[j].end.toFixed(6), '-i', paths[0]);
                            lab += '[' + j + ':a:0]';
                        }
                        aOut = 'spA.' + outExt;
                        temps.push(aOut);
                        await run(inArgs.concat(['-filter_complex', lab + 'concat=n=' + ranges.length + ':v=0:a=1[aj]', '-map', '[aj]'],
                            aEnc, ['-y', aOut]), 'audio join');
                    }
                }

                /* ── mux ── the Sergey #846 order stays: the concat above is
                   written WITHOUT faststart, and the pass that adds it rebuilds
                   the tables from packets (+genpts). */
                var muxArgs = aOut
                    ? ['-fflags', '+genpts', '-i', vOut, '-i', aOut, '-map', '0:v:0', '-map', '1:a:0', '-c', 'copy']
                    : ['-fflags', '+genpts', '-i', vOut, '-map', '0:v:0', '-c', 'copy'];
                muxArgs = muxArgs.concat(vts, mp4Fam ? ['-movflags', '+faststart'] : [], ['-y', outputName]);
                await run(muxArgs, 'mux');

                var data = await ffmpeg.readFile(outputName);
                var blob = new Blob([data], { type: _mimeFor(outputName) });

                /* ── gates: the output a player will open ── */
                var expectSec = 0, joinAt = null;
                for (var ei = 0; ei < pieces.length; ei++) {
                    if (joinAt === null && ei > 0 && pieces[ei].mode === 'copy' && pieces[ei - 1].mode === 'encode') joinAt = expectSec;
                    expectSec += Math.max(0, pieces[ei].end - pieces[ei].start);
                }
                expectSec = Math.max(0.1, expectSec);
                if (mp4Fam && typeof window.__Mp4BoxProbe === 'object' && window.__Mp4BoxProbe.probe) {
                    try {
                        var _probe = await window.__Mp4BoxProbe.probe(blob, { timeoutMs: 6000 });
                        var _outSec = _probe && _probe.duration ? _probe.duration : 0;
                        if (_outSec > 0 && _outSec > expectSec * 1.5) {
                            try { window.__ae && window.__ae('feature_use', { slug: 'video-trim', action: tag + '_duration_inflated',
                                expectedSec: Math.round(expectSec * 100) / 100, outSec: Math.round(_outSec * 100) / 100 }); } catch (_) {}
                            throw new Error(tag + ' output duration inflated: expected ' + expectSec.toFixed(2) + 's, got ' + _outSec.toFixed(2) + 's — falling back');
                        }
                    } catch (probeErr) {
                        if (/inflated/.test(probeErr && probeErr.message || '')) throw probeErr;
                    }
                }
                var truth = await _playerTruthProbe(blob, joinAt !== null ? joinAt + 0.5 : null, 6000);
                var slack = Math.max(1.0, expectSec * 0.15);
                if (truth.duration !== null && (truth.duration > expectSec * 1.5 || truth.duration < expectSec - slack)) {
                    try { window.__ae && window.__ae('feature_use', { slug: 'video-trim', action: tag + '_track_inflated',
                        expectedSec: Math.round(expectSec * 100) / 100, playerSec: Math.round(truth.duration * 100) / 100,
                        short: truth.duration < expectSec ? 1 : 0 }); } catch(_) {}
                    throw new Error(tag + ' PLAYER duration wrong: expected ' + expectSec.toFixed(2) + 's, player sees ' + truth.duration.toFixed(2) + 's — falling back');
                }
                if (truth.decodeError) {
                    try { window.__ae && window.__ae('feature_use', { slug: 'video-trim', action: tag + '_decode_failed',
                        joinAt: Math.round((joinAt || 0) * 100) / 100, msg: truth.decodeError }); } catch(_) {}
                    throw new Error(tag + ' output does not decode past the join (' + truth.decodeError + ') — falling back');
                }
                return { blob: blob, name: outputName, url: URL.createObjectURL(blob), size: blob.size };
            } finally {
                for (var t = 0; t < temps.length; t++) { try { await ffmpeg.deleteFile(temps[t]); } catch(_){} }
                try { await ffmpeg.deleteFile(outputName); } catch(_){}
            }
        });
    }

    FFmpegProcessor.smartTwoPassTrimStreaming = async function(file, selStart, splitAt, selEnd, encArgs, outputName, opts){
        /* Обе общие политики argv: компенсация задержки фильтров с lookahead и качество ресемплера. Дверь собирает argv сама, поэтому правка, сделанная в соседней, до неё не доходит. Обе идемпотентны, обе fail-open. */
        try { encArgs = window.FFmpegDelayCompensation.apply(encArgs); } catch (_) {}
        try { encArgs = window.FFmpegResampleQuality.apply(encArgs); } catch (_) {}
        opts = opts || {};
        /* The head/tail pair is the two-piece case of the splice — see
           _spliceStreaming for what the join has to get right and how it was
           measured. */
        try {
            return await _spliceStreaming(file, [
                { start: selStart, end: splitAt, mode: 'encode' },
                { start: splitAt, end: selEnd, mode: 'copy' },
            ], encArgs, outputName, opts, 'smart2pass');
        } catch(err){ _annotateErr(err, file && file.size); throw err; }
    };

    /**
     * concatPiecesStreaming — the smart 2-pass idea generalized to N pieces.
     *
     * 2026-07-14 subscriber #971: the CUT path (delete a middle/edge fragment)
     * promoted any off-keyframe keep boundary to a FULL re-encode of every
     * kept second (reencodeAndConcat). On his 766 MB / 32 min 1080p file that
     * meant tens of minutes of WASM x264 for a range whose TRIM-tab equivalent
     * finished in 14 s via smartTwoPassTrimStreaming. He tried three times,
     * abandoned, left a 1★. The caller (video-trim cut path) now plans a
     * piece list — per keep segment: encode ONLY the head GOP up to the next
     * keyframe, stream-copy the bulk — and this function executes it.
     *
     * pieces: [{ start, end, mode: 'encode'|'copy' }] in output order.
     *   encode → input-seek decode + encArgs (frame-exact start)
     *   copy   → input-seek + -c copy (start MUST be on a keyframe — the
     *            caller's planner guarantees it, same contract as the 2-pass
     *            tail)
     * encArgs — encoder args for 'encode' pieces (video part) and, when
     *   opts.audioCopy === false, for the kept ranges' audio.
     * opts.muteAudio / opts.audioCopy — as smartTwoPassTrimStreaming.
     * opts.onPieceProgress(i, n) — optional coarse progress callback.
     *
     * Every 'copy' piece must start on an IDR of an 8-bit H.264 track
     * (window.__spliceKeyframeAfter). The shared implementation is
     * _spliceStreaming; its gates throw so the caller falls back to the
     * slow-but-correct full re-encode.
     */
    FFmpegProcessor.concatPiecesStreaming = async function(file, pieces, encArgs, outputName, opts){
        /* Обе общие политики argv: компенсация задержки фильтров с lookahead и качество ресемплера. Дверь собирает argv сама, поэтому правка, сделанная в соседней, до неё не доходит. Обе идемпотентны, обе fail-open. */
        try { encArgs = window.FFmpegDelayCompensation.apply(encArgs); } catch (_) {}
        try { encArgs = window.FFmpegResampleQuality.apply(encArgs); } catch (_) {}
        opts = opts || {};
        if (!pieces || !pieces.length) throw new Error('concatPiecesStreaming: empty piece list');
        try {
            return await _spliceStreaming(file, pieces, encArgs, outputName, opts, 'smart_cut');
        } catch(err){ _annotateErr(err, file && file.size); throw err; }
    };

    /**
     * reverseChunked — chunk-and-reverse pipeline. The `-vf reverse` / `-af areverse`
     * filters require buffering EVERY decoded frame in heap (random-access by design),
     * so a 9-min SD clip alone needs ~7 GB raw frame buffer and OOMs WASM (2 GB cap)
     * with the classic "get_buffer() failed: Out of memory" log spam.
     *
     * The fix: split the input into short segments, reverse each segment in place
     * (small enough to fit), then concat the segments in REVERSE order. Mathematically
     * equivalent to a full-file reverse: concat(rev(C_n), rev(C_n-1), ..., rev(C_0))
     * == rev(concat(C_0, C_1, ..., C_n)). Audio same logic via areverse.
     *
     * `args` MUST include `-vf reverse...` (and `-af areverse` if audio is reversed)
     * plus the codec choice for the chunk output. Concat then runs `-c copy` so all
     * chunks must encode to the same codec/params — the caller's responsibility.
     *
     * `opts.chunkSec`     — chunk length in seconds. Default 4 s = ~360 MB raw frames
     *                       at 1080p25, well under the 2 GB heap. Drop to 2 s for 4K.
     * `opts.startOffset`  — seconds into the source where the range begins (lets the
     *                       caller request reverse of a sub-range without an extra
     *                       pre-trim encode). Default 0.
     * `opts.keepInFs`     — when true, leaves outputName in the FFmpeg FS (no readFile,
     *                       no blob) so a follow-up exec (e.g. concat / GIF transcode)
     *                       can reference it directly. Caller is responsible for
     *                       deleteFile. Default false.
     * `opts.onChunkProgress(globalRatio)` — GLOBAL 0..1 across the whole
     *                       operation: chunk index PLUS that chunk's own exec
     *                       ratio, plus the final concat as one extra unit.
     *
     *                       This function owns the mapping because it is the
     *                       only code that knows the chunk index. It used to
     *                       fire once BETWEEN chunks, which left the caller's
     *                       own `FFmpegProcessor.onProgress` handler painting a
     *                       per-EXEC 0→1 for every chunk — a bar that climbed
     *                       to the top and reset once per chunk. Bug report
     *                       2026-09-07 (/reverse-video, Yandex/Android, 133 MB):
     *                       «доходит до 95% и начинается заново, 4 раза подряд,
     *                       дальше я не стал ждать». Seven resets on a 25 s
     *                       clip in the lab; ~2 minutes per reset on the
     *                       reporter's phone.
     *
     *                       So the subscription is BORROWED for the duration of
     *                       the chunk loop and given back on exit — one writer
     *                       at a time, and the caller's non-chunked mapping is
     *                       still there for the execs that follow.
     */
    FFmpegProcessor.reverseChunked = async function(file, totalDuration, args, outputName, opts){
        /* Компенсация задержки фильтров с lookahead. Дверь строит argv сама,
           поэтому правка иначе до неё не доходит; идемпотентна (метка в цепочке),
           fail-open. */
        try { args = window.FFmpegDelayCompensation.apply(args); } catch (_) {}
        /* Качество ресемплера — общее умолчание, а не свойство двери. */
        try { args = window.FFmpegResampleQuality.apply(args); } catch (_) {}
        opts = opts || {};
        var chunkSec = opts.chunkSec || 4;
        var startOffset = opts.startOffset || 0;
        if (totalDuration <= 0) throw new Error('reverseChunked requires positive totalDuration');
        var segExt = outputName.split('.').pop();
        var n = Math.max(1, Math.ceil(totalDuration / chunkSec));

        /* ffmpeg.wasm never hands the heap back: every exec() grows the allocator
           and an exec traps once its own peak no longer fits in what is left —
           independent of the device's RAM. Measured 2026-07-10 on this very
           function, 720p source, chunkSec=4: chunk 45 dies with "memory access
           out of bounds", so any source past ~3 minutes never finishes. (Same
           class as the /music-video-maker montage.) deleteFile()ing the finished
           chunks does not help — the allocator grew, not MEMFS — but reinit()
           resets it in ~70 ms. So encode in batches, parking finished chunks
           outside the heap as Blobs, and hand the concat a fresh instance. */
        var CHUNKS_PER_INSTANCE = Math.max(1, Math.min(12, Math.floor(60 / chunkSec)));
        var temps = [], carried = {};

        /* ── borrow the progress subscription ──────────────────────────────
           `units` = n chunks + 1 concat, so the reported fraction is smooth and
           strictly non-decreasing across the whole operation. `progUnit` is
           read at fire time, not captured, because the handler outlives the
           loop iteration (and survives reinit(), which re-attaches it). */
        var onChunk = (typeof opts.onChunkProgress === 'function') ? opts.onChunkProgress : null;
        var prevProgRaw = onChunk ? (FFmpegProcessor._progressRaw || null) : null;
        var progUnit = 0, progUnits = n + 1, progHi = 0;
        function reportProgress(rp) {
            if (!onChunk) return;
            var r = (typeof rp === 'number' && isFinite(rp)) ? Math.max(0, Math.min(1, rp)) : 0;
            var g = (progUnit + r) / progUnits;
            if (g < progHi) g = progHi; else progHi = g;
            try { onChunk(Math.min(1, g)); } catch (_) {}
        }
        if (onChunk) { try { FFmpegProcessor.onProgress(reportProgress); } catch (_) {} }
        function releaseProgress() {
            if (!onChunk) return;
            try { FFmpegProcessor.onProgress(prevProgRaw || function () {}); } catch (_) {}
        }

        async function park(ffmpeg) {
            for (var p = 0; p < temps.length; p++) {
                if (carried[temps[p]]) continue;
                carried[temps[p]] = new Blob([await ffmpeg.readFile(temps[p])]);
                try { await ffmpeg.deleteFile(temps[p]); } catch(_){}
            }
        }
        async function unpark(ffmpeg) {
            var names = Object.keys(carried);
            for (var u = 0; u < names.length; u++) {
                await ffmpeg.writeFile(names[u], new Uint8Array(await carried[names[u]].arrayBuffer()));
            }
        }

        try {
            var j = 0;
            while (j < n) {
                var stop = Math.min(n, j + CHUNKS_PER_INSTANCE);
                await _withMounts(file, async function(paths){
                    var ffmpeg = FFmpegProcessor._getFFmpeg();
                    for (; j < stop; j++) {
                        if (opts.isCancelled && opts.isCancelled()) throw new Error('cancelled');
                        var s = startOffset + j * chunkSec;
                        var e = Math.min(startOffset + (j + 1) * chunkSec, startOffset + totalDuration);
                        var seg = 'rev_' + j + '.' + segExt;
                        temps.push(seg);
                        var a = ['-ss', s.toFixed(6), '-to', e.toFixed(6), '-i', paths[0]]
                                .concat(args).concat(['-y', seg]);
                        console.log('[ffmpeg] reverseChunked seg', j + '/' + n, ':', s.toFixed(2), '-', e.toFixed(2));
                        window._ffLogs = [];
                        var x = await ffmpeg.exec(a);
                        if (x !== 0) throw _execError(x, 'reverse seg ' + j + ': ' + _logTail());
                        progUnit = j + 1; reportProgress(0);
                    }
                });
                // The mount is disposed; MEMFS dies with the instance, so the chunks
                // ride out as Blobs before the heap is reset.
                await park(FFmpegProcessor._getFFmpeg());
                await FFmpegProcessor.reinit();
            }

            var ffmpeg = FFmpegProcessor._getFFmpeg();
            try {
                await unpark(ffmpeg);
                /* Concat in REVERSE order — the magic step. */
                var list = '';
                for (var k = temps.length - 1; k >= 0; k--) list += "file '" + temps[k] + "'\n";
                await ffmpeg.writeFile('list.txt', new TextEncoder().encode(list));
                var ca = ['-f', 'concat', '-safe', '0', '-i', 'list.txt', '-c', 'copy', '-y', outputName];
                progUnit = n; reportProgress(0);
                window._ffLogs = [];
                var x2 = await ffmpeg.exec(ca);
                if (x2 !== 0) throw _execError(x2, 'reverse concat: ' + _logTail());
                if (opts.keepInFs) {
                    return { name: outputName, chunks: n, inFs: true };
                }
                var data = await ffmpeg.readFile(outputName);
                var blob = new Blob([data], { type: _mimeFor(outputName) });
                return { blob: blob, name: outputName, url: URL.createObjectURL(blob), size: blob.size, chunks: n };
            } finally {
                releaseProgress();
                for (var t = 0; t < temps.length; t++) { try { await ffmpeg.deleteFile(temps[t]); } catch(_){} }
                try { await ffmpeg.deleteFile('list.txt'); } catch(_){}
                if (!opts.keepInFs) { try { await ffmpeg.deleteFile(outputName); } catch(_){} }
            }
        } catch(err){
            releaseProgress();
            // Cancel / failure leaves rev_*.mp4 behind; the success path's finally
            // never runs. Best-effort — the instance may already be gone.
            try {
                var dead = FFmpegProcessor._getFFmpeg();
                if (dead) for (var d = 0; d < temps.length; d++) { try { await dead.deleteFile(temps[d]); } catch(_){} }
            } catch(_){}
            _annotateErr(err, file && file.size); throw err;
        }
    };

    /**
     * processMultiStreaming — N inputs mounted once, one exec reads all. Used by
     * join / amerge / overlay scenarios where the classic processMulti() would
     * copy every input into heap.
     */
    // opts.preInputArgs — per-input arguments placed BEFORE that input's -i
    // (e.g. [['-stream_loop','-1'], []] loops input 0 under a finite input 1).
    // /video-loop's «own track» lane: the clip loops to the track's length in
    // ONE exec instead of a looped intermediate that would sit in memory twice.
    FFmpegProcessor.processMultiStreaming = async function(files, args, outputName, opts){
        /* Компенсация задержки фильтров с lookahead. `process()` — не
           единственная дверь в ffmpeg: этот путь и `processMulti` строят
           аргументы сами и exec-ают напрямую, поэтому правка иначе до них не
           доходила — а именно здесь мультиплексируются /gif-to-video и
           /add-music-to-video, чья аудио-ветка живёт в `-filter_complex`.
           Идемпотентна, fail-open. */
        try { args = window.FFmpegDelayCompensation.apply(args); args = window.FFmpegResampleQuality.apply(args); } catch (_) {}
        var totalSize = 0;
        for (var si = 0; si < files.length; si++) totalSize += (files[si] && files[si].size) || 0;
        try {
            return await _withMounts(files, async function(paths){
                var ffmpeg = FFmpegProcessor._getFFmpeg();
                var u = [];
                var preIn = (opts && Array.isArray(opts.preInputArgs)) ? opts.preInputArgs : [];
                for (var i = 0; i < paths.length; i++) {
                    if (preIn[i] && preIn[i].length) u = u.concat(preIn[i]);
                    u.push('-i', paths[i]);
                }
                u = u.concat(args).concat(['-y', outputName]);
                console.log('[ffmpeg] processMultiStreaming:', paths.length, 'inputs |', u.join(' '));
                window._ffLogs = [];
                var code = await ffmpeg.exec(u);
                if (code !== 0) throw _execError(code, _logTail());
                var data = await ffmpeg.readFile(outputName);
                try { await ffmpeg.deleteFile(outputName); } catch(_){}
                var blob = new Blob([data], { type: _mimeFor(outputName) });
                return { blob: blob, name: outputName, url: URL.createObjectURL(blob), size: blob.size };
            });
        } catch(err){ _annotateErr(err, totalSize); throw err; }
    };

    /**
     * probeStreaming — lightweight codec/stream scan without copying input bytes
     * into heap. Mirrors the classic probe() behaviour, including the defensive
     * re-init when FFmpeg logs "Aborted" (same post-probe WASM-state quirk).
     */
    /* ОДНА проба за раз. Слушатель 'log' общий на весь экземпляр, а exec в
       воркере строго последовательный: две пробы, вставшие рядом, обе слышат
       строки ОБЕИХ, и первая «Video:» из чужого хвоста становится кодеком не
       того файла. /video-merge 10.09.2026, VOB + mp4: VOB первым — mp4 получал
       сигнатуру mpeg2video и шёл в x264 вместо копии; mp4 первым — VOB получал
       ДЛИТЕЛЬНОСТЬ mp4 (70 с ленты считались 80), копия признавалась
       «повреждённой», и все клипы кодировались ДВАЖДЫ. Вторая половина той же
       ловушки — чужой exec (миниатюра), ещё идущий в воркере, когда проба
       вешает слушателя: захват начинается со строки, называющей НАШ
       смонтированный путь, хвост чужого прогона отбрасывается.
       Сторож — tests/playwright/ffmpeg-probes-do-not-share-a-log.mjs. */
    var _probeGate = Promise.resolve();

    /* Лог НАШЕГО запуска из общего потока: от баннера «ffmpeg version», которым
       FFmpeg открывает каждый запуск, до баннера следующего.

       До 25.09.2026 обе пробы резали лог по первой строке, называющей свой файл
       (10.09 — probeStreaming, 16.09 — probe). Но демуксер печатает свои
       диагнозы РАНЬШЕ этой строки: у файла без оглавления лог идёт
       «[mov,mp4,…] moov atom not found», и только потом «/_mnt_…/input.mp4:
       Invalid data found». Обрезка уносила ровно ту строку, по которой
       /repair-video узнаёт главный класс поломки: доля диагнозов moov_missing на
       проде упала с 40–70 в день до НУЛЯ с 17.09, и цепочка реконструкции
       (untrunc, образец с той же камеры) девять дней не запускалась ни разу.

       Баннер — граница, которую не подделать: запуски в воркере строго
       последовательны, а наш начинается со своего баннера (пробы идут без
       -hide_banner). Чужой хвост ДО него и чужой запуск ПОСЛЕ него (он тоже
       открывается баннером — старая обрезка его оставляла) остаются снаружи.
       Не нашли свою строку — вернуть всё: ничего не отрезать лучше, чем отрезать
       чужое вместе со своим. Сторожа — tests/js/ffmpeg-own-run-log.test.mjs и
       ProbeHearsOnlyItsOwnLogTest. */
    function ownRunLog(logs, needle){
        var at = -1, i;
        for (i = 0; i < logs.length; i++) if (String(logs[i]).indexOf(needle) !== -1) { at = i; break; }
        if (at < 0) return logs;
        var from = at;
        for (i = at; i >= 0; i--) if (/^ffmpeg version /.test(String(logs[i]))) { from = i; break; }
        var to = logs.length;
        for (i = at + 1; i < logs.length; i++) if (/^ffmpeg version /.test(String(logs[i]))) { to = i; break; }
        return (from > 0 || to < logs.length) ? logs.slice(from, to) : logs;
    }
    FFmpegProcessor._ownRunLog = ownRunLog;

    FFmpegProcessor.probeStreaming = async function(file){
        if (!(await FFmpegProcessor._ensureReady())) throw new Error('FFmpeg not initialized');
        if (!(file instanceof File) && !(file instanceof Blob)) throw new Error('probeStreaming requires File or Blob');
        var self = this;
        var body = function(){ return _probeStreamingBody.call(self, file); };
        var run = _probeGate.then(body, body);
        _probeGate = run.then(function(){}, function(){});
        return run;
    };
    async function _probeStreamingBody(file){
        var ffmpeg = this._getFFmpeg();
        var logs = [];
        var myPath = null;
        var logCb = function(ev){ logs.push(ev.message); };
        try {
            ffmpeg.on('log', logCb);
            await _withMounts(file, async function(paths){
                myPath = paths[0];
                // Give the probe a real (null) output so FFmpeg exits 0 instead of
                // aborting with "At least one output file must be specified". The old
                // `-i path` form ALWAYS aborted → the block below terminated+reinit'd
                // the 32 MB core on EVERY probe (the video-merge reinit storm: up to
                // 47 reloads/session). `-t 0 -f null -` parses headers, prints every
                // Stream/Duration/codec line callers parse, writes nothing, exits 0 →
                // a clean instance, zero reinit. A genuine WASM trap still logs
                // "Aborted" and is handled below.
                try { await ffmpeg.exec(['-i', paths[0], '-t', '0', '-f', 'null', '-']); } catch(_){}
            });
            try { ffmpeg.off('log', logCb); } catch(_){}
            if (myPath) logs = ownRunLog(logs, myPath);
            var result = logs.join('\n');
            // Reinit ONLY on a genuine fatal WASM trap that corrupts the instance —
            // NOT on the benign "Aborted" emscripten prints when ffmpeg exits via its
            // normal exit() path (every clean exec logs it in this build; the regular
            // process() path never reinits on it). The old blanket `indexOf('Aborted')`
            // reinit fired on EVERY probe → the video-merge reinit storm (up to 47
            // reloads/session), each a 32 MB teardown. A real corruption shows a memory
            // /runtime trap, which we still recover from.
            if (/memory access out of bounds|table index is out of bounds|RuntimeError|null function or function signature mismatch|Cannot enlarge memory|out of bounds memory access/i.test(result)) {
                console.log('[ffmpeg] probeStreaming hit a fatal wasm trap — reinitializing instance');
                try { ffmpeg.terminate(); } catch(_){}
                try { await FFmpegProcessor.reinit(); } catch(x){ console.warn('[ffmpeg] reinit after probeStreaming failed:', x.message); }
            }
            return result;
        } catch(err){
            try { ffmpeg.off('log', logCb); } catch(_){}
            throw err;
        }
    }

    /**
     * probeMeta — parsed metadata object from probeStreaming/probe log.
     *
     * Replaces the per-tool pattern of calling .probe() and then re-implementing
     * the regex parser inline. Tools previously assumed .probe() returned an
     * object with .videoCodec — it returns the FFmpeg log string. That mismatch
     * silently dropped codec info on the floor, killing codec-aware logic in
     * /video-compressor (Quick preset never knew about HEVC sources, leading
     * to "+5%" outcomes on iPhone HEVC re-encodes).
     *
     * Returns: { vcodec, acodec, fps, bitrate, audioBitrate, width, height,
     *            duration, rotation } — fields are absent when not detected.
     * Without a duration it may carry `problem`: 'no_moov' (an interrupted
     * recording — no index) or 'invalid_data' (FFmpeg did not recognise it).
     * Never throws — returns {} on probe failure.
     */
    FFmpegProcessor.probeMeta = async function(file){
        var meta = {};
        var log = '';
        try {
            if (!this.isReady()) await this.init();
            // Prefer probeStreaming (no heap copy); fall back to classic probe.
            if (typeof this.probeStreaming === 'function') {
                try { log = await this.probeStreaming(file); } catch(_){}
            }
            if (!log) {
                try { log = await this.probe(file); } catch(_){}
            }
        } catch(_){ return meta; }
        if (!log) return meta;

        // Stream lines — first Video / first Audio. Same regex set as
        // tool-file-info.js parseFFmpegLog so behaviour stays consistent.
        var v = log.match(/Stream\s+#\d+:\d+.*?Video:\s*(\w+)/i);
        if (v) meta.vcodec = v[1].toLowerCase();
        var a = log.match(/Stream\s+#\d+:\d+.*?Audio:\s*(\w+)/i);
        if (a) meta.acodec = a[1].toLowerCase();

        /* ВСЕ звуковые дорожки, а не только первая.
           Здесь этот парсер годами читал одну строку `Audio:` и выбрасывал
           остальные — а вместе с ними язык, заголовок и флаг `(default)`,
           то есть ровно те сведения, по которым плеер человека и выбирал
           дорожку. Из-за этого вопрос «какая дорожка доедет до выхода»
           решался НЕЯВНО и по-разному в каждом лейне (обращение #1665,
           /video-compressor: «после сжатия язык поменялся на английский»).
           Владелец вопроса — window.__audioTracks; здесь только выдача. */
        if (window.__audioTracks && typeof window.__audioTracks.parse === 'function') {
            try {
                meta.audioStreams = window.__audioTracks.parse(log);
                /* Счёт многодорожечных входов — тем же прибором, что и у
                   аппаратного лейна, чтобы обе половины сайта считались
                   одинаково. Молчит у однодорожечного файла (почти все). */
                if (meta.audioStreams.length > 1) {
                    var _mt = document.querySelector('meta[name="tool-slug"]');
                    window.__audioTracks.report(_mt ? _mt.content : '',
                        meta.audioStreams, window.__audioTracks.pick(meta.audioStreams));
                }
            } catch(_){}
        }

        // Audio channel layout → count. Lets a video tool detect its source's
        // channels (ChannelModule.detect) so a stereo→5.1 upmix is offered only
        // for stereo sources and a real 5.1 track is passed through untouched.
        var ac = log.match(/Audio:[^\n]*?\b(mono|stereo|5\.1(?:\(side\))?|7\.1|quad)\b/i);
        if (ac) {
            meta.audioChannels = { mono:1, stereo:2, quad:4, '5.1':6, '5.1(side)':6, '7.1':8 }[ac[1].toLowerCase()] || null;
        }
        // The audio stream's own rate, so a rescue decode can keep it instead
        // of resampling to a default (the AudioDecoderRobust tier-2 caller).
        var asr = log.match(/Audio:[^\n]*?(\d{4,6})\s*Hz/i);
        if (asr) meta.audioSampleRate = parseInt(asr[1], 10);

        // Container-level "bitrate: N kb/s" is overall (video+audio) — fine
        // for compressor's rough plan logic.
        var br = log.match(/bitrate:\s*(\d+)\s*kb\/s/i);
        if (br) meta.bitrate = parseInt(br[1], 10) * 1000; // → bits/sec

        // Audio-stream specific bitrate, if FFmpeg printed it.
        var ab = log.match(/Audio:[^\n]*?(\d+)\s*kb\/s/i);
        if (ab) meta.audioBitrate = parseInt(ab[1], 10) * 1000;

        var f = log.match(/([\d.]+)\s*fps/i);
        if (f) meta.fps = parseFloat(f[1]);

        var r = log.match(/Video:[^\n]*?(\d{3,5})x(\d{3,5})/i);
        if (r) { meta.width = parseInt(r[1], 10); meta.height = parseInt(r[2], 10); }

        var d = log.match(/Duration:\s*(\d+):(\d+):(\d+(?:\.\d+)?)/);
        if (d) meta.duration = parseInt(d[1])*3600 + parseInt(d[2])*60 + parseFloat(d[3]);

        /* Why the file did NOT open, in one word, so the tool can tell the person
           instead of «Error: name». The demuxer prints these lines; the log here is
           this run's own (ownRunLog), so a neighbour's failure cannot leak in.
           no_moov first: FFmpeg prints «Invalid data found» right after it. */
        if (!meta.duration) {
            if (/moov atom not found/i.test(log)) meta.problem = 'no_moov';
            else if (/Invalid data found when processing input/i.test(log)) meta.problem = 'invalid_data';
        }

        // Reuse the canonical rotation parser if available.
        if (typeof this.parseRotation === 'function') {
            try { meta.rotation = this.parseRotation(log); } catch(_){}
        }

        return meta;
    };

    /**
     * abort — synchronous cancel for Cancel-button handlers.
     *
     * Old pattern was `await FFmpegProcessor.reinit()` inside the click handler,
     * which blocked the UI for 2-5 s (terminate + re-download + re-init the 30 MB
     * WASM core) *before* the "Cancelled" message could render. Users clicked
     * Cancel expecting instant feedback and got 5 s of "hang" instead.
     *
     * abort() terminates the current instance immediately (any in-flight exec
     * rejects with "called FFmpeg.terminate()"), nulls the state so classifyError
     * knows the next call is on a fresh instance, and kicks off a *background*
     * init so the NEXT user action finds a warm WASM core waiting for it.
     *
     * Returns synchronously — callers update UI on the next line.
     */
    FFmpegProcessor.abort = function(){
        /* 2026-07-24: user intent marker — the central transient retry MUST NOT
           resurrect a job the user just cancelled (regression caught by test
           2026-07-24: the per-caller retry did exactly that). */
        FFmpegProcessor._userCancelAt = Date.now();
        var e = this._getFFmpeg();
        if (e) { window.__ffmpegIntentionalTerminateAt = Date.now(); try { e.terminate(); } catch(_){} }
        // Reset module-level state so process() treats the next call as cold-start.
        // We piggy-back on reinit() but do NOT await it — the init happens in the
        // background; the cancel UI renders first.
        try { this.reinit().catch(function(){}); } catch(_){}
    };

    /**
     * execGuarded — protected raw FFmpeg exec for tools that bypass .process()
     * for special-purpose flows (multi-input mux, PNG-sequence extract, etc.).
     *
     * Single source of truth for stall detection on raw exec. Replaces the
     * pattern of every blade hand-rolling
     *     await window.__withStallGuard(() => ffApi.exec(args), opts)
     * — which the AI Upscale path of /enhance-video forgot, leading to 35%
     * silent-hang rate (sid 8f3f4128 2026-05-07 "часами висит 99%"). After
     * migrating callers, blades should NEVER reach for `ffApi.exec` directly;
     * the FFmpegStallGuardTest lint enforces that.
     *
     * Why a separate API rather than wrapping `_getFFmpeg().exec` in place:
     *   1) Backwards-compat — `_getFFmpeg()` consumers expect raw `e` access
     *      for non-exec operations (writeFile, readFile, listDir, on/off).
     *   2) Opt-in semantics — callers that genuinely need un-guarded raw exec
     *      (none currently, but possible) can still drop to `_getFFmpeg().exec`.
     *   3) The guard's softMs/hardMs need per-callsite tuning (PNG extract is
     *      bounded, 8K libx264 mux is unbounded). Forcing all .exec() calls
     *      through one fixed timeout would either false-positive fast ops or
     *      let slow ops hang. execGuarded() takes opts per call.
     *
     * Args:
     *   args  — same shape as ffmpeg.exec(args): string array of CLI tokens.
     *   opts  — { softMs, hardMs, stage, meta, onLogs, timeout, signal }
     *           softMs (default 60000) — fires "Encoding is slow" toast.
     *           hardMs (default 600000) — throws errorType='stalled'.
     *           stage  — string label for telemetry meta.
     *           meta   — extra context for telemetry (slug, file size, etc.).
     *           onLogs (optional) — receives `window._ffLogs` snapshot on
     *                  failure, useful for caller-side diagnostic emission.
     *           timeout (optional, seconds) — forwarded as 2nd arg to
     *                  ffmpeg.exec(); -1 means no native timeout (typical).
     *           signal (optional, AbortSignal) — forwarded to ffmpeg.exec()'s
     *                  options bag (ffmpeg.wasm 0.12+ supports cancellation
     *                  via AbortSignal). Caller-owned cancel propagation —
     *                  separate concern from the stall guard's own timeout.
     *           onProgress (optional, fn(p)) — receives 0..1 progress from
     *                  FFmpeg's stderr-derived `ffmpeg-progress` window event
     *                  during the exec. This is REAL progress (libx264
     *                  "frame=N" reporting), not a fake asymptote — closes
     *                  the lie behind sid 8f3f4128 "часами висит 99%" where
     *                  the bar crept to 99 silently while the encode was
     *                  actually stuck. Listener is auto-cleaned up after
     *                  the exec finishes (success or failure).
     *
     * Returns the FFmpeg exit code (Number). Does NOT throw on non-zero code
     * — caller decides whether non-zero is fatal (matches `ffApi.exec()`
     * semantics). Throws on hard-abort (errorType='stalled') and on infra
     * errors (FFmpeg not initialized).
     *
     * Phase ④a will additionally wire stderr-progress events into this API
     * so callers get real progress signal without doing their own setup.
     */
    FFmpegProcessor.execGuarded = async function(args, opts) {
        opts = opts || {};
        var softMs = opts.softMs != null ? opts.softMs : 60000;
        var hardMs = opts.hardMs != null ? opts.hardMs : 600000;
        var stage  = opts.stage  || 'ffmpeg_exec';
        var meta   = opts.meta   || {};

        var ff = this._getFFmpeg();
        if (!ff || typeof ff.exec !== 'function') {
            await FFmpegProcessor._ensureReady();
            ff = this._getFFmpeg();
        }
        if (!ff || typeof ff.exec !== 'function') {
            throw new Error('FFmpeg not initialized — call FFmpegProcessor.init() first');
        }

        // Reset the per-exec log buffer so the caller can inspect tail on
        // failure (matches the existing _ffLogs convention used by .process()).
        window._ffLogs = [];

        // Build the actual ffmpeg.exec(args, timeout, options) call. The
        // timeout/signal pair maps onto ffmpeg.wasm 0.12+'s native API; only
        // pass them when the caller asked, so older callers see exec(args).
        var execFn;
        if (opts.signal != null || opts.timeout != null) {
            var nativeTimeout = (opts.timeout != null) ? opts.timeout : -1;
            var nativeOpts = opts.signal != null ? { signal: opts.signal } : undefined;
            execFn = function() { return ff.exec(args, nativeTimeout, nativeOpts); };
        } else {
            execFn = function() { return ff.exec(args); };
        }

        // Real-progress wiring: every FFmpeg instance auto-dispatches
        // `ffmpeg-progress` window events (detail = 0..1) during exec, derived
        // from libx264's stderr "frame=N" reports. Forward to caller's
        // onProgress so the UI bar moves on real signal — closes the
        // fake-progress lie that left users staring at "99 %" for hours.
        var progressForwarder = null;
        if (typeof opts.onProgress === 'function') {
            progressForwarder = function(ev) {
                var p = ev && ev.detail;
                if (typeof p === 'number') {
                    try { opts.onProgress(p); } catch(_){}
                }
            };
            window.addEventListener('ffmpeg-progress', progressForwarder);
        }

        try {
            if (typeof window.__withStallGuard !== 'function') {
                // Graceful degrade — page loaded before layout's stall guard
                // helper landed. Run un-guarded; should not happen in practice.
                return await execFn();
            }

            var rc = await window.__withStallGuard(
                execFn,
                { softMs: softMs, hardMs: hardMs, stage: stage, meta: meta }
            );

            if (typeof opts.onLogs === 'function') {
                try { opts.onLogs((window._ffLogs || []).slice()); } catch(_){}
            }
            return rc;
        } finally {
            if (progressForwarder) {
                try { window.removeEventListener('ffmpeg-progress', progressForwarder); } catch(_){}
            }
        }
    };
})();

/* ─────────────────────────────────────────────────────────────────────────
   FFmpegProcessor state machine — closes the FFMPEG_NOT_LOADED races.
   ─────────────────────────────────────────────────────────────────────────
   States: IDLE → LOADING → READY → BUSY → CANCELLING → IDLE
   Pre-fix telemetry showed 16 enhance-video tool_error events with
   err_msg "ffmpeg is not loaded, call await ffmpeg.load() first" — those
   came from process() / processStreaming() called between cancel() (which
   nulled `r` and `e`) and the background reinit() finishing. The wrapped
   methods now wait for state==READY instead of throwing.

   We wrap the public surface AFTER the original definitions so the
   un-state-machined originals stay reachable as `__sm_orig`. Wrapping is
   transparent: every existing tool keeps working, just with the race
   eliminated.
   ─────────────────────────────────────────────────────────────────────── */
(function(){
    var FP = window.FFmpegProcessor;
    if (!FP || FP.__stateMachine) return;

    var STATE = 'IDLE';
    var WAITERS = [];

    function setState(next){
        if (next === STATE) return;
        var prev = STATE;
        STATE = next;
        // Drain waiters: each predicate gets re-evaluated against the new state.
        var w = WAITERS; WAITERS = [];
        for (var i = 0; i < w.length; i++) try { w[i](next, prev); } catch(_){}
    }
    function waitFor(predicate, timeoutMs){
        return new Promise(function(resolve, reject){
            if (predicate(STATE)) return resolve(STATE);
            var done = false;
            var timer = timeoutMs ? setTimeout(function(){
                if (done) return; done = true;
                reject(new Error('FFmpeg state wait timeout: stuck in ' + STATE));
            }, timeoutMs) : null;
            function check(next){
                if (done) return;
                if (predicate(next)) {
                    done = true;
                    if (timer) clearTimeout(timer);
                    resolve(next);
                } else {
                    WAITERS.push(check);
                }
            }
            WAITERS.push(check);
        });
    }
    function isReadyState(s){ return s === 'READY' || s === 'BUSY'; }
    function isTerminal(s){ return s === 'READY' || s === 'IDLE'; }

    // Wrap init: enforce single-flight + state transitions.
    //
    // Source-of-truth check: probe() in the original module resets the
    // closure-scoped `r` / `e` flags directly when it detects an "Aborted"
    // state (https://github.com/ffmpegwasm/ffmpeg.wasm aborts the WASM
    // module on certain malformed inputs and recommends re-instantiating).
    // That bypasses our wrapper, so STATE can read READY while
    // FP.isReady() reads false. Any "fast path" that returns true without
    // re-checking isReady() leaves the next exec to throw
    // "FFmpeg not initialized". Always trust FP.isReady() over STATE.
    var origInit = FP.init.bind(FP);
    FP.init = async function(progressCb, opts){
        if ((STATE === 'READY' || STATE === 'BUSY') && FP.isReady()) return true;
        if (STATE === 'CANCELLING') {
            // Cancel is intrinsically fast (.terminate + flag reset); the 5s
            // wait covers the worst-case interleaving with a parallel reinit.
            await waitFor(function(s){ return s === 'IDLE'; }, 5000);
        }
        // Sentry 117158248 (5 users on /ru/denoise, Edge/Yandex slow CDN):
        // pre-fix the wrapper guarded LOADING with `waitFor(isTerminal,
        // 90000)`. On networks that take >90 s to retry-cycle 11 sources
        // (jsdelivr 503 → unpkg slow → direct timeout), the second caller
        // (e.g. engine-warmer ffmpeg → denoise-btn click) timed out at 90 s
        // even though the first caller's init was still progressing
        // legitimately — and reported "FFmpeg state wait timeout: stuck in
        // LOADING" while the underlying init eventually succeeded.
        // Solution: don't race a wall-clock against init. The underlying
        // origInit already implements a Promise-mutex (`_initPromise`) — every
        // concurrent caller awaits the SAME in-flight init. Calling
        // `origInit()` from both A and B returns the same Promise, so they
        // settle together regardless of how long the init actually takes.
        // setState is idempotent on equal state, so multiple completions are
        // safe.
        if (STATE !== 'LOADING') setState('LOADING');
        try {
            var ok = await origInit(progressCb, opts);
            if (STATE !== 'READY') setState(ok ? 'READY' : 'IDLE');
            return ok;
        } catch (err) {
            if (STATE !== 'IDLE') setState('IDLE');
            throw err;
        }
    };

    // Wrap busy operations: auto-init if needed, transition BUSY ↔ READY.
    function wrapOp(name){
        var orig = FP[name];
        if (typeof orig !== 'function') return;
        FP[name] = async function(){
            // Same source-of-truth concern as wrapped init: probe()'s
            // post-Aborted reset clears `r` without our state knowing, so
            // STATE can be READY/BUSY while FP.isReady() is false. Re-init
            // when our state and the underlying flags disagree.
            if (STATE === 'IDLE' || !FP.isReady()) {
                if (STATE !== 'IDLE' && STATE !== 'LOADING') setState('IDLE');
                var ok = await FP.init();
                if (!ok) throw new Error('FFmpeg init failed');
            } else if (STATE === 'LOADING' || STATE === 'CANCELLING') {
                // Same lesson as wrapped FP.init above (Sentry 117158248):
                // route through FP.init's Promise-mutex instead of racing a
                // wall-clock waitFor against an init that may legitimately
                // take >90 s on slow CDNs. CANCELLING transitions to IDLE
                // quickly; FP.init then either short-circuits (READY) or
                // restarts the init. Either way we don't fail an op just
                // because we got tired of waiting.
                var okOp = await FP.init();
                if (!okOp || !FP.isReady()) throw new Error('FFmpeg not ready (state=' + STATE + ')');
            }
            // Allow nested calls during BUSY (some tools do probe→process in one
            // promise chain). Only the outermost call flips READY→BUSY→READY;
            // nested ones see BUSY and pass through without changing state.
            var owns = (STATE === 'READY');
            if (owns) setState('BUSY');
            /* 2026-07-24 ETALON — in-flight accounting + ONE central transient
               retry for every tool on this engine (108 blade files call it).
               Before: each caller had to grow its own retry loop; only
               video-trim ever did, in four copy-pasted places, and that copy
               resurrected user-cancelled jobs. Now the policy lives here once:
                 · _inFlight lets probe() know not to tear down a busy engine;
                 · a terminate-class rejection is retried EXACTLY once, and only
                   when the user did not cancel after this op started. */
            FP._inFlight = (FP._inFlight || 0) + 1;
            var _opStart = Date.now();
            try {
                try {
                    return await orig.apply(this, arguments);
                } catch (_err) {
                    var _m = String(_err && _err.message || '');
                    var _isTransient = /terminate\(\)/i.test(_m);
                    var _userCancelled = (FP._userCancelAt || 0) >= _opStart;
                    /* 2026-09-03 — пометить отмену. Терминат от cancel()/abort()
                       и терминат от чужого килла приходят ОДНОЙ И ТОЙ ЖЕ строкой
                       "called FFmpeg.terminate()", поэтому вызывающий код не мог
                       их развести и показывал юзеру диалог ошибки в ответ на его
                       же «Отмена» (замер 14 д: 17 из 79 таких диалогов в
                       video-trim шли сразу после отмены; согласий на них — 0).
                       Метка ставится в движке, значит верна для всех 108 тулов. */
                    if (_isTransient && _userCancelled) {
                        /* A FRESH error, never a tag on _err (27.09.2026): @ffmpeg/ffmpeg
                           rejects EVERY pending call of a terminate with ONE module-level
                           Error object, so a tag written on it stayed for the page's life —
                           after one Cancel, every later terminate (a trap reset, a forced
                           reinit) read as the user's Cancel and was swallowed. Same message
                           and errorType as before, so message checks behave the same; name
                           AbortError + code USER_CANCELLED are what __isUserCancel reads. */
                        var _ce = new Error(_m || 'called FFmpeg.terminate()');
                        try { _ce.name = 'AbortError'; _ce.cancelled = true; _ce.code = 'USER_CANCELLED'; _ce.errorType = _err.errorType || 'cancelled'; _ce.userMessage = _err.userMessage; _ce.cause = _err; } catch (_) {}
                        throw _ce;
                    }
                    if (!_isTransient || _userCancelled || arguments.__ffRetried) throw _err;
                    if (window.__ffCancelledOps && window.__ffCancelledOps > 0) throw _err;
                    console.warn('[ffmpeg] transient engine kill during ' + name + ' — reinit + retry once');
                    try { window.__ae && window.__ae('feature_use', { slug: (window.__TOOL_SLUG || 'wasm'), action: 'engine_transient_retry', op: name }); } catch(_){}
                    try { await FP.reinit({ force: true }); } catch(_){}
                    var _r = await orig.apply(this, arguments);
                    try { window.__ae && window.__ae('feature_use', { slug: (window.__TOOL_SLUG || 'wasm'), action: 'engine_transient_retry_ok', op: name }); } catch(_){}
                    return _r;
                }
            } finally {
                FP._inFlight = Math.max(0, (FP._inFlight || 1) - 1);
                if (owns && STATE === 'BUSY') setState('READY');
            }
        };
    }
    ['process','processStreaming','processMulti','processSegments','processSegmentsStreaming',
     'concatSegments','concatSegmentsStreaming','reencodeAndConcat','reencodeAndConcatStreaming',
     'smartTwoPassTrimStreaming','concatPiecesStreaming','encodeWindowsStreaming',
     'decodeWindowsStreaming','soundForPictureStreaming',
     'reverseChunked','probe','probeStreaming','mountInput',
     /* processMultiStreaming was missing from this hand-typed list from the day
        it was added: /video-merge and /add-music-to-video are the only tools
        that call it directly, and they are exactly the two that report
        «FFmpeg not initialized» in prod telemetry. Kept in step by
        FFmpegDoorsSelfHealTest. */
     'processMultiStreaming',
     /* analyzeLoudnessStreaming выпала из этого списка в день, когда её
        добавили (4b99206a13): она монтирует файл и зовёт движок напрямую,
        то есть это полноценная дверь, а без wrapOp у неё нет ни учёта
        _inFlight, ни переинициализации при чужом terminate(). Ровно та же
        история, что с processMultiStreaming абзацем выше — рукописный
        список протухает, и держит его в тонусе
        FfmpegDoorsSelfHealConventionTest. */
     'analyzeLoudnessStreaming', 'analyzeLoudnessSeries'].forEach(wrapOp);

    // cancel / abort / reinit: explicit transitions to CANCELLING → IDLE / READY.
    var origCancel = FP.cancel.bind(FP);
    FP.cancel = function(opts){
        var prev = STATE;
        if (prev === 'IDLE') return;
        setState('CANCELLING');
        try { origCancel(opts); } catch(_){}
        setState('IDLE');
    };
    var origAbort = FP.abort.bind(FP);
    FP.abort = function(){
        var prev = STATE;
        if (prev === 'IDLE') { try { origAbort(); } catch(_){} return; }
        setState('CANCELLING');
        try { origAbort(); } catch(_){}
        // origAbort kicks off reinit() in background → that goes through our
        // wrapped reinit, which transitions CANCELLING→LOADING→READY|IDLE.
    };
    var origReinit = FP.reinit.bind(FP);
    FP.reinit = async function(opts){
        /* 2026-07-24 ETALON — reinit drains, it does not kill.
           43 tools call reinit() to free WASM memory before a big job. It used
           to terminate() the shared instance unconditionally, so any operation
           still running (a keyframe probe, a waveform pass, a previous export)
           died with "called FFmpeg.terminate()" — traced to a real export with
           a terminate() stack probe, and the caller list matches the telemetry
           ranking one-for-one. Wait for the engine to go quiet instead; a
           caller that genuinely means "kill it now" (user cancel, recovery
           after a kill) passes {force:true}. */
        var _force = !!(opts && opts.force);
        if (!_force && STATE !== 'CANCELLING' && (FP._inFlight || 0) > 0) {
            var _t0 = Date.now();
            while ((FP._inFlight || 0) > 0 && Date.now() - _t0 < 6000) {
                await new Promise(function(res){ setTimeout(res, 50); });
            }
            if ((FP._inFlight || 0) > 0) {
                /* Still busy after the grace period. Skip the memory-freeing
                   reinit rather than kill live work: memory pressure has its
                   own honest handling and retry ladder, a kill is a guaranteed
                   user-visible failure. */
                try { window.__ae && window.__ae('feature_use', { slug: (window.__TOOL_SLUG || 'wasm'), action: 'engine_reinit_skipped_busy' }); } catch(_){}
                console.log('[ffmpeg] reinit requested while ' + FP._inFlight + ' op(s) in flight — skipped instead of killing them');
                return true;
            }
        }
        if (STATE !== 'CANCELLING') setState('CANCELLING');
        // origReinit terminates the WASM instance AND resets the closure-
        // scoped r/o flags inside the module — both are essential. If we
        // just called FP.init() directly from CANCELLING/IDLE, origInit's
        // own `if(r) return true` short-circuit would skip the actual
        // re-load (the previous "loaded" flag is sticky), and the next
        // exec() would land on a terminated instance with the classic
        // "ffmpeg is not loaded, call await ffmpeg.load() first" error.
        // We pre-transition to IDLE so origReinit's internal call to our
        // wrapped FP.init doesn't deadlock waiting for IDLE — wrapped
        // init at IDLE drives the LOADING→READY|IDLE flow normally.
        setState('IDLE');
        try {
            var ok = await origReinit();
            // origReinit's nested wrapped init already set STATE=READY on
            // success (or IDLE on failure). Don't double-set.
            return ok;
        } catch(err) {
            if (STATE !== 'IDLE') setState('IDLE');
            throw err;
        }
    };

    FP.getState = function(){ return STATE; };
    FP.__stateMachine = true;
})();


// processWithSignal — AbortSignal bridge for FFmpegProcessor.process().
//
// The minified `process()` has a long-stable positional signature
// (file, args, outName, inName, preInputArgs, _retry) that downstream
// recovery wrappers depend on; threading an `opts.signal` through it would
// be high-risk. Instead this wrapper subscribes to the signal on behalf of
// the caller — on abort it calls FFmpegProcessor.abort() (= worker
// terminate(), the same mechanism Cancel buttons have always used) and
// rejects the wrapping promise with an AbortError so the caller can
// distinguish cancel from real failure.
//
// Use this from any audio-pipeline / per-tool path that wants Cancel-aware
// FFmpeg processing: `await FFmpegProcessor.processWithSignal(signal, file,
// args, outName, inName, preInputArgs)`. Signal-less calls use the
// existing .process() directly.
window.FFmpegProcessor.processWithSignal = async function (signal, file, args, name, preInputArgs, inName) {
    if (signal && signal.aborted) {
        throw new DOMException(
            (typeof signal.reason === 'string' && signal.reason) || 'FFmpegProcessor aborted',
            'AbortError'
        );
    }
    var aborted = false;
    var abortErr = null;
    var onAbort = signal ? function () {
        aborted = true;
        abortErr = new DOMException(
            (typeof signal.reason === 'string' && signal.reason) || 'FFmpegProcessor aborted',
            'AbortError'
        );
        try {
            if (typeof window.FFmpegProcessor.abort === 'function') window.FFmpegProcessor.abort();
            else if (typeof window.FFmpegProcessor.reinit === 'function') window.FFmpegProcessor.reinit();
        } catch (_) {}
    } : null;
    if (signal && onAbort) signal.addEventListener('abort', onAbort, { once: true });
    // Stash the signal so ffmpeg-auto-guard's AudioRecover.tryRepair call can
    // forward it. The auto-guard wrap is keyed by the positional signature
    // (input, args, outName, inputName, preArgs, _retry) and can't accept a
    // 7th param without breaking every existing caller. A module-level handoff
    // is the least invasive bridge.
    var prevSignal = window.__currentFFmpegSignal;
    window.__currentFFmpegSignal = signal || null;
    try {
        var result = await window.FFmpegProcessor.process(file, args, name, inName, preInputArgs);
        if (aborted) throw abortErr;
        return result;
    } catch (err) {
        if (aborted) throw abortErr;
        // FFmpeg's classifyError already maps the "called FFmpeg.terminate()"
        // message to 'cancelled' — surface that as AbortError too so callers
        // have a uniform abort contract regardless of which path tripped it.
        if (err && /terminate\(\)|FFmpeg\.terminate|called.*terminate/i.test(err.message || '')) {
            throw new DOMException('FFmpegProcessor terminated', 'AbortError');
        }
        throw err;
    } finally {
        window.__currentFFmpegSignal = prevSignal;
        if (signal && onAbort) {
            try { signal.removeEventListener('abort', onAbort); } catch (_) {}
        }
    }
};


// Drain queued calls captured by the stub registered in timbrica-core.js
// (defer-onerror race defense — Sentry 116972319 / 116972119, 2026-05-02).
if (typeof window.__drainSharedModule === 'function') window.__drainSharedModule('FFmpegProcessor');

/* ── No-SIMD lane: warm the engine on INTENT ──────────────────────────────
   The cohort behind this lane pairs old CPUs with slow links (kristinafey69,
   2026-07-31: slow-2g, 15 idle minutes between picking the file and pressing
   the button — enough for her channel, but nothing was downloading). Farid's
   call: do not preload for visitors who may never process anything; an
   explicit intent (a click on the upload zone, a picked file) is the trigger.
   Since 2026-09-02 warming is simply init(): the lane loads our no-SIMD build
   of the main core through the same blob cache as everyone else, so this is
   one download per session, never two. Save-Data is respected (same standard
   as earth-globe.js / emoji-picker-loader.js). __nosimdCorePrewarmDone is the
   flag tests/playwright/nosimd-engine-load.mjs reads. */
(function(){
    var FP = window.FFmpegProcessor;
    if (!FP) return;
    var done = false;
    function warm(){
        if (done) return;
        try { if (!window.__hasWasmSIMD || window.__hasWasmSIMD()) return; } catch (_) { return; }
        var c = navigator.connection;
        if (c && c.saveData) return;
        done = true;
        Promise.resolve()
            .then(function(){ return FP.init && FP.init(); })
            .then(function(){ try { window.__nosimdCorePrewarmDone = true; } catch (_) {} },
                  function(){ try { window.__nosimdCorePrewarmDone = true; } catch (_) {} });
        try { if (window.__ae) window.__ae('feature_use', { f: 'nosimd_core_prewarm', conn: (c && c.effectiveType) || '' }); } catch (_) {}
    }
    try {
        document.addEventListener('tool-uploader:file', warm, true);
        document.addEventListener('change', function (e) {
            var t = e && e.target;
            if (t && t.tagName === 'INPUT' && t.type === 'file' && t.files && t.files.length) warm();
        }, true);
        document.addEventListener('click', function (e) {
            var t = e && e.target;
            if (t && t.closest && t.closest('.tool-uploader')) warm();
        }, true);
    } catch (_) {}
})();

/* ── Perf instrumentation ─────────────────────────────────────────────────
   Emits the `perf` telemetry event ({slug, ms, size, out, via}) around every
   entry point that actually runs FFmpeg. It lives HERE, in the file that owns
   them, installed synchronously at the end of definition — which makes it the
   innermost wrapper, so later decorators stack around it and cannot displace it.

   Two things were wrong before 2026-08-09, and only a real-file run in a real
   browser separated them:

   1. It lived in timbrica-eta.js, an outside patcher. ffmpeg-auto-guard and
      telemetry-tier0 replace the same properties, each capturing "the original"
      at its own load time, so the perf wrapper could simply fall out of the
      chain — and it set a flag that stopped it re-installing.

   2. The real reason coverage was near-zero on heavy tools: auto-guard's
      process/processMulti wrappers have a STREAMING BRANCH. When inputs can be
      mounted (WORKERFS) they call processMultiStreaming/processStreaming and
      RETURN — the classic method, and anything wrapped around it, is never
      reached. Wrapping only `process`/`processMulti` therefore instrumented the
      fallback path and missed the one real users take. Measured over 7 prod
      days: add-music-to-video 32 perf events for 2764 completions (1.2%),
      video-frames 0/2079, music-video-maker 0/168 — those 32 were in-memory
      fallbacks. Verified in the browser: a genuine export drove processMulti
      twice while the classic-path wrapper ran ZERO times.

   Hence: instrument the streaming lanes too, and stamp `via` with the method
   name so the next blind spot shows up as a missing lane instead of silence.
   Nested calls (a streaming lane delegating to another) are depth-counted into
   one event, so one user-visible run stays one measurement.

   `perf` means "a completed run": a throwing call closes the span WITHOUT
   emitting, so a retry ladder contributes one event, and the ms distribution
   keeps the meaning dashboards already read it with. */
(function(){
    var FP = window.FFmpegProcessor;
    if (!FP || FP.__perfInstrumented) return;

    /* Every lane that does real work. Probes and plumbing (probeMeta,
       probeStreaming, mountInput, execGuarded) are deliberately absent — they
       are not runs, and counting them would inflate the metric. */
    var LANES = FP.WORK_LANES = [
        'process', 'processMulti', 'processSegments', 'concatSegments',
        'reencodeAndConcat', 'processReverse', 'processWithRotationFix',
        'concatParts', 'processStreaming', 'processMultiStreaming',
        'processSegmentsStreaming', 'concatSegmentsStreaming',
        'concatPiecesStreaming', 'reencodeAndConcatStreaming',
        'smartTwoPassTrimStreaming', 'reverseChunked', 'processWithSignal',
        'encodeWindowsStreaming', 'decodeWindowsStreaming', 'soundForPictureStreaming'
    ];

    var depth = 0, bytes = 0, outerVia = '';

    function sizeOf(a){
        if (!a) return 0;
        if (Array.isArray(a)) { var s = 0; for (var i=0;i<a.length;i++) s += (a[i] && (a[i].size||a[i].byteLength))||0; return s; }
        return a.size || a.byteLength || 0;
    }
    function begin(a, via){
        if (depth === 0) { bytes = 0; outerVia = via; if (window.__aePerfStart) window.__aePerfStart(); }
        bytes += sizeOf(a);
        depth++;
    }
    function end(result, ok){
        depth--;
        if (depth > 0) return;      /* inner lane of one user-visible run */
        depth = 0;
        if (ok === false) { window.__perfT0 = null; return; }
        if (!window.__aePerfEnd) return;
        window.__aePerfEnd({ size: bytes, out: (result && result.size) || 0, via: outerVia });
    }
    function wrap(orig, via){
        return function(){
            begin(arguments[0], via);
            var settled = false;
            var done = function(r, ok){ if (!settled) { settled = true; end(r, ok); } };
            try {
                var out = orig.apply(this, arguments);
                if (out && typeof out.then === 'function') {
                    return out.then(function(r){ done(r, true); return r; },
                                    function(e){ done(null, false); throw e; });
                }
                done(out, true);
                return out;
            } catch (e) { done(null, false); throw e; }
        };
    }

    for (var i = 0; i < LANES.length; i++) {
        var n = LANES[i];
        if (typeof FP[n] === 'function') FP[n] = wrap(FP[n], n);
    }
    FP.__perfInstrumented = true;
})();

/* ─────────────────────────────────────────────────────────────────────────
   Stall detection belongs to the ENGINE, not to each blade.
   ─────────────────────────────────────────────────────────────────────────
   `FFmpegStallGuardTest` has said since 2026-05-07 that a blade may reach for
   raw `exec()` only if it wraps it, "bypassing FFmpegProcessor.process(),
   which has its own internal stall detection via __withStallGuard".

   That sentence was not true. `process()` / `processStreaming()` had no stall
   detection of any kind; the guard existed only where a caller remembered to
   type it — six blades out of the 117 that load this file. So the lint policed
   the RARE door (raw exec) and left the door everyone actually uses wide open,
   while asserting the opposite. Nobody re-checked, because the assertion read
   like a fact.

   Bug #1526 (Артур, 2026-08-30, guest, Firefox/Win, 2 cores, SAB=0) is what
   that costs. A 452 MB / 90-minute source in /video-compressor: bar at 99 %,
   "1:52 remaining", no movement. He waited 1 h 46 m, reloaded, and paid another
   1 h 25 m — the second attempt finished (`compress_done`, 452 → 153 MB,
   5 083 s of a single exec). The run was almost certainly alive both times.
   Nothing in the product could tell him that, and nothing could have told him
   the opposite either: a dead encode looks exactly the same.

   So the guard moves to the one place every tool passes through. Same lane list
   the perf instrumentation uses (FP.WORK_LANES) — one definition, so "which
   calls are real work" cannot drift between the two. Probes and plumbing stay
   out for the reason stated there: they are bounded, and cancelling the engine
   under a slow probe would be the bug rather than the fix.

   Thresholds are measured, not guessed:
     · a healthy encode ticks every ~0.55 s (p50) and never went past 2.6 s in
       the two full runs traced in tests/playwright/vc-progress-curve.mjs;
     · 8.4 % of SUCCESSFUL prod runs on this tool exceed one hour and 15.6 %
       exceed thirty minutes (2 294 paired compress_start/compress_done rows,
       30 d) — so a wall-clock timeout is out of the question. Only SILENCE can
       be the signal, never duration.
     · the floor is 5 minutes rather than the primitive’s 180 s default because
       the tail after the last tick (faststart rewrite + readFile + Blob) is
       genuinely silent: measured 8.6 s for a 57 MB output on a warm desktop,
       and it scales with output size and device.
   `adaptive:true` then raises the threshold on machines whose ticks are slow,
   and `__withStallGuard` already declines to judge a hidden tab at all.
   ─────────────────────────────────────────────────────────────────────── */
(function(){
    var FP = window.FFmpegProcessor;
    if (!FP || FP.__stallGuarded || !FP.WORK_LANES) return;

    var depth = 0;

    function guard(orig, lane){
        return function(){
            var self = this, args = arguments;
            var run = function(){ return orig.apply(self, args); };
            // Nested lanes (a pipeline calling process() inside reverseChunked)
            // must not arm a second watchdog: the outer one already covers the
            // whole span, and two guards would race to cancel the same engine.
            if (depth > 0 || typeof window.__withStallGuard !== 'function') return run();
            depth++;
            var p;
            try {
                p = window.__withStallGuard(run, {
                    adaptive: true,
                    /* Overridable so a test can prove the guard fires without
                       burning five minutes of wall clock; production never sets
                       it (same convention as __ffmpegLongExecMs above). */
                    floorMs: window.__ffmpegStallFloorMs || 300000,
                    softMs: window.__ffmpegStallSoftMs || 90000,
                    stage: 'ffmpeg_' + lane,
                    meta: { slug: window.__TOOL_SLUG || window.__currentSlug || '', lane: lane }
                });
            } catch (e) { depth--; throw e; }
            return Promise.resolve(p).then(
                function(r){ depth--; return r; },
                function(e){ depth--; throw e; }
            );
        };
    }

    for (var i = 0; i < FP.WORK_LANES.length; i++) {
        var n = FP.WORK_LANES[i];
        if (typeof FP[n] === 'function') FP[n] = guard(FP[n], n);
    }
    /* Exposed so a test can wrap a stand-in body in the SAME wrapper the lanes
       got, instead of re-deriving one and proving a copy works. */
    FP.__guardFactory = guard;
    FP.__stallGuarded = true;
})();

/* __ffmpegPlaybackIntent:begin */
/* ═══════ Выход mp4 говорит плеерам Apple, как его играть (2026-11-04) ═══════
   «Фото» на iPhone и QuickTime играют середину файла ≥ 120 к/с как slow-mo, если в
   `moov/meta` нет ключа com.apple.quicktime.full-frame-rate-playback-intent = 1.
   Камера iPhone пишет его в каждую запись (1 у обычного видео, 0 у slo-mo), а
   FFmpeg его теряет: без `use_metadata_tags` молча, с ним — хуже, переписывает
   8-байтовое значение камеры как «0» и тащит модель и координаты (замер 04.11).
   Значит, 120 к/с с iPhone 16 Pro, прошедшие FFmpeg-лейн любого тула (браузер
   без WebCodecs, провал быстрого пути), выходили slow-mo. Здесь — та же дверь,
   что у WebCodecs-лейнов (`__mp4Tags.carry`), только для ключа (`tags:false`):
   описательными тегами FFmpeg распоряжается сам по аргументам вызывающего.

   Граница — РЕЗУЛЬТАТ рабочего лейна (тот же список FP.WORK_LANES, что у перф-
   замера и сторожа зависания): только там на руках и исходный файл, и выход.
   - источник — один файл mp4-семейства; склейки нескольких (processMulti…) — нет:
     чей там ключ, решает тул, и их внутренние вызовы тоже не решают;
   - вызывающий, который сам стирает метаданные (`-map_metadata -1`), — не трогаем;
   - выход — по байтам (`ftyp`), звук (.m4a/.aac…) — мимо;
   - дверь грузится в НАЧАЛЕ прогона: загрузка по требованию в конце с потолком
     10 с на медленной связи отдавала файл без ключа (стенд /video-fps 04.11).
   Fail-open везде: выход уходит как был. Разбор — docs/why/hfr-playback-intent.md. */
(function () {
    var FP = window.FFmpegProcessor;
    if (!FP || FP.__intentCarried || !FP.WORK_LANES) return;
    var SOURCE_NAME = /\.(mp4|m4v|mov|3gp)$/i;
    var SOUND_OUT = /\.(m4a|m4b|aac|mp3|wav|flac|ogg|oga|opus|weba)$/i;
    var MULTI = { processMulti: 1, processMultiStreaming: 1, concatParts: 1 };
    var multiDepth = 0, _door = null;

    function isFile(f) { return !!f && typeof f.slice === 'function' && typeof f.size === 'number'; }
    function sourceOf(name, a) {
        var f = name === 'processWithSignal' ? a[1] : a[0];
        if (!isFile(f)) return null;
        return (SOURCE_NAME.test(String(f.name || '')) || /^video\/(mp4|quicktime)/i.test(String(f.type || ''))) ? f : null;
    }
    function strips(a) {
        for (var i = 0; i < a.length; i++) {
            var v = a[i];
            if (!Array.isArray(v)) continue;
            for (var j = 0; j + 1 < v.length; j++) if (v[j] === '-map_metadata' && String(v[j + 1]) === '-1') return true;
        }
        return false;
    }
    function door() {
        if (window.__mp4Tags) return Promise.resolve(window.__mp4Tags);
        /* Свой загрузчик, без конвейера WebCodecs: на страницах no_video_js его нет
           (NoVideoJsOptOutTest), а FFmpeg-лейн там работает. */
        if (!_door) {
            var src = (typeof window.__jsSrc === 'function') ? window.__jsSrc('/js/mp4-tags.js') : '/js/mp4-tags.js';
            _door = (typeof window.__loadScriptsOnce === 'function' ? window.__loadScriptsOnce([src], 'mp4-tags') : Promise.reject(new Error('no loader')))
                .then(function () { return window.__mp4Tags || null; }, function () { _door = null; return window.__mp4Tags || null; });
        }
        return _door;
    }
    async function finish(src, res) {
        var blob = (typeof Blob !== 'undefined' && res instanceof Blob) ? res : (res && res.blob && typeof res.blob.slice === 'function' ? res.blob : null);
        if (!blob || blob.size < 16) return res;
        if (SOUND_OUT.test(String((res && res.name) || blob.name || ''))) return res;
        var h = new Uint8Array(await blob.slice(4, 8).arrayBuffer());
        if (String.fromCharCode(h[0], h[1], h[2], h[3]) !== 'ftyp') return res;
        var T = await door();
        if (!T || typeof T.carry !== 'function') return res;
        var nb = await T.carry(src, blob, { slug: window.__TOOL_SLUG || window.__currentSlug || 'ffmpeg', tags: false });
        if (!nb || nb === blob) return res;
        if (res === blob) return (typeof File !== 'undefined' && res instanceof File) ? new File([nb], res.name, { type: res.type || 'video/mp4' }) : nb;
        res.blob = nb;
        if (typeof res.size === 'number') res.size = nb.size;
        if (res.url) {
            try { URL.revokeObjectURL(res.url); } catch (_) {}
            res.url = URL.createObjectURL(nb);
        }
        return res;
    }
    function wrap(fn, name) {
        return function () {
            var a = arguments, multi = !!MULTI[name];
            var src = (multi || multiDepth > 0) ? null : sourceOf(name, a);
            var on = !!src && !strips(a);
            if (on) door();                    /* к концу прогона дверь уже здесь */
            if (multi) multiDepth++;
            var p;
            try { p = fn.apply(this, a); } catch (e) { if (multi) multiDepth--; throw e; }
            return Promise.resolve(p).then(function (r) {
                if (multi) multiDepth--;
                return on ? finish(src, r).catch(function () { return r; }) : r;
            }, function (e) { if (multi) multiDepth--; throw e; });
        };
    }
    for (var i = 0; i < FP.WORK_LANES.length; i++) {
        var n = FP.WORK_LANES[i];
        if (typeof FP[n] === 'function') FP[n] = wrap(FP[n], n);
    }
    /* Для теста — та же обёртка над подставным лейном, а не её копия. */
    FP.__intentWrapFactory = wrap;
    FP.__intentCarried = true;
})();
/* __ffmpegPlaybackIntent:end */
